import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar type represents time data, ISO-8601 encoded UTC date string. */
  DateTime: any;
  /** The `Date` scalar type represents date data, ISO-8601 encoded date string (YYYY-MM-DD). */
  Date: any;
  /** Arbitrary data encoded in JSON. See https://www.json.org/. */
  JSON: any;
};

export type Query = {
  __typename?: 'Query';
  activePlans?: Maybe<Array<Plan>>;
  activeTrips?: Maybe<Array<Trip>>;
  addGreenCornerPrice?: Maybe<AddGreenCornerPrice>;
  additionalTypes?: Maybe<Array<TypeOfAdditional>>;
  addresseesGroupToChat?: Maybe<Array<ChatGroup>>;
  addresseesUsersToChat?: Maybe<AddresseesUsersToChatsPaginatedList>;
  aggregateTypes?: Maybe<Array<Aggregate>>;
  akebonoPackages?: Maybe<PackagesPaginatedList>;
  ambassadors?: Maybe<AmbassadorsPaginatedList>;
  attachmentsTemplate?: Maybe<Array<AttachmentsTemplate>>;
  /** Получить все отзывы аукциона */
  auctionFeedbacks?: Maybe<AuctionFeedbacksPaginatedList>;
  /** Статистика осмотров на аукционе в разрезе аукционов */
  auctionInspectionAuctionStatistic?: Maybe<Array<Maybe<AuctionInspectionAuctionStatistic>>>;
  /** Статистика осмотров на аукционе в разрезе сотрудников */
  auctionInspectionUserStatistic?: Maybe<Array<Maybe<AuctionInspectionUserStatistic>>>;
  auctions?: Maybe<Array<Stock>>;
  autoResolveJobsQuery?: Maybe<Scalars['Boolean']>;
  /** Размер комиссии за перевод баланса между клиентами */
  balanceTransferComissionAmount?: Maybe<Price>;
  branchOffices?: Maybe<Array<Scalars['String']>>;
  brokerExcelTemplates?: Maybe<Array<BrokerExcelTemplate>>;
  brokers?: Maybe<BrokersPaginatedList>;
  carriers?: Maybe<Array<Carrier>>;
  carTypes?: Maybe<Array<TypeOfExport>>;
  chassisTypes?: Maybe<Array<TypeOfChassis>>;
  chatForOthers?: Maybe<ChatForOthers>;
  chatMessages?: Maybe<ChatMessagessPaginatedList>;
  chatsForOthers?: Maybe<ChatsForOtherssPaginatedList>;
  chatTags?: Maybe<Array<Tag>>;
  checkAgentDebts?: Maybe<Scalars['Boolean']>;
  clientContacts?: Maybe<Array<ClientContact>>;
  clientInvoiceCustomers?: Maybe<ClientInvoiceCustomersPaginatedList>;
  clientObject?: Maybe<ObjectOfServices>;
  /** Вложения, посылки */
  clientObjectAttachments?: Maybe<ClientObjectAttachmentsPaginatedList>;
  clientObjectByVin?: Maybe<ObjectOfServices>;
  /** Список рейсов с активными объектами или долгами */
  clientObjectDashboard?: Maybe<Array<ClientObjectsTrip>>;
  clientObjectDebts?: Maybe<OwnerBalance>;
  clientObjectLogs?: Maybe<ClientObjectLogsPaginatedList>;
  clientObjectQueue?: Maybe<ClientObjectQueuesPaginatedList>;
  /** Размер комиссии перепродажи ЗУ */
  clientObjectResaleComission?: Maybe<Price>;
  /** Сделки перепродажи */
  clientObjectResales?: Maybe<ObjectResalesPaginatedList>;
  clientObjects?: Maybe<ClientObjectsPaginatedList>;
  clientObjectsReportPaymentAkebonoAllow?: Maybe<ClientObjectsReportPaymentAkebonoAllowsPaginatedList>;
  clientObjectYears?: Maybe<Array<ClientObjectsYear>>;
  /** Поиск по UUID клиента */
  clientOwnerSearch?: Maybe<OwnerPrivateInfo>;
  clientRecipients?: Maybe<ClientRecipientsPaginatedList>;
  colors?: Maybe<Array<Color>>;
  /** Данные контейнера */
  container?: Maybe<Container>;
  /** Список контейнеров */
  containers?: Maybe<ContainersPaginatedList>;
  /** Типов контейнеров */
  containerTypes?: Maybe<Array<Maybe<TypeOfContainer>>>;
  countries?: Maybe<CountrysPaginatedList>;
  countUnreadChatMessages?: Maybe<Scalars['Int']>;
  currencies?: Maybe<Array<Currency>>;
  currentPlan?: Maybe<SbktsPlan>;
  currentUser?: Maybe<User>;
  currentUserNotifyMessages?: Maybe<Array<CurrentUserNotifyMessage>>;
  customPaymentTypes?: Maybe<Array<CustomPayment>>;
  customTypes?: Maybe<Array<TypeOfCustom>>;
  deliveryWheelPrice?: Maybe<Scalars['Int']>;
  depositOpenAmount?: Maybe<Array<Scalars['Int']>>;
  diffEntities?: Maybe<Array<LogEntity>>;
  diffEntityTypes?: Maybe<Array<Scalars['String']>>;
  /** Данные по донату на буханку */
  donateBuhankaStatus?: Maybe<DonateBuhanka>;
  drivers?: Maybe<Array<User>>;
  /** Курсы валют для платёжного агента */
  dzenPayRates?: Maybe<Array<DzenPayRate>>;
  ecarJpBotSubscribeUrl: Scalars['String'];
  engines?: Maybe<Array<TypeOfEngine>>;
  engineTypes?: Maybe<Array<TypeOfEngine>>;
  exchangeJobActions?: Maybe<Array<Scalars['String']>>;
  exchangeJobs?: Maybe<ExchangeJobsPaginatedList>;
  exchangeJobTransports?: Maybe<Array<Scalars['String']>>;
  /** Список сторонних рейсов */
  exportTrips?: Maybe<ExportTripsPaginatedList>;
  fastObjectsByTrip?: Maybe<Array<FastObjectsByTrip>>;
  /** Получить все отзывы */
  feedbacks?: Maybe<FeedbackssPaginatedList>;
  financeReport?: Maybe<Array<FinanceReport>>;
  flatTypes?: Maybe<Array<TypeOfFlat>>;
  /** Формальник по id */
  formalOwner?: Maybe<FormalOwner>;
  formalOwners?: Maybe<FormalOwnersPaginatedList>;
  /** Список форватеров */
  forwarders?: Maybe<Array<Maybe<Forwarder>>>;
  /** Список типов фрахта контейнера */
  freightTypes?: Maybe<Array<Maybe<TypeOfFreight>>>;
  getEPTSLauncherUrls?: Maybe<Array<Scalars['String']>>;
  /** Справочник частей кузова для осмотра ЗУ */
  greenCornerBodyParts?: Maybe<Array<GreenCornerBodyPartItem>>;
  /** Счётчики страницы управления ЗУ: объект попадает во все свои признаки, признак из фильтра не учитывается */
  greenCornerManageCounters: GreenCornerObjectCounters;
  /** Активные объекты ЗУ для страницы управления */
  greenCornerManageObjects?: Maybe<GreenCornerManageObjectsPaginatedList>;
  /** Статистика + объекты ЗУ с грузополучателем */
  greenCornerObjects?: Maybe<GreenCornerObjects>;
  /** Статистика ЗУ перепродано, куда (аукцион, клиенту) */
  greenCornerObjectsResaleStat?: Maybe<GreenCornerObjectsResaleStat>;
  greenCornerStoragePeriod?: Maybe<GreenCornerStoragePeriod>;
  /** Фото объекта, которые можно выбрать для публикации ЗУ */
  greenCornerTgMedia?: Maybe<Array<GreenCornerTgMedia>>;
  /** Публикация ЗУ в Telegram */
  greenCornerTgPost?: Maybe<GreenCornerTgPost>;
  /** Публикации ЗУ в Telegram, новые первыми */
  greenCornerTgPosts?: Maybe<GreenCornerTgPostsPaginatedList>;
  /** Предпросмотр публикации ЗУ со свежими данными объекта */
  greenCornerTgPreview: GreenCornerTgPreview;
  /** Шаблон публикации ЗУ в Telegram */
  greenCornerTgTemplate?: Maybe<GreenCornerTgTemplate>;
  /** Шаблоны публикаций ЗУ в Telegram, шаблон по умолчанию первый */
  greenCornerTgTemplates?: Maybe<Array<GreenCornerTgTemplate>>;
  /** Переменные и условия для конструктора шаблонов ЗУ */
  greenCornerTgVariables?: Maybe<Array<GreenCornerTgVariable>>;
  houseTypes?: Maybe<Array<TypeOfHouse>>;
  housingTypes?: Maybe<Array<TypeOfHousing>>;
  /** Список платёжек платёжного агента */
  invoiceCustomDzenPayList?: Maybe<InvoiceCustomDzenPaysPaginatedList>;
  /** Статистика платёжек по агентам */
  invoiceCustomDzenPayStats?: Maybe<InvoiceCustomDzenPayStats>;
  /** Статистика платёжек по агентам детальная */
  invoiceCustomPaymentAgentStats?: Maybe<InvoiceCustomDzenPayAnalytics>;
  invoiceCustoms?: Maybe<InvoiceCustomerInfosPaginatedList>;
  invoiceLogs?: Maybe<InvoiceLogsPaginatedList>;
  /** Excel отчёт по платёжкам - Платёжных агентов */
  invoiceReport?: Maybe<Scalars['String']>;
  /** Список и поиск инвойсов */
  invoicesSearch?: Maybe<InvoicesSearchsPaginatedList>;
  invoiceTypes?: Maybe<Array<InvoiceType>>;
  /** Запросы на изменение инвойса */
  invoiceUpdateRequests?: Maybe<Array<InvoiceUpdateRequest>>;
  isSubscribedToGreenCorner?: Maybe<Scalars['Boolean']>;
  /** Состояние автовыставления лотов */
  kaitaiAutoResubmitState?: Maybe<KaitaiAutoResubmitStateEnum>;
  /** Состояние очереди Kaitai емэйлов */
  kaitaiQueueStatus?: Maybe<QueueStatus>;
  kaitaiRemarks?: Maybe<Array<KaitaiRemark>>;
  kaitaiSides?: Maybe<Array<KaitaiSide>>;
  laboratories?: Maybe<Array<Laboratory>>;
  limitsPlan?: Maybe<LimitsPlan>;
  localityTypes?: Maybe<Array<TypeOfLocality>>;
  logAgentEvents?: Maybe<LogAgentEventsPaginatedList>;
  logObjectEvents?: Maybe<Array<ObjectLogEvent>>;
  logs?: Maybe<LogsPaginatedList>;
  logsUserRequests?: Maybe<LogsUserRequestsPaginatedList>;
  logsUserRequestTypes?: Maybe<Array<Scalars['String']>>;
  logTypes?: Maybe<Array<Scalars['String']>>;
  /** Получить список лотерейных билетов. */
  lotteryTickets?: Maybe<Array<Maybe<LotteryTicket>>>;
  makerColors?: Maybe<Array<MakerColor>>;
  makers?: Maybe<Array<Maker>>;
  marks?: Maybe<Array<Mark>>;
  masterAccountsClients?: Maybe<MasterAccountsClientsPaginatedList>;
  mediaStatistics?: Maybe<MediaStatistics>;
  mediaTypes?: Maybe<Array<MediaTypeEnum>>;
  models?: Maybe<Array<Model>>;
  /** Курс по банку MUFG JPT/CNY */
  mufgJpyToCnyExhangeRate?: Maybe<Scalars['Float']>;
  /** Курс по банку MUFG JPT/EUR */
  mufgJpyToEurExhangeRate?: Maybe<Scalars['Float']>;
  /** Курс по банку MUFG JPT/USD */
  mufgJpyToUsdExhangeRate?: Maybe<Scalars['Float']>;
  navisSchedule?: Maybe<TripSchedule>;
  nomenclatures?: Maybe<Array<Nomenclature>>;
  notificationLogs?: Maybe<NotificationLogsPaginatedList>;
  objectActivities?: Maybe<ObjectActivitysPaginatedList>;
  objectKeyTypes?: Maybe<Array<TypeOfObjectKey>>;
  operationalObjects?: Maybe<OperationalObjectsPaginatedList>;
  /** Список организаций */
  organizations?: Maybe<Array<Organization>>;
  owner?: Maybe<Owner>;
  owners?: Maybe<OwnersPaginatedList>;
  /** Число сделок, где нужно действие: создана, ждёт оплату или подтверждение продавца */
  p2pActiveDealsCount?: Maybe<Scalars['Int']>;
  /** Карточка любой записи со сделками и историей */
  p2pAdminBuyRequest?: Maybe<P2pBuyRequest>;
  /** Все заявки на покупку в любом статусе, только для администратора */
  p2pAdminBuyRequests?: Maybe<P2pAdminBuyRequestsPaginatedList>;
  /** Карточка любой сделки с историей и чатом */
  p2pAdminDeal?: Maybe<P2pDeal>;
  /** Все P2P-сделки, только для администратора */
  p2pAdminDeals?: Maybe<P2pAdminDealsPaginatedList>;
  /** Названия и количество сделок по статусам для фильтров админки */
  p2pAdminDealStatusCounts?: Maybe<Array<P2pDealStatusCount>>;
  /** Карточка любой записи со сделками и историей */
  p2pAdminOffer?: Maybe<P2pOffer>;
  /** Все предложения на продажу в любом статусе, только для администратора */
  p2pAdminOffers?: Maybe<P2pAdminOffersPaginatedList>;
  /** Названия и количество предложений по статусам для фильтров админки (в т.ч. на модерации) */
  p2pAdminOfferStatusCounts?: Maybe<Array<P2pOfferStatusCount>>;
  /** Единый список P2P-объявлений для администратора: продажи и покупки */
  p2pAdminRequests?: Maybe<P2pAdminRequestsPaginatedList>;
  p2pBuyRequest?: Maybe<P2pBuyRequestPublic>;
  p2pBuyRequests?: Maybe<P2pPublicBuyRequestsPaginatedList>;
  /** Сделки пользователя, завершённые за последние дни */
  p2pCompletedDealsCount?: Maybe<Scalars['Int']>;
  p2pDeal?: Maybe<P2pDeal>;
  p2pDealReportDownload?: Maybe<Scalars['String']>;
  p2pMyBuyRequest?: Maybe<P2pBuyRequest>;
  p2pMyBuyRequests?: Maybe<P2pMyBuyRequestsPaginatedList>;
  p2pMyDeals?: Maybe<P2pMyDealsPaginatedList>;
  p2pMyOffer?: Maybe<P2pOffer>;
  p2pMyOffers?: Maybe<P2pMyOffersPaginatedList>;
  /** Единый список P2P-записей пользователя: свои предложения и заявки, а также чужие, по которым у него есть сделки */
  p2pMyRequests?: Maybe<P2pMyRequestsPaginatedList>;
  p2pOffer?: Maybe<P2pOfferPublic>;
  p2pOffers?: Maybe<P2pPublicOffersPaginatedList>;
  p2pPaymentDetails?: Maybe<Array<P2pPaymentDetail>>;
  /** Настройки P2P: комиссия, лимиты и доступный аукционный баланс */
  p2pSettings?: Maybe<P2pSettings>;
  /** Список палет */
  pallet?: Maybe<PalletsPaginatedList>;
  parkingPrice?: Maybe<Scalars['Int']>;
  partTemplates?: Maybe<Array<PartTemplate>>;
  paymentAgentRates?: Maybe<Array<DzenPayRate>>;
  paymentAgents?: Maybe<Array<BankInvoice>>;
  paymentsHistory?: Maybe<Array<PaymentHistory>>;
  plan?: Maybe<Plan>;
  /** @deprecated Deprecated */
  planGenerate?: Maybe<SbktsPlan>;
  plans?: Maybe<SbktsPlansPaginatedList>;
  /** Список портов и аэропортов */
  ports?: Maybe<Array<PortInfo>>;
  /** Список типов портов */
  portTypes?: Maybe<Array<PortTypeInfo>>;
  /** Стоимость услуги Подготовка пакета документов для жителей не ДВФО */
  prepareDocumentsPrice?: Maybe<Scalars['Int']>;
  /** Объективность цены */
  priceLevel?: Maybe<PriceLevel>;
  /** QR payment availability for selected objects */
  qrPaymentAvailability?: Maybe<QrPaymentAvailability>;
  reasons?: Maybe<Array<Reason>>;
  /** Отчёты */
  reports?: Maybe<ReportsPaginatedList>;
  /** Типы отчётов */
  reportTypes?: Maybe<Array<TypeOfReport>>;
  sawTypes?: Maybe<Array<TypeOfSaw>>;
  sbktsBrokerStatistic?: Maybe<SbktsStatistic>;
  sbktsPlanStatistic?: Maybe<SbktsPlanStatistic>;
  sbktsRequest?: Maybe<SbktsRequest>;
  sbktsRequests?: Maybe<SbktsRequestsPaginatedList>;
  /** Список автомобилей на утилизацию */
  scrapObjects?: Maybe<DisposalsPaginatedList>;
  /** Список описаний шаблонов запчастей */
  scrapTypeDescriptions?: Maybe<ScrapTypeDescriptionsPaginatedList>;
  scrapTypes?: Maybe<Array<Scrap>>;
  /** Список морских доставщиков */
  seaCarriers?: Maybe<SeaCarriersPaginatedList>;
  searchObjects?: Maybe<SearchObjectsPaginatedList>;
  sectors?: Maybe<Array<Sector>>;
  senderAgentsSearch?: Maybe<OwnerAgentsPaginatedList>;
  senders?: Maybe<SendersPaginatedList>;
  /** Данные заявки на доп услугу */
  serviceRequest?: Maybe<ServiceRequest>;
  /** Наличие заявки на фото с лота */
  serviceRequestAuctionLotByUser?: Maybe<ServiceRequest>;
  /** Наличие заявки на фото с лота */
  serviceRequestAuctionLotPrice?: Maybe<Scalars['Int']>;
  serviceRequestObjects?: Maybe<ServiceRequestObjectsPaginatedList>;
  /** Стоимость услуги (инспекций и т.д) */
  serviceRequestPrice?: Maybe<Scalars['Int']>;
  /** Список заявок на доп услуги */
  serviceRequests?: Maybe<ServiceRequestsPaginatedList>;
  /** Количество заявок на инспекцию */
  serviceRequestsCount?: Maybe<ServiceRequestCount>;
  serviceRequestTypeParams?: Maybe<Array<ServiceRequestTypeParam>>;
  serviceRequestTypes?: Maybe<Array<TypeOfServiceRequest>>;
  /** Получить статистику на постановку в план. */
  statisticCarInPlan: CarInPlantStatistic;
  statuses?: Maybe<Array<Status>>;
  /** Страны в которых есть склады */
  stockCountries?: Maybe<StockCountiesPaginatedList>;
  /** Список складов */
  stocks?: Maybe<StocksPaginatedList>;
  svhDeliveryAmbassadors?: Maybe<SvhDeliveryAmbassadorsPaginatedList>;
  svhDeliveryRequests?: Maybe<SvhDeliveryRequestsPaginatedList>;
  ticket?: Maybe<Ticket>;
  ticketDecisionsQuery?: Maybe<TicketDecisionsPaginatedList>;
  tickets?: Maybe<TicketsPaginatedList>;
  ticketsReasons?: Maybe<TicketsReasonsPaginatedList>;
  ticketsReportDownload?: Maybe<Scalars['String']>;
  ticketsStatistic?: Maybe<TicketStatistic>;
  ticketStatuses?: Maybe<Array<TicketStatus>>;
  /** Получить дополнительне отметки при работе с претензиями. */
  ticketSubTypes?: Maybe<Array<TypeOfTicketSub>>;
  ticketTypes?: Maybe<Array<TypeOfTicket>>;
  timeZones?: Maybe<Array<TimeZone>>;
  totalCustomsClearanceTime?: Maybe<TotalCustomsClearanceTime>;
  /** Данные со стоимость для транспортировки авто по городам */
  transportationData?: Maybe<Array<TransportationData>>;
  trip?: Maybe<Trip>;
  trips?: Maybe<TripsPaginatedList>;
  tripsCalendar?: Maybe<TripsCalendar>;
  undefinedPayments?: Maybe<UndefinedPaymentsPaginatedList>;
  /** Получить логи по объекту */
  unionLog?: Maybe<ClientUnionLogsPaginatedList>;
  userMenu?: Maybe<Array<PermissionMenuItem>>;
  users?: Maybe<UsersPaginatedList>;
  /** Список кораблей, судов */
  vessels?: Maybe<Array<Vessel>>;
  vesselTypes?: Maybe<Array<VesselTypeInfo>>;
  watchCommentTemplate?: Maybe<Array<WatchCommentTemplate>>;
  watchType?: Maybe<Array<TypeOfWatchCar>>;
  /** Список колес */
  wheel?: Maybe<WheelsPaginatedList>;
  /** Список колес для менеджера */
  wheelAll?: Maybe<WheelAllsPaginatedList>;
  /** Значения фильтра для списка колес */
  wheelFilter?: Maybe<WheelFilterValue>;
  /** Статистика колес для менеджера */
  wheelStatistic?: Maybe<WheelStatistic>;
  withoutMediaObjects?: Maybe<MediaObjectssPaginatedList>;
  yahooOwners?: Maybe<YahooOwnersPaginatedList>;
};


export type QueryAddresseesGroupToChatArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryAddresseesUsersToChatArgs = {
  first?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryAkebonoPackagesArgs = {
  filter?: Maybe<PackagesFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryAmbassadorsArgs = {
  byAgent?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryAuctionFeedbacksArgs = {
  auctionId: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryAuctionInspectionAuctionStatisticArgs = {
  dateFrom: Scalars['DateTime'];
  dateTo?: Maybe<Scalars['DateTime']>;
  requestTypeIds?: Maybe<Array<Scalars['Int']>>;
};


export type QueryAuctionInspectionUserStatisticArgs = {
  dateFrom: Scalars['DateTime'];
  dateTo?: Maybe<Scalars['DateTime']>;
  requestTypeIds?: Maybe<Array<Scalars['Int']>>;
};


export type QueryAuctionsArgs = {
  partName?: Maybe<Scalars['String']>;
};


export type QueryBrokerExcelTemplatesArgs = {
  broker?: Maybe<Scalars['Int']>;
};


export type QueryBrokersArgs = {
  first?: Maybe<Scalars['Int']>;
  forSbkts?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  partName?: Maybe<Scalars['String']>;
  withoutPb?: Maybe<Scalars['Boolean']>;
};


export type QueryCarTypesArgs = {
  forWorldWide?: Maybe<Scalars['Boolean']>;
};


export type QueryChatForOthersArgs = {
  chatId: Scalars['Int'];
};


export type QueryChatMessagesArgs = {
  chatId: Scalars['Int'];
  filter?: Maybe<ChatMessagessFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryChatsForOthersArgs = {
  filter?: Maybe<ChatsForOtherssFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryClientInvoiceCustomersArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryClientObjectArgs = {
  objectId: Scalars['Int'];
};


export type QueryClientObjectAttachmentsArgs = {
  filter?: Maybe<ClientObjectAttachmentsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryClientObjectByVinArgs = {
  vin: Scalars['String'];
};


export type QueryClientObjectDashboardArgs = {
  filter?: Maybe<ClientObjectDashboardFilter>;
};


export type QueryClientObjectDebtsArgs = {
  agentId?: Maybe<Scalars['Int']>;
  isAkebono?: Maybe<Scalars['Boolean']>;
  objectId: Scalars['Int'];
};


export type QueryClientObjectLogsArgs = {
  filter?: Maybe<ClientObjectLogsFilter>;
  first?: Maybe<Scalars['Int']>;
  objectId: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
};


export type QueryClientObjectQueueArgs = {
  first?: Maybe<Scalars['Int']>;
  objectId: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
};


export type QueryClientObjectResalesArgs = {
  filter?: Maybe<ObjectResalesFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryClientObjectsArgs = {
  filter?: Maybe<ClientObjectsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<ClientObjectsSort>;
};


export type QueryClientObjectsReportPaymentAkebonoAllowArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  partVin: Scalars['String'];
};


export type QueryClientObjectYearsArgs = {
  agentId?: Maybe<Scalars['Int']>;
};


export type QueryClientOwnerSearchArgs = {
  uuid: Scalars['String'];
};


export type QueryClientRecipientsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryContainerArgs = {
  id: Scalars['Int'];
};


export type QueryContainersArgs = {
  filter?: Maybe<ContainersFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryCountriesArgs = {
  filter?: Maybe<CountrysFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryCountUnreadChatMessagesArgs = {
  onlyClients?: Maybe<Scalars['Boolean']>;
  onlyTickets?: Maybe<Scalars['Boolean']>;
};


export type QueryCurrenciesArgs = {
  filter?: Maybe<CurrencyFilter>;
};


export type QueryCurrentPlanArgs = {
  date?: Maybe<Scalars['String']>;
};


export type QueryCurrentUserNotifyMessagesArgs = {
  onlyEcarjpBot?: Maybe<Scalars['Boolean']>;
};


export type QueryDiffEntitiesArgs = {
  filter?: Maybe<DiffEntityFilter>;
};


export type QueryDriversArgs = {
  carrierId?: Maybe<Scalars['Int']>;
};


export type QueryDzenPayRatesArgs = {
  bankId: Scalars['Int'];
  forCash?: Maybe<Scalars['Boolean']>;
  forMain?: Maybe<Scalars['Boolean']>;
  invoiceType?: Maybe<InvoiceCustomTypeEnum>;
};


export type QueryExchangeJobsArgs = {
  filter?: Maybe<ExchangeJobsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryExportTripsArgs = {
  filter?: Maybe<ExportTripsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<ExportTripsSort>;
};


export type QueryFeedbacksArgs = {
  filter?: Maybe<FeedbackssFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryFinanceReportArgs = {
  agentId?: Maybe<Scalars['Int']>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  objectId?: Maybe<Scalars['Int']>;
};


export type QueryFormalOwnerArgs = {
  id: Scalars['Int'];
};


export type QueryFormalOwnersArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  partName: Scalars['String'];
};


export type QueryGreenCornerManageCountersArgs = {
  filter?: Maybe<GreenCornerObjectFilter>;
};


export type QueryGreenCornerManageObjectsArgs = {
  filter?: Maybe<GreenCornerManageObjectsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<GreenCornerManageObjectsSort>;
};


export type QueryGreenCornerObjectsResaleStatArgs = {
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  topLimit?: Maybe<Scalars['Int']>;
};


export type QueryGreenCornerTgMediaArgs = {
  carId: Scalars['Int'];
};


export type QueryGreenCornerTgPostArgs = {
  id: Scalars['Int'];
};


export type QueryGreenCornerTgPostsArgs = {
  carId?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  status?: Maybe<Array<GreenCornerTgPostStatus>>;
};


export type QueryGreenCornerTgPreviewArgs = {
  body?: Maybe<Scalars['String']>;
  carId?: Maybe<Scalars['Int']>;
  mediaIds?: Maybe<Array<Scalars['Int']>>;
  templateId?: Maybe<Scalars['Int']>;
  vinOrId?: Maybe<Scalars['String']>;
};


export type QueryGreenCornerTgTemplateArgs = {
  id: Scalars['Int'];
};


export type QueryInvoiceCustomDzenPayListArgs = {
  filter?: Maybe<InvoiceCustomDzenPaysFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryInvoiceCustomDzenPayStatsArgs = {
  filter?: Maybe<InvoiceCustomDzenPayFilter>;
};


export type QueryInvoiceCustomPaymentAgentStatsArgs = {
  filter?: Maybe<InvoiceCustomDzenPayFilter>;
};


export type QueryInvoiceCustomsArgs = {
  ownerId: Scalars['Int'];
  partName?: Maybe<Scalars['String']>;
};


export type QueryInvoiceLogsArgs = {
  objectId: Scalars['Int'];
};


export type QueryInvoiceReportArgs = {
  filter?: Maybe<InvoiceCustomDzenPayFilter>;
};


export type QueryInvoicesSearchArgs = {
  filter?: Maybe<InvoicesSearchsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryInvoiceUpdateRequestsArgs = {
  invoiceId: Scalars['Int'];
};


export type QueryLogAgentEventsArgs = {
  filter?: Maybe<LogAgentEventsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryLogObjectEventsArgs = {
  objectId: Scalars['Int'];
};


export type QueryLogsArgs = {
  filter?: Maybe<LogsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryLogsUserRequestsArgs = {
  filter?: Maybe<LogsUserRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryLogsUserRequestTypesArgs = {
  user?: Maybe<Scalars['Int']>;
};


export type QueryMakerColorsArgs = {
  makerId?: Maybe<Scalars['Int']>;
};


export type QueryMarksArgs = {
  makerId: Scalars['Int'];
};


export type QueryMasterAccountsClientsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  partName?: Maybe<Scalars['String']>;
};


export type QueryMediaStatisticsArgs = {
  filter?: Maybe<MediaObjectsFilter>;
  mediaType: MediaTypeEnum;
};


export type QueryModelsArgs = {
  markId: Scalars['Int'];
  vin?: Maybe<Scalars['String']>;
};


export type QueryNavisScheduleArgs = {
  comingSoon?: Maybe<Scalars['Boolean']>;
};


export type QueryNotificationLogsArgs = {
  filter?: Maybe<NotificationLogsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryObjectActivitiesArgs = {
  filter?: Maybe<ObjectActivitysFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<ObjectActivitysSort>;
};


export type QueryOperationalObjectsArgs = {
  filter?: Maybe<OperationalObjectsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryOrganizationsArgs = {
  forTickets?: Maybe<Scalars['Boolean']>;
};


export type QueryOwnerArgs = {
  id: Scalars['Int'];
};


export type QueryOwnersArgs = {
  filter?: Maybe<OwnersFilter>;
  first?: Maybe<Scalars['Int']>;
  fullSearch?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  partName: Scalars['String'];
};


export type QueryP2pAdminBuyRequestArgs = {
  id: Scalars['Int'];
};


export type QueryP2pAdminBuyRequestsArgs = {
  filter?: Maybe<P2pAdminBuyRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pAdminDealArgs = {
  id: Scalars['Int'];
};


export type QueryP2pAdminDealsArgs = {
  filter?: Maybe<P2pAdminDealsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pAdminOfferArgs = {
  id: Scalars['Int'];
};


export type QueryP2pAdminOffersArgs = {
  filter?: Maybe<P2pAdminOffersFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pAdminRequestsArgs = {
  filter?: Maybe<P2pAdminRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pBuyRequestArgs = {
  id: Scalars['Int'];
};


export type QueryP2pBuyRequestsArgs = {
  amountFrom?: Maybe<Scalars['Int']>;
  amountTo?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
  rateFrom?: Maybe<Scalars['Float']>;
  rateTo?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['String']>;
};


export type QueryP2pCompletedDealsCountArgs = {
  days?: Maybe<Scalars['Int']>;
};


export type QueryP2pDealArgs = {
  id: Scalars['Int'];
};


export type QueryP2pDealReportDownloadArgs = {
  id: Scalars['Int'];
};


export type QueryP2pMyBuyRequestArgs = {
  id: Scalars['Int'];
};


export type QueryP2pMyBuyRequestsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pMyDealsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pMyOfferArgs = {
  id: Scalars['Int'];
};


export type QueryP2pMyOffersArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pMyRequestsArgs = {
  filter?: Maybe<P2pMyRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryP2pOfferArgs = {
  id: Scalars['Int'];
};


export type QueryP2pOffersArgs = {
  amountFrom?: Maybe<Scalars['Int']>;
  amountTo?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
  rateFrom?: Maybe<Scalars['Float']>;
  rateTo?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['String']>;
};


export type QueryPalletArgs = {
  filter?: Maybe<PalletsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryPaymentsHistoryArgs = {
  agentId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
};


export type QueryPlanArgs = {
  id: Scalars['Int'];
};


export type QueryPlansArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryPortsArgs = {
  typeId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};


export type QueryPriceLevelArgs = {
  objectId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};


export type QueryQrPaymentAvailabilityArgs = {
  objectIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};


export type QueryReportsArgs = {
  filter?: Maybe<ReportsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<ReportsSort>;
};


export type QueryReportTypesArgs = {
  filter?: Maybe<ReportTypeFilter>;
};


export type QuerySawTypesArgs = {
  chassisTypeId?: Maybe<Scalars['Int']>;
  objectTypeId?: Maybe<Scalars['Int']>;
};


export type QuerySbktsBrokerStatisticArgs = {
  date: Scalars['String'];
};


export type QuerySbktsPlanStatisticArgs = {
  brokers?: Maybe<Array<Scalars['Int']>>;
  date: Scalars['String'];
  dateTo: Scalars['String'];
};


export type QuerySbktsRequestArgs = {
  id: Scalars['Int'];
};


export type QuerySbktsRequestsArgs = {
  filter?: Maybe<SbktsRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<SbktsRequestsSort>;
};


export type QueryScrapObjectsArgs = {
  first?: Maybe<Scalars['Int']>;
  makerId?: Maybe<Scalars['Int']>;
  markId?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['String']>;
};


export type QueryScrapTypeDescriptionsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryScrapTypesArgs = {
  isDeleted?: Maybe<Scalars['Boolean']>;
  objectId?: Maybe<Scalars['Int']>;
};


export type QuerySeaCarriersArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QuerySearchObjectsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search: Scalars['String'];
};


export type QuerySectorsArgs = {
  stockId: Scalars['Int'];
};


export type QuerySenderAgentsSearchArgs = {
  filter?: Maybe<OwnerAgentsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QuerySendersArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  partName?: Maybe<Scalars['String']>;
};


export type QueryServiceRequestArgs = {
  requestId: Scalars['Int'];
};


export type QueryServiceRequestAuctionLotByUserArgs = {
  lotId: Scalars['String'];
  lotSource: Scalars['String'];
  lotSubgroup: Scalars['String'];
};


export type QueryServiceRequestAuctionLotPriceArgs = {
  lotId: Scalars['String'];
  lotSource: Scalars['String'];
  lotSubgroup: Scalars['String'];
  type?: Maybe<Scalars['Int']>;
};


export type QueryServiceRequestObjectsArgs = {
  filter?: Maybe<ServiceRequestObjectsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<ServiceRequestObjectsSort>;
};


export type QueryServiceRequestPriceArgs = {
  type: Scalars['Int'];
};


export type QueryServiceRequestsArgs = {
  filter?: Maybe<ServiceRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<ServiceRequestsSort>;
};


export type QueryServiceRequestTypeParamsArgs = {
  makerId?: Maybe<Scalars['Int']>;
  markId?: Maybe<Scalars['Int']>;
  requestTypeId: Scalars['Int'];
};


export type QueryServiceRequestTypesArgs = {
  isAucInspection?: Maybe<Scalars['Boolean']>;
  objectId?: Maybe<Scalars['Int']>;
};


export type QueryStatisticCarInPlanArgs = {
  byAuctionId?: Maybe<Scalars['Int']>;
  byDate?: Maybe<Scalars['DateTime']>;
  dateFrom: Scalars['DateTime'];
  dateTo?: Maybe<Scalars['DateTime']>;
  statisticBy: StatisticTypeEnum;
};


export type QueryStatusesArgs = {
  type: TypeOfStatusEnum;
};


export type QueryStockCountriesArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryStocksArgs = {
  filter?: Maybe<StocksFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  partName?: Maybe<Scalars['String']>;
};


export type QuerySvhDeliveryAmbassadorsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  partName?: Maybe<Scalars['String']>;
};


export type QuerySvhDeliveryRequestsArgs = {
  filter?: Maybe<SvhDeliveryRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<SvhDeliveryRequestsSort>;
};


export type QueryTicketArgs = {
  id: Scalars['Int'];
};


export type QueryTicketDecisionsQueryArgs = {
  filter?: Maybe<TicketDecisionsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryTicketsArgs = {
  filter?: Maybe<TicketsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<TicketsSort>;
};


export type QueryTicketsReasonsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryTicketsReportDownloadArgs = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
};


export type QueryTripArgs = {
  id: Scalars['Int'];
};


export type QueryTripsArgs = {
  filter?: Maybe<TripsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<TripsSort>;
};


export type QueryUndefinedPaymentsArgs = {
  filter?: Maybe<UndefinedPaymentsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<UndefinedPaymentsSort>;
};


export type QueryUnionLogArgs = {
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  first?: Maybe<Scalars['Int']>;
  objectId: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
};


export type QueryUserMenuArgs = {
  permissions?: Maybe<Array<Scalars['String']>>;
};


export type QueryUsersArgs = {
  filter?: Maybe<UsersFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryVesselsArgs = {
  all?: Maybe<Scalars['Boolean']>;
  forTickets?: Maybe<Scalars['Boolean']>;
  isExport?: Maybe<Scalars['Boolean']>;
  typeId?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};


export type QueryVesselTypesArgs = {
  forWorldWide?: Maybe<Scalars['Boolean']>;
};


export type QueryWheelArgs = {
  filter?: Maybe<WheelsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryWheelAllArgs = {
  filter?: Maybe<WheelAllsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryWithoutMediaObjectsArgs = {
  filter?: Maybe<MediaObjectssFilter>;
  first?: Maybe<Scalars['Int']>;
  mediaType: MediaTypeEnum;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<MediaObjectssSort>;
};


export type QueryYahooOwnersArgs = {
  first?: Maybe<Scalars['Int']>;
  idList?: Maybe<Array<Scalars['Int']>>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

export type Plan = {
  __typename?: 'Plan';
  /** К погрузке */
  activeObjectsCount?: Maybe<Scalars['Int']>;
  addToTripTitle?: Maybe<Scalars['String']>;
  /** Контейнеры на судне */
  containers?: Maybe<Array<Container>>;
  countCars?: Maybe<Scalars['Int']>;
  countCarsPrimbroker?: Maybe<Scalars['Int']>;
  countObjects?: Maybe<Scalars['Int']>;
  countOcrObjects?: Maybe<Scalars['Int']>;
  countSaws?: Maybe<Scalars['Int']>;
  /** Всего на судне */
  countTotal?: Maybe<Scalars['Int']>;
  customsAt?: Maybe<Scalars['DateTime']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  driveFrom?: Maybe<Scalars['DateTime']>;
  drivePaused?: Maybe<Scalars['Boolean']>;
  driveTo?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  loadingFinishedAt?: Maybe<Scalars['DateTime']>;
  loadingFinishedBy?: Maybe<User>;
  name?: Maybe<Scalars['String']>;
  nextContractNumber?: Maybe<Scalars['Int']>;
  /** Сгон со складов */
  notDeliveredObjectsCount?: Maybe<Scalars['Int']>;
  /** кол-во объектов вне судна */
  notLoadingObjectsCount?: Maybe<Scalars['Int']>;
  objects?: Maybe<Array<ObjectOfServices>>;
  portFrom?: Maybe<Port>;
  simpleTitle?: Maybe<Scalars['String']>;
  stockFrom?: Maybe<Stock>;
  trip?: Maybe<Trip>;
  /** Ждем в порт */
  waitObjectsInPortCount?: Maybe<Scalars['Int']>;
};


export type PlanActiveObjectsCountArgs = {
  isAkebono?: Maybe<Scalars['Boolean']>;
};


export type PlanCountTotalArgs = {
  completed?: Maybe<Scalars['Boolean']>;
};


export type PlanNotDeliveredObjectsCountArgs = {
  isAkebono?: Maybe<Scalars['Boolean']>;
};


export type PlanWaitObjectsInPortCountArgs = {
  isAkebono?: Maybe<Scalars['Boolean']>;
};

export type Container = {
  __typename?: 'Container';
  arrivalDate?: Maybe<Scalars['DateTime']>;
  /** Можно ли поставить объекты на данный рейс */
  canAddToPlan?: Maybe<AddToPlanAttention>;
  carrier?: Maybe<Carrier>;
  containerType?: Maybe<TypeOfContainer>;
  countObjects?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfLoadingAt?: Maybe<Scalars['DateTime']>;
  driver?: Maybe<Driver>;
  events?: Maybe<Array<Maybe<ContainerEvent>>>;
  files?: Maybe<Array<S3File>>;
  forwarder?: Maybe<Forwarder>;
  freightType?: Maybe<TypeOfFreight>;
  id?: Maybe<Scalars['Int']>;
  insurancePolicy?: Maybe<Scalars['String']>;
  /** Можно ли выгрузить в страну */
  isCanUnloading?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  objects?: Maybe<Array<ObjectOfServices>>;
  seaCarrier?: Maybe<SeaCarrier>;
  sendedAt?: Maybe<Scalars['DateTime']>;
  /** Сотрудники ваннинга, которые грузили объекты в контейнер */
  vanningUsers?: Maybe<Array<User>>;
};


export type ContainerCanAddToPlanArgs = {
  planId: Scalars['Int'];
};

export type AddToPlanAttention = {
  __typename?: 'AddToPlanAttention';
  reason?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['Boolean']>;
};

export type Carrier = {
  __typename?: 'Carrier';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type TypeOfContainer = {
  __typename?: 'TypeOfContainer';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Driver = {
  __typename?: 'Driver';
  carrier?: Maybe<Carrier>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Vehicle>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentKm?: Maybe<VehicleKm>;
  driver?: Maybe<Driver>;
  employees?: Maybe<Array<Maybe<User>>>;
  etcCard?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<S3File>>>;
  /**
   * Номер топливной карты (устарело, используйте fuelCards)
   * @deprecated Deprecated. Use fuelCards instead.
   */
  fuelCard?: Maybe<Scalars['String']>;
  /** Номера топливных карт */
  fuelCards?: Maybe<Array<Maybe<Scalars['String']>>>;
  fuelTankVolume?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  maker?: Maybe<Maker>;
  mark?: Maybe<Mark>;
  name?: Maybe<Scalars['String']>;
  nameShort?: Maybe<Scalars['String']>;
  plate?: Maybe<Scalars['String']>;
  technicalInspectionExpirationDate?: Maybe<Scalars['String']>;
  useType?: Maybe<TypeOfUseVehicle>;
  vin?: Maybe<Scalars['String']>;
};

export type VehicleKm = {
  __typename?: 'VehicleKm';
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<Maybe<S3File>>>;
  id?: Maybe<Scalars['Int']>;
  km?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  vehicle?: Maybe<Vehicle>;
};

export type S3File = {
  __typename?: 'S3File';
  /** Base64 файл */
  binaryBase64?: Maybe<Scalars['String']>;
  /** Ссылка через клаудфронт */
  cloudFrontPath?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Состояние файлов для файлов таможни */
  customDocumentStatus?: Maybe<FileCustomDocumentStatusEnum>;
  /** CDN c учётом разрешения файла и бакета (для старых файлов) */
  fullPathByExtension?: Maybe<Scalars['String']>;
  /** Ссылка на файл с учётом бакета */
  fullPathForFile?: Maybe<Scalars['String']>;
  /** Ссылка через бакет на прямую */
  fullPathForFileWithoutCdn?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** Путь в бакете */
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<UserShortInfo>;
};

/** Статусы загрузки файлов для таможни */
export enum FileCustomDocumentStatusEnum {
  /** Подтвержден */
  Accepted = 'ACCEPTED',
  /** Новый файл */
  New = 'NEW',
  /** Не изменялся */
  NotChanged = 'NOT_CHANGED'
}

export type UserShortInfo = {
  __typename?: 'UserShortInfo';
  id?: Maybe<Scalars['Int']>;
  /** Дата и время торгов */
  isClient?: Maybe<Scalars['Boolean']>;
  isStaff?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  absences?: Maybe<Array<Maybe<EmployeeAbsence>>>;
  agent?: Maybe<Agent>;
  allowedMediaTypes?: Maybe<Array<MediaTypeEnum>>;
  applicationModules?: Maybe<Array<Module>>;
  /** Роуты внутри приложения */
  applicationRoutes?: Maybe<Array<Maybe<ApplicationRoute>>>;
  auctionGroups?: Maybe<Array<AuctionGroup>>;
  balance?: Maybe<Array<Money>>;
  broker?: Maybe<Broker>;
  carrierDriver?: Maybe<Driver>;
  chatGroups?: Maybe<Array<ChatGroup>>;
  commentCssClass?: Maybe<Scalars['String']>;
  debtUpdatedDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  digests?: Maybe<Array<Digest>>;
  documents?: Maybe<Array<Maybe<EmployeeDocument>>>;
  driverMode?: Maybe<DriverMode>;
  emails?: Maybe<Array<UserEmail>>;
  employeeAssets?: Maybe<Array<Maybe<EmployeeAsset>>>;
  employment?: Maybe<Employment>;
  employments?: Maybe<Array<Maybe<Employment>>>;
  expireAccount?: Maybe<Scalars['String']>;
  expireToken?: Maybe<Scalars['Int']>;
  freightPaymentCountry?: Maybe<Country>;
  guid1C?: Maybe<Scalars['String']>;
  hasPermission?: Maybe<Scalars['Boolean']>;
  hasRole?: Maybe<Scalars['Boolean']>;
  homePageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isAcceptCondition?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  /** Наличие подключенного телеграмм бота akebonobot */
  isBotAkebono?: Maybe<Scalars['Boolean']>;
  /** Наличие подключенного телеграмм бота cartrackbot */
  isBotCarsTrack?: Maybe<Scalars['Boolean']>;
  /** Наличие подключенного телеграмм бота ecarjpbot */
  isBotEcarJpAuc?: Maybe<Scalars['Boolean']>;
  isBroker?: Maybe<Scalars['Boolean']>;
  isChangePassword?: Maybe<Scalars['Boolean']>;
  isClient?: Maybe<Scalars['Boolean']>;
  /** Политика со скрытыми финансами */
  isHiddenFinance?: Maybe<Scalars['Boolean']>;
  isMasquerade?: Maybe<Scalars['Boolean']>;
  isPermanent?: Maybe<Scalars['Boolean']>;
  isSender?: Maybe<Scalars['Boolean']>;
  /** Флаг для отображения\скрытия отчёта 1С */
  isShowReport?: Maybe<Scalars['Boolean']>;
  isStaff?: Maybe<Scalars['Boolean']>;
  isUpdateContact?: Maybe<Scalars['Boolean']>;
  laboratoryExpert?: Maybe<LaboratoryExpert>;
  language?: Maybe<LanguageEnum>;
  masqueradeUser?: Maybe<Scalars['Int']>;
  mobilePhone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  owner?: Maybe<Owner>;
  permissionGroups?: Maybe<Array<PermissionGroup>>;
  permissions?: Maybe<Array<Permission>>;
  ports?: Maybe<Array<Port>>;
  profile?: Maybe<UserProfile>;
  /** @deprecated Useless */
  reminders?: Maybe<Array<Reminder>>;
  requiredChangePassword?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UserRole>;
  roles?: Maybe<Array<UserRole>>;
  sender?: Maybe<Sender>;
  stocks?: Maybe<Array<Stock>>;
  systemCreatedAt?: Maybe<Scalars['DateTime']>;
  tickets?: Maybe<Array<Ticket>>;
  timeZone?: Maybe<TimeZone>;
  type?: Maybe<TypeOfUser>;
  username?: Maybe<Scalars['String']>;
  /** @deprecated reg_users_params removed; fields live on User / staff CRM. Compat resolve from RegUserModel. */
  userParameter?: Maybe<UserParameter>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  vessels?: Maybe<Array<Vessel>>;
};


export type UserApplicationRoutesArgs = {
  source: AppSourceEnum;
};


export type UserBalanceArgs = {
  isAkebono?: Maybe<Scalars['Boolean']>;
};


export type UserHasPermissionArgs = {
  code: Scalars['String'];
  componentName?: Maybe<Scalars['String']>;
  ignoreSuperPermission?: Maybe<Scalars['Boolean']>;
};


export type UserHasRoleArgs = {
  isBase: Scalars['Boolean'];
  role: RoleEnum;
};

/** Отсутствие сотрудника */
export type EmployeeAbsence = {
  __typename?: 'EmployeeAbsence';
  /** Тип отсутствия */
  absenceType?: Maybe<AbsenceType>;
  /** Кто согласовал отсутствие */
  approvedByUser?: Maybe<User>;
  /** Дата начала */
  dateFrom?: Maybe<Scalars['Date']>;
  /** Дата окончания */
  dateTo?: Maybe<Scalars['Date']>;
  /** Трудоустройство */
  employment?: Maybe<Employment>;
  /** ID записи отсутствия */
  id?: Maybe<Scalars['Int']>;
  /** Причина */
  reason?: Maybe<Scalars['String']>;
  /** Статус отсутствия */
  status?: Maybe<Scalars['String']>;
  /** Сотрудник */
  user?: Maybe<User>;
};

/** Тип отсутствия сотрудника */
export type AbsenceType = {
  __typename?: 'AbsenceType';
  /** Код */
  code?: Maybe<Scalars['String']>;
  /** ID типа отсутствия */
  id?: Maybe<Scalars['Int']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Статус (active/inactive) */
  status?: Maybe<Scalars['String']>;
};

/** Трудоустройство сотрудника */
export type Employment = {
  __typename?: 'Employment';
  /** Филиал */
  branch?: Maybe<Branch>;
  /** Организация */
  company?: Maybe<Organization>;
  /** Отдел */
  department?: Maybe<Department>;
  /** Табельный номер */
  employeeNumber?: Maybe<Scalars['String']>;
  /** Тип занятости (full_time, part_time и т.д.) */
  employmentType?: Maybe<Scalars['String']>;
  /** Дата найма */
  hireDate?: Maybe<Scalars['Date']>;
  /** История изменений трудоустройства */
  history?: Maybe<Array<Maybe<EmploymentHistory>>>;
  /** ID трудоустройства */
  id?: Maybe<Scalars['Int']>;
  /** Основное трудоустройство */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** Должность */
  position?: Maybe<Position>;
  /** Испытательный срок до */
  probationUntil?: Maybe<Scalars['Date']>;
  /** Статус трудоустройства */
  status?: Maybe<Scalars['String']>;
  /** Дата увольнения */
  terminationDate?: Maybe<Scalars['Date']>;
  /** Причина увольнения */
  terminationReason?: Maybe<Scalars['String']>;
  /** Сотрудник */
  user?: Maybe<User>;
  /** Рабочий email */
  workEmail?: Maybe<Scalars['String']>;
  /** Тип рабочего места (office/remote/hybrid) */
  workLocationType?: Maybe<Scalars['String']>;
  /** Рабочий телефон */
  workPhone?: Maybe<Scalars['String']>;
};

/** Филиал организации */
export type Branch = {
  __typename?: 'Branch';
  /** Адрес */
  address?: Maybe<Scalars['String']>;
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** Код филиала */
  code?: Maybe<Scalars['String']>;
  /** Организация */
  company?: Maybe<Organization>;
  /** Страна */
  country?: Maybe<Country>;
  /** Отделы филиала */
  departments?: Maybe<Array<Maybe<Department>>>;
  /** ID филиала */
  id?: Maybe<Scalars['Int']>;
  /** Название филиала */
  name?: Maybe<Scalars['String']>;
  /** Статус (active/inactive) */
  status?: Maybe<Scalars['String']>;
  /** Часовой пояс */
  timezone?: Maybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  alfa2?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  engName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

/** Отдел организации */
export type Department = {
  __typename?: 'Department';
  /** Филиал */
  branch?: Maybe<Branch>;
  /** Дочерние отделы */
  children?: Maybe<Array<Maybe<Department>>>;
  /** Код отдела */
  code?: Maybe<Scalars['String']>;
  /** Организация */
  company?: Maybe<Organization>;
  /** ID отдела */
  id?: Maybe<Scalars['Int']>;
  /** Название отдела */
  name?: Maybe<Scalars['String']>;
  /** Родительский отдел */
  parent?: Maybe<Department>;
  /** Статус (active/inactive) */
  status?: Maybe<Scalars['String']>;
};

/** Запись истории трудоустройства */
export type EmploymentHistory = {
  __typename?: 'EmploymentHistory';
  /** Кто внёс изменение */
  changedByUser?: Maybe<User>;
  /** Дата создания записи */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Дата вступления в силу */
  effectiveAt?: Maybe<Scalars['DateTime']>;
  /** Трудоустройство */
  employment?: Maybe<Employment>;
  /** Тип события */
  eventType?: Maybe<Scalars['String']>;
  /** ID записи истории */
  id?: Maybe<Scalars['Int']>;
  /** Новые значения */
  newValues?: Maybe<Scalars['JSON']>;
  /** Предыдущие значения */
  oldValues?: Maybe<Scalars['JSON']>;
  /** Причина изменения */
  reason?: Maybe<Scalars['String']>;
  /** Сотрудник */
  user?: Maybe<User>;
};

/** Должность */
export type Position = {
  __typename?: 'Position';
  /** Код должности */
  code?: Maybe<Scalars['String']>;
  /** Организация */
  company?: Maybe<Organization>;
  /** Описание должности */
  description?: Maybe<Scalars['String']>;
  /** ID должности */
  id?: Maybe<Scalars['Int']>;
  /** Руководящая должность */
  isManager?: Maybe<Scalars['Boolean']>;
  /** Уровень должности */
  level?: Maybe<Scalars['Int']>;
  /** Название должности */
  name?: Maybe<Scalars['String']>;
  /** Статус (active/inactive) */
  status?: Maybe<Scalars['String']>;
};

export type Agent = {
  __typename?: 'Agent';
  emails?: Maybe<Array<Scalars['String']>>;
  /** Есть сделки перепродажи, требующие подтверждения */
  hasNotApprovedResales?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isAllowChangeCustomsPaymentType?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** Количество сделок перепродажи, требующих подтверждения */
  notApprovedResalesCount?: Maybe<Scalars['Int']>;
  phones?: Maybe<Array<Scalars['String']>>;
};

export enum MediaTypeEnum {
  AdditionalInvoiceCustom = 'ADDITIONAL_INVOICE_CUSTOM',
  AgentPassportAll = 'AGENT_PASSPORT_ALL',
  AkebonoUpForAuction = 'AKEBONO_UP_FOR_AUCTION',
  AucCopyDocs = 'AUC_COPY_DOCS',
  AucDocs = 'AUC_DOCS',
  AucMedia = 'AUC_MEDIA',
  AucMediaHidden = 'AUC_MEDIA_HIDDEN',
  AuctionAutoFee = 'AUCTION_AUTO_FEE',
  AuctionLoader = 'AUCTION_LOADER',
  AuctionLoading = 'AUCTION_LOADING',
  AuctionPaySheet = 'AUCTION_PAY_SHEET',
  AutoImportAcceptObject = 'AUTO_IMPORT_ACCEPT_OBJECT',
  AutoImportIssueObject = 'AUTO_IMPORT_ISSUE_OBJECT',
  AutoimportAfterDisassembly = 'AUTOIMPORT_AFTER_DISASSEMBLY',
  AutoimportBeforeDisassembly = 'AUTOIMPORT_BEFORE_DISASSEMBLY',
  AutoimportFastening = 'AUTOIMPORT_FASTENING',
  AutoimportParkingPass = 'AUTOIMPORT_PARKING_PASS',
  BarhatAcceptObject = 'BARHAT_ACCEPT_OBJECT',
  BarhatIssueObject = 'BARHAT_ISSUE_OBJECT',
  BeforeOutsideParking = 'BEFORE_OUTSIDE_PARKING',
  BrAgentBusinessCard = 'BR_AGENT_BUSINESS_CARD',
  BrAgentImages = 'BR_AGENT_IMAGES',
  BrAgentLogo = 'BR_AGENT_LOGO',
  BrokerImportExcels = 'BROKER_IMPORT_EXCELS',
  CarsAdMedia = 'CARS_AD_MEDIA',
  CertificateGlonassDocs = 'CERTIFICATE_GLONASS_DOCS',
  Chat = 'CHAT',
  Client = 'CLIENT',
  ClientBoardingPasses = 'CLIENT_BOARDING_PASSES',
  ClientCertificateFromHotel = 'CLIENT_CERTIFICATE_FROM_HOTEL',
  ClientExplanatory = 'CLIENT_EXPLANATORY',
  ClientExplanatoryNoDvfo = 'CLIENT_EXPLANATORY_NO_DVFO',
  ClientInvoiceDoc = 'CLIENT_INVOICE_DOC',
  ClientPassport = 'CLIENT_PASSPORT',
  ClientTempRegistration = 'CLIENT_TEMP_REGISTRATION',
  ClientVerificationTempRegistration = 'CLIENT_VERIFICATION_TEMP_REGISTRATION',
  ContainerBookedConfirm = 'CONTAINER_BOOKED_CONFIRM',
  ContainerInsurePolicy = 'CONTAINER_INSURE_POLICY',
  ContainerPhotos = 'CONTAINER_PHOTOS',
  ContainerUnloading = 'CONTAINER_UNLOADING',
  CustomInvoiceCorrection = 'CUSTOM_INVOICE_CORRECTION',
  CustomInvoiceDoc = 'CUSTOM_INVOICE_DOC',
  CustomInvoiceLogo = 'CUSTOM_INVOICE_LOGO',
  CustomPaymentDoc = 'CUSTOM_PAYMENT_DOC',
  DeliveryFromAuctionTroubles = 'DELIVERY_FROM_AUCTION_TROUBLES',
  DeliverySheet = 'DELIVERY_SHEET',
  DzenpayDocumentPack = 'DZENPAY_DOCUMENT_PACK',
  EnginePhoto = 'ENGINE_PHOTO',
  ExportBl = 'EXPORT_BL',
  ExportCertificate = 'EXPORT_CERTIFICATE',
  ExportDeclaration = 'EXPORT_DECLARATION',
  ExportInvoice = 'EXPORT_INVOICE',
  GasFilling = 'GAS_FILLING',
  GcNiceMedia = 'GC_NICE_MEDIA',
  GcStockVideo = 'GC_STOCK_VIDEO',
  GcThicknessMedia = 'GC_THICKNESS_MEDIA',
  GosuslugiProfileScreen = 'GOSUSLUGI_PROFILE_SCREEN',
  ImageToAct = 'IMAGE_TO_ACT',
  Inn = 'INN',
  InnLegalOwner = 'INN_LEGAL_OWNER',
  InnPdf = 'INN_PDF',
  Invoice = 'INVOICE',
  InvoiceCorrection = 'INVOICE_CORRECTION',
  InvoiceTransportCompany = 'INVOICE_TRANSPORT_COMPANY',
  IssueFromStockMedia = 'ISSUE_FROM_STOCK_MEDIA',
  Loading = 'LOADING',
  LoadingAtSvh = 'LOADING_AT_SVH',
  LoadingOnTruck = 'LOADING_ON_TRUCK',
  MainInvoiceCustom = 'MAIN_INVOICE_CUSTOM',
  Maintenance = 'MAINTENANCE',
  ObjectAfterDeliveryFromAuction = 'OBJECT_AFTER_DELIVERY_FROM_AUCTION',
  ObjectAttachment = 'OBJECT_ATTACHMENT',
  ObjectBrokerPhotos = 'OBJECT_BROKER_PHOTOS',
  ObjectCatalyst = 'OBJECT_CATALYST',
  ObjectClientPassport = 'OBJECT_CLIENT_PASSPORT',
  ObjectCopyConsignment = 'OBJECT_COPY_CONSIGNMENT',
  ObjectElptsPhotos = 'OBJECT_ELPTS_PHOTOS',
  ObjectExplode = 'OBJECT_EXPLODE',
  ObjectGlonassContract = 'OBJECT_GLONASS_CONTRACT',
  ObjectImage360Internal = 'OBJECT_IMAGE360_INTERNAL',
  ObjectInvoiceChanged = 'OBJECT_INVOICE_CHANGED',
  ObjectInvoiceForShippingKaitai = 'OBJECT_INVOICE_FOR_SHIPPING_KAITAI',
  ObjectInvoiceOriginal = 'OBJECT_INVOICE_ORIGINAL',
  ObjectKaitaiPhoto = 'OBJECT_KAITAI_PHOTO',
  ObjectLotScan = 'OBJECT_LOT_SCAN',
  ObjectOldElptsPhotos = 'OBJECT_OLD_ELPTS_PHOTOS',
  ObjectOldSbktsPdf = 'OBJECT_OLD_SBKTS_PDF',
  ObjectSbktsBackViewPhotos = 'OBJECT_SBKTS_BACK_VIEW_PHOTOS',
  ObjectSbktsForwardViewPhotos = 'OBJECT_SBKTS_FORWARD_VIEW_PHOTOS',
  ObjectSbktsNameplatePhotos = 'OBJECT_SBKTS_NAMEPLATE_PHOTOS',
  ObjectSbktsPanelPhotos = 'OBJECT_SBKTS_PANEL_PHOTOS',
  ObjectSbktsPdf = 'OBJECT_SBKTS_PDF',
  ObjectSbktsPhotos = 'OBJECT_SBKTS_PHOTOS',
  ObjectTpoPhotos = 'OBJECT_TPO_PHOTOS',
  ObjectWheelStockman = 'OBJECT_WHEEL_STOCKMAN',
  Odometer = 'ODOMETER',
  OgrnLegalOwner = 'OGRN_LEGAL_OWNER',
  OutsideParking = 'OUTSIDE_PARKING',
  PartnerOffice = 'PARTNER_OFFICE',
  PassengerCustomsDeclaration = 'PASSENGER_CUSTOMS_DECLARATION',
  PassportCommonSheet = 'PASSPORT_COMMON_SHEET',
  PassportMainSheet = 'PASSPORT_MAIN_SHEET',
  PassportRegistrationSheet = 'PASSPORT_REGISTRATION_SHEET',
  PaySheetReturn = 'PAY_SHEET_RETURN',
  PaymentAdditionalInvoiceCustom = 'PAYMENT_ADDITIONAL_INVOICE_CUSTOM',
  PaymentAgentInvoiceQr = 'PAYMENT_AGENT_INVOICE_QR',
  PaymentCustomBroker = 'PAYMENT_CUSTOM_BROKER',
  PaymentCustomStock = 'PAYMENT_CUSTOM_STOCK',
  PaymentInvoiceTransportCompany = 'PAYMENT_INVOICE_TRANSPORT_COMPANY',
  PaymentMainInvoiceCustom = 'PAYMENT_MAIN_INVOICE_CUSTOM',
  PaymentNotary = 'PAYMENT_NOTARY',
  PaymentOverstaying = 'PAYMENT_OVERSTAYING',
  PaymentTransferFromCustom = 'PAYMENT_TRANSFER_FROM_CUSTOM',
  PbAgreementBlank = 'PB_AGREEMENT_BLANK',
  PbAgreementClientPhoto = 'PB_AGREEMENT_CLIENT_PHOTO',
  PbAgreementClientSigned = 'PB_AGREEMENT_CLIENT_SIGNED',
  PbProformaInvoice = 'PB_PROFORMA_INVOICE',
  PdfAct = 'PDF_ACT',
  PreDeliveryOrder = 'PRE_DELIVERY_ORDER',
  PurchaseReceipt = 'PURCHASE_RECEIPT',
  PurchaseReceiptPdf = 'PURCHASE_RECEIPT_PDF',
  QrSheet = 'QR_SHEET',
  ReceiptOfMoneyToFtsFile = 'RECEIPT_OF_MONEY_TO_FTS_FILE',
  RecipientsDocs = 'RECIPIENTS_DOCS',
  RoadManifest = 'ROAD_MANIFEST',
  RussianStock = 'RUSSIAN_STOCK',
  RussianWatchMedia = 'RUSSIAN_WATCH_MEDIA',
  SbktsDocuments = 'SBKTS_DOCUMENTS',
  SbktsDocxFizik = 'SBKTS_DOCX_FIZIK',
  SbktsDocxUrik = 'SBKTS_DOCX_URIK',
  SenderDocument = 'SENDER_DOCUMENT',
  ServiceRequestCompleted = 'SERVICE_REQUEST_COMPLETED',
  StockMedia = 'STOCK_MEDIA',
  SupplierInvoice = 'SUPPLIER_INVOICE',
  TripBoxPhotos = 'TRIP_BOX_PHOTOS',
  TripExportPayment = 'TRIP_EXPORT_PAYMENT',
  TsmReplace = 'TSM_REPLACE',
  UnavailableAct = 'UNAVAILABLE_ACT',
  Unloading = 'UNLOADING',
  UnloadingNavis = 'UNLOADING_NAVIS',
  UnloadingToTc = 'UNLOADING_TO_TC',
  UserContractScan = 'USER_CONTRACT_SCAN',
  UserDriverLicenseScan = 'USER_DRIVER_LICENSE_SCAN',
  UserInsuranceScan = 'USER_INSURANCE_SCAN',
  UserPassportScan = 'USER_PASSPORT_SCAN',
  UserProfilePhoto = 'USER_PROFILE_PHOTO',
  UserResidentCardScan = 'USER_RESIDENT_CARD_SCAN',
  UserResumeScan = 'USER_RESUME_SCAN',
  Vehicle = 'VEHICLE',
  WatchMedia = 'WATCH_MEDIA',
  WeighingAutoimport = 'WEIGHING_AUTOIMPORT',
  WorkerMedia = 'WORKER_MEDIA',
  WorldWideMedia = 'WORLD_WIDE_MEDIA'
}

export type Module = {
  __typename?: 'Module';
  applicationId?: Maybe<Scalars['Int']>;
  applicationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  moduleIcon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
  weightOrder?: Maybe<Scalars['Int']>;
};

export enum AppSourceEnum {
  AkbClientApp = 'akb_client_app',
  AkbStaffApp = 'akb_staff_app',
  EcarjpApp = 'ecarjp_app',
  Web = 'web',
  YahooClientApp = 'yahoo_client_app'
}

export type ApplicationRoute = {
  __typename?: 'ApplicationRoute';
  children?: Maybe<Array<ApplicationRoute>>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<ApplicationRouteSettings>;
  url?: Maybe<Scalars['String']>;
};

export type ApplicationRouteSettings = {
  __typename?: 'ApplicationRouteSettings';
  animation?: Maybe<ApplicationRouteAnimationSettings>;
  custom?: Maybe<Scalars['JSON']>;
  layout?: Maybe<ApplicationRouteLayoutSettings>;
  render?: Maybe<ApplicationRouteRenderSettings>;
  visibility?: Maybe<ApplicationRouteVisibilitySettings>;
};

export type ApplicationRouteAnimationSettings = {
  __typename?: 'ApplicationRouteAnimationSettings';
  delay?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ApplicationRouteLayoutSettings = {
  __typename?: 'ApplicationRouteLayoutSettings';
  alignment?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['String']>;
  columns?: Maybe<Scalars['Int']>;
  direction?: Maybe<Scalars['String']>;
  gap?: Maybe<Scalars['Float']>;
};

export type ApplicationRouteRenderSettings = {
  __typename?: 'ApplicationRouteRenderSettings';
  backgroundColor?: Maybe<Scalars['String']>;
  borderColor?: Maybe<Scalars['String']>;
  borderRadius?: Maybe<Scalars['Float']>;
  borderWidth?: Maybe<Scalars['Float']>;
  fontSize?: Maybe<Scalars['Float']>;
  fontWeight?: Maybe<Scalars['String']>;
  gradient?: Maybe<ApplicationRouteGradient>;
  height?: Maybe<Scalars['Float']>;
  iconColor?: Maybe<Scalars['String']>;
  margin?: Maybe<ApplicationRouteSpacing>;
  opacity?: Maybe<Scalars['Float']>;
  padding?: Maybe<ApplicationRouteSpacing>;
  shadow?: Maybe<ApplicationRouteShadow>;
  size?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type ApplicationRouteGradient = {
  __typename?: 'ApplicationRouteGradient';
  angle?: Maybe<Scalars['Float']>;
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
  stops?: Maybe<Array<Maybe<Scalars['Float']>>>;
  type?: Maybe<Scalars['String']>;
};

export type ApplicationRouteSpacing = {
  __typename?: 'ApplicationRouteSpacing';
  bottom?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
  top?: Maybe<Scalars['Float']>;
};

export type ApplicationRouteShadow = {
  __typename?: 'ApplicationRouteShadow';
  blur?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
  spread?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type ApplicationRouteVisibilitySettings = {
  __typename?: 'ApplicationRouteVisibilitySettings';
  badge?: Maybe<ApplicationRouteBadge>;
  disabled?: Maybe<Scalars['Boolean']>;
  showIcon?: Maybe<Scalars['Boolean']>;
  showLabel?: Maybe<Scalars['Boolean']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type ApplicationRouteBadge = {
  __typename?: 'ApplicationRouteBadge';
  backgroundColor?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type AuctionGroup = {
  __typename?: 'AuctionGroup';
  createdAt?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMenu?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  queryAlias?: Maybe<Scalars['String']>;
  stocks?: Maybe<Array<Stock>>;
};

export type Stock = {
  __typename?: 'Stock';
  /** Список активных секторов */
  activeSectors?: Maybe<Array<Sector>>;
  /** Вместимость */
  capacity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** Склад в Отару */
  inOtaru?: Maybe<Scalars['Boolean']>;
  /** Склад в Томакомай */
  inTomakomai?: Maybe<Scalars['Boolean']>;
  /** Склад в Тояме */
  inToyama?: Maybe<Scalars['Boolean']>;
  /** Склад аукциона */
  isAuction?: Maybe<Scalars['Boolean']>;
  /** Склад в ЯП */
  isJapan?: Maybe<Scalars['Boolean']>;
  /** Склад порта */
  isPort?: Maybe<Scalars['Boolean']>;
  /** Хранение на складе платное */
  isStoragePaid?: Maybe<Scalars['Boolean']>;
  /** Склад с которых можно делать выдачу */
  issueAllow?: Maybe<Scalars['Boolean']>;
  /** Склад судна */
  isVessel?: Maybe<Scalars['Boolean']>;
  /** Виртуальный склад */
  isVirtual?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
  /** Флаг отправки уведомления о прибытии на склад клиенту */
  notificationClient?: Maybe<Scalars['Boolean']>;
  /** Флаг отправки уведомления о прибытии на склад менеджеру */
  notificationManager?: Maybe<Scalars['Boolean']>;
  /** Список всех секторов */
  sectors?: Maybe<Array<Sector>>;
  /** Стоимость хранения */
  storageCost?: Maybe<Scalars['Int']>;
  /** Количество дней бесплатного хранения */
  storageFreeDays?: Maybe<Scalars['Int']>;
  /** Кол-во объектов в секторе */
  totalCars?: Maybe<Scalars['Int']>;
};

export type Sector = {
  __typename?: 'Sector';
  /** Вместимость */
  capacity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
  /** Порядок вывода секторов в списках (сортировка) */
  order?: Maybe<Scalars['Int']>;
  /** Кол-во объектов в секторе */
  totalCars?: Maybe<Scalars['Int']>;
};

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
};

export type Currency = {
  __typename?: 'Currency';
  code?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  internationalSymbol?: Maybe<Scalars['String']>;
  isoCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<CurrencyEnum>;
};

export enum CurrencyEnum {
  Aed = 'AED',
  Cny = 'CNY',
  Eur = 'EUR',
  Jpy = 'JPY',
  Mnt = 'MNT',
  Php = 'PHP',
  Rub = 'RUB',
  Sgd = 'SGD',
  Usd = 'USD'
}

export type Broker = {
  __typename?: 'Broker';
  engName?: Maybe<Scalars['String']>;
  fullNameAgent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
  powerOfAttorneyInfo?: Maybe<Scalars['String']>;
};

export type ChatGroup = {
  __typename?: 'ChatGroup';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  users?: Maybe<Array<UserShortInfo>>;
};

export type Digest = {
  __typename?: 'Digest';
  name?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
};

/** Документ сотрудника */
export type EmployeeDocument = {
  __typename?: 'EmployeeDocument';
  /** Страна выдачи */
  country?: Maybe<Country>;
  /** Тип документа */
  documentType?: Maybe<DocumentType>;
  /** Срок действия */
  expiresAt?: Maybe<Scalars['Date']>;
  /** Файл документа */
  file?: Maybe<S3File>;
  /** ID документа */
  id?: Maybe<Scalars['Int']>;
  /** Дата выдачи */
  issuedAt?: Maybe<Scalars['Date']>;
  /** Кем выдан */
  issuedBy?: Maybe<Scalars['String']>;
  /** Заметки */
  notes?: Maybe<Scalars['String']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']>;
  /** Статус документа */
  status?: Maybe<Scalars['String']>;
  /** Сотрудник */
  user?: Maybe<User>;
};

/** Тип документа сотрудника */
export type DocumentType = {
  __typename?: 'DocumentType';
  /** Код типа */
  code?: Maybe<Scalars['String']>;
  /** За сколько дней уведомлять об истечении */
  expiryNotifyDays?: Maybe<Scalars['Int']>;
  /** ID типа документа */
  id?: Maybe<Scalars['Int']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Требуется срок действия */
  requiresExpiration?: Maybe<Scalars['Boolean']>;
  /** Требуется номер документа */
  requiresNumber?: Maybe<Scalars['Boolean']>;
  /** Статус (active/inactive) */
  status?: Maybe<Scalars['String']>;
};

export type DriverMode = {
  __typename?: 'DriverMode';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type UserEmail = {
  __typename?: 'UserEmail';
  dateConfirm?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isConfirm?: Maybe<Scalars['Boolean']>;
  useForChatNotifications?: Maybe<Scalars['Boolean']>;
};

/** Выдача имущества сотруднику */
export type EmployeeAsset = {
  __typename?: 'EmployeeAsset';
  /** Имущество */
  asset?: Maybe<Asset>;
  /** Состояние при выдаче */
  conditionOnIssue?: Maybe<Scalars['String']>;
  /** Состояние при возврате */
  conditionOnReturn?: Maybe<Scalars['String']>;
  /** Дата создания записи */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** ID выдачи */
  id?: Maybe<Scalars['Int']>;
  /** Дата выдачи */
  issuedAt?: Maybe<Scalars['Date']>;
  /** Кто выдал */
  issuedBy?: Maybe<User>;
  /** Заметки (SIM, номер и т.п.) */
  notes?: Maybe<Scalars['String']>;
  /** Дата возврата */
  returnedAt?: Maybe<Scalars['Date']>;
  /** Дата обновления записи */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Сотрудник */
  user?: Maybe<User>;
};

/** Оборудование / имущество */
export type Asset = {
  __typename?: 'Asset';
  /** Текущая выдача */
  activeAssignment?: Maybe<EmployeeAsset>;
  /** История выдач */
  assignments?: Maybe<Array<Maybe<EmployeeAsset>>>;
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Описание (SIM, номер телефона и т.п.) */
  description?: Maybe<Scalars['String']>;
  /** ID имущества */
  id?: Maybe<Scalars['Int']>;
  /** Инвентарный номер */
  inventoryNumber?: Maybe<Scalars['String']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Серийный номер */
  serialNumber?: Maybe<Scalars['String']>;
  /** Статус: available|assigned|repair|lost|retired */
  status?: Maybe<Scalars['String']>;
  /** Тип (laptop, phone, sim, monitor, other) */
  type?: Maybe<Scalars['String']>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum RoleEnum {
  AkebonoBukhgalter = 'AkebonoBukhgalter',
  AkebonoDokumentoved = 'AkebonoDokumentoved',
  AkebonoMenedzher = 'AkebonoMenedzher',
  AkebonoOtpravkaPoMiru = 'AkebonoOtpravkaPoMiru',
  AkebonoRazbor = 'AkebonoRazbor',
  AkebonoRossiya = 'AkebonoRossiya',
  AkebonoShipping = 'AkebonoShipping',
  AkebonoSklad = 'AkebonoSklad',
  AkebonoSkladMedia = 'AkebonoSkladMedia',
  AkebonoStarshijRazborshhik = 'AkebonoStarshijRazborshhik',
  AkebonoYaponskijOfis = 'AkebonoYaponskijOfis',
  Auktsionist = 'Auktsionist',
  BlNaEhksportnjkhRejsakh = 'BLNaEhksportnjkhRejsakh',
  Broker = 'Broker',
  Bukhgaltera = 'Bukhgaltera',
  BukhgalterPrimbroker = 'BukhgalterPrimbroker',
  ChatGruppaPrimbroker = 'ChatGruppaPrimbroker',
  DannjeAuktsionaVKartochkeObiekta = 'DannjeAuktsionaVKartochkeObiekta',
  Deklarant = 'Deklarant',
  Direktor = 'Direktor',
  DobavlenieKommentariyaKontragentu = 'DobavlenieKommentariyaKontragentu',
  DosmotrPrimbroker = 'DosmotrPrimbroker',
  DostupKDokumentamObiekta = 'DostupKDokumentamObiekta',
  DostupKProsmotryuPretenzij = 'DostupKProsmotryuPretenzij',
  DostupOrganizatsiiVlk = 'DostupOrganizatsiiVLK',
  EhkipazhSudna = 'EhkipazhSudna',
  EhksportnjeSertifikatjWorldWide = 'EhksportnjeSertifikatjWorldWide',
  GeneratsiyaOtchetaExcelPoZayavkamNaDostavku = 'GeneratsiyaOtchetaExcelPoZayavkamNaDostavku',
  IzmenenieOtmetkiKontragenta = 'IzmenenieOtmetkiKontragenta',
  IzmenenieSpiskaOzhidaniyaPogruzki = 'IzmenenieSpiskaOzhidaniyaPogruzki',
  IzmenenieYazjkaKontragenta = 'IzmenenieYazjkaKontragenta',
  Klient = 'Klient',
  Logist = 'Logist',
  LogistRf = 'LogistRF',
  LogistVoditelej = 'LogistVoditelej',
  MagadanStikerj = 'MagadanStikerj',
  MenedzherSvKh = 'MenedzherSVKh',
  MenedzherZelenjjUgol20 = 'MenedzherZelenjjUgol20',
  MladshijSotrudnikOtdelaPogruzki = 'MladshijSotrudnikOtdelaPogruzki',
  Nablyudatelj = 'Nablyudatelj',
  NapominaniyaBl = 'NapominaniyaBL',
  NavisAnalitik = 'NavisAnalitik',
  NavisDosmotr = 'NavisDosmotr',
  NavisDosmotrRossiya = 'NavisDosmotrRossiya',
  NavisFukui = 'NavisFukui',
  NavisMini = 'NavisMini',
  NavisOtaru = 'NavisOtaru',
  NavisPoluchateli = 'NavisPoluchateli',
  NavisShipping = 'NavisShipping',
  NavisShippingJsc = 'NavisShippingJSC',
  NavisSklad = 'NavisSklad',
  NovjjDogovorPb = 'NovjjDogovorPB',
  OtdelPogruzkiNavisShipping = 'OtdelPogruzkiNavisShipping',
  OtmetkaInvojsaOplachennjm = 'OtmetkaInvojsaOplachennjm',
  Otpravitelj = 'Otpravitelj',
  OtpravkaTelegramUvedomlenij = 'OtpravkaTelegramUvedomlenij',
  OuterAgentOtaru = 'OuterAgentOtaru',
  OuterCarrier = 'OuterCarrier',
  OuterOtaru = 'OuterOtaru',
  PartnerPerevozchik = 'PartnerPerevozchik',
  PartnerSbkts = 'PartnerSBKTS',
  PeremeshhenieObiektaMezhduSkladami = 'PeremeshhenieObiektaMezhduSkladami',
  PeremeshhenieObiektaMezhduStranami = 'PeremeshhenieObiektaMezhduStranami',
  PeremeshhenieZayavokDostavkiMezhduGruppami = 'PeremeshhenieZayavokDostavkiMezhduGruppami',
  PokazKlientovAkebono = 'PokazKlientovAkebono',
  PolnjjDostupKMenyuDejstvijQr = 'PolnjjDostupKMenyuDejstvijQR',
  PolnjjPoiskKontragenta = 'PolnjjPoiskKontragenta',
  PolnjjPoiskObiektov = 'PolnjjPoiskObiektov',
  PolnjjProsmotrKartochkiObiekta = 'PolnjjProsmotrKartochkiObiekta',
  Priemnaya = 'Priemnaya',
  ProsmotrDejstvijPoljzovatelya = 'ProsmotrDejstvijPoljzovatelya',
  ProsmotrIIzmenenieBl = 'ProsmotrIIzmenenieBL',
  ProsmotrInvojsov = 'ProsmotrInvojsov',
  ProsmotrKartochkiDostavki = 'ProsmotrKartochkiDostavki',
  ProsmotrKartochkiKontragenta = 'ProsmotrKartochkiKontragenta',
  ProsmotrKtoOnlajn = 'ProsmotrKtoOnlajn',
  ProsmotrLichnjkhKabinetov = 'ProsmotrLichnjkhKabinetov',
  ProsmotrLkVjbrannjkhKlientov = 'ProsmotrLKVjbrannjkhKlientov',
  ProsmotrObiektovBezDokumentovSAuktsionov = 'ProsmotrObiektovBezDokumentovSAuktsionov',
  ProsmotrOtchetaAkebono = 'ProsmotrOtchetaAkebono',
  ProsmotrPolnogoProfilyaPoljzovatelya = 'ProsmotrPolnogoProfilyaPoljzovatelya',
  ProsmotrSpiskaZelenjjUgol20 = 'ProsmotrSpiskaZelenjjUgol20',
  ProsmotrVsekhLkVjbrannjkhKlientov = 'ProsmotrVsekhLKVjbrannjkhKlientov',
  ProverkaDolgovPoObiektu = 'ProverkaDolgovPoObiektu',
  RabotaSKlyuchami = 'RabotaSKlyuchami',
  RazborshhikOtDostupnjkhSudov = 'RazborshhikOtDostupnjkhSudov',
  RedaktirovanieEhksportnjkhSertifikatov = 'RedaktirovanieEhksportnjkhSertifikatov',
  RedaktirovaniePoljzovatelya = 'RedaktirovaniePoljzovatelya',
  SbktsEhkspert = 'SBKTSEhkspert',
  SbktsRazreshenieUdalyatjZayavki = 'SBKTSRazreshenieUdalyatjZayavki',
  SbktsStrashnijEhkspert = 'SBKTSStrashnijEhkspert',
  SbrosPogruzkiRejsa = 'SbrosPogruzkiRejsa',
  SbrosRazgruzkiRejsa = 'SbrosRazgruzkiRejsa',
  SchyotchikPredvariteljnjkhZayavokNaDostavku = 'SchyotchikPredvariteljnjkhZayavokNaDostavku',
  SkladovshhikSvKh = 'SkladovshhikSVKh',
  SkladRossiya = 'SkladRossiya',
  SmenaKlientaObiekta = 'SmenaKlientaObiekta',
  SmenaNomeraKuzova = 'SmenaNomeraKuzova',
  SmenaOtpravitelyaObiekta = 'SmenaOtpravitelyaObiekta',
  SmenaProizvoditelyaIMarki = 'SmenaProizvoditelyaIMarki',
  SmenaStranjNaznacheniya = 'SmenaStranjNaznacheniya',
  SnyatieNomerov = 'SnyatieNomerov',
  SozdanieInvojsaRikun = 'SozdanieInvojsaRikun',
  SozdanieInvojsaZaPokupkuNaYaponskomAuktsione = 'SozdanieInvojsaZaPokupkuNaYaponskomAuktsione',
  SozdanieKontragenta = 'SozdanieKontragenta',
  SozdanieLotaVAkebonoIn = 'SozdanieLotaVAkebonoIn',
  SozdanieZayavokSbkts = 'SozdanieZayavokSBKTS',
  SozdatjZaprosNaVjdachu = 'SozdatjZaprosNaVjdachu',
  SozdavatjZayavkuNaDostavku = 'SozdavatjZayavkuNaDostavku',
  SpisatjSoSklada = 'SpisatjSoSklada',
  StatistikaZagruzkiFotoPoRejsam = 'StatistikaZagruzkiFotoPoRejsam',
  TorgovetsPogranichkami = 'TorgovetsPogranichkami',
  UdalenieFajlovBl = 'UdalenieFajlovBL',
  UdalenieFajlovRaschyotnjjList = 'UdalenieFajlovRaschyotnjjList',
  UdalenieVideo = 'UdalenieVideo',
  UpravlenieChatami = 'UpravlenieChatami',
  UpravleniePoljzovatelyami = 'UpravleniePoljzovatelyami',
  VerifitsirovatjPoluchatelya = 'VerifitsirovatjPoluchatelya',
  VjdachaPravaMenyatjTipOplatjTamozhni = 'VjdachaPravaMenyatjTipOplatjTamozhni',
  Voditelj = 'Voditelj',
  YahooMenedzher = 'YahooMenedzher',
  YahooSkladMoto = 'YahooSkladMoto',
  YaponskayaTamozhnya = 'YaponskayaTamozhnya',
  YaponskieRaschetkiSAuktsiona = 'YaponskieRaschetkiSAuktsiona',
  YaponskijSudovojAgent = 'YaponskijSudovojAgent',
  YaponskoeMenyuLogista = 'YaponskoeMenyuLogista',
  ZakrjvatjPretenziiBezUvedomlenij = 'ZakrjvatjPretenziiBezUvedomlenij'
}

export type LaboratoryExpert = {
  __typename?: 'LaboratoryExpert';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Инструменты эксперта */
  expertData?: Maybe<Array<ExpertData>>;
  /** Инструменты эксперта (удаленные) */
  expertDataDeleted?: Maybe<Array<ExpertData>>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ignoreSendToFgis?: Maybe<Scalars['Boolean']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isJunior?: Maybe<Scalars['Boolean']>;
  isSignDeputy?: Maybe<Scalars['Boolean']>;
  jobRole?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  /** Стажёры */
  juniors?: Maybe<Array<LaboratoryExpert>>;
  laboratory?: Maybe<Laboratory>;
  name?: Maybe<Scalars['String']>;
  parentExpert?: Maybe<LaboratoryExpert>;
  patronymic?: Maybe<Scalars['String']>;
  /** Получатели транспортного средства */
  receivers?: Maybe<Array<LaboratoryExpert>>;
  secondName?: Maybe<Scalars['String']>;
  thumbprint?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type ExpertData = {
  __typename?: 'ExpertData';
  categoriesCar?: Maybe<Array<CategoryCar>>;
  certificateNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  docName?: Maybe<Scalars['String']>;
  factoryN?: Maybe<Scalars['String']>;
  /** Конец эксплуатации инструмента */
  finishServiceAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  inventoryN?: Maybe<Scalars['String']>;
  inventoryNumber?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** Начало эксплуатации инструмента */
  startServiceAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  validityPeriod?: Maybe<Scalars['String']>;
};

export type CategoryCar = {
  __typename?: 'CategoryCar';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Laboratory = {
  __typename?: 'Laboratory';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deputyDirectorFirstName?: Maybe<Scalars['String']>;
  deputyDirectorLastName?: Maybe<Scalars['String']>;
  deputyDirectorPatronymic?: Maybe<Scalars['String']>;
  deputyThumbprint?: Maybe<Scalars['String']>;
  directorFirstName?: Maybe<Scalars['String']>;
  directorLastName?: Maybe<Scalars['String']>;
  directorPatronymic?: Maybe<Scalars['String']>;
  experts?: Maybe<Array<LaboratoryExpert>>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameAlias?: Maybe<Scalars['String']>;
  numberAccredited?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  sendToExternal?: Maybe<Scalars['Boolean']>;
  thumbprint?: Maybe<Scalars['String']>;
};

export enum LanguageEnum {
  En = 'en',
  Ja = 'ja',
  Ru = 'ru'
}

export type Owner = {
  __typename?: 'Owner';
  address?: Maybe<Scalars['String']>;
  advanceAkebonoBalance?: Maybe<Scalars['Int']>;
  akebonoData?: Maybe<OwnerAkebono>;
  akebonoPenalties?: Maybe<OwnerAkebonoPenalty>;
  allUser?: Maybe<Array<User>>;
  availableDepositAmounts?: Maybe<Array<Scalars['Int']>>;
  /** Доступные банки для выставления инвойсов */
  availableInvoiceBanks?: Maybe<Array<BankInvoice>>;
  balance?: Maybe<OwnerBalance>;
  /** Может выводить разницу */
  canWithdrawMoney?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Array<OwnerComment>>;
  countryIso?: Maybe<Scalars['String']>;
  /** @deprecated Moved to formal owner */
  dataForDocuments?: Maybe<OwnerData>;
  daysOfFreeStorageOnDelivery?: Maybe<Scalars['Int']>;
  depositAkebonoBalance?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Scalars['String']>>;
  engLegalAddress?: Maybe<Scalars['String']>;
  engName?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  guid1c?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inn?: Maybe<Scalars['String']>;
  /** Банк для выставления дефолтный */
  invoiceBank?: Maybe<BankInvoice>;
  invoices?: Maybe<Array<Invoice>>;
  invoicesCustom?: Maybe<Array<InvoiceCustom>>;
  isAcceptedStorageAgreement?: Maybe<Scalars['Boolean']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  isBroker?: Maybe<Scalars['Boolean']>;
  isDealer?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use isPaymentAgent */
  isDzenPay?: Maybe<Scalars['Boolean']>;
  isExportToOtherCountry?: Maybe<Scalars['Boolean']>;
  isHasBlockedObjects?: Maybe<Scalars['Boolean']>;
  isHasOldDebts?: Maybe<Scalars['Boolean']>;
  isHasPenalty?: Maybe<Scalars['Boolean']>;
  isMasterAccount?: Maybe<Scalars['Boolean']>;
  /** Контрагент платёжный агент */
  isPaymentAgent?: Maybe<Scalars['Boolean']>;
  /** Льготный депозит */
  isPreferentialDeposit?: Maybe<Scalars['Boolean']>;
  isRemoved?: Maybe<Scalars['Boolean']>;
  isSender?: Maybe<Scalars['Boolean']>;
  isUnfairPartner?: Maybe<Scalars['Boolean']>;
  isWarning?: Maybe<Scalars['Boolean']>;
  lastPlannedObject?: Maybe<ObjectOfServices>;
  lastPurchasedObject?: Maybe<ObjectOfServices>;
  logo?: Maybe<S3File>;
  lotteryTickets?: Maybe<Array<Maybe<LotteryTicker>>>;
  /** Менеджер клиента */
  manager?: Maybe<OwnerInfo>;
  name?: Maybe<Scalars['String']>;
  notPaidBidsDisplayStatus?: Maybe<PaidBidsDisplayStatus>;
  objectsStatistic?: Maybe<Scalars['Int']>;
  paidBidsDisplayStatuses?: Maybe<Array<Maybe<PaidBidsDisplayStatus>>>;
  /** Дополнительная информация по партнеру */
  partnerInfo?: Maybe<PartnerInfo>;
  /** Является аккредитованным партнером */
  partnerInfoIsAccredited?: Maybe<Scalars['Boolean']>;
  /** Платёжный агент */
  paymentAgent?: Maybe<BankInvoice>;
  phones?: Maybe<Array<Scalars['String']>>;
  senderAgents?: Maybe<Array<SenderAgent>>;
  senderCode?: Maybe<Scalars['String']>;
  senderComment?: Maybe<Scalars['String']>;
  senderEmails?: Maybe<Array<Scalars['String']>>;
  senderFax?: Maybe<Scalars['String']>;
  senderPhone?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  tariffModel?: Maybe<Tariff>;
  userBroker?: Maybe<User>;
  userRecipient?: Maybe<User>;
  userSender?: Maybe<User>;
  uuid?: Maybe<Scalars['String']>;
  yahooUser?: Maybe<Scalars['Int']>;
};


export type OwnerBalanceArgs = {
  isAkebono?: Maybe<Scalars['Boolean']>;
  objectId?: Maybe<Scalars['Int']>;
};


export type OwnerObjectsStatisticArgs = {
  active?: Maybe<Scalars['Boolean']>;
  isAkebono?: Maybe<Scalars['Boolean']>;
  type: TypeOfOwnerEnum;
};

export type OwnerAkebono = {
  __typename?: 'OwnerAkebono';
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type OwnerAkebonoPenalty = {
  __typename?: 'OwnerAkebonoPenalty';
  totalBases?: Maybe<Array<Money>>;
  totalPenaltiesRub?: Maybe<Money>;
  totalProposedPenaltiesJpy?: Maybe<Money>;
  totalProposedPenaltiesRub?: Maybe<Money>;
  totalTaxes?: Maybe<Array<Money>>;
};

export type BankInvoice = {
  __typename?: 'BankInvoice';
  /** Доступ к разделу Авто */
  accessAuto?: Maybe<Scalars['Boolean']>;
  /** Доступ к разделу P2P */
  accessP2p?: Maybe<Scalars['Boolean']>;
  /** Доступ к разделу Shop */
  accessShop?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  /** Админское выключение, агент не может менять */
  adminDisabled?: Maybe<Scalars['Boolean']>;
  agreementDate?: Maybe<Scalars['String']>;
  agreementNumber?: Maybe<Scalars['String']>;
  /** Лимит для уведомлений */
  alertLimit?: Maybe<Scalars['Int']>;
  allocationReportTemplate?: Maybe<S3File>;
  /** Разрешённые типы инвойсов */
  allowedInvoiceTypes?: Maybe<Scalars['JSON']>;
  balanceLimit?: Maybe<Scalars['Int']>;
  bankName?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  /** Агент может сам настраивать курс */
  canConfigureExchangeRate?: Maybe<Scalars['Boolean']>;
  /** HEX цвет платёжного агента для фронтенда */
  color?: Maybe<Scalars['String']>;
  correspAcc?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Текущий баланс */
  currentBalance?: Maybe<Scalars['Float']>;
  /** Текущий холд */
  currentHold?: Maybe<Scalars['Float']>;
  /** Лимит депозита */
  depositLimit?: Maybe<Scalars['Int']>;
  disabledForClients?: Maybe<Scalars['Boolean']>;
  documentTemplate?: Maybe<S3File>;
  exchangeRateFormulaConfig?: Maybe<Scalars['JSON']>;
  exchangeRateRub?: Maybe<Scalars['Float']>;
  fileExpireTtl?: Maybe<Scalars['Int']>;
  /** Генерация доп. инвойса под свои реквизиты */
  generateOwnRequisitesInvoice?: Maybe<Scalars['Boolean']>;
  hasPaymentAgent?: Maybe<Scalars['Boolean']>;
  /** Скрывать доп. курсы (ATB/Solid) в ЛК клиента */
  hideAdditionalRates?: Maybe<Scalars['Boolean']>;
  /** Скрывать чаты в ЛК агента */
  hideChats?: Maybe<Scalars['Boolean']>;
  iban?: Maybe<Scalars['String']>;
  ibanUsd?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inn?: Maybe<Scalars['String']>;
  innerExchangeRate?: Maybe<Scalars['Float']>;
  innerExchangeRateCashDiff?: Maybe<Scalars['Float']>;
  innerExchangeRateDiff?: Maybe<Scalars['Float']>;
  innerName?: Maybe<Scalars['String']>;
  /** Настройка инвойсов по типу и клиенту */
  invoiceRoutingConfig?: Maybe<Scalars['JSON']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** Is default payment agent */
  isDefault?: Maybe<Scalars['Boolean']>;
  /** Оплата через ДзенПей */
  isDzenPay?: Maybe<Scalars['Boolean']>;
  /** Логировать изменение курса */
  isLogEnabled?: Maybe<Scalars['Boolean']>;
  kpp?: Maybe<Scalars['String']>;
  /** Дополнительный баланс */
  linkedBalanceAgent?: Maybe<OwnerInfo>;
  /** Лимит объектов в неделю на второй баланс */
  linkedBalanceWeeklyLimit?: Maybe<Scalars['Int']>;
  maxExchangeRatePercentUp?: Maybe<Scalars['Int']>;
  /** Минимальная сумма в JPY для создания заказа */
  minAmountToCreateOrder?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** Email-адреса для писем платёжному агенту */
  notificationEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Ежедневный отчёт по загруженным ПТД */
  notifyDailyPassengerDeclaration?: Maybe<Scalars['Boolean']>;
  /** Ежедневный отчёт по завершённым платежам */
  notifyDailyPayments?: Maybe<Scalars['Boolean']>;
  /** Письмо с пакетом документов */
  notifyDocumentPack?: Maybe<Scalars['Boolean']>;
  /** Письмо о принятом платеже */
  notifyPaymentAccepted?: Maybe<Scalars['Boolean']>;
  /** Контрагент платёжного агента */
  paymentAgent?: Maybe<OwnerInfo>;
  personalAcc?: Maybe<Scalars['String']>;
  personalBank?: Maybe<Scalars['String']>;
  personalName?: Maybe<Scalars['String']>;
  personalNameEng?: Maybe<Scalars['String']>;
  purposeTemplate?: Maybe<Scalars['JSON']>;
  schedule?: Maybe<Scalars['JSON']>;
  swift?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Пользователи, которым виден агент. Пустой список — видят все */
  visibleUserIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type OwnerInfo = {
  __typename?: 'OwnerInfo';
  engName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  yahooUserId?: Maybe<Scalars['Int']>;
};

export type OwnerBalance = {
  __typename?: 'OwnerBalance';
  advances?: Maybe<Array<Money>>;
  advancesByAgreement?: Maybe<Array<BalanceByAgreement>>;
  advancesByOrganization?: Maybe<Array<BalanceByOrganization>>;
  debts?: Maybe<Array<Money>>;
  deposits?: Maybe<Array<Money>>;
};

export type BalanceByAgreement = {
  __typename?: 'BalanceByAgreement';
  balance?: Maybe<Array<Money>>;
  type?: Maybe<ClientBalanceTypeEnum>;
};

/** Client balance types */
export enum ClientBalanceTypeEnum {
  /** Auction balance */
  Auction = 'AUCTION',
  /** Additional balance */
  Hold = 'HOLD',
  /** Yahoo balance */
  Yahoo = 'YAHOO'
}

export type BalanceByOrganization = {
  __typename?: 'BalanceByOrganization';
  balance?: Maybe<Array<Money>>;
  organization?: Maybe<Organization>;
};

export type OwnerComment = {
  __typename?: 'OwnerComment';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type OwnerData = {
  __typename?: 'OwnerData';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  /** Последний запрос на изменение */
  activeUpdateRequest?: Maybe<InvoiceUpdateRequest>;
  amount?: Maybe<Scalars['Float']>;
  amountSupplier?: Maybe<Scalars['Float']>;
  client?: Maybe<Owner>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  file?: Maybe<S3File>;
  id?: Maybe<Scalars['Int']>;
  isPaid?: Maybe<Scalars['Boolean']>;
  isSendSupplier?: Maybe<Scalars['Boolean']>;
  isSent?: Maybe<Scalars['Boolean']>;
  isSentTo1C?: Maybe<Scalars['Boolean']>;
  isShow1c?: Maybe<Scalars['Boolean']>;
  nomenclaturesList?: Maybe<Array<Maybe<InvoiceNomenclatureItem>>>;
  number?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  organization?: Maybe<Organization>;
  sender?: Maybe<Sender>;
  type?: Maybe<InvoiceType>;
  /** Запросы на изменение */
  updateRequests?: Maybe<Array<InvoiceUpdateRequest>>;
};

export type InvoiceUpdateRequest = {
  __typename?: 'InvoiceUpdateRequest';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Array<InvoiceUpdateRequestData>>;
  files?: Maybe<Array<S3File>>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** Номенклатуры, затронутые в данном запросе */
  nomenclatures?: Maybe<Array<Nomenclature>>;
};

export type InvoiceUpdateRequestData = {
  __typename?: 'InvoiceUpdateRequestData';
  newValue?: Maybe<Scalars['Int']>;
  nomenclatureId?: Maybe<Scalars['Int']>;
  oldValue?: Maybe<Scalars['Int']>;
};

export type Nomenclature = {
  __typename?: 'Nomenclature';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isForExportPrice?: Maybe<Scalars['Boolean']>;
  isForWorldWide?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
  ndsType?: Maybe<NdsType>;
};

export type NdsType = {
  __typename?: 'NdsType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** Ставка включена в сумму начисления */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Ставка НДС в процентах */
  value?: Maybe<Scalars['Int']>;
};

export type InvoiceNomenclatureItem = {
  __typename?: 'InvoiceNomenclatureItem';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  nomenclature?: Maybe<Nomenclature>;
};

export type ObjectOfServices = {
  __typename?: 'ObjectOfServices';
  accountantChatId?: Maybe<Scalars['Int']>;
  activeHash?: Maybe<Scalars['String']>;
  acts?: Maybe<Array<ChatForOthers>>;
  additionalType?: Maybe<TypeOfAdditional>;
  aggregateType?: Maybe<Aggregate>;
  aiParkingPass?: Maybe<ObjectParkingPass>;
  akebonoBuyer?: Maybe<Owner>;
  akebonoPenalty?: Maybe<AkebonoPenalty>;
  allKeys?: Maybe<Array<Maybe<ObjectKey>>>;
  /** Разрешена смена грузополучателя, даже если поля закрыты из-за оплаты */
  allowChangeRecipient?: Maybe<Scalars['Boolean']>;
  /** Разрешенные статусы ресайкла для установки */
  allowedRecycleStatuses?: Maybe<Array<Status>>;
  ambassadors?: Maybe<Array<Ambassador>>;
  attachmentObjects?: Maybe<Array<ObjectOfServices>>;
  attachments?: Maybe<Scalars['String']>;
  auction?: Maybe<ObjectAuction>;
  auctionHistory?: Maybe<Array<ObjectAuctionHistory>>;
  auctionListing?: Maybe<AuctionListing>;
  auctionPaySheet?: Maybe<AuctionPaySheet>;
  auctionPaySheetObject?: Maybe<AuctionPaySheetObject>;
  bls?: Maybe<Array<Bl>>;
  /** Номер букинга */
  bookingNumber?: Maybe<Scalars['String']>;
  bookingRequests?: Maybe<Array<BookingRequest>>;
  /** Дата хранения на СВХ */
  bookParkingLotDate?: Maybe<Scalars['DateTime']>;
  branchOffice?: Maybe<Scalars['String']>;
  broker?: Maybe<Broker>;
  /** @deprecated Use BrokerType */
  brokerNameForClient?: Maybe<Scalars['String']>;
  /** Можно ли поставить объект на данный рейс */
  canAddToPlan?: Maybe<AddToPlanAttention>;
  /** Можно ли сделать претензию типа Таможенное оформление */
  canMakeCustomTicket?: Maybe<Scalars['Boolean']>;
  /** Доступна ли загрузка таможенных документов */
  canUploadCustomDocuments?: Maybe<Scalars['Boolean']>;
  carBuy?: Maybe<ObjectToSale>;
  carClientParam?: Maybe<CarClientParam>;
  carsClearance?: Maybe<ObjectClearance>;
  carType?: Maybe<TypeOfExport>;
  chassisType?: Maybe<TypeOfChassis>;
  chats?: Maybe<Array<ChatForOthers>>;
  /** Проверка возможности создать сделку перепродажи */
  checkAllowCreateResale?: Maybe<ObjectResaleActionCheck>;
  /** Начисления СБКТС и ЭПТС */
  checkLaboratoryPayments?: Maybe<SbktsPayment>;
  clientDebts?: Maybe<Array<Price>>;
  comment?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<ObjectComment>>;
  complexAmount?: Maybe<Scalars['Float']>;
  /** Стоимость указанные в инвойсе */
  complexByInvoice?: Maybe<ComplexByInvoice>;
  /** Состояние грузо получателя */
  conditionConsignee?: Maybe<ConditionConsigneeEnum>;
  consigneeAddress?: Maybe<Scalars['String']>;
  consigneeNameForClient?: Maybe<Scalars['String']>;
  consignment?: Maybe<Scalars['Int']>;
  container?: Maybe<Container>;
  creditsStorage?: Maybe<Array<Maybe<CreditStorage>>>;
  currentExportCertificate?: Maybe<Scalars['String']>;
  currentExportTrip?: Maybe<ExportTrip>;
  currentOnPlan?: Maybe<OnPlan>;
  currentThirdPartyTrip?: Maybe<ThirdPartyTrip>;
  /** Набор документов для таможни */
  customDocument?: Maybe<ObjectCustomDocument>;
  /**
   * Набор документов для таможни
   * @deprecated Use customDocument
   */
  customDocuments?: Maybe<Array<Maybe<ObjectCustomDocument>>>;
  /** Способ оплаты таможни */
  customPaymentType?: Maybe<CustomPayment>;
  customType?: Maybe<TypeOfCustom>;
  customZone?: Maybe<Scalars['String']>;
  /** Дата прибытия во Владивосток */
  dateArrivalVladivostok?: Maybe<Scalars['DateTime']>;
  /** Дата покупки */
  dateBuy?: Maybe<Scalars['DateTime']>;
  /** Предположительная дата получения авто с аукциона */
  dateCarWithAuction?: Maybe<Scalars['DateTime']>;
  dateDismantleForCube?: Maybe<Scalars['DateTime']>;
  /** Предположительная дата получения документов с аукциона */
  dateDocumentWithAuction?: Maybe<Scalars['DateTime']>;
  /** Дата ближайшего рейса */
  dateNearTrip?: Maybe<Scalars['DateTime']>;
  /** Предположительная дата выдачи клиету */
  dateOfIssue?: Maybe<Scalars['DateTime']>;
  dateOfManufacture?: Maybe<Scalars['String']>;
  dateRecyclingToCube?: Maybe<Scalars['DateTime']>;
  dateSoldRecyclingCube?: Maybe<Scalars['DateTime']>;
  /** Предположительная дата получения с аукциона. Max(dateCarWithAuction, dateDocumentWithAuction) */
  dateWithAuction?: Maybe<Scalars['DateTime']>;
  daysPaidStorageAutoimport?: Maybe<Scalars['Int']>;
  delayRequests?: Maybe<Array<ObjectDelayRequest>>;
  delivered?: Maybe<Array<ObjectDelivered>>;
  delivery?: Maybe<ObjectDelivery>;
  deliveryRequestFromPreDelivery?: Maybe<DeliveryRequest>;
  deliveryRequests?: Maybe<Array<DeliveryRequest>>;
  desiredTrip?: Maybe<DesiredTrip>;
  destinationCountry?: Maybe<Country>;
  diagnosticDoc?: Maybe<DiagnosticDoc>;
  disassemble?: Maybe<Disassemble>;
  /** Кол-во снятых колёс */
  disassembleWheelCount?: Maybe<Scalars['Int']>;
  disassemblyState?: Maybe<DisassemblyStateEnum>;
  draftBroker?: Maybe<DraftBroker>;
  draftClient?: Maybe<DraftClient>;
  draftFreightObject?: Maybe<DraftFreightObject>;
  elpts?: Maybe<Elpts>;
  emailMessages?: Maybe<Array<ObjectNotification>>;
  exportCertificate?: Maybe<ExportCertificate>;
  exportCertificates?: Maybe<Array<ExportCertificate>>;
  exportPrice?: Maybe<Price>;
  exportTrips?: Maybe<Array<ExportTrip>>;
  feedback?: Maybe<CarFeedback>;
  files?: Maybe<Array<S3File>>;
  firstDeliveryCarrier?: Maybe<Carrier>;
  firstDeliveryRequest?: Maybe<DeliveryRequest>;
  /** FOB цена */
  fobPrice?: Maybe<Scalars['Int']>;
  formalBroker?: Maybe<Broker>;
  formalOwner?: Maybe<FormalOwner>;
  formalOwnerState?: Maybe<FormalOwnerStateEnum>;
  freight?: Maybe<Scalars['Float']>;
  freightCountryReason?: Maybe<Scalars['String']>;
  /** Лимит FOB цены для установки в каталоге Зеленого угла */
  gcFobPriceLimit?: Maybe<Scalars['Int']>;
  /**
   * Количество дней до начала начислений
   * @deprecated Use paymentFreeDaysLeft
   */
  greenCornerFreeDaysLeft?: Maybe<Scalars['Int']>;
  /** Итог проверки объекта ЗУ толщиномером */
  greenCornerInspection?: Maybe<GreenCornerInspection>;
  guid?: Maybe<Scalars['String']>;
  /** Есть активная заявка отложенной доставки */
  hasActiveDelay?: Maybe<Scalars['Boolean']>;
  /** @deprecated Delete un use */
  hasActiveDeliveryToAutoImport?: Maybe<Scalars['Boolean']>;
  /** @deprecated Delete un use */
  hasActiveDeliveryToTroyan?: Maybe<Scalars['Boolean']>;
  hasActiveTransportingRequest?: Maybe<Scalars['Boolean']>;
  hasAkebonoJpyDebts?: Maybe<Scalars['Boolean']>;
  hasChassisNumber?: Maybe<Scalars['Boolean']>;
  /** @deprecated Delete un use */
  hasClosedDeliveryToTroyan?: Maybe<Scalars['Boolean']>;
  hasFrameNumber?: Maybe<Scalars['Boolean']>;
  hash?: Maybe<Scalars['String']>;
  hasStatus?: Maybe<Scalars['Boolean']>;
  hasVin?: Maybe<Scalars['Boolean']>;
  /** Akebono user uploaded media to a non-Akebono object */
  hasWrongAkebonoUpload?: Maybe<Scalars['Boolean']>;
  headObject?: Maybe<ObjectOfServices>;
  holdTo?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  inRussia?: Maybe<Scalars['Boolean']>;
  inventoryObjects?: Maybe<Array<InventoryObject>>;
  invoice?: Maybe<Invoice>;
  invoices?: Maybe<Array<Invoice>>;
  invoicesCustom?: Maybe<Array<InvoiceCustom>>;
  invoiceUrl?: Maybe<Scalars['String']>;
  isAggregate?: Maybe<Scalars['Boolean']>;
  /** Загружено изображение договора */
  isAgreementClientSigned?: Maybe<Scalars['Boolean']>;
  isAutoImport?: Maybe<Scalars['Boolean']>;
  /** Признак запроса букинга */
  isBookingRequested?: Maybe<Scalars['Boolean']>;
  isBoundary?: Maybe<Scalars['Boolean']>;
  /** Брокер был изменён менее 5 дней назад */
  isBrokerRecentlyAdded?: Maybe<Scalars['Boolean']>;
  /** Признак можно ли снимать колеса */
  isCanCreateWheel?: Maybe<Scalars['Boolean']>;
  isCanEditByTroyan?: Maybe<Scalars['Boolean']>;
  isCanFillSbkts?: Maybe<Scalars['Boolean']>;
  /** Можно ли выдать объект */
  isCanIssue?: Maybe<Scalars['Boolean']>;
  isCanRequestParking?: Maybe<Scalars['Boolean']>;
  isCar?: Maybe<Scalars['Boolean']>;
  isCarFinanceClearAkebono?: Maybe<Scalars['Boolean']>;
  isCarFinanceClearFull?: Maybe<Scalars['Boolean']>;
  isCarFinanceClearNavis?: Maybe<Scalars['Boolean']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeliveryAllowed?: Maybe<Scalars['Boolean']>;
  isDisassemble?: Maybe<Scalars['Boolean']>;
  isFullFilledSbktsData?: Maybe<Scalars['Boolean']>;
  /** Автозачет делается на общих основаниях */
  isGeneralBasisAdvance?: Maybe<Scalars['Boolean']>;
  isGlonassNeed?: Maybe<Scalars['Boolean']>;
  /** Зелёный угол */
  isGreenCorner?: Maybe<Scalars['Boolean']>;
  isHaveVehicleRegistrationNumber?: Maybe<Scalars['Boolean']>;
  isImpassable?: Maybe<Scalars['Boolean']>;
  isMoto?: Maybe<Scalars['Boolean']>;
  isNeedConsignee?: Maybe<Scalars['Boolean']>;
  isNeedVideo?: Maybe<Scalars['Boolean']>;
  isNoAutoFreightCountry?: Maybe<Scalars['Boolean']>;
  isNumberCut?: Maybe<Scalars['Boolean']>;
  isOnDisassemblyStock?: Maybe<Scalars['Boolean']>;
  isOwnOwner?: Maybe<Scalars['Boolean']>;
  isPaidStorageStarted?: Maybe<Scalars['Boolean']>;
  isPart?: Maybe<Scalars['Boolean']>;
  /** Приняты\Не получены документы\Отклонены (если есть pbPassportDeclineComment) */
  isPbReceivedPassportCopy?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isPrimbroker?: Maybe<Scalars['Boolean']>;
  isPriorityPass?: Maybe<Scalars['Boolean']>;
  /** Признак что файлы поданные для таможни находятся в очереди их пред обработки */
  isQueueCustomFile?: Maybe<Scalars['Boolean']>;
  isRemoved?: Maybe<Scalars['Boolean']>;
  /** Когда у клиента запрошены документы для таможни игнорируя статус Погружен */
  isRequestDocumentsOfCustoms?: Maybe<Scalars['DateTime']>;
  /** Заказан пакет документов для жителей не ДВФО */
  isRequestedPrepareDocuments?: Maybe<Scalars['Boolean']>;
  /** Запросить квитанцию для предварительного пополнения лицевого счета на ФТС */
  isRequestReceiptFcs?: Maybe<Scalars['Boolean']>;
  isSaw?: Maybe<Scalars['Boolean']>;
  issueBlocks?: Maybe<Array<IssueBlock>>;
  /** Есть претензии */
  isTicket?: Maybe<Scalars['Boolean']>;
  isTroyan?: Maybe<Scalars['Boolean']>;
  /** Загружен ли набор документов и подтвержден */
  isUploadedCustomDocuments?: Maybe<Scalars['Boolean']>;
  isVladTrek?: Maybe<Scalars['Boolean']>;
  isYahoo?: Maybe<Scalars['Boolean']>;
  /** Список оплат УСО по Японии */
  japanPayments?: Maybe<Array<Maybe<JapanPaymentsToRequest>>>;
  jpTrackingNumberForPlate?: Maybe<Scalars['String']>;
  kaitaiParam?: Maybe<KaitaiParam>;
  keys?: Maybe<Array<Maybe<ObjectKey>>>;
  keysCount?: Maybe<Scalars['Int']>;
  labelElementType?: Maybe<Scalars['String']>;
  labelEmbeddedType?: Maybe<Scalars['String']>;
  /** Лаборатория */
  laboratory?: Maybe<Laboratory>;
  lastArrivalToAutoImport?: Maybe<StorageDaysByStock>;
  lastStatusToObject?: Maybe<StatusToObject>;
  /** @deprecated Use StockType */
  locationNameForChat?: Maybe<Scalars['String']>;
  /** @deprecated Replaced to logObjectEvents query */
  logEvents?: Maybe<Array<ObjectLogEvent>>;
  /** Данные лота Зеленый угол */
  lot?: Maybe<Lot>;
  masterAccountClient?: Maybe<Owner>;
  media?: Maybe<Array<ObjectMedia>>;
  mediaCount?: Maybe<Scalars['Int']>;
  /** @deprecated Useless, remove */
  mirrors?: Maybe<Array<ObjectMirror>>;
  name?: Maybe<Scalars['String']>;
  name1c?: Maybe<Scalars['String']>;
  notRejectRecipient?: Maybe<Recipient>;
  numberCut?: Maybe<Scalars['String']>;
  objectActions?: Maybe<Array<ObjectActionsEnum>>;
  objectCount?: Maybe<Scalars['Int']>;
  objectDisassemble?: Maybe<ObjectDisassemble>;
  objectIcons?: Maybe<Array<ObjectIconsEnum>>;
  onPlans?: Maybe<Array<OnPlan>>;
  owner?: Maybe<Owner>;
  /** Параметры платного хранения */
  paidStorageData?: Maybe<ObjectPaidStorageData>;
  parkginRequestCancel?: Maybe<ObjectParkingRequestCancel>;
  parkginRequestsCancel?: Maybe<Array<Maybe<ObjectParkingRequestCancel>>>;
  parkingRequest?: Maybe<ObjectParkingRequest>;
  partObjects?: Maybe<Array<ObjectOfServices>>;
  partRelationType?: Maybe<ObjectRelationTypeEnum>;
  /** Статус ПТД */
  passengerCustomsDeclarationStatus?: Maybe<PassengerCustomsDeclarationStatusEnum>;
  payCountry?: Maybe<Country>;
  /** Количество дней до начала начислений */
  paymentFreeDaysLeft?: Maybe<Scalars['Int']>;
  /** План (тариф) оплаты объекта */
  paymentPlan?: Maybe<PaymentPlan>;
  pbAgreement?: Maybe<PbAgreement>;
  pbAgreementBlank?: Maybe<S3File>;
  pbAgreements?: Maybe<Array<Maybe<PbAgreement>>>;
  /** Причина отмены документов */
  pbPassportDeclineComment?: Maybe<Scalars['String']>;
  photoVisibleBlock?: Maybe<ObjectMediaBlock>;
  /** Планируемый тип судна */
  plannedVesselType?: Maybe<VesselTypeInfo>;
  preDeliveryObject?: Maybe<PreDeliveryObject>;
  preDeliveryObjects?: Maybe<Array<PreDeliveryObject>>;
  quantityStorageDays?: Maybe<Scalars['Int']>;
  radiation?: Maybe<Scalars['String']>;
  /** Данные оплаты */
  receiptOfPayment?: Maybe<ReceiptOfPayment>;
  /** Данные оплаты */
  receiptOfPayments?: Maybe<Array<Maybe<ReceiptOfPayment>>>;
  recipientHash?: Maybe<Scalars['String']>;
  recipients?: Maybe<Array<Recipient>>;
  /** Ссылка на грузополучателя */
  recipientUrl?: Maybe<Scalars['String']>;
  /** Текущий статус ресайкла, установленный на объекте */
  recycleStatus?: Maybe<ObjectRecycleStatus>;
  /** Все статусы ресайкла, установленные на объекте */
  recycleStatuses?: Maybe<Array<ObjectRecycleStatus>>;
  /** Юридическое лицо «для коммерческих целей» */
  registrationForCommercialPurposes?: Maybe<Scalars['Boolean']>;
  requestToIssueObject?: Maybe<RequestToIssueObject>;
  /** Сделка перепродажи */
  resale?: Maybe<ObjectResale>;
  rightSector?: Maybe<Sector>;
  sawType?: Maybe<TypeOfSaw>;
  sbktsRequest?: Maybe<SbktsRequest>;
  sbktsRequests?: Maybe<Array<SbktsRequest>>;
  scrapObject?: Maybe<ScrapObject>;
  scrapObjectsByParent?: Maybe<Array<ScrapObject>>;
  sender?: Maybe<Sender>;
  senderObject?: Maybe<ObjectSender>;
  /** Запрошенные услуги по объекту */
  servicesRequests?: Maybe<Array<ServiceRequest>>;
  /** Дата продажи авто Дубаи, Монголия и т.д */
  soldDate?: Maybe<Scalars['DateTime']>;
  statuses?: Maybe<Array<StatusToObject>>;
  statusReadyForClient?: Maybe<StatusToObject>;
  statusReleasedFromCustoms?: Maybe<StatusToObject>;
  statusReleasedFromStock?: Maybe<StatusToObject>;
  stock?: Maybe<Stock>;
  storageDaysByStock?: Maybe<Array<StorageDaysByStock>>;
  sumAkebonoJpyDebts?: Maybe<Scalars['Int']>;
  svhIssuedDate?: Maybe<Scalars['DateTime']>;
  tariffModel?: Maybe<Tariff>;
  thingsAttachments?: Maybe<Array<ObjectAttachment>>;
  thingsAttachmentsLog?: Maybe<Array<ObjectAttachmentTypeLog>>;
  thirdPartyTrips?: Maybe<Array<ThirdPartyTrip>>;
  tickets?: Maybe<Array<Ticket>>;
  title?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<LotTranslation>>>;
  /** Заказанные транспортировки */
  transportingRequests?: Maybe<Array<Maybe<TransportationData>>>;
  troyanCustomer?: Maybe<TroyanCustomer>;
  troyanCustomers?: Maybe<Array<Maybe<TroyanCustomer>>>;
  videoCount?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
  watch?: Maybe<Watch>;
  wheelOptions?: Maybe<Wheel>;
  yahooCode?: Maybe<Scalars['String']>;
  yahooConsignmentName?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};


export type ObjectOfServicesCanAddToPlanArgs = {
  planId: Scalars['Int'];
};


export type ObjectOfServicesDeliveryRequestsArgs = {
  organization?: Maybe<OrganizationEnum>;
};


export type ObjectOfServicesFilesArgs = {
  type?: Maybe<MediaTypeEnum>;
};


export type ObjectOfServicesHasStatusArgs = {
  statusId: Scalars['Int'];
};


export type ObjectOfServicesMediaArgs = {
  types?: Maybe<Array<MediaTypeEnum>>;
};


export type ObjectOfServicesObjectActionsArgs = {
  actions?: Maybe<Array<ObjectActionsEnum>>;
};


export type ObjectOfServicesObjectIconsArgs = {
  icons?: Maybe<Array<ObjectIconsEnum>>;
};

export type ChatForOthers = {
  __typename?: 'ChatForOthers';
  accessUsers?: Maybe<Array<ChatAccessUser>>;
  chatMembers?: Maybe<Array<Scalars['String']>>;
  countTasksResolved?: Maybe<Scalars['Int']>;
  countTasksUnresolved?: Maybe<Scalars['Int']>;
  countUnreadMessages?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  lastMessage?: Maybe<ChatMessage>;
  messages?: Maybe<Array<ChatMessage>>;
  object?: Maybe<ObjectOfServices>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  ticket?: Maybe<Ticket>;
  toGroups?: Maybe<Array<ChatGroup>>;
};

export type ChatAccessUser = {
  __typename?: 'ChatAccessUser';
  accessGranted?: Maybe<User>;
  asObserver?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use creatorName */
  creator?: Maybe<User>;
  creatorName?: Maybe<Scalars['String']>;
  files?: Maybe<Array<S3File>>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Автор сообщения — владелец объявления (продавец оффера / покупатель заявки) */
  isP2pListingOwner?: Maybe<Scalars['Boolean']>;
  /** seller | buyer в P2P-чате сделки; null если чат не P2P */
  p2pRole?: Maybe<Scalars['String']>;
  task?: Maybe<ChatMessageTask>;
  text?: Maybe<Scalars['String']>;
};

export type ChatMessageTask = {
  __typename?: 'ChatMessageTask';
  executor?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  solvedAt?: Maybe<Scalars['DateTime']>;
};

export type Tag = {
  __typename?: 'Tag';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_eng?: Maybe<Scalars['String']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  accessUsers?: Maybe<Array<User>>;
  /** @deprecated Moved to decision */
  approvedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Moved to decision */
  approvedBy?: Maybe<User>;
  canApproveOrganization?: Maybe<Scalars['Boolean']>;
  canApproveStaff?: Maybe<Scalars['Boolean']>;
  canDecline?: Maybe<Scalars['Boolean']>;
  canPayout?: Maybe<Scalars['Boolean']>;
  canStaffActions?: Maybe<Scalars['Boolean']>;
  clientChat?: Maybe<ChatForOthers>;
  closedAt?: Maybe<Scalars['DateTime']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  decisions?: Maybe<Array<TicketDecision>>;
  declineAt?: Maybe<Scalars['DateTime']>;
  expireTime?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<S3File>>;
  history?: Maybe<Array<TicketHistory>>;
  id?: Maybe<Scalars['Int']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isDecline?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  organizationChat?: Maybe<ChatForOthers>;
  reasonInner?: Maybe<TicketReason>;
  requestAmount?: Maybe<Price>;
  review?: Maybe<TicketReview>;
  status?: Maybe<TicketStatus>;
  statuses?: Maybe<Array<TicketStatuses>>;
  ticketReason?: Maybe<TicketReason>;
  ticketSubType?: Maybe<TypeOfTicketSub>;
  ticketType?: Maybe<TypeOfTicket>;
};

export type TicketDecision = {
  __typename?: 'TicketDecision';
  amount?: Maybe<Price>;
  appealCount?: Maybe<Scalars['Int']>;
  appealMessage?: Maybe<Scalars['String']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<User>;
  approveToPayoutAt?: Maybe<Scalars['DateTime']>;
  approveToPayoutBy?: Maybe<User>;
  canAppeal?: Maybe<Scalars['Boolean']>;
  canApproveOrganization?: Maybe<Scalars['Boolean']>;
  canCancel?: Maybe<Scalars['Boolean']>;
  cancelAt?: Maybe<Scalars['DateTime']>;
  cancelBy?: Maybe<User>;
  canChange?: Maybe<Scalars['Boolean']>;
  canResetWaitPayout?: Maybe<Scalars['Boolean']>;
  compensationAmount?: Maybe<Price>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  expireTime?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<S3File>>;
  guiltyMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isCompensatedByThirdParty?: Maybe<Scalars['Boolean']>;
  isPayOrganization?: Maybe<Scalars['Boolean']>;
  isPenalty?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  organizationComment?: Maybe<Scalars['String']>;
  payoutAt?: Maybe<Scalars['DateTime']>;
  payoutBy?: Maybe<User>;
  status?: Maybe<TicketStatus>;
  ticket?: Maybe<Ticket>;
};

export type Price = {
  __typename?: 'Price';
  currency?: Maybe<Currency>;
  value?: Maybe<Scalars['Int']>;
};

export type TicketStatus = {
  __typename?: 'TicketStatus';
  forDecision?: Maybe<Scalars['Boolean']>;
  forTicket?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  innerName?: Maybe<Scalars['String']>;
  outerName?: Maybe<Scalars['String']>;
  outerNameEn?: Maybe<Scalars['String']>;
};

export type TicketHistory = {
  __typename?: 'TicketHistory';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type TicketReason = {
  __typename?: 'TicketReason';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TicketReview = {
  __typename?: 'TicketReview';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Float']>;
};

export type TicketStatuses = {
  __typename?: 'TicketStatuses';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<TicketStatus>;
};

export type TypeOfTicketSub = {
  __typename?: 'TypeOfTicketSub';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TypeOfTicket = {
  __typename?: 'TypeOfTicket';
  code?: Maybe<Scalars['String']>;
  defaultCurrency?: Maybe<Currency>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};

export type TypeOfAdditional = {
  __typename?: 'TypeOfAdditional';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  id?: Maybe<Scalars['Int']>;
  isDefaultForScrap?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<AggregateTypeEnum>;
};

export enum AggregateTypeEnum {
  Body = 'body',
  Engine = 'engine',
  Frame = 'frame'
}

export type ObjectParkingPass = {
  __typename?: 'ObjectParkingPass';
  createdAt?: Maybe<Scalars['DateTime']>;
  expireAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<S3File>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isReady?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  type?: Maybe<MediaTypeEnum>;
};

export type AkebonoPenalty = {
  __typename?: 'AkebonoPenalty';
  /** Процент от стоимости покупки */
  baseAmount?: Maybe<Money>;
  createdAt?: Maybe<Scalars['Int']>;
  dayFirstPenalty?: Maybe<Scalars['DateTime']>;
  days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object?: Maybe<ObjectOfServices>;
  penaltyDays?: Maybe<Scalars['Int']>;
  penaltyDaysTotal?: Maybe<Scalars['Int']>;
  penaltyRubAmount?: Maybe<Money>;
  proposedPenaltyDays?: Maybe<Scalars['Int']>;
  /** Планируется начислить */
  proposedPenaltyJpyAmount?: Maybe<Money>;
  /** 100% начисленные пеналити */
  proposedPenaltyRubAmount?: Maybe<Money>;
  /** 1/x от стоимости авто */
  taxAmount?: Maybe<Money>;
};

export type ObjectKey = {
  __typename?: 'ObjectKey';
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  stage?: Maybe<Scalars['String']>;
  type?: Maybe<TypeOfObjectKey>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TypeOfObjectKey = {
  __typename?: 'TypeOfObjectKey';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};

export type Status = {
  __typename?: 'Status';
  id?: Maybe<Scalars['Int']>;
  outerNameEng?: Maybe<Scalars['String']>;
  outerNameRu?: Maybe<Scalars['String']>;
};

export type Ambassador = {
  __typename?: 'Ambassador';
  agent?: Maybe<Owner>;
  createdAt?: Maybe<Scalars['DateTime']>;
  formalBroker?: Maybe<Broker>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameRod?: Maybe<Scalars['String']>;
  nameRodShort?: Maybe<Scalars['String']>;
  nameShort?: Maybe<Scalars['String']>;
  nameShortAfter?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  requester?: Maybe<Broker>;
  thumbprint?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ObjectAuction = {
  __typename?: 'ObjectAuction';
  additionalKeysStatus?: Maybe<AdditionalKeysStatusEnum>;
  auc?: Maybe<Auction>;
  aucId?: Maybe<Scalars['Int']>;
  commentForClient?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  documentsComment?: Maybe<Scalars['String']>;
  freightPrice?: Maybe<Price>;
  id?: Maybe<Scalars['Int']>;
  isHaveVehicleRegistrationNumber?: Maybe<Scalars['Boolean']>;
  /** Фрахт оплачивается самостоятельно */
  isIndependentFreightPayment?: Maybe<Scalars['Boolean']>;
  isReturned?: Maybe<Scalars['Boolean']>;
  keepDocument?: Maybe<Scalars['Boolean']>;
  keepLicensePlates?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  lotData?: Maybe<Scalars['JSON']>;
  number?: Maybe<Scalars['String']>;
  paidAuctionInvoiceDate?: Maybe<Scalars['DateTime']>;
  /**
   * Стоимость объекта в Дубае
   * @deprecated Move to carClientParam type
   */
  priceInStock?: Maybe<Price>;
  /**
   * Стоимость объекта в пути до Дубая
   * @deprecated Move to carClientParam type
   */
  priceOnDelivery?: Maybe<Price>;
  purchasePrice?: Maybe<Price>;
  receivedCopyAuctionDoc?: Maybe<Scalars['Boolean']>;
  sawPrice?: Maybe<Price>;
  stock?: Maybe<Stock>;
  troubleComment?: Maybe<Scalars['String']>;
  vanningPrice?: Maybe<Price>;
};

export enum AdditionalKeysStatusEnum {
  Exist = 'EXIST',
  PutInside = 'PUT_INSIDE',
  Received = 'RECEIVED'
}

export type Auction = {
  __typename?: 'Auction';
  address?: Maybe<Scalars['String']>;
  auctionData?: Maybe<AuctionData>;
  auctionsCountryRestrictions?: Maybe<Array<AuctionsCountryRestrictions>>;
  auctionsDealerFees?: Maybe<Array<AuctionsDealerFees>>;
  auctionsDeliveryCosts?: Maybe<Array<AuctionsDeliveryCosts>>;
  /** Лого банка */
  bankLogo?: Maybe<S3File>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rating?: Maybe<AuctionRating>;
  stock?: Maybe<Stock>;
  ticketRules?: Maybe<Scalars['String']>;
};

export type AuctionData = {
  __typename?: 'AuctionData';
  auctionDealer?: Maybe<Scalars['Int']>;
  auctionDelivery?: Maybe<Scalars['Int']>;
  auctionDeliveryUndriveable?: Maybe<Scalars['Int']>;
  auctionSbor?: Maybe<Scalars['Int']>;
  auctionSborByNegotiations?: Maybe<Scalars['Int']>;
  carrier?: Maybe<Carrier>;
  costDelivery?: Maybe<Scalars['Float']>;
  destinationStock?: Maybe<Stock>;
  freight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  /** Time in HH:MM until when inspection is available after auction ends */
  inspectionAfterEndUntilTimeJst?: Maybe<Scalars['String']>;
  /** Hours before auction when inspection is available */
  inspectionAvailableBeforeHours?: Maybe<Scalars['Int']>;
  /** Whether inspection is enabled for this auction */
  inspectionEnabled?: Maybe<Scalars['Boolean']>;
  /** Inspection id */
  inspectionId?: Maybe<Scalars['Int']>;
  /** Service request type for inspection */
  inspectionRequestType?: Maybe<TypeOfServiceRequest>;
  isNoGroup?: Maybe<Scalars['Boolean']>;
  isNoPallet?: Maybe<Scalars['Boolean']>;
  port?: Maybe<Port>;
  remoteness?: Maybe<AuctionRemotenessEnum>;
  sourceStocks?: Maybe<Array<Stock>>;
};

export type TypeOfServiceRequest = {
  __typename?: 'TypeOfServiceRequest';
  additionalTypes?: Maybe<Array<TypeOfAdditionalServiceRequest>>;
  auctionName?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionEng?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isAdditional?: Maybe<Scalars['Boolean']>;
  /** Услуга является осмотром с аукциона */
  isAucInspection?: Maybe<Scalars['Boolean']>;
  isForObject?: Maybe<Scalars['Boolean']>;
  isOrdered?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};


export type TypeOfServiceRequestIsOrderedArgs = {
  objectId?: Maybe<Scalars['Int']>;
};

export type TypeOfAdditionalServiceRequest = {
  __typename?: 'TypeOfAdditionalServiceRequest';
  cost?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionEng?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};

export type Port = {
  __typename?: 'Port';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  portData?: Maybe<PortData>;
  stock?: Maybe<Stock>;
};

export type PortData = {
  __typename?: 'PortData';
  countryIso?: Maybe<Scalars['String']>;
  freight?: Maybe<Scalars['Float']>;
  freightM3?: Maybe<Scalars['Float']>;
  freightPart?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
};

export enum AuctionRemotenessEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type AuctionsCountryRestrictions = {
  __typename?: 'AuctionsCountryRestrictions';
  countryIso?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type AuctionsDealerFees = {
  __typename?: 'AuctionsDealerFees';
  commission?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['Int']>;
};

export type AuctionsDeliveryCosts = {
  __typename?: 'AuctionsDeliveryCosts';
  costDelivery?: Maybe<Scalars['Float']>;
  destinationCountryIso?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type AuctionRating = {
  __typename?: 'AuctionRating';
  /** Аукцион */
  auction?: Maybe<Auction>;
  /** Колличество оценок */
  evaluationCount?: Maybe<Scalars['Int']>;
  /** Колличество отзывов */
  feedbackCount?: Maybe<Scalars['Int']>;
  /** Id */
  id?: Maybe<Scalars['Int']>;
  /** Рейтинг аукциона */
  rating?: Maybe<Scalars['Float']>;
};

export type ObjectAuctionHistory = {
  __typename?: 'ObjectAuctionHistory';
  author?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  solver?: Maybe<Scalars['String']>;
  textError?: Maybe<Scalars['String']>;
  textSolve?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AuctionListing = {
  __typename?: 'AuctionListing';
  auction?: Maybe<Auction>;
  auctionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  kai?: Maybe<Scalars['String']>;
  notSoldPrice?: Maybe<Scalars['Int']>;
  numberLot?: Maybe<Scalars['String']>;
  soldPrice?: Maybe<Scalars['Int']>;
  startPrice?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
  transportCompany?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  wishPrice?: Maybe<Scalars['Int']>;
};

export type AuctionPaySheet = {
  __typename?: 'AuctionPaySheet';
  auction?: Maybe<Auction>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['String']>;
  files?: Maybe<Array<S3File>>;
  id?: Maybe<Scalars['Int']>;
  /** Отметка о том, что сумма проверена бухгалтером (null для legacy) */
  isAmountVerified?: Maybe<Scalars['Boolean']>;
  isSend?: Maybe<Scalars['Boolean']>;
  /** История изменений суммы Factual Invoice */
  metadata?: Maybe<Scalars['JSON']>;
  objectCount?: Maybe<Scalars['Int']>;
  objects?: Maybe<Array<ObjectOfServices>>;
  /** Информация о том кто нажимал оплачен расчётный лист */
  paidData?: Maybe<Array<AuctionPaySheetPaidData>>;
  paySheetObjects?: Maybe<Array<AuctionPaySheetObject>>;
  paySheetPayments?: Maybe<Array<AuctionPaySheetPayment>>;
  /** Статистика по расчетному листу (универсальная: legacy или factual) */
  paySheetStat?: Maybe<PaySheetsStat>;
  sendedAt?: Maybe<Scalars['DateTime']>;
  /** Тип листа: null (legacy), draft, active, closed, overpaid */
  type?: Maybe<PaySheetTypeEnum>;
};

export type AuctionPaySheetPaidData = {
  __typename?: 'AuctionPaySheetPaidData';
  createdTime?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type AuctionPaySheetObject = {
  __typename?: 'AuctionPaySheetObject';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  isPaid?: Maybe<Scalars['Boolean']>;
  lotNumber?: Maybe<Scalars['Int']>;
  lotNumberId?: Maybe<Scalars['Int']>;
  object?: Maybe<ObjectOfServices>;
};

export type AuctionPaySheetPayment = {
  __typename?: 'AuctionPaySheetPayment';
  amount?: Maybe<Scalars['Int']>;
  /** Комментарий менеджера */
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  /** Тип платежа: payment, advance, refund */
  type?: Maybe<PaySheetPaymentTypeEnum>;
  user?: Maybe<User>;
};

export enum PaySheetPaymentTypeEnum {
  /** Аванс */
  Advance = 'advance',
  /** Оплата */
  Payment = 'payment',
  /** Возврат */
  Refund = 'refund'
}

export type PaySheetsStat = {
  __typename?: 'PaySheetsStat';
  /** Введённая вручную сумма счёта от аукциона (null, если не введена) */
  factualInvoice?: Maybe<Scalars['Float']>;
  /** Флаг: подтверждён ли счёт менеджером вручную */
  isFactualInvoiceSet?: Maybe<Scalars['Boolean']>;
  notPaid?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export enum PaySheetTypeEnum {
  /** Активный */
  Active = 'active',
  /** Закрыт */
  Closed = 'closed',
  /** Черновик */
  Draft = 'draft',
  /** Переплачен */
  Overpaid = 'overpaid'
}

export type Bl = {
  __typename?: 'Bl';
  date?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<S3File>>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  objects?: Maybe<Array<ObjectOfServices>>;
};

export type BookingRequest = {
  __typename?: 'BookingRequest';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  objectStateName?: Maybe<Scalars['String']>;
  plan?: Maybe<Plan>;
  portFrom?: Maybe<Port>;
  sender?: Maybe<Sender>;
  senderCancelledAt?: Maybe<Scalars['DateTime']>;
  trip?: Maybe<Trip>;
};

export type Sender = {
  __typename?: 'Sender';
  address?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  defaultOwner?: Maybe<DefaultOwner>;
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Scalars['String']>>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Scalars['String']>>;
};

export type DefaultOwner = {
  __typename?: 'DefaultOwner';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Trip = {
  __typename?: 'Trip';
  bls?: Maybe<Array<Bl>>;
  contractClosingDate?: Maybe<Scalars['DateTime']>;
  countObjectByPlan?: Maybe<Scalars['Int']>;
  /** Растаможка от */
  customsClearanceFrom?: Maybe<Scalars['DateTime']>;
  /** Растаможка до */
  customsClearanceTo?: Maybe<Scalars['DateTime']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  dateVl?: Maybe<Scalars['DateTime']>;
  exportDeclarations?: Maybe<Array<ExportDeclaration>>;
  exportPaidAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<S3File>>;
  fullTitle?: Maybe<Scalars['String']>;
  guaranteedPlaces?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isArrived?: Maybe<Scalars['Boolean']>;
  isBookingAllow?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isExport?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  numberContainerLine?: Maybe<Scalars['String']>;
  /** Third party objects */
  objects?: Maybe<Array<ObjectOfServices>>;
  plan?: Maybe<Plan>;
  plans?: Maybe<Array<Plan>>;
  portFrom?: Maybe<Port>;
  portTo?: Maybe<Port>;
  reservePlaces?: Maybe<Scalars['Int']>;
  seaCarrier?: Maybe<SeaCarrier>;
  shipped?: Maybe<Scalars['Boolean']>;
  /** Выгрузка от */
  shipUnloadingFrom?: Maybe<Scalars['DateTime']>;
  /** Выгрузка до */
  shipUnloadingTo?: Maybe<Scalars['DateTime']>;
  simpleTitle?: Maybe<Scalars['String']>;
  stockTo?: Maybe<Stock>;
  tripBoxes?: Maybe<Array<TripBox>>;
  unloadingByUser?: Maybe<User>;
  unloadingFinishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vessel?: Maybe<Vessel>;
  vesselArrived?: Maybe<Scalars['Boolean']>;
  vesselNotArrived?: Maybe<Scalars['Boolean']>;
};

export type ExportDeclaration = {
  __typename?: 'ExportDeclaration';
  bookingNo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<S3File>>;
  id?: Maybe<Scalars['Int']>;
  objects?: Maybe<Array<ObjectOfServices>>;
  registrationDate?: Maybe<Scalars['DateTime']>;
};

export type SeaCarrier = {
  __typename?: 'SeaCarrier';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TripBox = {
  __typename?: 'TripBox';
  destinationOffice?: Maybe<Scalars['Int']>;
  destinationOfficeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  packages?: Maybe<Array<ObjectPackage>>;
  trip?: Maybe<Trip>;
};

export type ObjectPackage = {
  __typename?: 'ObjectPackage';
  attachments?: Maybe<Array<ObjectAttachment>>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  emailSentAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<S3File>>;
  id?: Maybe<Scalars['Int']>;
  isReturnableToOffice?: Maybe<Scalars['Boolean']>;
  isReturnableToTrip?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  issuedBy?: Maybe<User>;
  object?: Maybe<ObjectOfServices>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  recipient?: Maybe<User>;
  tripBox?: Maybe<TripBox>;
};

export type ObjectAttachment = {
  __typename?: 'ObjectAttachment';
  comment?: Maybe<Scalars['String']>;
  files?: Maybe<Array<S3File>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  package?: Maybe<ObjectPackage>;
  quantity?: Maybe<Scalars['Int']>;
  statusName?: Maybe<Scalars['String']>;
};

export type Vessel = {
  __typename?: 'Vessel';
  id?: Maybe<Scalars['Int']>;
  isAircraft?: Maybe<Scalars['Boolean']>;
  isRoro?: Maybe<Scalars['Boolean']>;
  lastNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numbers?: Maybe<Array<Scalars['String']>>;
  vesselType?: Maybe<VesselTypeInfo>;
};

export type VesselTypeInfo = {
  __typename?: 'VesselTypeInfo';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};

export type ObjectToSale = {
  __typename?: 'ObjectToSale';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Price>;
  saleAt?: Maybe<Scalars['DateTime']>;
};

export type CarClientParam = {
  __typename?: 'CarClientParam';
  createdAt?: Maybe<Scalars['DateTime']>;
  dealerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hasTelegram?: Maybe<Scalars['Boolean']>;
  hasWhatsapp?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  isSendToChannel?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  priceInDestination?: Maybe<Price>;
  priceInJapan?: Maybe<Price>;
  priceOnDelivery?: Maybe<Price>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ObjectClearance = {
  __typename?: 'ObjectClearance';
  createdAt?: Maybe<Scalars['DateTime']>;
  dateClearance?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
};

export type TypeOfExport = {
  __typename?: 'TypeOfExport';
  id?: Maybe<Scalars['Int']>;
  isDefaultForScrap?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
  outerNameEng?: Maybe<Scalars['String']>;
  outerNameRu?: Maybe<Scalars['String']>;
};

export type TypeOfChassis = {
  __typename?: 'TypeOfChassis';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<ChassisTypeEnum>;
};

export enum ChassisTypeEnum {
  Chassis = 'chassis',
  Frame = 'frame'
}

export type ObjectResaleActionCheck = {
  __typename?: 'ObjectResaleActionCheck';
  reason?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['Boolean']>;
};

export type SbktsPayment = {
  __typename?: 'SbktsPayment';
  /** Начисление ЭПТС */
  elpts?: Maybe<Scalars['Boolean']>;
  /** Начисление СБКТС */
  sbkts?: Maybe<Scalars['Boolean']>;
};

export type ObjectComment = {
  __typename?: 'ObjectComment';
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ComplexByInvoice = {
  __typename?: 'ComplexByInvoice';
  /** Комплекс услуг */
  complex?: Maybe<Scalars['Float']>;
  /** Фрахт */
  freight?: Maybe<Scalars['Float']>;
  /** Стоимость покупки */
  purchase?: Maybe<Scalars['Float']>;
  /** Ресайкл */
  recycle?: Maybe<Scalars['Float']>;
  /** Итого */
  total?: Maybe<Scalars['Float']>;
};

export enum ConditionConsigneeEnum {
  /** Отсутствует */
  Empty = 'Empty',
  /** Обработан */
  Processed = 'Processed',
  /** Предоставлен */
  Provided = 'Provided',
  /** Отклонен */
  Rejected = 'Rejected'
}

export type CreditStorage = {
  __typename?: 'CreditStorage';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['Int']>;
};

export type ExportTrip = {
  __typename?: 'ExportTrip';
  cancelReason?: Maybe<Scalars['String']>;
  declarationFile?: Maybe<S3File>;
  id?: Maybe<Scalars['Int']>;
  invoiceFile?: Maybe<S3File>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type OnPlan = {
  __typename?: 'OnPlan';
  boardingAt?: Maybe<Scalars['DateTime']>;
  contract?: Maybe<Scalars['Int']>;
  hasGeneratedBl?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isAttention?: Maybe<Scalars['Boolean']>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  jpCheckerNumber?: Maybe<Scalars['Int']>;
  object?: Maybe<ObjectOfServices>;
  plan?: Maybe<Plan>;
  quantity?: Maybe<Scalars['Int']>;
  quantityCancelled?: Maybe<Scalars['Int']>;
  reason?: Maybe<PlanCancellationReason>;
  unloadingAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type PlanCancellationReason = {
  __typename?: 'PlanCancellationReason';
  id?: Maybe<Scalars['Int']>;
  nameEn?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
};

export type ThirdPartyTrip = {
  __typename?: 'ThirdPartyTrip';
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  contract?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityCancelled?: Maybe<Scalars['String']>;
  trip?: Maybe<Trip>;
};

export type ObjectCustomDocument = {
  __typename?: 'ObjectCustomDocument';
  /** Список принятых типов документов которые нельзя перезагружать */
  acceptedFile?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Время смены статуса декларантом */
  changeStateAt?: Maybe<Scalars['DateTime']>;
  /** Требуется явка в таможню */
  comeToCustoms?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<Maybe<S3File>>>;
  id?: Maybe<Scalars['Int']>;
  invoiceCreateDate?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Документы приняты */
  isAccepted?: Maybe<Scalars['Boolean']>;
  /** Документы отклонены */
  isDecline?: Maybe<Scalars['Boolean']>;
  /** Можно ли принять или отменить набор документов */
  isNeedAction?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  /** Причина отмены */
  reasonCancel?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Пользователь */
  user?: Maybe<User>;
};

export type CustomPayment = {
  __typename?: 'CustomPayment';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TypeOfCustom = {
  __typename?: 'TypeOfCustom';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ObjectDelayRequest = {
  __typename?: 'ObjectDelayRequest';
  createdAt?: Maybe<Scalars['DateTime']>;
  holdTo?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  startDelayFrom?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type ObjectDelivered = {
  __typename?: 'ObjectDelivered';
  destinationStock?: Maybe<Stock>;
  driver?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  isDelivered?: Maybe<Scalars['Boolean']>;
  /** Сквозной номер заявки на доставку */
  number?: Maybe<Scalars['String']>;
  plan?: Maybe<Plan>;
  sourceStock?: Maybe<Stock>;
  systemCreatedAt?: Maybe<Scalars['DateTime']>;
  time?: Maybe<Scalars['DateTime']>;
  vehicle?: Maybe<Vehicle>;
  watch?: Maybe<Watch>;
};

export type Watch = {
  __typename?: 'Watch';
  airbagExploded?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['Int']>;
  colorObject?: Maybe<Color>;
  commentWatch?: Maybe<Scalars['String']>;
  countKeys?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  emptyBattery?: Maybe<Scalars['Boolean']>;
  engine?: Maybe<Scalars['String']>;
  engineCapacityL?: Maybe<Scalars['Float']>;
  engineModel?: Maybe<Scalars['String']>;
  enginePowerKwh?: Maybe<Scalars['Float']>;
  engineType?: Maybe<TypeOfEngine>;
  engineVolumeCm3?: Maybe<Scalars['Float']>;
  explodeDate?: Maybe<Scalars['DateTime']>;
  explodedBy?: Maybe<User>;
  explodeReportPrintedAt?: Maybe<Scalars['DateTime']>;
  freonRemoved?: Maybe<Scalars['Boolean']>;
  glonassIdentifier?: Maybe<Scalars['String']>;
  glonassModel?: Maybe<Scalars['String']>;
  /** Фальшфейер */
  hasBeaconFire?: Maybe<Scalars['Boolean']>;
  /** Регистратор */
  hasDashcam?: Maybe<Scalars['Boolean']>;
  /** Домкрат */
  hasJack?: Maybe<Scalars['Boolean']>;
  /** Насос компрессор */
  hasPumpCompressor?: Maybe<Scalars['Boolean']>;
  hasSdCard?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAcceptSecurity?: Maybe<Scalars['Boolean']>;
  isBroken?: Maybe<Scalars['Boolean']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isDrivable?: Maybe<Scalars['Boolean']>;
  isNeedEngineWatch?: Maybe<Scalars['Boolean']>;
  length?: Maybe<Scalars['Int']>;
  loadCapacity?: Maybe<Scalars['Float']>;
  maker?: Maybe<Maker>;
  makerColor?: Maybe<MakerColor>;
  /** Страна производства */
  manufactureCountry?: Maybe<Country>;
  mark?: Maybe<Mark>;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Model>;
  noFuel?: Maybe<Scalars['Boolean']>;
  permittedMaximumWeightSbkts?: Maybe<Scalars['Int']>;
  recycleNumber?: Maybe<Scalars['String']>;
  seats?: Maybe<Scalars['Int']>;
  transmission?: Maybe<Transmission>;
  user?: Maybe<User>;
  watchCarType?: Maybe<TypeOfWatchCar>;
  weight?: Maybe<Scalars['Float']>;
  weightFull?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Int']>;
};

export type Color = {
  __typename?: 'Color';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameWithoutCode?: Maybe<Scalars['String']>;
};

export type TypeOfEngine = {
  __typename?: 'TypeOfEngine';
  alias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Maker = {
  __typename?: 'Maker';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type MakerColor = {
  __typename?: 'MakerColor';
  colorCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  maker?: Maybe<Maker>;
};

export type Mark = {
  __typename?: 'Mark';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Model = {
  __typename?: 'Model';
  chassisType?: Maybe<Chassis>;
  engine?: Maybe<Engine>;
  height?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageEngine?: Maybe<S3File>;
  length?: Maybe<Scalars['String']>;
  mark?: Maybe<Mark>;
  name?: Maybe<Scalars['String']>;
  places?: Maybe<Scalars['String']>;
  transmission?: Maybe<Transmission>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['String']>;
};

export type Chassis = {
  __typename?: 'Chassis';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Engine = {
  __typename?: 'Engine';
  engineType?: Maybe<TypeOfEngine>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
};

export type Transmission = {
  __typename?: 'Transmission';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TypeOfWatchCar = {
  __typename?: 'TypeOfWatchCar';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ObjectDelivery = {
  __typename?: 'ObjectDelivery';
  contract?: Maybe<Scalars['Int']>;
  destinationSector?: Maybe<Sector>;
  destinationStock?: Maybe<Stock>;
  driver?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  isFound?: Maybe<Scalars['Boolean']>;
  /** Сквозной номер заявки на доставку */
  number?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  plan?: Maybe<Plan>;
  sourceSector?: Maybe<Sector>;
  sourceStock?: Maybe<Stock>;
  systemCreatedAt?: Maybe<Scalars['DateTime']>;
  watch?: Maybe<Watch>;
};

export type DeliveryRequest = {
  __typename?: 'DeliveryRequest';
  /** Примерная дата доставки */
  approximateDeliveryDate?: Maybe<Scalars['Date']>;
  assignCompanyAt?: Maybe<Scalars['DateTime']>;
  carrier?: Maybe<Carrier>;
  carrierComment?: Maybe<Scalars['String']>;
  clientPrice?: Maybe<Price>;
  comment?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdOver3Hours?: Maybe<Scalars['Boolean']>;
  deliveredDate?: Maybe<Scalars['DateTime']>;
  deliveryPrice?: Maybe<Price>;
  destinationStock?: Maybe<Stock>;
  driver?: Maybe<Driver>;
  driverBeginAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isAddedToPlan?: Maybe<Scalars['Boolean']>;
  isFound?: Maybe<Scalars['Boolean']>;
  /** Наши японские доставки c аукциона, между складами */
  isOwnJapan?: Maybe<Scalars['Boolean']>;
  /** Наши РФ доставки по перегонам */
  isOwnRussian?: Maybe<Scalars['Boolean']>;
  /** Сквозной номер заявки на доставку */
  number?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  /** Состояние объекта доставки для Бархатной */
  objectState?: Maybe<ObjectDeliveryState>;
  plan?: Maybe<DeliveryPlan>;
  priority?: Maybe<Scalars['Boolean']>;
  sourceStock?: Maybe<Stock>;
  status?: Maybe<Status>;
};

export type ObjectDeliveryState = {
  __typename?: 'ObjectDeliveryState';
  /** Есть ли доставка */
  hasDeliveryRequest?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  /** Находится в плане доставки */
  inPlan?: Maybe<Scalars['Boolean']>;
  /** Есть ли доставка */
  inRussia?: Maybe<Scalars['Boolean']>;
  /** Работа завершена */
  isCompleted?: Maybe<Scalars['Boolean']>;
  /** Доставлена */
  isDelivered?: Maybe<Scalars['Boolean']>;
  /** Начата доставка */
  onTransfer?: Maybe<Scalars['Boolean']>;
};

export type DeliveryPlan = {
  __typename?: 'DeliveryPlan';
  completedAt?: Maybe<Scalars['DateTime']>;
  countObjects?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deliveryRequests?: Maybe<Array<DeliveryRequest>>;
  driver?: Maybe<Driver>;
  id?: Maybe<Scalars['Int']>;
  isBeginDelivery?: Maybe<Scalars['Boolean']>;
  numberPlan?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vehicle?: Maybe<Vehicle>;
};

export enum OrganizationEnum {
  AkebonoLtd = 'AKEBONO_LTD',
  Autoimport = 'AUTOIMPORT'
}

export type DesiredTrip = {
  __typename?: 'DesiredTrip';
  createdAt?: Maybe<Scalars['DateTime']>;
  draftObject?: Maybe<DraftFreightObject>;
  id?: Maybe<Scalars['Int']>;
  object?: Maybe<ObjectOfServices>;
  trip?: Maybe<Trip>;
};

export type DraftFreightObject = {
  __typename?: 'DraftFreightObject';
  auction?: Maybe<Auction>;
  broker?: Maybe<Broker>;
  client?: Maybe<Owner>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfManufacture?: Maybe<Scalars['DateTime']>;
  desiredTrip?: Maybe<DesiredTrip>;
  draftBroker?: Maybe<DraftBroker>;
  draftClient?: Maybe<DraftClient>;
  exportPrice?: Maybe<Price>;
  id?: Maybe<Scalars['Int']>;
  isBoundary?: Maybe<Scalars['Boolean']>;
  maker?: Maybe<Maker>;
  mark?: Maybe<Mark>;
  name?: Maybe<Scalars['String']>;
  objectStateName?: Maybe<ObjectStateEnum>;
  payCountry?: Maybe<Country>;
  sender?: Maybe<Sender>;
  senderClient?: Maybe<DraftSenderClient>;
  vin?: Maybe<Scalars['String']>;
};

export type DraftBroker = {
  __typename?: 'DraftBroker';
  address?: Maybe<Scalars['String']>;
  contacts?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DraftClient = {
  __typename?: 'DraftClient';
  createdAt?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
};

export enum ObjectStateEnum {
  Car = 'CAR',
  Cut = 'CUT'
}

export type DraftSenderClient = {
  __typename?: 'DraftSenderClient';
  agent?: Maybe<Agent>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type DiagnosticDoc = {
  __typename?: 'DiagnosticDoc';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  issuedDate?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Disassemble = {
  __typename?: 'Disassemble';
  backPart?: Maybe<Scalars['Boolean']>;
  enginePart?: Maybe<Scalars['Boolean']>;
  forwardPart?: Maybe<Scalars['Boolean']>;
  framePart?: Maybe<Scalars['Boolean']>;
  palletPart?: Maybe<Scalars['Boolean']>;
};

export enum DisassemblyStateEnum {
  Active = 'active',
  Await = 'await',
  Completed = 'completed',
  Finish = 'finish',
  FinishNotSend = 'finish_not_send',
  Processing = 'processing'
}

export type Elpts = {
  __typename?: 'Elpts';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  issuedDate?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ObjectNotification = {
  __typename?: 'ObjectNotification';
  createdAt?: Maybe<Scalars['DateTime']>;
  emails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phones?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ExportCertificate = {
  __typename?: 'ExportCertificate';
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['String']>;
  file?: Maybe<S3File>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Int']>;
  issuedStatus?: Maybe<StatusToObject>;
  number?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  receivedOriginal?: Maybe<Scalars['Int']>;
  receivedStatus?: Maybe<StatusToObject>;
  returnAt?: Maybe<Scalars['DateTime']>;
  returnReason?: Maybe<Scalars['String']>;
  scheduledDate?: Maybe<Scalars['String']>;
};

export type StatusToObject = {
  __typename?: 'StatusToObject';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Status>;
};

export type CarFeedback = {
  __typename?: 'CarFeedback';
  /** Аукцион */
  auction?: Maybe<Auction>;
  /** Информация об обьекте */
  carInfo?: Maybe<CarInfo>;
  /** Дата создания */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Оценка 1-5 */
  evaluation?: Maybe<Scalars['Int']>;
  /** Отзыв */
  feedback?: Maybe<Scalars['String']>;
  /** Id */
  id?: Maybe<Scalars['Int']>;
  /** Создатель отзыва */
  owner?: Maybe<OwnerFeedback>;
};

export type CarInfo = {
  __typename?: 'CarInfo';
  /** Цвет */
  color?: Maybe<Scalars['String']>;
  /** Производитель */
  maker?: Maybe<Scalars['String']>;
  /** Марка */
  mark?: Maybe<Scalars['String']>;
  /** Год выпуска */
  year?: Maybe<Scalars['String']>;
};

export type OwnerFeedback = {
  __typename?: 'OwnerFeedback';
  /** Id пользователя */
  id?: Maybe<Scalars['Int']>;
  /** Ссылка на лот */
  link?: Maybe<Scalars['String']>;
  /** Колличество покупок совешенных пользователем */
  purchase?: Maybe<Scalars['Int']>;
  /** Рейтинг пользователя */
  rating?: Maybe<UserRatingEnum>;
};

/** Рейтинг */
export enum UserRatingEnum {
  Gold = 'gold',
  Newbie = 'newbie',
  Silver = 'silver'
}

export type FormalOwner = {
  __typename?: 'FormalOwner';
  bank?: Maybe<Scalars['String']>;
  bik?: Maybe<Scalars['String']>;
  dataForDocuments?: Maybe<OwnerData>;
  dateOfBirthday?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['String']>;
  documentIssuedAt?: Maybe<Scalars['DateTime']>;
  documentIssuedUnit?: Maybe<Scalars['String']>;
  documentIssuedUnitName?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Scalars['String']>>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inn?: Maybe<Scalars['String']>;
  innFile?: Maybe<S3File>;
  isLegalPerson?: Maybe<Scalars['Boolean']>;
  kpp?: Maybe<Scalars['String']>;
  ks?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
  officialName?: Maybe<Scalars['String']>;
  ogrn?: Maybe<Scalars['String']>;
  ogrnFile?: Maybe<S3File>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSerial?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Scalars['String']>>;
  placeOfBirthday?: Maybe<Scalars['String']>;
  registrationAddress?: Maybe<RegistrationAddress>;
  rs?: Maybe<Scalars['String']>;
  snils?: Maybe<Scalars['String']>;
};

export type RegistrationAddress = {
  __typename?: 'RegistrationAddress';
  country?: Maybe<Country>;
  detailedRegistrationAddress?: Maybe<DetailedRegistrationAddress>;
  fullAddressNameEng?: Maybe<Scalars['String']>;
  fullAddressNameRu?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type DetailedRegistrationAddress = {
  __typename?: 'DetailedRegistrationAddress';
  cityName?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  flat?: Maybe<Scalars['String']>;
  flatType?: Maybe<TypeOfFlat>;
  house?: Maybe<Scalars['String']>;
  houseType?: Maybe<TypeOfHouse>;
  housing?: Maybe<Scalars['String']>;
  housingType?: Maybe<TypeOfHousing>;
  localityName?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
};

export type TypeOfFlat = {
  __typename?: 'TypeOfFlat';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TypeOfHouse = {
  __typename?: 'TypeOfHouse';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TypeOfHousing = {
  __typename?: 'TypeOfHousing';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export enum FormalOwnerStateEnum {
  FormalOwner = 'FORMAL_OWNER',
  None = 'NONE',
  Recipient = 'RECIPIENT'
}

export type GreenCornerInspection = {
  __typename?: 'GreenCornerInspection';
  /** Проблемные части кузова */
  bodyParts?: Maybe<Array<GreenCornerBodyPartItem>>;
  /** Проверено Акебоно / Под восстановление, null — обычный объект */
  status?: Maybe<GreenCornerInspectionStatus>;
  statusName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Int'];
};

export type GreenCornerBodyPartItem = {
  __typename?: 'GreenCornerBodyPartItem';
  code: GreenCornerBodyPart;
  name: Scalars['String'];
  nameEng: Scalars['String'];
};

export enum GreenCornerBodyPart {
  /** Центральная левая стойка */
  CenterLeftPillar = 'center_left_pillar',
  /** Центральная правая стойка */
  CenterRightPillar = 'center_right_pillar',
  /** Передний бампер */
  FrontBumper = 'front_bumper',
  /** Передняя левая дверь */
  FrontLeftDoor = 'front_left_door',
  /** Переднее левое крыло */
  FrontLeftFender = 'front_left_fender',
  /** Передняя левая стойка */
  FrontLeftPillar = 'front_left_pillar',
  /** Передняя панель */
  FrontPanel = 'front_panel',
  /** Передняя правая дверь */
  FrontRightDoor = 'front_right_door',
  /** Переднее правое крыло */
  FrontRightFender = 'front_right_fender',
  /** Передняя правая стойка */
  FrontRightPillar = 'front_right_pillar',
  /** Капот */
  Hood = 'hood',
  /** Левый порог */
  LeftSill = 'left_sill',
  /** Задний бампер */
  RearBumper = 'rear_bumper',
  /** Задняя левая дверь */
  RearLeftDoor = 'rear_left_door',
  /** Задняя левая стойка */
  RearLeftPillar = 'rear_left_pillar',
  /** Левая задняя боковина */
  RearLeftQuarterPanel = 'rear_left_quarter_panel',
  /** Задняя панель */
  RearPanel = 'rear_panel',
  /** Задняя правая дверь */
  RearRightDoor = 'rear_right_door',
  /** Задняя правая стойка */
  RearRightPillar = 'rear_right_pillar',
  /** Правая задняя боковина */
  RearRightQuarterPanel = 'rear_right_quarter_panel',
  /** Правый порог */
  RightSill = 'right_sill',
  /** Крыша */
  Roof = 'roof',
  /** Задняя дверь / крышка багажного отсека */
  Tailgate = 'tailgate',
  /** Крышка багажника */
  TrunkLid = 'trunk_lid'
}

export enum GreenCornerInspectionStatus {
  /** Проверено Акебоно */
  Approved = 'APPROVED',
  /** Под восстановление */
  Restoration = 'RESTORATION'
}

export type InventoryObject = {
  __typename?: 'InventoryObject';
  checkedAt?: Maybe<Scalars['DateTime']>;
  checker?: Maybe<User>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inventory?: Maybe<Inventory>;
  inventorySource?: Maybe<Scalars['String']>;
  isFound?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  objectName?: Maybe<Scalars['String']>;
  sector?: Maybe<Sector>;
  vin?: Maybe<Scalars['String']>;
};

export type Inventory = {
  __typename?: 'Inventory';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  sectors?: Maybe<Array<Sector>>;
  solver?: Maybe<User>;
  stock?: Maybe<Stock>;
};

export type InvoiceCustom = {
  __typename?: 'InvoiceCustom';
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  advance?: Maybe<Scalars['Float']>;
  /** Сумма к оплате (с учётом аванса и депозита) */
  amount?: Maybe<Scalars['Float']>;
  bank?: Maybe<BankInvoice>;
  /** Можно ли перегенерировать документы */
  canRegenerateDocumentPack?: Maybe<Scalars['Boolean']>;
  /** Может выводить разницу по инвойсу */
  canWithdrawMoney?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  /** Ссылка на скачивание PDF-файла инвойса */
  customInvoiceUrl?: Maybe<Scalars['String']>;
  deliveryDay?: Maybe<Scalars['DateTime']>;
  deposit?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  fullName?: Maybe<Scalars['String']>;
  fullNameRu?: Maybe<Scalars['String']>;
  hasCustomLogo?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  inn?: Maybe<Scalars['String']>;
  invoiceType?: Maybe<InvoiceType>;
  number?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  objectsInvoice?: Maybe<Array<InvoiceCustomObject>>;
  owner?: Maybe<Owner>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  /** Платёжка  */
  paymentAgentRequest?: Maybe<InvoiceCustomDzenPay>;
  phone?: Maybe<Scalars['String']>;
  portName?: Maybe<Scalars['String']>;
  purposeMessage?: Maybe<Scalars['String']>;
  toBase64?: Maybe<Scalars['String']>;
  type?: Maybe<InvoiceCustomTypeEnum>;
  useAdvance?: Maybe<Scalars['Boolean']>;
  useDeposit?: Maybe<Scalars['Boolean']>;
};

export type InvoiceType = {
  __typename?: 'InvoiceType';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type InvoiceCustomObject = {
  __typename?: 'InvoiceCustomObject';
  amount?: Maybe<Scalars['Float']>;
  complexAmount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  freight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  object?: Maybe<ObjectOfServices>;
};

export type InvoiceCustomDzenPay = {
  __typename?: 'InvoiceCustomDzenPay';
  /** Сумма в иенах к зачислению */
  amountInJpy?: Maybe<Scalars['Float']>;
  amountInRubles?: Maybe<Scalars['Float']>;
  /** Время подтверждения отмены */
  approveCancelAt?: Maybe<Scalars['DateTime']>;
  /** Действия доступные для данного заказа в текущем статусе */
  availableActions?: Maybe<Array<DzenPayAvailableActionEnum>>;
  /** Контрагент баланса */
  balanceAgent?: Maybe<OwnerInfo>;
  /** Остаток в рублях */
  balanceInRub?: Maybe<Scalars['Float']>;
  bankInvoice?: Maybe<BankInvoice>;
  canceledBy?: Maybe<UserShortInfo>;
  cancelReason?: Maybe<Scalars['String']>;
  chat?: Maybe<ChatForOthers>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currencyControlPassedAt?: Maybe<Scalars['DateTime']>;
  /** Курс DzenPay */
  exchangeRate?: Maybe<Scalars['Float']>;
  /** Курс клиента */
  exchangeRateCustomer?: Maybe<Scalars['Float']>;
  /** Внутренний курс валюты */
  exchangeRateInner?: Maybe<Scalars['Float']>;
  /** Внутренний курс валюты (от курса платёжного агента) */
  exchangeRateInnerC?: Maybe<Scalars['Float']>;
  /** Актуальный document pack */
  files?: Maybe<Array<S3File>>;
  filesExpireAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  invoice?: Maybe<Invoice>;
  invoiceCustom?: Maybe<InvoiceCustom>;
  invoiceNumber?: Maybe<Scalars['String']>;
  /** В обработке */
  isProcessing?: Maybe<Scalars['Boolean']>;
  lastErrorMessage?: Maybe<Scalars['String']>;
  orderUid?: Maybe<Scalars['String']>;
  owner?: Maybe<OwnerInfo>;
  paymentAcceptedAt?: Maybe<Scalars['DateTime']>;
  paymentPageLink?: Maybe<Scalars['String']>;
  /** Тип оплаты */
  paymentType?: Maybe<DzenPayPaymentTypeEnum>;
  processedAt?: Maybe<Scalars['DateTime']>;
  /** Ошибка обработки */
  processingMessage?: Maybe<Scalars['String']>;
  ptdFiles?: Maybe<Array<S3File>>;
  receiptOfPayment?: Maybe<ReceiptOfPayment>;
  rejectedAt?: Maybe<Scalars['DateTime']>;
  sentToJapanAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<DzenPayOrderStatusEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Доступная мутация по заказу DzenPay */
export enum DzenPayAvailableActionEnum {
  /** Добавить менеджера DzenPay в чат */
  DzenPayAddManager = 'dzenPayAddManager',
  /** Менеджер: принять платёж */
  DzenPayManagerAcceptPayment = 'dzenPayManagerAcceptPayment',
  /** Менеджер: подтвердить отмену */
  DzenPayManagerConfirmCancellation = 'dzenPayManagerConfirmCancellation',
  /** Создать чат с клиентом */
  DzenPayManagerCreateChat = 'dzenPayManagerCreateChat',
  /** Менеджер: отклонить платёж */
  DzenPayManagerRejectPayment = 'dzenPayManagerRejectPayment',
  /** Партнёр: отклонить */
  DzenPayPartnerCancelled = 'dzenPayPartnerCancelled',
  /** Партнёр: завершить (только после принятия платежа менеджером) */
  DzenPayPartnerCompleted = 'dzenPayPartnerCompleted',
  /** Партнёр: восстановление заявки  */
  DzenPayPartnerRestoreInvoice = 'dzenPayPartnerRestoreInvoice',
  /** Перегенерировать document pack (пока нет квитанции об оплате) */
  DzenPayRegenerateDocuments = 'dzenPayRegenerateDocuments',
  /** Платёжный агент: обновить данные плательщика и пересобрать document pack */
  InvoiceCorrectionGenerate = 'invoiceCorrectionGenerate'
}

/** Тип оплаты */
export enum DzenPayPaymentTypeEnum {
  /** CASH */
  Cash = 'CASH',
  /** QR */
  Qr = 'QR'
}

export type ReceiptOfPayment = {
  __typename?: 'ReceiptOfPayment';
  /** Сумма платежа */
  amount?: Maybe<Scalars['Float']>;
  /** Валюта платежа */
  currency?: Maybe<Currency>;
  /** Дата оплаты */
  dateOfPayment?: Maybe<Scalars['DateTime']>;
  /** Файл чека в объекте */
  file?: Maybe<Array<Maybe<S3File>>>;
  /**
   * Файл чека депозит\аванс
   * @deprecated Moved to file
   */
  fileOthers?: Maybe<Array<Maybe<S3File>>>;
  id?: Maybe<Scalars['Int']>;
  /** Номер инвойса */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Результаты верификации загруженного чека */
  latestReceiptValidation?: Maybe<ReceiptValidation>;
  /** Комментарий */
  message?: Maybe<Scalars['String']>;
  /** Имя плательщика */
  senderName?: Maybe<Scalars['String']>;
};

export type ReceiptValidation = {
  __typename?: 'ReceiptValidation';
  amountOk?: Maybe<Scalars['Boolean']>;
  /** Когда была выполнена проверка */
  checkedAt?: Maybe<Scalars['DateTime']>;
  /** AI confidence in field extraction/comparison, not receipt authenticity */
  confidence?: Maybe<Scalars['Float']>;
  /** AI confidence percentage in field extraction/comparison */
  confidencePercent?: Maybe<Scalars['Int']>;
  currencyOk?: Maybe<Scalars['Boolean']>;
  customerNameOk?: Maybe<Scalars['Boolean']>;
  /** Решение проверки: verified/needs_review/rejected */
  decision?: Maybe<ReceiptValidationDecisionEnum>;
  /** AI provider: gemini/openai */
  driver?: Maybe<Scalars['String']>;
  /** Ошибка проверки */
  errorMessage?: Maybe<Scalars['String']>;
  extractedAmount?: Maybe<Scalars['Float']>;
  extractedCurrency?: Maybe<Scalars['String']>;
  extractedCustomerName?: Maybe<Scalars['String']>;
  extractedInvoicePurposeText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoicePurposeTextOk?: Maybe<Scalars['Boolean']>;
  /** Чек требует ручной проверки */
  isNeedsReview?: Maybe<Scalars['Boolean']>;
  /** Чек отклонен автоматической проверкой */
  isRejected?: Maybe<Scalars['Boolean']>;
  /** Чек автоматически подтвержден */
  isVerified?: Maybe<Scalars['Boolean']>;
  /** AI model name */
  model?: Maybe<Scalars['String']>;
  /** Raw validation result JSON */
  resultJson?: Maybe<Scalars['String']>;
  /** Статус проверки: processing/completed/failed */
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

/** Receipt validation decision */
export enum ReceiptValidationDecisionEnum {
  /** Receipt needs manual review */
  NeedsReview = 'needs_review',
  /** Receipt is rejected */
  Rejected = 'rejected',
  /** Receipt is verified */
  Verified = 'verified'
}

/** Статус платёжного заказа */
export enum DzenPayOrderStatusEnum {
  /** Отменённые */
  Canceled = 'CANCELED',
  /** Отменён клиентом */
  CancelledByClient = 'CANCELLED_BY_CLIENT',
  /** Агент принял платёж */
  Completed = 'COMPLETED',
  /** Клиент загрузил чек оплаты */
  CustomerCheckUploaded = 'CUSTOMER_CHECK_UPLOADED',
  /** Документы отправлены */
  DocumentPackSent = 'DOCUMENT_PACK_SENT',
  /** Заказ создан */
  OrderCreated = 'ORDER_CREATED',
  /** Менеджер АКБ принял платёж */
  PaymentAccepted = 'PAYMENT_ACCEPTED',
  /** Менеджер АКБ отклонил платёж */
  RejectedByManager = 'REJECTED_BY_MANAGER',
  /** Агент отклонил платёж */
  RejectedByPartner = 'REJECTED_BY_PARTNER'
}

export enum InvoiceCustomTypeEnum {
  Advance = 'advance',
  Default = 'default',
  Deposit = 'deposit',
  YahooDeposit = 'yahoo_deposit'
}

export type IssueBlock = {
  __typename?: 'IssueBlock';
  comment?: Maybe<Scalars['String']>;
  sourceType?: Maybe<IssueBlockedSourceEnum>;
};

export enum IssueBlockedSourceEnum {
  Navis = 'navis',
  Sender = 'sender',
  TemporaryStorage = 'temporary_storage',
  Trip = 'trip'
}

/** Объект на который произвели начисление со связью к заявке на доставку или сгон */
export type JapanPaymentsToRequest = {
  __typename?: 'JapanPaymentsToRequest';
  /** Начисленная сумма */
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** Статус отправки в 1С */
  isSend?: Maybe<Scalars['Boolean']>;
  /** Квинтанция расходов по Японии */
  japanPayment?: Maybe<JapanPayment>;
  /** Объект */
  object?: Maybe<ObjectOfServices>;
  /** Заявка с аукциона или сгон */
  request?: Maybe<DeliveryUnion>;
};

/** Квинтанция расходов по Японии */
export type JapanPayment = {
  __typename?: 'JapanPayment';
  /** Кол-во заявок */
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  /** Водитель выбрранный для начисления расходов */
  driver?: Maybe<Driver>;
  id?: Maybe<Scalars['Int']>;
  /** Заявки на доставк, сгон и объект за этот период */
  japanPaymentsToRequests?: Maybe<Array<Maybe<JapanPaymentsToRequest>>>;
  /** Статус обработки */
  status?: Maybe<Scalars['Boolean']>;
  /** Общая сумма в иенах */
  totalAmount?: Maybe<Scalars['Int']>;
  /** Тип начисления */
  type?: Maybe<TypeOfJapanPaymentEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Юзер создавший запись */
  user?: Maybe<User>;
};

export enum TypeOfJapanPaymentEnum {
  Food = 'FOOD',
  Fuel = 'FUEL',
  Highway = 'HIGHWAY'
}

export type DeliveryUnion = DeliveryRequest | ObjectDelivered;

export type KaitaiParam = {
  __typename?: 'KaitaiParam';
  id?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Price>;
};

export type StorageDaysByStock = {
  __typename?: 'StorageDaysByStock';
  carrier?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityStorageDays?: Maybe<Scalars['Int']>;
  stock?: Maybe<Stock>;
};

export type ObjectLogEvent = {
  __typename?: 'ObjectLogEvent';
  createdTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userName?: Maybe<Scalars['String']>;
};

export type Lot = {
  __typename?: 'Lot';
  /** Цвет */
  color?: Maybe<Scalars['String']>;
  /** Компания производитель */
  company?: Maybe<Scalars['String']>;
  /** Создано */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Дата производства */
  dateOfManufacture?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Скидка в % */
  discount?: Maybe<Scalars['Float']>;
  /** Дата окончания скидки (timestamp) */
  discountExpiresAt?: Maybe<Scalars['DateTime']>;
  /** Цена со скидкой */
  discountPrice?: Maybe<Scalars['Float']>;
  /** Исходное значение скидки */
  discountRaw?: Maybe<Scalars['Float']>;
  /** Тип скидки: percent или amount */
  discountType?: Maybe<DiscountTypeEnum>;
  /** Тип привода */
  driveType?: Maybe<Scalars['String']>;
  /** Объем двигателя */
  engineVolumeNum?: Maybe<Scalars['String']>;
  /** Оборудование */
  equipment?: Maybe<Scalars['String']>;
  /** Кузов */
  frame?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор */
  guid1C?: Maybe<Scalars['String']>;
  /** Наличе экспортного сертификата */
  hasExportCertificate?: Maybe<Scalars['Boolean']>;
  /** Мощность в лошадиных силах */
  horsepower?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** Красивые фото ЗУ отсортированы */
  isMediaSorted?: Maybe<Scalars['Boolean']>;
  /** Признак продано */
  isSold?: Maybe<Scalars['Boolean']>;
  /** Страна нахождения */
  location?: Maybe<Scalars['String']>;
  /** Фотографии */
  media?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Пробег */
  mileageNum?: Maybe<Scalars['String']>;
  /** Модель */
  model?: Maybe<Scalars['String']>;
  modelGrade?: Maybe<Scalars['String']>;
  /** Модель */
  modelType?: Maybe<Scalars['String']>;
  /** Просмотры всего */
  newPrice?: Maybe<Scalars['Boolean']>;
  /** Тип объекта */
  objectType?: Maybe<Scalars['String']>;
  /** Id dump */
  originalId?: Maybe<Scalars['String']>;
  /** Данные партнёра */
  partner?: Maybe<PartnerInfo>;
  /** Цена */
  priceInJapan?: Maybe<Scalars['String']>;
  /** Валюта */
  priceInJapanCurrency?: Maybe<Scalars['String']>;
  /** Цена */
  priceInStock?: Maybe<Scalars['String']>;
  /** Валюта */
  priceInStockCurrency?: Maybe<Scalars['String']>;
  /** Цена */
  priceOnDelivery?: Maybe<Scalars['String']>;
  /** Валюта */
  priceOnDeliveryCurrency?: Maybe<Scalars['String']>;
  /** Dump name */
  provider?: Maybe<Scalars['String']>;
  /** Оценка */
  scores?: Maybe<Scalars['String']>;
  /** Тип транспорта */
  subgroup?: Maybe<Scalars['String']>;
  /** Миниатюры фотографий */
  thumbnails?: Maybe<Scalars['String']>;
  /** Полное название */
  title?: Maybe<Scalars['String']>;
  /** Трансмиссия */
  transmission?: Maybe<Scalars['String']>;
  /** Просмотры всего */
  viewsAll: Scalars['Int'];
  /** Просмотры сегодня */
  viewsToday: Scalars['Int'];
  /** Вин код */
  vin?: Maybe<Scalars['String']>;
  /** Год выпуска */
  year?: Maybe<Scalars['String']>;
  /** Год для расчёт таможенных платежей */
  yearForCustom?: Maybe<Scalars['String']>;
};

export enum DiscountTypeEnum {
  Amount = 'amount',
  Percent = 'percent'
}

export type PartnerInfo = {
  __typename?: 'PartnerInfo';
  /** Адрес */
  address?: Maybe<Scalars['String']>;
  /** Количество продаваемых машин */
  carActiveCount?: Maybe<Scalars['Int']>;
  /** Количество привезенных машин */
  carCount?: Maybe<Scalars['Int']>;
  /** Количество проданных машин */
  carSoldCount?: Maybe<Scalars['Int']>;
  /** Ссылки на подробную информацию */
  contacts?: Maybe<Array<Maybe<ContactInfo>>>;
  /** Дата аккредитации */
  dateAccreditation?: Maybe<Scalars['DateTime']>;
  /** Год основания самого дилера */
  dateFoundationPartner?: Maybe<Scalars['String']>;
  /** Типы доставок */
  deliveryTypes?: Maybe<Array<Maybe<DeliveryTypeEnum>>>;
  /** Описание кратко, для карточки */
  description?: Maybe<Scalars['String']>;
  /** Скрывать контакты партнера */
  hideContacts?: Maybe<Scalars['Boolean']>;
  /** id */
  id?: Maybe<Scalars['Int']>;
  /** Геопозиция широта */
  latitude?: Maybe<Scalars['Float']>;
  /** Логотип */
  logo?: Maybe<Scalars['String']>;
  /** Геопозиция долгота */
  longitude?: Maybe<Scalars['Float']>;
  /** Фотографии офиса */
  officeImage?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Способы оплат */
  paymentTypes?: Maybe<Array<Maybe<PaymentTypeEnum>>>;
  /** Телефоны */
  phone?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Порядок отображения */
  position?: Maybe<Scalars['Int']>;
  /**
   * Use status, showOnHomepage, position
   * @deprecated Will be delete
   */
  showMain?: Maybe<StatusMainEnum>;
  /** Показать на главной */
  showOnHomepage?: Maybe<Scalars['Boolean']>;
  /** Статус партнёра */
  status?: Maybe<PartnerStatusEnum>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /**
   * Ссылки на подробную информацию
   * @deprecated Use contacts fieldd
   */
  urlsDetailedData?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Просмотры всего */
  viewsAll: Scalars['Int'];
  /** Просмотры сегодня */
  viewsToday: Scalars['Int'];
  /** Статус VIP */
  vip?: Maybe<Scalars['Boolean']>;
  /** Часы работы */
  workTime?: Maybe<Array<Maybe<WorkTime>>>;
};


export type PartnerInfoLogoArgs = {
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};


export type PartnerInfoOfficeImageArgs = {
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  /** Тип контакта */
  type?: Maybe<ContactTypeEnum>;
  /** Значение контакта */
  value?: Maybe<Scalars['String']>;
};

export enum ContactTypeEnum {
  AutoRu = 'auto_ru',
  Drom = 'drom',
  Email = 'email',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  MainWebsite = 'main_website',
  Max = 'max',
  Other = 'other',
  Phone = 'phone',
  Rutube = 'rutube',
  Telegram = 'telegram',
  Viber = 'viber',
  Vk = 'vk',
  Website = 'website',
  Whatsapp = 'whatsapp',
  YandexMap = 'yandex_map'
}

/** Типы доставок */
export enum DeliveryTypeEnum {
  /** Автовоз */
  CarHauler = 'car_hauler',
  /** Самовывоз */
  OwnCollection = 'own_collection',
  /** Ж/Д */
  Railway = 'railway'
}

/** Способы оплат */
export enum PaymentTypeEnum {
  /** Банковский перевод */
  BankPayment = 'bank_payment',
  /** Наличными в офисе */
  Cash = 'cash',
  /** Криптовалюта */
  CryptoCurrency = 'crypto_currency'
}

export enum StatusMainEnum {
  /** Активный */
  Active = 'active',
  /** Не активный */
  NotActive = 'not_active',
  /** На модерации */
  OnModeration = 'on_moderation'
}

export enum PartnerStatusEnum {
  /** Активный */
  Active = 'active',
  /** Не активный */
  NotActive = 'not_active',
  /** На модерации */
  OnModeration = 'on_moderation'
}

export type WorkTime = {
  __typename?: 'WorkTime';
  /** Конец рабочего дня */
  end?: Maybe<Scalars['DateTime']>;
  /** Начало рабочего дня */
  start?: Maybe<Scalars['DateTime']>;
};

export type ObjectMedia = {
  __typename?: 'ObjectMedia';
  items?: Maybe<Array<ObjectMediaItem>>;
  mediaType?: Maybe<MediaTypeEnum>;
};

export type ObjectMediaItem = {
  __typename?: 'ObjectMediaItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  fullPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageOrder?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isPhoto?: Maybe<Scalars['Boolean']>;
  thumbPath?: Maybe<Scalars['String']>;
};

export type ObjectMirror = {
  __typename?: 'ObjectMirror';
  id?: Maybe<Scalars['Int']>;
  isRemoved?: Maybe<Scalars['Boolean']>;
  vin?: Maybe<Scalars['String']>;
};

export type Recipient = {
  __typename?: 'Recipient';
  customPaymentType?: Maybe<CustomPayment>;
  declarant?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inn?: Maybe<Scalars['String']>;
  isAccepted?: Maybe<Scalars['Boolean']>;
  /** Грузополучатель находится в Дальневосточном федеральном округе */
  isDvfo?: Maybe<Scalars['Boolean']>;
  isLegalEntity?: Maybe<Scalars['Boolean']>;
  isNotProcessed?: Maybe<Scalars['Boolean']>;
  isRejected?: Maybe<Scalars['Boolean']>;
  /** Запросить квитанцию для предварительного пополнения лицевого счета на ФТС */
  isRequestReceiptFcs?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  nameIgnoreType?: Maybe<Scalars['String']>;
  passport?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
};

export enum ObjectActionsEnum {
  AcceptSvhDeliveryRequest = 'accept_svh_delivery_request',
  AddComment = 'add_comment',
  AddDeliveryToStock = 'add_delivery_to_stock',
  AddDisassemblyManual = 'add_disassembly_manual',
  AddDisassemblyNotice = 'add_disassembly_notice',
  AddObjectToPlan = 'add_object_to_plan',
  AddPriorityPass = 'add_priority_pass',
  AddRecipientsBroker = 'add_recipients_broker',
  AddRecipientsClient = 'add_recipients_client',
  AddRikuunAccrual = 'add_rikuun_accrual',
  AkebonoObjectPayDebt = 'akebono_object_pay_debt',
  AllowChangeRecipient = 'allow_change_recipient',
  Attachments = 'attachments',
  BookParkingLot = 'book_parking_lot',
  ButtonObjectHide = 'button_object_hide',
  ButtonObjectRemove = 'button_object_remove',
  CancelSvhDeliveryRequest = 'cancel_svh_delivery_request',
  ChangeBroker = 'change_broker',
  ChangeDesiredTrip = 'change_desired_trip',
  ChangeDestinationCountry = 'change_destination_country',
  ChangeExportPrice = 'change_export_price',
  ChangeFormalOwner = 'change_formal_owner',
  ChangeFreightCountry = 'change_freight_country',
  ChangeObjectInLoading = 'change_object_in_loading',
  ChangeObjectType = 'change_object_type',
  ChangeObjectVehicleType = 'change_object_vehicle_type',
  ChangeOwner = 'change_owner',
  ChangeParentObject = 'change_parent_object',
  ChangeSawType = 'change_saw_type',
  ChangeSender = 'change_sender',
  ChangeSenderClient = 'change_sender_client',
  ChangeVin = 'change_vin',
  CheckDateManufacture = 'check_date_manufacture',
  CompleteObject = 'complete_object',
  CreateAct = 'create_act',
  CreateChat = 'create_chat',
  CreateDeliveryRequest = 'create_delivery_request',
  CreateFeedbackCar = 'create_feedback_car',
  CreateInvoiceJapanAuctionPurchase = 'create_invoice_japan_auction_purchase',
  CreateParkingRequest = 'create_parking_request',
  CreateSbktsRequest = 'create_sbkts_request',
  CreateTicket = 'create_ticket',
  DeleteObject = 'delete_object',
  ExportToAuction = 'export_to_auction',
  FillEptsForm = 'fill_epts_form',
  GetActSvhDeliveryRequest = 'get_act_svh_delivery_request',
  HideImages = 'hide_images',
  HoldTo = 'hold_to',
  LockIssuance = 'lock_issuance',
  MoveMediaToObject = 'move_media_to_object',
  PbAgreementSended = 'pb_agreement_sended',
  PbAgreementUpload = 'pb_agreement_upload',
  PickupAppointment = 'pickup_appointment',
  PrintQr = 'print_qr',
  PutUpForSaleCreate = 'put_up_for_sale_create',
  PutUpForSaleSoldOut = 'put_up_for_sale_sold_out',
  PutUpForSaleUpdate = 'put_up_for_sale_update',
  PutUpForSaleWithdraw = 'put_up_for_sale_withdraw',
  RemoveFromStock = 'remove_from_stock',
  RemoveIsGreenCorner = 'remove_is_green_corner',
  RemoveObjectFromPlan = 'remove_object_from_plan',
  ReplaceDouble = 'replace_double',
  ReplaceToStock = 'replace_to_stock',
  ReportPaymentAkebono = 'report_payment_akebono',
  RequestDeliveryRussia = 'request_delivery_russia',
  RequestInvoicePrimBroker = 'request_invoice_prim_broker',
  RequestPrepareDocuments = 'request_prepare_documents',
  RequestToIssue = 'request_to_issue',
  Resale = 'resale',
  ResetObject = 'reset_object',
  RestoreObject = 'restore_object',
  SendObjectTo_1c = 'send_object_to_1c',
  ServiceRequestCreate = 'service_request_create',
  SetDateDismantleForCube = 'set_date_dismantle_for_cube',
  SetDateRecyclingToCube = 'set_date_recycling_to_cube',
  SetDateSoldRecyclingCube = 'set_date_sold_recycling_cube',
  SetDateSvhDeliveryRequest = 'set_date_svh_delivery_request',
  SetGeneralBasisAdvance = 'set_general_basis_advance',
  SetGlonassNeed = 'set_glonass_need',
  SetGuidFrom_1c = 'set_guid_from_1c',
  SetIndependentFreightPaymentFalse = 'set_independent_freight_payment_false',
  SetIndependentFreightPaymentTrue = 'set_independent_freight_payment_true',
  SetIsBoundary = 'set_is_boundary',
  SetIsGreenCorner = 'set_is_green_corner',
  SetMasterAccountClient = 'set_master_account_client',
  SetObjectCatalogPrices = 'set_object_catalog_prices',
  SetObjectGreenPrices = 'set_object_green_prices',
  SetObjectSoldDate = 'set_object_sold_date',
  ShowImages = 'show_images',
  SvhDeliveryRequest = 'svh_delivery_request',
  TakeSvhDeliveryRequest = 'take_svh_delivery_request',
  TransportingRequest = 'transporting_request',
  UnlockIssuance = 'unlock_issuance',
  UploadClientImages = 'upload_client_images',
  UploadCustomPaymentDoc = 'upload_custom_payment_doc',
  UploadFiles = 'upload_files',
  UploadPassengerCustomsDeclaration = 'upload_passenger_customs_declaration',
  VideoWatchRequest = 'video_watch_request',
  WatchObjectInLoading = 'watch_object_in_loading'
}

export type ObjectDisassemble = {
  __typename?: 'ObjectDisassemble';
  assignedAt?: Maybe<Scalars['DateTime']>;
  assignedBy?: Maybe<User>;
  assistants?: Maybe<Array<User>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  finishWorkAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isCurrentUserJob?: Maybe<Scalars['Boolean']>;
  manual?: Maybe<Scalars['String']>;
  notice?: Maybe<Scalars['String']>;
  selfAssistant?: Maybe<Scalars['Boolean']>;
  startWorkAt?: Maybe<Scalars['DateTime']>;
  worker?: Maybe<User>;
};

export enum ObjectIconsEnum {
  CustomsPaymentClient = 'CUSTOMS_PAYMENT_CLIENT',
  CustomsReceiptsInvoice = 'CUSTOMS_RECEIPTS_INVOICE',
  HasElpts = 'HAS_ELPTS',
  HasSbkts = 'HAS_SBKTS',
  IconAdditionalKeysExits = 'ICON_ADDITIONAL_KEYS_EXITS',
  IconAdditionalKeysPutInside = 'ICON_ADDITIONAL_KEYS_PUT_INSIDE',
  IconAdditionalKeysReceived = 'ICON_ADDITIONAL_KEYS_RECEIVED',
  IconAttachments = 'ICON_ATTACHMENTS',
  IconAttention = 'ICON_ATTENTION',
  IconAuctionDocuments = 'ICON_AUCTION_DOCUMENTS',
  IconAuctionPaid = 'ICON_AUCTION_PAID',
  IconBl = 'ICON_BL',
  IconBlockedBy_1C = 'ICON_BLOCKED_BY_1C',
  IconBlockedBySender = 'ICON_BLOCKED_BY_SENDER',
  IconBlockedByTrip = 'ICON_BLOCKED_BY_TRIP',
  IconBoundary = 'ICON_BOUNDARY',
  IconBroken = 'ICON_BROKEN',
  IconCarDelete = 'ICON_CAR_DELETE',
  IconComplete = 'ICON_COMPLETE',
  IconCopyAuctionDocs = 'ICON_COPY_AUCTION_DOCS',
  IconCut = 'ICON_CUT',
  IconDebt = 'ICON_DEBT',
  IconDelayedDelivery = 'ICON_DELAYED_DELIVERY',
  IconDocuments = 'ICON_DOCUMENTS',
  IconEmptyBattery = 'ICON_EMPTY_BATTERY',
  IconExportCertificate = 'ICON_EXPORT_CERTIFICATE',
  IconExportCertificateOriginal = 'ICON_EXPORT_CERTIFICATE_ORIGINAL',
  IconExportPrice = 'ICON_EXPORT_PRICE',
  IconFreightInvoiceNotPaid = 'ICON_FREIGHT_INVOICE_NOT_PAID',
  IconFreightInvoicePaid = 'ICON_FREIGHT_INVOICE_PAID',
  IconHasDisassemblyPhoto = 'ICON_HAS_DISASSEMBLY_PHOTO',
  IconHasDisassemblyVideo = 'ICON_HAS_DISASSEMBLY_VIDEO',
  IconHasOcrObject = 'ICON_HAS_OCR_OBJECT',
  IconHasRecipient = 'ICON_HAS_RECIPIENT',
  IconHasSbktsPdf = 'ICON_HAS_SBKTS_PDF',
  IconIndependentFreightPayment = 'ICON_INDEPENDENT_FREIGHT_PAYMENT',
  IconIsGreenCorner = 'ICON_IS_GREEN_CORNER',
  IconKeepDocuments = 'ICON_KEEP_DOCUMENTS',
  IconKeepLicensePlates = 'ICON_KEEP_LICENSE_PLATES',
  IconNeedFixSaw = 'ICON_NEED_FIX_SAW',
  IconNewCarObject = 'ICON_NEW_CAR_OBJECT',
  IconNoAuctionDocuments = 'ICON_NO_AUCTION_DOCUMENTS',
  IconNoCopyAuctionDocs = 'ICON_NO_COPY_AUCTION_DOCS',
  IconNoExportCertificate = 'ICON_NO_EXPORT_CERTIFICATE',
  IconNoExportCertificateOriginal = 'ICON_NO_EXPORT_CERTIFICATE_ORIGINAL',
  IconNoFuel = 'ICON_NO_FUEL',
  IconNonPassLab = 'ICON_NON_PASS_LAB',
  IconNotDrivable = 'ICON_NOT_DRIVABLE',
  IconObjectMedia = 'ICON_OBJECT_MEDIA',
  IconPackages = 'ICON_PACKAGES',
  IconPaidStock = 'ICON_PAID_STOCK',
  IconPaySheet = 'ICON_PAY_SHEET',
  IconPbDocumentsIsDeclined = 'ICON_PB_DOCUMENTS_IS_DECLINED',
  IconPbDocumentsIsNotReceived = 'ICON_PB_DOCUMENTS_IS_NOT_RECEIVED',
  IconPbDocumentsIsReceived = 'ICON_PB_DOCUMENTS_IS_RECEIVED',
  IconPickUpAppointmentPlanned = 'ICON_PICK_UP_APPOINTMENT_PLANNED',
  IconPlannedVessel = 'ICON_PLANNED_VESSEL',
  IconReceiptOfPayment = 'ICON_RECEIPT_OF_PAYMENT',
  IconReceiptOfPaymentAttached = 'ICON_RECEIPT_OF_PAYMENT_ATTACHED',
  IconSahalin = 'ICON_SAHALIN',
  IconTemporaryPass = 'ICON_TEMPORARY_PASS',
  IconTickets = 'ICON_TICKETS',
  IconTrackingNumber = 'ICON_TRACKING_NUMBER'
}

export type ObjectPaidStorageData = {
  __typename?: 'ObjectPaidStorageData';
  /** Дней до начала начислений на склад */
  freeDaysLeft?: Maybe<Scalars['Int']>;
  /** Прошло дней с начислением */
  paidDays?: Maybe<Scalars['Int']>;
  /** Сумма к начислению */
  paidDaysSum?: Maybe<Scalars['Int']>;
};

export type ObjectParkingRequestCancel = {
  __typename?: 'ObjectParkingRequestCancel';
  comment?: Maybe<Scalars['String']>;
  commentAi?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['Boolean']>;
  type?: Maybe<ParkingRequestCanceledTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export enum ParkingRequestCanceledTypeEnum {
  Both = 'BOTH',
  Parking = 'PARKING',
  ToAutoimport = 'TO_AUTOIMPORT'
}

export type ObjectParkingRequest = {
  __typename?: 'ObjectParkingRequest';
  comment?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasOutFromSVHStatus?: Maybe<Scalars['Boolean']>;
  histories?: Maybe<Array<ObjectParkingRequestHistory>>;
  id?: Maybe<Scalars['Int']>;
  invoices?: Maybe<Array<Invoice>>;
  isActive?: Maybe<Scalars['Boolean']>;
  isCanCancel?: Maybe<Scalars['Boolean']>;
  isCanClose?: Maybe<Scalars['Boolean']>;
  isCanRequestPass?: Maybe<Scalars['Boolean']>;
  isCanUploadFiles?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHasBeforeOuterParkingPhoto?: Maybe<Scalars['Boolean']>;
  isHasOuterParkingPhoto?: Maybe<Scalars['Boolean']>;
  isPrepared?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ObjectParkingRequestHistory = {
  __typename?: 'ObjectParkingRequestHistory';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
  user?: Maybe<User>;
};

export enum ObjectRelationTypeEnum {
  Attachment = 'ATTACHMENT',
  Saw = 'SAW',
  Self = 'SELF'
}

export enum PassengerCustomsDeclarationStatusEnum {
  /** Не требуется */
  NotRequired = 'NOT_REQUIRED',
  /** Требуется */
  Required = 'REQUIRED',
  /** Загружена */
  Uploaded = 'UPLOADED'
}

export type PaymentPlan = {
  __typename?: 'PaymentPlan';
  /** Ставки плана оплаты */
  conditions?: Maybe<Array<PaymentPlanCondition>>;
  /** Доп. описание */
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** Краткое обозначение */
  name: Scalars['String'];
};

export type PaymentPlanCondition = {
  __typename?: 'PaymentPlanCondition';
  /** Период до(-)/после(+) события */
  days: Scalars['Int'];
  /** Событие */
  event: PaymentPlanEventEnum;
  id: Scalars['Int'];
  /** Процентная ставка */
  percentage: Scalars['Int'];
};

export enum PaymentPlanEventEnum {
  /** Добавлен в план */
  AddToPlan = 'ADD_TO_PLAN',
  /** Дата прибытия в порт */
  BeforeArrived = 'BEFORE_ARRIVED',
  /** BL отправлен */
  BlSend = 'BL_SEND',
  /** Куплен */
  Buy = 'BUY',
  /** Погружен */
  LoadingToBoat = 'LOADING_TO_BOAT',
  /** Выгружен */
  Unload = 'UNLOAD'
}

export type PbAgreement = {
  __typename?: 'PbAgreement';
  cancelReason?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inn?: Maybe<Scalars['String']>;
  isAcceptedInOffice?: Maybe<Scalars['Boolean']>;
  isSendToOffice?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  passport?: Maybe<Scalars['String']>;
  passportAddress?: Maybe<DetailedRegistrationAddress>;
  passportIssued?: Maybe<Scalars['String']>;
  passportIssuedAt?: Maybe<Scalars['String']>;
  passportIssueUnit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ObjectMediaBlock = {
  __typename?: 'ObjectMediaBlock';
  id?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

export type PreDeliveryObject = {
  __typename?: 'PreDeliveryObject';
  delivery?: Maybe<DeliveryRequest>;
  executeAfterPaymentDate?: Maybe<Scalars['Boolean']>;
  frameNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDrivable?: Maybe<Scalars['Boolean']>;
  lotId?: Maybe<Scalars['String']>;
  maker?: Maybe<Scalars['String']>;
  paymentDate?: Maybe<Scalars['DateTime']>;
  preDeliveryAuction?: Maybe<PreDeliveryAuction>;
  price?: Maybe<Price>;
  reasonReject?: Maybe<Scalars['String']>;
  status?: Maybe<DeliveryObjectStatusEnum>;
};

export type PreDeliveryAuction = {
  __typename?: 'PreDeliveryAuction';
  aucName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryRequest>;
  id?: Maybe<Scalars['Int']>;
  isNumberCut?: Maybe<Scalars['Boolean']>;
  numberCut?: Maybe<Scalars['String']>;
  objects?: Maybe<Array<PreDeliveryObject>>;
  port?: Maybe<Port>;
  preDeliveryRequest?: Maybe<PreDeliveryRequest>;
  stock?: Maybe<Stock>;
};

export type PreDeliveryRequest = {
  __typename?: 'PreDeliveryRequest';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  navisInternalId?: Maybe<Scalars['String']>;
  preDeliveryRequest?: Maybe<Array<PreDeliveryAuction>>;
};

export enum DeliveryObjectStatusEnum {
  Active = 'active',
  Reject = 'reject'
}

export type ObjectRecycleStatus = {
  __typename?: 'ObjectRecycleStatus';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserShortInfo>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserShortInfo>;
};

export type RequestToIssueObject = {
  __typename?: 'RequestToIssueObject';
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  plannedAt?: Maybe<Scalars['DateTime']>;
  sender?: Maybe<Sender>;
  storageDaysCount?: Maybe<Scalars['Int']>;
};

export type ObjectResale = {
  __typename?: 'ObjectResale';
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<User>;
  buyer?: Maybe<Owner>;
  buyerApprovedAt?: Maybe<Scalars['DateTime']>;
  /** Долги покупателя */
  buyerDebts?: Maybe<Array<Price>>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerFullName?: Maybe<Scalars['String']>;
  buyerPhone?: Maybe<Scalars['String']>;
  checkAllowApprove?: Maybe<ObjectResaleActionCheck>;
  checkAllowComplete?: Maybe<ObjectResaleActionCheck>;
  checkAllowDelete?: Maybe<ObjectResaleActionCheck>;
  checkAllowUpdate?: Maybe<ObjectResaleActionCheck>;
  /** Сумма комиссии за услугу перепродажи */
  comissionAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  /** Сумма фрахта для покупателя */
  freightAmount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** Текущий юзер - покупатель */
  isBuyer?: Maybe<Scalars['Boolean']>;
  /** Текущий юзер - продавец */
  isSeller?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  price?: Maybe<Price>;
  seller?: Maybe<Owner>;
  sellerApprovedAt?: Maybe<Scalars['DateTime']>;
  /** Долги продавца */
  sellerDebts?: Maybe<Array<Price>>;
  /** Сумма фрахта для продавца */
  sellerFreightAmount?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};

export type TypeOfSaw = {
  __typename?: 'TypeOfSaw';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  plan?: Maybe<DisassemblyPlan>;
};

export type DisassemblyPlan = {
  __typename?: 'DisassemblyPlan';
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['Int']>;
  isDelete?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  saw?: Maybe<TypeOfSaw>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SbktsRequest = {
  __typename?: 'SbktsRequest';
  activeAdditionalBlanks?: Maybe<Array<SbktsAdditionalBlank>>;
  activeHold?: Maybe<SbktsHold>;
  ambassador?: Maybe<Ambassador>;
  approve?: Maybe<SbktsApprove>;
  assignedUser?: Maybe<User>;
  assignedUserAt?: Maybe<Scalars['DateTime']>;
  beginWorkAt?: Maybe<Scalars['DateTime']>;
  blankNumber?: Maybe<Scalars['String']>;
  blankSeria?: Maybe<SbktsBlankSeria>;
  cancelReason?: Maybe<SbktsReason>;
  categoryCar?: Maybe<CategoryCar>;
  comments?: Maybe<Array<SbktsRequestComment>>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  damagedBlanks?: Maybe<Array<SbktsDamagedBlank>>;
  deletedAdditionalBlanks?: Maybe<Array<SbktsAdditionalBlank>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryToAi?: Maybe<DeliveryRequest>;
  deliveryToTroyan?: Maybe<DeliveryRequest>;
  events?: Maybe<Array<SbktsRequestEvent>>;
  expertDailyParams?: Maybe<Array<ExpertDailyParam>>;
  files?: Maybe<Array<Maybe<SbktsFile>>>;
  hasClosedHolds?: Maybe<Scalars['Boolean']>;
  holds?: Maybe<Array<SbktsHold>>;
  id?: Maybe<Scalars['Int']>;
  inBoxing?: Maybe<Scalars['Boolean']>;
  inCustomLaboratory?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isCanEditClosed?: Maybe<Scalars['Boolean']>;
  isCanPrint?: Maybe<Scalars['Boolean']>;
  isCanRestore?: Maybe<Scalars['Boolean']>;
  isCompleteRelease?: Maybe<Scalars['Boolean']>;
  isCreateBlank1c?: Maybe<Scalars['Boolean']>;
  isCreateObject1c?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEmptyThumbprint?: Maybe<Scalars['Boolean']>;
  isExternal?: Maybe<Scalars['Boolean']>;
  isHasFewTemplate?: Maybe<Scalars['Boolean']>;
  isHasRequestPdf?: Maybe<Scalars['Boolean']>;
  isHasRequiredAgentMedia?: Maybe<Scalars['Boolean']>;
  isLegalPerson?: Maybe<Scalars['Boolean']>;
  isPaperType?: Maybe<Scalars['Boolean']>;
  isPassedTests?: Maybe<Scalars['Boolean']>;
  isPassedTestsAt?: Maybe<Scalars['DateTime']>;
  isProcessed?: Maybe<Scalars['Boolean']>;
  isQuickly?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['String']>;
  /** Лаборатория */
  laboratory?: Maybe<Laboratory>;
  laboratoryExpert?: Maybe<LaboratoryExpert>;
  /** Приемщик транспортного средства */
  laboratoryVehicleReceiver?: Maybe<LaboratoryExpert>;
  media?: Maybe<Array<Maybe<SbktsObjectMedia>>>;
  notApprovedByDays?: Maybe<Scalars['Boolean']>;
  object?: Maybe<ObjectOfServices>;
  protocolNumber?: Maybe<Scalars['String']>;
  readySendToFgisAt?: Maybe<Scalars['DateTime']>;
  requester?: Maybe<Broker>;
  requestNumber?: Maybe<Scalars['String']>;
  sbktsNumber?: Maybe<Scalars['String']>;
  sbktsObject?: Maybe<SbktsObject>;
  sendToFgisAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};


export type SbktsRequestNotApprovedByDaysArgs = {
  days: Scalars['Int'];
};

export type SbktsAdditionalBlank = {
  __typename?: 'SbktsAdditionalBlank';
  blankSeria?: Maybe<SbktsBlankSeria>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SbktsBlankSeria = {
  __typename?: 'SbktsBlankSeria';
  blankRegistration?: Maybe<SbktsBlankRegistration>;
  blankType?: Maybe<SbktsBlankSeriaEnum>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  laboratory?: Maybe<Laboratory>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  usedCount?: Maybe<Scalars['Int']>;
};

export type SbktsBlankRegistration = {
  __typename?: 'SbktsBlankRegistration';
  id?: Maybe<Scalars['Int']>;
  numberFrom?: Maybe<Scalars['Int']>;
  numberTo?: Maybe<Scalars['Int']>;
};

export enum SbktsBlankSeriaEnum {
  TypeAdditional = 'TYPE_ADDITIONAL',
  TypeMain = 'TYPE_MAIN'
}

export type SbktsHold = {
  __typename?: 'SbktsHold';
  holdAt?: Maybe<Scalars['DateTime']>;
  holdType?: Maybe<TypeOfHold>;
  id?: Maybe<Scalars['Int']>;
  reason?: Maybe<SbktsReason>;
  unHoldAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type TypeOfHold = {
  __typename?: 'TypeOfHold';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type SbktsReason = {
  __typename?: 'SbktsReason';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type SbktsApprove = {
  __typename?: 'SbktsApprove';
  approvedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type SbktsRequestComment = {
  __typename?: 'SbktsRequestComment';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

export type SbktsDamagedBlank = {
  __typename?: 'SbktsDamagedBlank';
  additionalBlank?: Maybe<SbktsAdditionalBlank>;
  blankSeria?: Maybe<SbktsBlankSeria>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  sbktsRequest?: Maybe<SbktsRequest>;
  status?: Maybe<SbktsDamagedStatusEnum>;
  user?: Maybe<User>;
};

export enum SbktsDamagedStatusEnum {
  StatusDamaged = 'STATUS_DAMAGED',
  StatusRevoke = 'STATUS_REVOKE'
}

export type SbktsRequestEvent = {
  __typename?: 'SbktsRequestEvent';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Модель с данными для заполнения ежедневных измерений */
export type ExpertDailyParam = {
  __typename?: 'ExpertDailyParam';
  /** Аффикс для названия передается во ФГИС */
  affixText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Ключ в документах */
  docName?: Maybe<Scalars['String']>;
  /** Подгруппа параметров */
  groupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** Лаборатория */
  laboratory?: Maybe<Laboratory>;
  /** Название параметра */
  name?: Maybe<Scalars['String']>;
  /** Порядок отображения */
  position?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SbktsFile = {
  __typename?: 'SbktsFile';
  createdAt?: Maybe<Scalars['DateTime']>;
  doc?: Maybe<DocxTemplate>;
  fileDocx?: Maybe<S3File>;
  filePdf?: Maybe<S3File>;
  fileSig?: Maybe<S3File>;
  id?: Maybe<Scalars['Int']>;
  statusFgis?: Maybe<Scalars['String']>;
  /** Список незаполненных полей в документе */
  undefinedVariables?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DocxTemplate = {
  __typename?: 'DocxTemplate';
  categoriesCar?: Maybe<Array<CategoryCar>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentType?: Maybe<TypeOfDocumentEnum>;
  fileFizik?: Maybe<S3File>;
  filesOld?: Maybe<Array<Maybe<S3File>>>;
  fileUrik?: Maybe<S3File>;
  id?: Maybe<Scalars['Int']>;
  internalUse?: Maybe<Scalars['Boolean']>;
  isProcessed?: Maybe<Scalars['Boolean']>;
  laboratory?: Maybe<Laboratory>;
  name?: Maybe<Scalars['String']>;
  needSignDeputy?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  protocolToFgis?: Maybe<Scalars['Boolean']>;
  pteToFgis?: Maybe<Scalars['Boolean']>;
  suffix?: Maybe<Scalars['String']>;
  template?: Maybe<DocxTemplateInfo>;
};

export enum TypeOfDocumentEnum {
  Header = 'header',
  Template = 'template'
}

export type DocxTemplateInfo = {
  __typename?: 'DocxTemplateInfo';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type SbktsObjectMedia = {
  __typename?: 'SbktsObjectMedia';
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<S3File>;
  fileOld?: Maybe<MediaUnion>;
  fileSig?: Maybe<S3File>;
  id?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<SbktsObjectMediaTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MediaUnion = ObjectMediaItem | S3File;

export enum SbktsObjectMediaTypeEnum {
  HeadlightTest = 'headlight_test',
  ImgBrakeSystem = 'img_brake_system',
  ImgConsignment = 'img_consignment',
  ImgEmissions = 'img_emissions',
  ImgGeneralView_1 = 'img_general_view_1',
  ImgGeneralView_2 = 'img_general_view_2',
  ImgIdentificationPlate = 'img_identification_plate',
  ImgInnLegalOwner = 'img_inn_legal_owner',
  ImgNoise = 'img_noise',
  ImgOgrnLegalOwner = 'img_ogrn_legal_owner',
  ImgPassportFirst = 'img_passport_first',
  ImgPassportMain = 'img_passport_main',
  ImgPassportRegistration = 'img_passport_registration',
  ImgTpo_1 = 'img_tpo_1',
  ImgTpo_2 = 'img_tpo_2',
  MeasuringPlatform = 'measuring_platform',
  VehicleFromBelow = 'vehicle_from_below'
}

export type SbktsObject = {
  __typename?: 'SbktsObject';
  axesNumber?: Maybe<Scalars['String']>;
  baseSize?: Maybe<Scalars['String']>;
  batterySystem?: Maybe<Scalars['String']>;
  brakeSystem?: Maybe<Scalars['String']>;
  cabine?: Maybe<Scalars['String']>;
  carCategory?: Maybe<Scalars['String']>;
  cargoPlace?: Maybe<Scalars['String']>;
  carLinkage?: Maybe<Scalars['String']>;
  chassis?: Maybe<Scalars['String']>;
  chassisOther?: Maybe<Scalars['String']>;
  clutchSystem?: Maybe<Scalars['String']>;
  collectorSystem?: Maybe<Scalars['String']>;
  combisionEngine?: Maybe<Scalars['String']>;
  combisionEngineCompression?: Maybe<Scalars['String']>;
  combisionEngineCylinder?: Maybe<Scalars['String']>;
  combisionEngineCylindersNumber?: Maybe<Scalars['String']>;
  combisionEngineCylindersPosition?: Maybe<Scalars['String']>;
  combisionEngineFuel?: Maybe<Scalars['String']>;
  combisionEngineFuelSystem?: Maybe<Scalars['String']>;
  combisionEngineIgnitionSystem?: Maybe<Scalars['String']>;
  combisionEngineMaxPowerKWt?: Maybe<Scalars['String']>;
  combisionEngineMaxRpm?: Maybe<Scalars['String']>;
  combisionEngineMinRpm?: Maybe<Scalars['String']>;
  combisionEngineVolumeCm3?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  document?: Maybe<DocumentTemplate>;
  driveType?: Maybe<Scalars['String']>;
  ecologyClass?: Maybe<Scalars['String']>;
  electroSystem?: Maybe<Scalars['String']>;
  electroSystem30mMaxPowerKWt?: Maybe<Scalars['String']>;
  electroSystemVoltage?: Maybe<Scalars['String']>;
  enginePosition?: Maybe<Scalars['String']>;
  forwardSuspensionSystem?: Maybe<Scalars['String']>;
  frameType?: Maybe<Scalars['String']>;
  fullWeight?: Maybe<Scalars['String']>;
  gearBoxSystem?: Maybe<Scalars['String']>;
  generatorSystem?: Maybe<Scalars['String']>;
  generatorSystem30mMaxPower?: Maybe<Scalars['String']>;
  generatorSystemVoltage?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  hybridSystem?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  length?: Maybe<Scalars['String']>;
  luggagePlace?: Maybe<Scalars['String']>;
  mainBrakeSystem?: Maybe<Scalars['String']>;
  makerAddress?: Maybe<Scalars['String']>;
  makerName?: Maybe<Scalars['String']>;
  makerPlant?: Maybe<Scalars['String']>;
  manualBrakeSystem?: Maybe<Scalars['String']>;
  markName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  passengerPlaces?: Maybe<Scalars['String']>;
  places?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  protocol?: Maybe<DocumentProtocol>;
  protocolFields?: Maybe<Array<ProtocolField>>;
  rearSuspensionSystem?: Maybe<Scalars['String']>;
  request?: Maybe<SbktsRequest>;
  sbktsMaker?: Maybe<Scalars['String']>;
  sbktsMark?: Maybe<Scalars['String']>;
  sbktsModel?: Maybe<Scalars['String']>;
  seatPlace?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  spareBrakeSystem?: Maybe<Scalars['String']>;
  steerageSystem?: Maybe<Scalars['String']>;
  steeringWheelPosition?: Maybe<Scalars['String']>;
  suspensionSystem?: Maybe<Scalars['String']>;
  tires?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  transmittionSystem?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['String']>;
  wheelsTrack?: Maybe<Scalars['String']>;
  wheelsType?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  comment?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<DocumentField>>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isElectricCar?: Maybe<Scalars['Boolean']>;
  length?: Maybe<Scalars['Int']>;
  maker?: Maybe<DocumentValue>;
  mark?: Maybe<DocumentValue>;
  model?: Maybe<DocumentValue>;
  name?: Maybe<Scalars['String']>;
  objectMaker?: Maybe<Maker>;
  objectMark?: Maybe<Mark>;
  objectModel?: Maybe<Model>;
  protocols?: Maybe<Array<DocumentProtocol>>;
  title?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type DocumentField = {
  __typename?: 'DocumentField';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['Int']>;
};

export type DocumentValue = {
  __typename?: 'DocumentValue';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type DocumentProtocol = {
  __typename?: 'DocumentProtocol';
  additionalFields?: Maybe<Array<DocumentAdditionField>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  docTemplate?: Maybe<DocumentTemplate>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isTechnical?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Model>;
  name?: Maybe<Scalars['String']>;
};

export type DocumentAdditionField = {
  __typename?: 'DocumentAdditionField';
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldName?: Maybe<DocumentFieldName>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type DocumentFieldName = {
  __typename?: 'DocumentFieldName';
  description?: Maybe<Scalars['String']>;
  docName?: Maybe<Scalars['String']>;
  fieldName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isProtocol?: Maybe<Scalars['Boolean']>;
  isRegularFill?: Maybe<Scalars['Boolean']>;
  laboratory?: Maybe<Laboratory>;
  position?: Maybe<Scalars['Int']>;
};

export type ProtocolField = {
  __typename?: 'ProtocolField';
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldName?: Maybe<DocumentFieldName>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ScrapObject = {
  __typename?: 'ScrapObject';
  address?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  auctionSheet?: Maybe<ObjectMediaItem>;
  autoExtension?: Maybe<Scalars['Boolean']>;
  basket?: Maybe<Scalars['String']>;
  buyoutPrice?: Maybe<Scalars['Int']>;
  carrier?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  countResubmitted?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['Int']>;
  error?: Maybe<YahooLotError>;
  id?: Maybe<Scalars['Int']>;
  isAccepted?: Maybe<Scalars['Boolean']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDelivered?: Maybe<Scalars['Boolean']>;
  isNotSold?: Maybe<Scalars['Boolean']>;
  isResubmitted?: Maybe<Scalars['Boolean']>;
  isSentToYahoo?: Maybe<Scalars['Boolean']>;
  isSold?: Maybe<Scalars['Boolean']>;
  isUtilized?: Maybe<Scalars['Boolean']>;
  isWaitDelivery?: Maybe<Scalars['Boolean']>;
  isWaitUtilization?: Maybe<Scalars['Boolean']>;
  kaitaiRemarks?: Maybe<Array<Maybe<KaitaiRemark>>>;
  kaitaiSides?: Maybe<Array<Maybe<KaitaiSide>>>;
  lastSubject?: Maybe<Scalars['String']>;
  lotSize?: Maybe<Scalars['String']>;
  lotSizeMultiplier?: Maybe<Scalars['Int']>;
  markdownRatio?: Maybe<YahooLotResubmitRatioEnum>;
  numResubmit?: Maybe<Scalars['Int']>;
  parentObject?: Maybe<ObjectOfServices>;
  price?: Maybe<Price>;
  scrapObject?: Maybe<ObjectOfServices>;
  scrapType?: Maybe<Scrap>;
  sendToYahooAt?: Maybe<Scalars['DateTime']>;
  sendToYahooBy?: Maybe<User>;
  shipNames?: Maybe<Scalars['String']>;
  shipping?: Maybe<Scalars['String']>;
  shippingInput?: Maybe<YahooLotShippingInputEnum>;
  shipschedule?: Maybe<Scalars['String']>;
  shipSizes?: Maybe<YahooLotShipSizes>;
  state?: Maybe<YahooStateLotEnum>;
  status?: Maybe<Status>;
  trackNumber?: Maybe<Scalars['String']>;
  yahooAccount?: Maybe<Scalars['String']>;
  yahooBuyerId?: Maybe<Scalars['Int']>;
  yahooCategoryCode?: Maybe<Scalars['String']>;
  yahooCategoryId?: Maybe<Scalars['String']>;
  yahooCount?: Maybe<Scalars['Int']>;
  yahooLotDescription?: Maybe<Scalars['String']>;
  yahooLotId?: Maybe<Scalars['String']>;
  yahooLotName?: Maybe<Scalars['String']>;
  yahooPlace?: Maybe<Scalars['String']>;
  yahooPlaceStorage?: Maybe<Scalars['String']>;
};

export type YahooLotError = {
  __typename?: 'YahooLotError';
  message?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type KaitaiRemark = {
  __typename?: 'KaitaiRemark';
  id?: Maybe<Scalars['Int']>;
  nameEn?: Maybe<Scalars['String']>;
  nameJp?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
};

export type KaitaiSide = {
  __typename?: 'KaitaiSide';
  id?: Maybe<Scalars['Int']>;
  nameEn?: Maybe<Scalars['String']>;
  nameJp?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
};

export enum YahooLotResubmitRatioEnum {
  V_0 = 'v_0',
  V_10 = 'v_10',
  V_15 = 'v_15',
  V_20 = 'v_20',
  V_25 = 'v_25',
  V_30 = 'v_30',
  V_5 = 'v_5'
}

export type Scrap = {
  __typename?: 'Scrap';
  aggregateType?: Maybe<Aggregate>;
  blockingParts?: Maybe<Array<Scrap>>;
  costInPercent?: Maybe<Scalars['Int']>;
  countObjects?: Maybe<Scalars['Int']>;
  description?: Maybe<ScrapTypeDescription>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isNeedEngineNumber?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameEn?: Maybe<Scalars['String']>;
  nameJp?: Maybe<Scalars['String']>;
  objectType?: Maybe<TypeOfExport>;
};

export type ScrapTypeDescription = {
  __typename?: 'ScrapTypeDescription';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  value?: Maybe<Scalars['String']>;
};

export enum YahooLotShippingInputEnum {
  Arrival = 'arrival',
  Later = 'later'
}

export type YahooLotShipSizes = {
  __typename?: 'YahooLotShipSizes';
  isJpYupacketOfficialShip?: Maybe<Scalars['Boolean']>;
  isJpYupackOfficialShip?: Maybe<Scalars['Boolean']>;
  isYahunekoNekoposuShip?: Maybe<Scalars['Boolean']>;
  isYahunekoTaqbinBigShip?: Maybe<Scalars['Boolean']>;
  isYahunekoTaqbinCompactShip?: Maybe<Scalars['Boolean']>;
  isYahunekoTaqbinShip?: Maybe<Scalars['Boolean']>;
};

export enum YahooStateLotEnum {
  New = 'new',
  Used10 = 'used10',
  Used20 = 'used20',
  Used40 = 'used40',
  Used60 = 'used60',
  Used80 = 'used80'
}

export type ObjectSender = {
  __typename?: 'ObjectSender';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  senderClient?: Maybe<SenderAgent>;
};

export type SenderAgent = {
  __typename?: 'SenderAgent';
  data?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sender?: Maybe<Sender>;
};

export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  amount?: Maybe<Scalars['Int']>;
  /** Идентификатор источника обработки услуги */
  appSource?: Maybe<AppSourceEnum>;
  /** Название аукциона */
  auctionName?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  canceledBy?: Maybe<User>;
  /** Причина отмены заявки */
  cancelReason?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<UserShortInfo>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserShortInfo>;
  /** Дата и время торгов */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** Файлы заявки (ограничены для не-владельца без инвойса по доп. услуге) */
  files?: Maybe<Array<Maybe<S3File>>>;
  id?: Maybe<Scalars['Int']>;
  /** Является ли пользователь владельцем заявки */
  isForCurrentUser?: Maybe<Scalars['Boolean']>;
  lotLink?: Maybe<Scalars['String']>;
  /** Количество доп. сервисов */
  numOfAdditionalServices?: Maybe<Scalars['Int']>;
  object?: Maybe<ObjectOfServices>;
  owner?: Maybe<Owner>;
  /** Доп. параметры услуги */
  requestParam?: Maybe<ServiceRequestTypeParam>;
  /** Тип услуги */
  requestType?: Maybe<TypeOfServiceRequest>;
  status?: Maybe<ServiceRequestStatusEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceRequestTypeParam = {
  __typename?: 'ServiceRequestTypeParam';
  cost?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  descriptionEng?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
};

export enum ServiceRequestStatusEnum {
  Active = 'active',
  Canceled = 'canceled',
  Completed = 'completed'
}

export type Tariff = {
  __typename?: 'Tariff';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ObjectAttachmentTypeLog = {
  __typename?: 'ObjectAttachmentTypeLog';
  message?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  user?: Maybe<Scalars['String']>;
};

export type LotTranslation = {
  __typename?: 'LotTranslation';
  file?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  translator?: Maybe<LotTranslator>;
};

export type LotTranslator = {
  __typename?: 'LotTranslator';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** Данные транспортировки */
export type TransportationData = {
  __typename?: 'TransportationData';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryDays?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  priceBus?: Maybe<Scalars['Int']>;
  priceCrossover?: Maybe<Scalars['Int']>;
  priceJeep?: Maybe<Scalars['Int']>;
  priceKeiCar?: Maybe<Scalars['Int']>;
  priceSedan?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TroyanCustomer = {
  __typename?: 'TroyanCustomer';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
};

export type Wheel = {
  __typename?: 'Wheel';
  /** Объект с которого сняли колеса */
  disassembleObject?: Maybe<ObjectOfServices>;
  /** Производитель диска */
  diskManufacturer?: Maybe<Scalars['String']>;
  /** Тип диска */
  diskType?: Maybe<Scalars['String']>;
  /** ID обьекта */
  id?: Maybe<Scalars['Int']>;
  /** Собран на полете */
  isLoaded?: Maybe<Scalars['Boolean']>;
  /** Куплен */
  isPurchased?: Maybe<Scalars['Boolean']>;
  /** Палета */
  pallet?: Maybe<Pallet>;
  /** Цена */
  price?: Maybe<Price>;
  /** Производитель резины */
  tireManufacturer?: Maybe<Scalars['String']>;
  /** Высота */
  tireProfileHeight?: Maybe<Scalars['Int']>;
  /** Ширина */
  tireProfileWidth?: Maybe<Scalars['Int']>;
  /** Радиус */
  tireRadius?: Maybe<Scalars['Int']>;
  /** Тип резины */
  tireType?: Maybe<Scalars['String']>;
  /** Процент износа резины */
  tireWear?: Maybe<Scalars['Int']>;
};

export type Pallet = {
  __typename?: 'Pallet';
  /** ID палеты */
  id?: Maybe<Scalars['Int']>;
  /** Объект на складе порта */
  isInPort?: Maybe<Scalars['Boolean']>;
  /** Название плаеты */
  name?: Maybe<Scalars['String']>;
  /** ID номер */
  number?: Maybe<Scalars['String']>;
  /** Список колес */
  objects?: Maybe<Array<Maybe<ObjectOfServices>>>;
  /** Колличество бъектов */
  objectsCount?: Maybe<Scalars['Int']>;
  /** План отгрузки */
  plan?: Maybe<Plan>;
  /** Колличество колес */
  wheelCount?: Maybe<Scalars['Int']>;
};

export type LotteryTicker = {
  __typename?: 'LotteryTicker';
  agentId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ticketId?: Maybe<Scalars['Int']>;
};

export type PaidBidsDisplayStatus = {
  __typename?: 'PaidBidsDisplayStatus';
  createdAt?: Maybe<Scalars['DateTime']>;
  datePaidAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isPaid?: Maybe<Scalars['Boolean']>;
  paidBidsDisplayPrice?: Maybe<Scalars['Int']>;
};

export enum TypeOfOwnerEnum {
  Broker = 'BROKER',
  FormalOwner = 'FORMAL_OWNER',
  Owner = 'OWNER',
  Sender = 'SENDER'
}

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jsonPermissions?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Permission>>;
};

export type Permission = {
  __typename?: 'Permission';
  action?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  resource?: Maybe<Scalars['String']>;
};

/** HR-профиль сотрудника */
export type UserProfile = {
  __typename?: 'UserProfile';
  /** Дополнительная информация */
  additionalInfo?: Maybe<Scalars['String']>;
  /** Адрес */
  address?: Maybe<Scalars['String']>;
  /** Характеристика */
  characteristic?: Maybe<Scalars['String']>;
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** Контакты */
  contacts?: Maybe<Array<Maybe<PersonContact>>>;
  /** Страна проживания */
  country?: Maybe<Country>;
  /** Дата рождения */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** Экстренные контакты */
  emergencyContacts?: Maybe<Array<Maybe<EmergencyContact>>>;
  /** Имя */
  firstName?: Maybe<Scalars['String']>;
  /** Пол */
  gender?: Maybe<Scalars['String']>;
  /** ID профиля */
  id?: Maybe<Scalars['Int']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['String']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']>;
  /** Гражданство */
  nationality?: Maybe<Country>;
  /** Личный телефон */
  personalPhone?: Maybe<Scalars['String']>;
  /** Фотографии */
  photos?: Maybe<Array<Maybe<S3File>>>;
  /** Предпочитаемое имя */
  preferredName?: Maybe<Scalars['String']>;
  /** Предыдущее место работы */
  previousJob?: Maybe<Scalars['String']>;
};

/** Контактные данные сотрудника */
export type PersonContact = {
  __typename?: 'PersonContact';
  /** ID контакта */
  id?: Maybe<Scalars['Int']>;
  /** Основной контакт */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** Подпись */
  label?: Maybe<Scalars['String']>;
  /** Тип контакта (phone/email/messenger и т.д.) */
  type?: Maybe<Scalars['String']>;
  /** Значение контакта */
  value?: Maybe<Scalars['String']>;
};

/** Экстренный контакт сотрудника */
export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  /** Email */
  email?: Maybe<Scalars['String']>;
  /** ID контакта */
  id?: Maybe<Scalars['Int']>;
  /** ФИО контакта */
  name?: Maybe<Scalars['String']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']>;
  /** Кем приходится */
  relation?: Maybe<Scalars['String']>;
};

export type Reminder = {
  __typename?: 'Reminder';
  id?: Maybe<Scalars['Int']>;
  lastAt?: Maybe<Scalars['DateTime']>;
  period?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  systemCreatedAt?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  sync1C?: Maybe<Scalars['Boolean']>;
  systemCreatedAt?: Maybe<Scalars['String']>;
};

export type TimeZone = {
  __typename?: 'TimeZone';
  name?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['String']>;
};

export type TypeOfUser = {
  __typename?: 'TypeOfUser';
  id?: Maybe<Scalars['Int']>;
  nameEn?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
  type?: Maybe<TypeOfUserEnum>;
};

export enum TypeOfUserEnum {
  UserTypeBrokerAccount = 'USER_TYPE_BROKER_ACCOUNT',
  UserTypeClientAccount = 'USER_TYPE_CLIENT_ACCOUNT',
  UserTypeEmployeeAccount = 'USER_TYPE_EMPLOYEE_ACCOUNT',
  UserTypeRecipientAccount = 'USER_TYPE_RECIPIENT_ACCOUNT',
  UserTypeSenderAccount = 'USER_TYPE_SENDER_ACCOUNT',
  UserTypeSvhManagerAccount = 'USER_TYPE_SVH_MANAGER_ACCOUNT',
  UserTypeTroyanEmployeeAccount = 'USER_TYPE_TROYAN_EMPLOYEE_ACCOUNT'
}

export type UserParameter = {
  __typename?: 'UserParameter';
  agent?: Maybe<Agent>;
  baseModule?: Maybe<Module>;
  /** @deprecated Chat alias removed; always null */
  chatAlias?: Maybe<ChatAlias>;
  commentCssClass?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  driverMode?: Maybe<DriverMode>;
  expireAccount?: Maybe<Scalars['String']>;
  expirePassword?: Maybe<Scalars['Int']>;
  expirePermission?: Maybe<Scalars['Int']>;
  expireToken?: Maybe<Scalars['Int']>;
  freightPaymentCountry?: Maybe<Country>;
  guid1C?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isChangePassword?: Maybe<Scalars['Boolean']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']>;
  language?: Maybe<LanguageEnum>;
  oldRole?: Maybe<UserRole>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']>;
  policy?: Maybe<Policy>;
  smsPasswordChangedAt?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userType?: Maybe<TypeOfUser>;
};

export type ChatAlias = {
  __typename?: 'ChatAlias';
  alias?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
};

export type Policy = {
  __typename?: 'Policy';
  baseModule?: Maybe<Module>;
  carrier?: Maybe<CarrierInfo>;
  chats?: Maybe<Array<ChatGroup>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  digests?: Maybe<Array<Digest>>;
  emailMaintainer?: Maybe<Scalars['String']>;
  expirePassword?: Maybe<Scalars['Int']>;
  expireToken?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isNewRoute?: Maybe<Scalars['Boolean']>;
  language?: Maybe<LanguageEnum>;
  name?: Maybe<Scalars['String']>;
  oldRole?: Maybe<UserRole>;
  oldRouteUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  permissionGroups?: Maybe<Array<PermissionGroup>>;
  permissions?: Maybe<Array<Permission>>;
  ports?: Maybe<Array<Port>>;
  stocks?: Maybe<Array<Stock>>;
  updatedAt?: Maybe<Scalars['Int']>;
  userType?: Maybe<UserType>;
  vessels?: Maybe<Array<Vessel>>;
};

export type CarrierInfo = {
  __typename?: 'CarrierInfo';
  /** @deprecated Refactored */
  carrier?: Maybe<Scalars['Int']>;
  carrierId?: Maybe<Scalars['Int']>;
  carrierName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type UserType = {
  __typename?: 'UserType';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TypeOfUseVehicle = {
  __typename?: 'TypeOfUseVehicle';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type ContainerEvent = {
  __typename?: 'ContainerEvent';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Forwarder = {
  __typename?: 'Forwarder';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TypeOfFreight = {
  __typename?: 'TypeOfFreight';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type AddGreenCornerPrice = {
  __typename?: 'AddGreenCornerPrice';
  motoBidLimit?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export type AddresseesUsersToChatsPaginatedList = {
  __typename?: 'AddresseesUsersToChatsPaginatedList';
  nodes: Array<User>;
  total: Scalars['Int'];
};

export type PackagesFilter = {
  package?: Maybe<PackageFilter>;
};

export type PackageFilter = {
  partVin?: Maybe<Scalars['String']>;
  /** Готовые к выдачи */
  showIssued?: Maybe<Scalars['Boolean']>;
  tripId?: Maybe<Scalars['Int']>;
};

export type PackagesPaginatedList = {
  __typename?: 'PackagesPaginatedList';
  nodes: Array<ObjectPackage>;
  total: Scalars['Int'];
};

export type AmbassadorsPaginatedList = {
  __typename?: 'AmbassadorsPaginatedList';
  nodes: Array<Ambassador>;
  total: Scalars['Int'];
};

export type AttachmentsTemplate = {
  __typename?: 'AttachmentsTemplate';
  engName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type AuctionFeedbacksPaginatedList = {
  __typename?: 'AuctionFeedbacksPaginatedList';
  nodes: Array<CarFeedback>;
  total: Scalars['Int'];
};

export type AuctionInspectionAuctionStatistic = {
  __typename?: 'AuctionInspectionAuctionStatistic';
  /** ID аукциона */
  auctionId?: Maybe<Scalars['Int']>;
  /** Название аукциона */
  auctionName?: Maybe<Scalars['String']>;
  /** Из них выполнено бесплатно (кол-во) */
  freeCount?: Maybe<Scalars['Int']>;
  /** Первичные осмотры (кол-во) */
  primaryCount?: Maybe<Scalars['Int']>;
  /** Перепродажи осмотра (докупка готового результата, кол-во) */
  resaleCount?: Maybe<Scalars['Int']>;
};

export type AuctionInspectionUserStatistic = {
  __typename?: 'AuctionInspectionUserStatistic';
  /** ID исполнителя (completed_by основного осмотра) */
  executorId?: Maybe<Scalars['Int']>;
  /** Имя исполнителя */
  executorName?: Maybe<Scalars['String']>;
  /** Из них выполнено бесплатно (кол-во) */
  freeCount?: Maybe<Scalars['Int']>;
  /** Первичные осмотры (кол-во) */
  primaryCount?: Maybe<Scalars['Int']>;
  /** Перепродажи осмотра (докупка готового результата, кол-во) */
  resaleCount?: Maybe<Scalars['Int']>;
};

export type BrokerExcelTemplate = {
  __typename?: 'BrokerExcelTemplate';
  broker?: Maybe<Broker>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isLegalEntity?: Maybe<Scalars['Boolean']>;
  mask?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<BrokerExcelTemplateEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum BrokerExcelTemplateEnum {
  Address = 'address',
  Applicant = 'applicant',
  Color = 'color',
  Consignment = 'consignment',
  DateOfManufacture = 'date_of_manufacture',
  DryWeight = 'dry_weight',
  EngineModel = 'engine_model',
  EngineNumber = 'engine_number',
  EnginePower = 'engine_power',
  EngineType = 'engine_type',
  EngineVolume = 'engine_volume',
  GlonassModel = 'glonass_model',
  GlonassNumber = 'glonass_number',
  IndividualApplicant = 'individual_applicant',
  LegalApplicant = 'legal_applicant',
  Maker = 'maker',
  Mark = 'mark',
  MaxWeight = 'max_weight',
  Model = 'model',
  Ogrn = 'ogrn',
  Seats = 'seats',
  Vin = 'vin'
}

export type BrokersPaginatedList = {
  __typename?: 'BrokersPaginatedList';
  nodes: Array<Broker>;
  total: Scalars['Int'];
};

export type ChatMessagessFilter = {
  onlyTasks?: Maybe<OnlyTasksFilter>;
};

export type OnlyTasksFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type ChatMessagessPaginatedList = {
  __typename?: 'ChatMessagessPaginatedList';
  nodes: Array<ChatMessage>;
  total: Scalars['Int'];
};

export type ChatsForOtherssFilter = {
  asObserver?: Maybe<AsObserverFilter>;
  chatAll?: Maybe<ChatAllFilter>;
  chatObjectId?: Maybe<ChatObjectIdFilter>;
  chatSearch?: Maybe<ChatSearchFilter>;
  chatTagId?: Maybe<ChatTagIdFilter>;
  showArchive: ShowArchiveFilter;
  unread?: Maybe<UnreadFilter>;
  unResolvedTask?: Maybe<UnResolvedTaskFilter>;
  withUserMessages?: Maybe<WithUserMessagesFilter>;
};

export type AsObserverFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type ChatAllFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type ChatObjectIdFilter = {
  eq?: Maybe<Scalars['Int']>;
};

export type ChatSearchFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type ChatTagIdFilter = {
  eq?: Maybe<Scalars['Int']>;
};

export type ShowArchiveFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type UnreadFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type UnResolvedTaskFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type WithUserMessagesFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type ChatsForOtherssPaginatedList = {
  __typename?: 'ChatsForOtherssPaginatedList';
  nodes: Array<ChatForOthers>;
  total: Scalars['Int'];
};

export type ClientContact = {
  __typename?: 'ClientContact';
  hasTelegram?: Maybe<Scalars['Boolean']>;
  hasWhatsapp?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
};

export type ClientInvoiceCustomersPaginatedList = {
  __typename?: 'ClientInvoiceCustomersPaginatedList';
  nodes: Array<InvoiceCustom>;
  total: Scalars['Int'];
};

export type ClientObjectAttachmentsFilter = {
  clientObjectAttachment?: Maybe<ClientObjectAttachmentFilter>;
};

export type ClientObjectAttachmentFilter = {
  partVin?: Maybe<Scalars['String']>;
  /** Готовые к выдачи */
  showIssued?: Maybe<Scalars['Boolean']>;
  tripId?: Maybe<Scalars['Int']>;
};

export type ClientObjectAttachmentsPaginatedList = {
  __typename?: 'ClientObjectAttachmentsPaginatedList';
  nodes: Array<ObjectAttachment>;
  total: Scalars['Int'];
};

export type ClientObjectDashboardFilter = {
  /** Заблокированные */
  isBlocked?: Maybe<Scalars['Boolean']>;
  /** Готовые к выдаче */
  isHasIssuedStatus?: Maybe<Scalars['Boolean']>;
  /** С долгами */
  withDebts?: Maybe<Scalars['Boolean']>;
};

export type ClientObjectsTrip = {
  __typename?: 'ClientObjectsTrip';
  /** Кол-во готовых к выдаче */
  countHasIssuedStatus?: Maybe<Scalars['Int']>;
  /** Кол-во без грузополучателя */
  countWithoutConsignee?: Maybe<Scalars['Int']>;
  debts?: Maybe<Array<DebtPrice>>;
  id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  trip?: Maybe<Trip>;
};

export type DebtPrice = {
  __typename?: 'DebtPrice';
  currency?: Maybe<Currency>;
  value?: Maybe<Scalars['Float']>;
};

export type ClientObjectLogsFilter = {
  clientObjectLog?: Maybe<ClientObjectLogFilter>;
};

export type ClientObjectLogFilter = {
  byGuid?: Maybe<Scalars['Boolean']>;
  byVin?: Maybe<Scalars['Boolean']>;
  isFull?: Maybe<Scalars['Boolean']>;
};

export type ClientObjectLogsPaginatedList = {
  __typename?: 'ClientObjectLogsPaginatedList';
  nodes: Array<ClientObjectLog>;
  total: Scalars['Int'];
};

export type ClientObjectLog = {
  __typename?: 'ClientObjectLog';
  guid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  msg?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type ClientObjectQueuesPaginatedList = {
  __typename?: 'ClientObjectQueuesPaginatedList';
  nodes: Array<ClientObjectQueue>;
  total: Scalars['Int'];
};

export type ClientObjectQueue = {
  __typename?: 'ClientObjectQueue';
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  messageId?: Maybe<Scalars['String']>;
  routeKey?: Maybe<Scalars['String']>;
};

export type ObjectResalesFilter = {
  objectResale?: Maybe<ObjectResaleFilter>;
};

export type ObjectResaleFilter = {
  buyerId?: Maybe<Scalars['Int']>;
  createdFrom?: Maybe<Scalars['DateTime']>;
  createdTo?: Maybe<Scalars['DateTime']>;
  /** Не отменённые и не завершённые */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Ожидающие подтверждения текущим пользователем */
  isNeedApprove?: Maybe<Scalars['Boolean']>;
  sellerId?: Maybe<Scalars['Int']>;
  statusId?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
};

export type ObjectResalesPaginatedList = {
  __typename?: 'ObjectResalesPaginatedList';
  nodes: Array<ObjectResale>;
  total: Scalars['Int'];
};

export type ClientObjectsFilter = {
  dealerObjects?: Maybe<DealerObjectsFilter>;
  objectAuctionListing?: Maybe<ObjectAuctionListingFilter>;
  objectGreenCorner?: Maybe<ObjectGreenCornerFilter>;
  objectOfService?: Maybe<ObjectOfServiceFilter>;
  objectPlan?: Maybe<ObjectPlanFilter>;
  objectRecycleStatus?: Maybe<ObjectRecycleStatusFilter>;
  objectSvhDelivery?: Maybe<ObjectSvhDeliveryFilter>;
  objectWorldWide?: Maybe<ObjectWorldWideFilter>;
  scrap?: Maybe<ScrapFilter>;
};

export type DealerObjectsFilter = {
  /** Дилерские объекты */
  isDealer?: Maybe<Scalars['Boolean']>;
};

/** Фильтр для выставленных на аукцион */
export type ObjectAuctionListingFilter = {
  /** Поиск по номеру лота */
  aucNumber?: Maybe<Scalars['String']>;
  /** Авто выставленные на выбранные аукцион */
  auction?: Maybe<Scalars['Int']>;
  /** Выставлено от */
  createdFrom?: Maybe<Scalars['DateTime']>;
  /** Выставлено до */
  createdTo?: Maybe<Scalars['DateTime']>;
  /** Дата торгов от */
  dateFrom?: Maybe<Scalars['DateTime']>;
  /** Дата торгов до */
  dateTo?: Maybe<Scalars['DateTime']>;
  /** Объекты которые можно выставить */
  forAuctionListing?: Maybe<Scalars['Boolean']>;
  /** Все выставленные */
  isListenedAuction?: Maybe<Scalars['Boolean']>;
  /** Фильтр по статусу */
  status?: Maybe<Array<Maybe<ObjectAuctionListingStatusEnum>>>;
};

export enum ObjectAuctionListingStatusEnum {
  /** Добавлен к выставлению */
  Listed = 'LISTED',
  /** Не продан */
  NotSold = 'NOT_SOLD',
  /** Подготовлен */
  Prepared = 'PREPARED',
  /** Отправлен */
  Send = 'SEND',
  /** Продан */
  Sold = 'SOLD'
}

export type ObjectGreenCornerFilter = {
  isGreenCorner?: Maybe<Scalars['Boolean']>;
  noPrice?: Maybe<Scalars['Boolean']>;
};

export type ObjectOfServiceFilter = {
  aggregateTypes?: Maybe<Array<Scalars['Int']>>;
  /** Дата покупки от */
  auctionDate?: Maybe<Scalars['String']>;
  /** Дата покупки до (Если null берется конец дня auctionDate) */
  auctionDateTo?: Maybe<Scalars['String']>;
  auctions?: Maybe<Array<Scalars['Int']>>;
  /** По названию филиала офиса */
  branchOffice?: Maybe<Scalars['String']>;
  brokers?: Maybe<Array<Scalars['Int']>>;
  buyByMonth?: Maybe<Scalars['String']>;
  byDateIssueElpts?: Maybe<Scalars['String']>;
  byDelayRequestDay?: Maybe<Scalars['String']>;
  byInvoicePaymentType?: Maybe<Scalars['Boolean']>;
  carTypes?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<CityEnum>;
  containerId?: Maybe<Scalars['Int']>;
  containerNumber?: Maybe<Scalars['String']>;
  customTypes?: Maybe<Array<Scalars['Int']>>;
  dashboardTrip?: Maybe<Scalars['Int']>;
  expiredDelayRequestDay?: Maybe<Scalars['Boolean']>;
  formalOwners?: Maybe<Array<Scalars['Int']>>;
  forTrip?: Maybe<Scalars['Boolean']>;
  /** С долгами по клиенту */
  hasClientDebts?: Maybe<Scalars['Boolean']>;
  hasTicket?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  independentlyPaymentType?: Maybe<Scalars['Boolean']>;
  inJapan?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAkebono?: Maybe<Scalars['Boolean']>;
  /** Заблокированные */
  isBlocked?: Maybe<Scalars['Boolean']>;
  isBoundary?: Maybe<Scalars['Boolean']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDelayDelivery?: Maybe<Scalars['Boolean']>;
  isDisassembly?: Maybe<Scalars['Boolean']>;
  isHasCustomInvoice?: Maybe<Scalars['Boolean']>;
  isHasCustomPayment?: Maybe<Scalars['Boolean']>;
  isHasElpts?: Maybe<Scalars['Boolean']>;
  /** Готовые к выдаче */
  isHasIssuedStatus?: Maybe<Scalars['Boolean']>;
  isHasPenalty?: Maybe<Scalars['Boolean']>;
  isHasSbkts?: Maybe<Scalars['Boolean']>;
  isHold?: Maybe<Scalars['Boolean']>;
  isKaitai?: Maybe<Scalars['Boolean']>;
  isPart?: Maybe<Scalars['Boolean']>;
  isPassedTestDate?: Maybe<Scalars['String']>;
  isRecycleCube?: Maybe<Scalars['Boolean']>;
  isRemoved?: Maybe<Scalars['Boolean']>;
  /** Является донором */
  isScrap?: Maybe<Scalars['Boolean']>;
  /** Является запчастью */
  isScrapObjects?: Maybe<Scalars['Boolean']>;
  isSoldRecycleCube?: Maybe<Scalars['Boolean']>;
  isYahoo?: Maybe<Scalars['Boolean']>;
  owners?: Maybe<Array<Scalars['Int']>>;
  ownStocks?: Maybe<Scalars['Boolean']>;
  partVin?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['Int']>;
  sawTypes?: Maybe<Array<Scalars['Int']>>;
  sectorId?: Maybe<Scalars['Int']>;
  senders?: Maybe<Array<Scalars['Int']>>;
  stockId?: Maybe<Scalars['Int']>;
  stocks?: Maybe<Array<Scalars['Int']>>;
  trip?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
  /** С долгами по типу пользователя */
  withDebts?: Maybe<Scalars['Boolean']>;
  withoutIssued?: Maybe<Scalars['Boolean']>;
  withStorageData?: Maybe<Scalars['Boolean']>;
};

export enum CityEnum {
  All = 'all',
  Otaru = 'otaru',
  Tomakomai = 'tomakomai',
  Toyama = 'toyama'
}

export type ObjectPlanFilter = {
  contract?: Maybe<Scalars['Int']>;
  plan?: Maybe<Scalars['Int']>;
  trip?: Maybe<Scalars['Int']>;
};

export type ObjectRecycleStatusFilter = {
  isAllowToProcess?: Maybe<Scalars['Boolean']>;
  statusIds?: Maybe<Array<Scalars['Int']>>;
  withRelations?: Maybe<Scalars['Boolean']>;
};

/** Фильтр для доставок с СВХ в транспортную компанию */
export type ObjectSvhDeliveryFilter = {
  /** Доступность заказа доставки */
  isDeliveryAllowed?: Maybe<Scalars['Boolean']>;
};

export type ObjectWorldWideFilter = {
  bookingNumber?: Maybe<Scalars['String']>;
  container?: Maybe<ContainerFilterEnum>;
  countryId?: Maybe<Scalars['Int']>;
  exportCertificate?: Maybe<Scalars['String']>;
  isBookingRequested?: Maybe<Scalars['Boolean']>;
  isHasBookingNumber?: Maybe<Scalars['Boolean']>;
  isSahalin?: Maybe<Scalars['Boolean']>;
  isWorldWide?: Maybe<Scalars['Boolean']>;
  managerId?: Maybe<Scalars['Int']>;
  trip?: Maybe<TripFilterEnum>;
  vesselTypeId?: Maybe<Scalars['Int']>;
};

export enum ContainerFilterEnum {
  All = 'all',
  WithContainer = 'with_container',
  WithoutContainer = 'without_container'
}

export enum TripFilterEnum {
  All = 'all',
  WithTrip = 'with_trip',
  WithoutTrip = 'without_trip'
}

export type ScrapFilter = {
  akbVin?: Maybe<Scalars['String']>;
  canceled?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['Boolean']>;
  dateEnd?: Maybe<Scalars['String']>;
  delivered?: Maybe<Scalars['Boolean']>;
  /** Находится в статусе Ожидает выставления, Выставлен, Не продан, Продан, Отправлен в Яху, Ожидает отправки */
  inStock?: Maybe<Scalars['Boolean']>;
  isKaitai?: Maybe<Scalars['Boolean']>;
  /** Является запчастью */
  isScrap?: Maybe<Scalars['Boolean']>;
  maker?: Maybe<Scalars['Int']>;
  mark?: Maybe<Scalars['Int']>;
  notSold?: Maybe<Scalars['Boolean']>;
  scrapTypeId?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
  waitDelivery?: Maybe<Scalars['Boolean']>;
  waitSendToYahoo?: Maybe<Scalars['Boolean']>;
  waitToYahoo?: Maybe<Scalars['Boolean']>;
  waitUtilization?: Maybe<Scalars['Boolean']>;
  waitYahooApprove?: Maybe<Scalars['Boolean']>;
  withoutPlace?: Maybe<Scalars['Boolean']>;
  year?: Maybe<Scalars['Int']>;
};

export type ClientObjectsSort = {
  objectOfService?: Maybe<ObjectOfServiceSort>;
};

export type ObjectOfServiceSort = {
  auctionDate?: Maybe<SortOrderEnum>;
  holdAt?: Maybe<SortOrderEnum>;
  id?: Maybe<SortOrderEnum>;
  listingCreatedAt?: Maybe<SortOrderEnum>;
  locationId?: Maybe<SortOrderEnum>;
  statusAt?: Maybe<SortOrderEnum>;
};

export enum SortOrderEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type ClientObjectsPaginatedList = {
  __typename?: 'ClientObjectsPaginatedList';
  nodes: Array<ObjectOfServices>;
  total: Scalars['Int'];
};

export type ClientObjectsReportPaymentAkebonoAllowsPaginatedList = {
  __typename?: 'ClientObjectsReportPaymentAkebonoAllowsPaginatedList';
  nodes: Array<ObjectOfServices>;
  total: Scalars['Int'];
};

export type ClientObjectsYear = {
  __typename?: 'ClientObjectsYear';
  months?: Maybe<Array<ClientObjectsMonth>>;
  year?: Maybe<Scalars['String']>;
};

export type ClientObjectsMonth = {
  __typename?: 'ClientObjectsMonth';
  countWithoutConsignee?: Maybe<Scalars['Int']>;
  debts?: Maybe<Array<Price>>;
  hasPenaltyTax?: Maybe<Scalars['Boolean']>;
  hasProposedPenalty?: Maybe<Scalars['Boolean']>;
  month?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type OwnerPrivateInfo = {
  __typename?: 'OwnerPrivateInfo';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ClientRecipientsPaginatedList = {
  __typename?: 'ClientRecipientsPaginatedList';
  nodes: Array<ClientRecipients>;
  total: Scalars['Int'];
};

export type ClientRecipients = {
  __typename?: 'ClientRecipients';
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  objectName?: Maybe<Scalars['String']>;
  recipientObject?: Maybe<Scalars['String']>;
  recipientRequest?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
};

export type ContainersFilter = {
  container?: Maybe<ContainerFilter>;
};

export type ContainerFilter = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  notSended?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sectorId?: Maybe<Scalars['Int']>;
  stockId?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
};

export type ContainersPaginatedList = {
  __typename?: 'ContainersPaginatedList';
  nodes: Array<Container>;
  total: Scalars['Int'];
};

export type CountrysFilter = {
  isPaymentCountry?: Maybe<IsPaymentCountryFilter>;
};

export type IsPaymentCountryFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type CountrysPaginatedList = {
  __typename?: 'CountrysPaginatedList';
  nodes: Array<Country>;
  total: Scalars['Int'];
};

export type CurrencyFilter = {
  isPayment?: Maybe<Scalars['Boolean']>;
  isStaff?: Maybe<Scalars['Boolean']>;
};

export type SbktsPlan = {
  __typename?: 'SbktsPlan';
  createdAt?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  id?: Maybe<Scalars['Int']>;
  limitObjects?: Maybe<Scalars['Int']>;
  objects?: Maybe<Array<SbktsObjectToPlan>>;
  planDate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SbktsObjectToPlan = {
  __typename?: 'SbktsObjectToPlan';
  approvedAt?: Maybe<Scalars['DateTime']>;
  approver?: Maybe<User>;
  broker?: Maybe<Broker>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completeUser?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  driverToAi?: Maybe<Driver>;
  driverToTroyan?: Maybe<Driver>;
  elptsAt?: Maybe<Scalars['DateTime']>;
  expert?: Maybe<User>;
  expertAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isExtra?: Maybe<Scalars['Boolean']>;
  movedToAiAt?: Maybe<Scalars['DateTime']>;
  movedToTroyanAt?: Maybe<Scalars['DateTime']>;
  object?: Maybe<ObjectOfServices>;
  plan?: Maybe<SbktsPlan>;
  request?: Maybe<SbktsRequest>;
  sbktsAt?: Maybe<Scalars['DateTime']>;
  unloadAt?: Maybe<Scalars['DateTime']>;
};

export type CurrentUserNotifyMessage = {
  __typename?: 'CurrentUserNotifyMessage';
  bot?: Maybe<NotifyBotInfo>;
  channels?: Maybe<Array<UserChannel>>;
  messageTypes?: Maybe<Array<NotifyMessage>>;
};

export type NotifyBotInfo = {
  __typename?: 'NotifyBotInfo';
  clientName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type UserChannel = {
  __typename?: 'UserChannel';
  enabled?: Maybe<Scalars['Boolean']>;
  enabledMessage?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

export type NotifyMessage = {
  __typename?: 'NotifyMessage';
  channels?: Maybe<Array<UserChannel>>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};

export type DiffEntityFilter = {
  entityId?: Maybe<Scalars['Int']>;
  entityType?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
};

export type LogEntity = {
  __typename?: 'LogEntity';
  createdTime?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<Scalars['Int']>;
  entityType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  newData?: Maybe<Scalars['String']>;
  oldData?: Maybe<Scalars['String']>;
  operation?: Maybe<Scalars['String']>;
  serviceCode?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type DonateBuhanka = {
  __typename?: 'DonateBuhanka';
  collected?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type DzenPayRate = {
  __typename?: 'DzenPayRate';
  effectiveAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isoCode?: Maybe<Scalars['String']>;
  maxRateValue?: Maybe<Scalars['Float']>;
  providerTenantId?: Maybe<Scalars['String']>;
  rateValue?: Maybe<Scalars['Float']>;
  sourceNote?: Maybe<Scalars['String']>;
};

export type ExchangeJobsFilter = {
  exchangeJob?: Maybe<ExchangeJobFilter>;
};

export type ExchangeJobFilter = {
  action?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  isHasFail?: Maybe<Scalars['Boolean']>;
  isNotResolve?: Maybe<Scalars['Boolean']>;
  isTroyan?: Maybe<Scalars['Boolean']>;
  objectId?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  transport?: Maybe<Scalars['String']>;
};

export type ExchangeJobsPaginatedList = {
  __typename?: 'ExchangeJobsPaginatedList';
  nodes: Array<ExchangeJob>;
  total: Scalars['Int'];
};

export type ExchangeJob = {
  __typename?: 'ExchangeJob';
  action?: Maybe<Scalars['String']>;
  connection?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobFail?: Maybe<ExchangeJobFail>;
  parameters?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedMessage?: Maybe<Scalars['String']>;
  transport?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['String']>;
};

export type ExchangeJobFail = {
  __typename?: 'ExchangeJobFail';
  attempts?: Maybe<Scalars['Int']>;
  exception?: Maybe<Scalars['String']>;
  failedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ExportTripsFilter = {
  trip?: Maybe<TripFilter>;
};

export type TripFilter = {
  /** По названию филиала офиса */
  branchOffice?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  destinationCountry?: Maybe<Scalars['Int']>;
  forBoxes?: Maybe<Scalars['Boolean']>;
  forParking?: Maybe<Scalars['Boolean']>;
  forTickets?: Maybe<Scalars['Boolean']>;
  fromCountry?: Maybe<Array<Scalars['Int']>>;
  fromJapan?: Maybe<Scalars['Boolean']>;
  /** С долгами */
  hasDebts?: Maybe<Scalars['Boolean']>;
  /** По состоянию */
  isActive?: Maybe<Scalars['Boolean']>;
  isAir?: Maybe<Scalars['Boolean']>;
  isRoro?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  tripsIds?: Maybe<Array<Scalars['Int']>>;
  vesselId?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type ExportTripsSort = {
  trip?: Maybe<TripSort>;
};

export type TripSort = {
  createdAt?: Maybe<SortOrderEnum>;
  dateFrom?: Maybe<SortOrderEnum>;
  dateTo?: Maybe<SortOrderEnum>;
};

export type ExportTripsPaginatedList = {
  __typename?: 'ExportTripsPaginatedList';
  nodes: Array<Trip>;
  total: Scalars['Int'];
};

export type FastObjectsByTrip = {
  __typename?: 'FastObjectsByTrip';
  byTypes?: Maybe<Array<FastObjectsByTypeOf>>;
  plan?: Maybe<Plan>;
};

export type FastObjectsByTypeOf = {
  __typename?: 'FastObjectsByTypeOf';
  objects?: Maybe<Array<FastObjects>>;
  type?: Maybe<TypeOfExport>;
};

export type FastObjects = {
  __typename?: 'FastObjects';
  all?: Maybe<Scalars['Int']>;
  object?: Maybe<ObjectOfServices>;
  stockToPort?: Maybe<Scalars['Int']>;
  toStock?: Maybe<Scalars['Int']>;
};

export type FeedbackssFilter = {
  feedback?: Maybe<FeedbackFilter>;
};

export type FeedbackFilter = {
  /** Период начало */
  dateFrom?: Maybe<Scalars['String']>;
  /** Период конец */
  dateTo?: Maybe<Scalars['String']>;
  /** По отценке */
  evaluation?: Maybe<Scalars['Int']>;
  /** По содержимому отзыва */
  feedback?: Maybe<Scalars['String']>;
  /** По пользователю */
  userId?: Maybe<Scalars['Int']>;
};

export type FeedbackssPaginatedList = {
  __typename?: 'FeedbackssPaginatedList';
  nodes: Array<CarFeedback>;
  total: Scalars['Int'];
};

export type FinanceReport = {
  __typename?: 'FinanceReport';
  balanceIn?: Maybe<Scalars['Float']>;
  balanceOut?: Maybe<Scalars['Float']>;
  contractName?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  documents?: Maybe<Array<FinanceReportDocument>>;
};

export type FinanceReportDocument = {
  __typename?: 'FinanceReportDocument';
  comment?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  objects?: Maybe<Array<FinanceReportObject>>;
  type?: Maybe<Scalars['String']>;
};

export type FinanceReportObject = {
  __typename?: 'FinanceReportObject';
  amountIn?: Maybe<Scalars['Float']>;
  amountOut?: Maybe<Scalars['Float']>;
  balanceIn?: Maybe<Scalars['Float']>;
  object?: Maybe<ObjectOfServices>;
  type?: Maybe<Scalars['Int']>;
};

export type FormalOwnersPaginatedList = {
  __typename?: 'FormalOwnersPaginatedList';
  nodes: Array<FormalOwner>;
  total: Scalars['Int'];
};

export type GreenCornerObjectFilter = {
  /** Дата постановки на ЗУ */
  addedAt?: Maybe<RangeDate>;
  /** true — с ценой, false — без цены, не передан — все */
  hasPrice?: Maybe<Scalars['Boolean']>;
  /** Контрагенты (владельцы объекта) */
  ownerIds?: Maybe<Array<Scalars['Int']>>;
  /** VIN или название автомобиля */
  search?: Maybe<Scalars['String']>;
  /** Признак объекта, в счётчиках не учитывается */
  stage?: Maybe<GreenCornerObjectStage>;
  /** Отправлено, запланировано или не отправлено в Telegram */
  telegramStatus?: Maybe<GreenCornerTgPostStatus>;
};

export type RangeDate = {
  /** От */
  from?: Maybe<Scalars['DateTime']>;
  /** До */
  to?: Maybe<Scalars['DateTime']>;
};

export enum GreenCornerObjectStage {
  /** В Akebono museum */
  Arrived = 'ARRIVED',
  /** Ожидают фото */
  AwaitingPhotos = 'AWAITING_PHOTOS',
  /** Ожидают цену */
  AwaitingPrice = 'AWAITING_PRICE',
  /** Ожидают услуг */
  AwaitingServices = 'AWAITING_SERVICES',
  /** Ожидают проверки */
  AwaitingThickness = 'AWAITING_THICKNESS',
  /** В перемещении */
  InTransit = 'IN_TRANSIT',
  /** На ярдах */
  OnYards = 'ON_YARDS',
  /** Запланирован */
  Planned = 'PLANNED',
  /** Опубликованы */
  Published = 'PUBLISHED',
  /** Готовы к публикации */
  Ready = 'READY'
}

export enum GreenCornerTgPostStatus {
  /** Не опубликовано */
  NotPublished = 'NOT_PUBLISHED',
  /** Опубликовано */
  Published = 'PUBLISHED',
  /** Запланировано */
  Scheduled = 'SCHEDULED'
}

export type GreenCornerObjectCounters = {
  __typename?: 'GreenCornerObjectCounters';
  /** Сумма цен FOB из каталога по валютам */
  amounts?: Maybe<Array<GreenCornerObjectAmount>>;
  /** Сколько объектов сейчас на ярде музея */
  onYard: Scalars['Int'];
  /** Количество объектов по каждому признаку */
  stages?: Maybe<Array<GreenCornerObjectStageCounter>>;
  /** Все активные объекты ЗУ с учётом фильтров */
  total: Scalars['Int'];
};

export type GreenCornerObjectAmount = {
  __typename?: 'GreenCornerObjectAmount';
  amount: Scalars['Float'];
  currency?: Maybe<Currency>;
};

export type GreenCornerObjectStageCounter = {
  __typename?: 'GreenCornerObjectStageCounter';
  count: Scalars['Int'];
  name: Scalars['String'];
  stage: GreenCornerObjectStage;
};

export type GreenCornerManageObjectsFilter = {
  greenCornerObject?: Maybe<GreenCornerObjectFilter>;
};

export type GreenCornerManageObjectsSort = {
  greenCornerObject?: Maybe<GreenCornerObjectSort>;
};

export type GreenCornerObjectSort = {
  /** По дате постановки на ЗУ */
  addedAt?: Maybe<SortOrderEnum>;
  /** По производителю, затем по модели */
  maker?: Maybe<SortOrderEnum>;
  /** По цене FOB из каталога */
  price?: Maybe<SortOrderEnum>;
};

export type GreenCornerManageObjectsPaginatedList = {
  __typename?: 'GreenCornerManageObjectsPaginatedList';
  nodes: Array<GreenCornerManageObject>;
  total: Scalars['Int'];
};

export type GreenCornerManageObject = {
  __typename?: 'GreenCornerManageObject';
  /** Дата постановки на ЗУ */
  addedAt?: Maybe<Scalars['DateTime']>;
  /** Сколько дней объект на текущем складе */
  daysOnStock?: Maybe<Scalars['Int']>;
  object: ObjectOfServices;
  /** Незавершённые услуги ЗУ */
  pendingServices?: Maybe<Array<Scalars['String']>>;
  /** Сектор на текущем складе */
  sector?: Maybe<Scalars['String']>;
  /** Где объект: запланирован, в перемещении, в музее или на ярдах */
  stage: GreenCornerObjectStage;
  stageName: Scalars['String'];
  /** Все признаки объекта, включая местоположение */
  stages?: Maybe<Array<GreenCornerObjectStage>>;
  /** Когда объект поступил на текущий склад */
  stockArrivedAt?: Maybe<Scalars['DateTime']>;
  telegram: GreenCornerObjectTelegram;
};

export type GreenCornerObjectTelegram = {
  __typename?: 'GreenCornerObjectTelegram';
  messageUrl?: Maybe<Scalars['String']>;
  /** Публикация состояния, для не отправленных — последний черновик */
  postId?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  status: GreenCornerTgPostStatus;
  statusName: Scalars['String'];
};

export type GreenCornerObjects = {
  __typename?: 'GreenCornerObjects';
  /** Всего ЗУ с грузополучателем */
  all?: Maybe<Scalars['Int']>;
  /** кол-во объектов не добавленных в список ожидания */
  notInAwaitingList?: Maybe<Scalars['Int']>;
  /** Объекты не добавленные в список ожидания */
  objects?: Maybe<Array<Maybe<ObjectOfServices>>>;
};

export type GreenCornerObjectsResaleStat = {
  __typename?: 'GreenCornerObjectsResaleStat';
  /** Активные объекты ЗУ с получателем */
  activeObjects?: Maybe<GreenCornerInventoryStat>;
  /** Статистика продаж за указанный период */
  sales?: Maybe<GreenCornerResaleSalesStat>;
  /** Топ аукционов по количеству проданных объектов ЗУ */
  topAuctions?: Maybe<Array<GreenCornerAuctionRankingItem>>;
  /** Покупатели по количеству перепродаж */
  topBuyers?: Maybe<Array<GreenCornerRankingItem>>;
  /** Популярные марки среди проданных объектов */
  topMakes?: Maybe<Array<GreenCornerRankingItem>>;
  /** Популярные модели среди проданных объектов */
  topModels?: Maybe<Array<GreenCornerRankingItem>>;
  /** Продавцы по количеству перепродаж клиентам */
  topResaleSellers?: Maybe<Array<GreenCornerRankingItem>>;
};

export type GreenCornerInventoryStat = {
  __typename?: 'GreenCornerInventoryStat';
  count?: Maybe<Scalars['Int']>;
  purchaseAmount?: Maybe<Scalars['Float']>;
};

export type GreenCornerResaleSalesStat = {
  __typename?: 'GreenCornerResaleSalesStat';
  differenceAmount?: Maybe<Scalars['Float']>;
  originalAmount?: Maybe<Scalars['Float']>;
  saleAmount?: Maybe<Scalars['Float']>;
  selfSalesCount?: Maybe<Scalars['Int']>;
  toAuctionCount?: Maybe<Scalars['Int']>;
  toClientCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GreenCornerAuctionRankingItem = {
  __typename?: 'GreenCornerAuctionRankingItem';
  averageSaleAmount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
};

export type GreenCornerRankingItem = {
  __typename?: 'GreenCornerRankingItem';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GreenCornerStoragePeriod = {
  __typename?: 'GreenCornerStoragePeriod';
  period?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
};

export type GreenCornerTgMedia = {
  __typename?: 'GreenCornerTgMedia';
  id: Scalars['Int'];
  /** Фото или видео */
  isPhoto: Scalars['Boolean'];
  mediaType?: Maybe<Scalars['String']>;
  /** Порядок фото в карточке объекта, у видео null */
  order?: Maybe<Scalars['Int']>;
  /** Превью фото, у видео null */
  thumbnailUrl?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type GreenCornerTgPost = {
  __typename?: 'GreenCornerTgPost';
  author?: Maybe<User>;
  /** Собственный текст публикации, null — берётся текст шаблона */
  body?: Maybe<Scalars['String']>;
  carId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  editor?: Maybe<User>;
  /** Ошибка последней попытки публикации */
  error?: Maybe<Scalars['String']>;
  errorAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  /** Выбранные фото в порядке публикации */
  media?: Maybe<Array<GreenCornerTgMedia>>;
  /** ID сообщения в Telegram */
  messageId?: Maybe<Scalars['Int']>;
  /** Ссылка на сообщение в канале */
  messageUrl?: Maybe<Scalars['String']>;
  /** Публикация со свежими данными объекта */
  preview: GreenCornerTgPreview;
  /** Фактическое время публикации */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** Текст, который сейчас в канале */
  publishedText?: Maybe<Scalars['String']>;
  /** Запланированное время публикации */
  scheduledAt?: Maybe<Scalars['DateTime']>;
  status: GreenCornerTgPostStatus;
  statusName: Scalars['String'];
  template?: Maybe<GreenCornerTgTemplate>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GreenCornerTgPreview = {
  __typename?: 'GreenCornerTgPreview';
  isTooLong: Scalars['Boolean'];
  /** Публикацию можно отправить */
  isValid: Scalars['Boolean'];
  /** Длина текста так, как её считает Telegram */
  length: Scalars['Int'];
  /** 1024 для публикации с фото, 4096 без фото */
  maxLength: Scalars['Int'];
  media?: Maybe<Array<GreenCornerTgMedia>>;
  /** Что мешает отправке */
  problems?: Maybe<Array<Scalars['String']>>;
  /** Готовый текст в HTML Telegram, null если шаблон с ошибками */
  text?: Maybe<Scalars['String']>;
};

export type GreenCornerTgTemplate = {
  __typename?: 'GreenCornerTgTemplate';
  author?: Maybe<User>;
  /** Текст шаблона: HTML Telegram с переменными {{key}} и условиями {{#key}}…{{/key}} */
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  editor?: Maybe<User>;
  id: Scalars['Int'];
  /** Используется по умолчанию */
  isDefault: Scalars['Boolean'];
  /** Название шаблона */
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GreenCornerTgPostsPaginatedList = {
  __typename?: 'GreenCornerTgPostsPaginatedList';
  nodes: Array<GreenCornerTgPost>;
  total: Scalars['Int'];
};

export type GreenCornerTgVariable = {
  __typename?: 'GreenCornerTgVariable';
  group: Scalars['String'];
  groupName: Scalars['String'];
  /** Используется только как условие {{#key}}…{{/key}} */
  isCondition: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  /** Готовая вставка для конструктора */
  snippet: Scalars['String'];
};

export type InvoiceCustomDzenPaysFilter = {
  invoiceCustomDzenPay?: Maybe<InvoiceCustomDzenPayFilter>;
};

export type InvoiceCustomDzenPayFilter = {
  /** Активные */
  active?: Maybe<Scalars['Boolean']>;
  /** По контрагенту баланса (холд/зачёт) */
  balanceAgentId?: Maybe<Scalars['Int']>;
  /** Дата подтверждения отмены */
  byApproveDate?: Maybe<RangeDate>;
  /** Дата создания */
  createdAt?: Maybe<RangeDate>;
  /** По клиенту */
  ownerId?: Maybe<Scalars['Int']>;
  /** По агенту */
  paymentAgentId?: Maybe<Scalars['Int']>;
  /** Тип оплаты */
  paymentType?: Maybe<DzenPayPaymentTypeEnum>;
  /** Дата загрузки ПТД */
  ptdUploadedAt?: Maybe<RangeDate>;
  /** Поиск */
  search?: Maybe<Scalars['String']>;
  /** Поиск по плательщику */
  searchClient?: Maybe<Scalars['String']>;
  /** Статус платёжки DzenPay */
  status?: Maybe<DzenPayOrderStatusEnum>;
};

export type InvoiceCustomDzenPaysPaginatedList = {
  __typename?: 'InvoiceCustomDzenPaysPaginatedList';
  nodes: Array<InvoiceCustomDzenPay>;
  total: Scalars['Int'];
};

export type InvoiceCustomDzenPayStats = {
  __typename?: 'InvoiceCustomDzenPayStats';
  acceptedByPartner?: Maybe<InvoiceCustomDzenPayStatsCountSum>;
  cancelledByClientApproved?: Maybe<InvoiceCustomDzenPayStatsCountSum>;
  cash?: Maybe<InvoiceCustomDzenPayStatsCountSum>;
  onHold?: Maybe<InvoiceCustomDzenPayStatsCountSum>;
  rejectedByPartner?: Maybe<InvoiceCustomDzenPayStatsCountSum>;
  totalSumInvoiceJpy?: Maybe<Scalars['Float']>;
  totalSumToCreditJpy?: Maybe<Scalars['Float']>;
  totalSumToPayRub?: Maybe<Scalars['Float']>;
  totalTransactionsCount?: Maybe<Scalars['Float']>;
  waitingForPayment?: Maybe<InvoiceCustomDzenPayStatsCountSum>;
};

export type InvoiceCustomDzenPayStatsCountSum = {
  __typename?: 'InvoiceCustomDzenPayStatsCountSum';
  count?: Maybe<Scalars['Int']>;
  sum?: Maybe<Scalars['Float']>;
  sumRub?: Maybe<Scalars['Float']>;
};

export type InvoiceCustomDzenPayAnalytics = {
  __typename?: 'InvoiceCustomDzenPayAnalytics';
  /** Статистика по активным инвойсам, количества и суммы */
  active?: Maybe<InvoiceCustomDzenPayActiveStats>;
  /** Общая аналитика */
  analytics?: Maybe<InvoiceCustomDzenPayAnalyticsDetails>;
  /** Сгрупированный по платежным агентам */
  byPaymentAgent?: Maybe<Array<Maybe<InvoiceCustomDzenPayPaymentAgentAnalytics>>>;
  /** Статистика по отменам */
  cancellations?: Maybe<InvoiceCustomDzenPayCancellationStats>;
  /** Статистика по разнице курса клиента и агента */
  clientMargin?: Maybe<InvoiceCustomDzenPayClientMargin>;
  /** Статистика по разнице курса агента и внутреннего курса */
  margin?: Maybe<InvoiceCustomDzenPayMargin>;
  /** Общая статистика, количества и суммы */
  overview?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** Статистика по динамике курсов */
  rateDynamics?: Maybe<InvoiceCustomDzenPayRateDynamics>;
  /** Статистика результатов проверки чеков */
  receiptValidation?: Maybe<InvoiceCustomDzenPayReceiptValidationStats>;
  /** Статистика по времени загрузки чека и по завершению инвойса */
  timings?: Maybe<InvoiceCustomDzenPayTimingStats>;
};

export type InvoiceCustomDzenPayActiveStats = {
  __typename?: 'InvoiceCustomDzenPayActiveStats';
  /** Зачислено */
  credited?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** Заморожено, сумма Не оплачено и оплачено */
  frozen?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** Оплачено */
  paid?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** Не оплачено */
  unpaid?: Maybe<InvoiceCustomDzenPayMoneyStats>;
};

export type InvoiceCustomDzenPayMoneyStats = {
  __typename?: 'InvoiceCustomDzenPayMoneyStats';
  /** Количество */
  count?: Maybe<Scalars['Int']>;
  /** Сумма инвойсов */
  invoiceSumJpy?: Maybe<Scalars['Float']>;
  /** К зачислению */
  toCreditJpy?: Maybe<Scalars['Float']>;
  /** К оплате */
  toPayRub?: Maybe<Scalars['Float']>;
};

export type InvoiceCustomDzenPayAnalyticsDetails = {
  __typename?: 'InvoiceCustomDzenPayAnalyticsDetails';
  /** Статистика, сгруппированная по типу инвойса */
  byInvoiceType?: Maybe<Array<Maybe<InvoiceCustomDzenPayAnalyticsSlice>>>;
  /** Статистика, сгруппированная по платёжным агентам. */
  byPaymentAgent?: Maybe<Array<Maybe<InvoiceCustomDzenPayAnalyticsSlice>>>;
  /** Статистика, сгруппированная по типу оплаты. */
  byPaymentType?: Maybe<Array<Maybe<InvoiceCustomDzenPayAnalyticsSlice>>>;
  /** Процент успешно завершённых заявок. */
  completionRatePercent?: Maybe<Scalars['Float']>;
  /** Процент заявок, подтверждённых менеджером. */
  managerAcceptedRatePercent?: Maybe<Scalars['Float']>;
  /** Процент заявок, в которых клиент загрузил подтверждение оплаты. */
  receiptUploadedRatePercent?: Maybe<Scalars['Float']>;
  /** Общее количество обработанных заявок. */
  totalRowsCount?: Maybe<Scalars['Int']>;
};

export type InvoiceCustomDzenPayAnalyticsSlice = {
  __typename?: 'InvoiceCustomDzenPayAnalyticsSlice';
  /** Количество */
  count?: Maybe<Scalars['Int']>;
  /** Сумма инвойсов */
  invoiceSumJpy?: Maybe<Scalars['Float']>;
  /** Наименование */
  name?: Maybe<Scalars['String']>;
  /** К зачислению */
  toCreditJpy?: Maybe<Scalars['Float']>;
  /** К оплате */
  toPayRub?: Maybe<Scalars['Float']>;
};

export type InvoiceCustomDzenPayPaymentAgentAnalytics = {
  __typename?: 'InvoiceCustomDzenPayPaymentAgentAnalytics';
  /** Статистика по активным инвойсам, количества и суммы */
  active?: Maybe<InvoiceCustomDzenPayActiveStats>;
  /** Общая аналитика */
  analytics?: Maybe<InvoiceCustomDzenPayAnalyticsDetails>;
  /** Статистика по отменам */
  cancellations?: Maybe<InvoiceCustomDzenPayCancellationStats>;
  /** Статистика по разнице курса агента и внутреннего курса */
  margin?: Maybe<InvoiceCustomDzenPayMargin>;
  /** Общая статистика, количества и суммы */
  overview?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** ID Платежного агента */
  paymentAgentId?: Maybe<Scalars['Int']>;
  /** Наименовение платежного агента */
  paymentAgentName?: Maybe<Scalars['String']>;
  /** Статистика по динамике курсов */
  rateDynamics?: Maybe<InvoiceCustomDzenPayRateDynamics>;
};

export type InvoiceCustomDzenPayCancellationStats = {
  __typename?: 'InvoiceCustomDzenPayCancellationStats';
  /** Отменено платежным агентом */
  cancelledByAgents?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** DEPRECATED Отменено клиентом и подтверждено менеджером */
  cancelledByClientApproved?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** Отменено менеджером */
  cancelledByManager?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** Отменено клиентом но еще не подтверждено менеджером */
  managerReviewRequired?: Maybe<InvoiceCustomDzenPayMoneyStats>;
  /** Общее количество */
  total?: Maybe<InvoiceCustomDzenPayMoneyStats>;
};

export type InvoiceCustomDzenPayMargin = {
  __typename?: 'InvoiceCustomDzenPayMargin';
  /** Средняя разница между курсом платежного агента и внутренним курсом */
  agentInnerRateDifferenceAverage?: Maybe<Scalars['Float']>;
  /** Максимальная разница между курсом платежного агента и внутренним курсом */
  agentInnerRateDifferenceMax?: Maybe<Scalars['Float']>;
  /** Суммарная разница в RUB по всем операциям. */
  agentInnerRateDifferenceRub?: Maybe<Scalars['Float']>;
  /** Средняя разница в RUB на одну операцию. */
  agentInnerRateDifferenceRubAverage?: Maybe<Scalars['Float']>;
  /** Максимальная разница в RUB по одной операции. */
  agentInnerRateDifferenceRubMax?: Maybe<Scalars['Float']>;
  /** Количество операций, участвующих в расчёте. */
  count?: Maybe<Scalars['Int']>;
};

export type InvoiceCustomDzenPayRateDynamics = {
  __typename?: 'InvoiceCustomDzenPayRateDynamics';
  /** График курсов */
  agentRateChart?: Maybe<Array<Maybe<InvoiceCustomDzenPayRateChartItem>>>;
  /** Средняя разница между курсом платежного агента и внутренним базовым курсом компании. */
  averageAgentRateChange?: Maybe<Scalars['Float']>;
  /** Средняя разница между клиентским курсом и курсом платежного агента */
  averageCustomerRateChange?: Maybe<Scalars['Float']>;
  /** Гармоническое среднее процента наценки клиента относительно внутреннего курса компании. */
  harmonicAverageMarkupPercent?: Maybe<Scalars['Float']>;
  /** Количество исключённых выбросов при расчёте наценки */
  markupOutliersExcluded?: Maybe<Scalars['Int']>;
  /** Количество операций, использованных для расчёта наценки. */
  markupSamplesCount?: Maybe<Scalars['Int']>;
};

export type InvoiceCustomDzenPayRateChartItem = {
  __typename?: 'InvoiceCustomDzenPayRateChartItem';
  /** Курс платежного агента */
  agentRate?: Maybe<Scalars['Float']>;
  /** Курс АТБ, действует до следующего изменения */
  atbRate?: Maybe<Scalars['Float']>;
  /** Количество */
  count?: Maybe<Scalars['Int']>;
  /** Курс клиента */
  customerRate?: Maybe<Scalars['Float']>;
  /** Дата */
  date?: Maybe<Scalars['String']>;
  /** Внутренний курс */
  innerRate?: Maybe<Scalars['Float']>;
  /** Курс Солида, действует до следующего изменения */
  solidRate?: Maybe<Scalars['Float']>;
};

export type InvoiceCustomDzenPayClientMargin = {
  __typename?: 'InvoiceCustomDzenPayClientMargin';
  /** Средняя разница между курсом клиента и платежного агента */
  clientAgentRateDifferenceAverage?: Maybe<Scalars['Float']>;
  /** Максимальная разница между курсом клиента и платежного агента */
  clientAgentRateDifferenceMax?: Maybe<Scalars['Float']>;
  /** Суммарная разница в RUB по всем операциям. */
  clientAgentRateDifferenceRub?: Maybe<Scalars['Float']>;
  /** Средняя разница в RUB на одну операцию. */
  clientAgentRateDifferenceRubAverage?: Maybe<Scalars['Float']>;
  /** Максимальная разница в RUB по одной операции. */
  clientAgentRateDifferenceRubMax?: Maybe<Scalars['Float']>;
  /** Количество операций, участвующих в расчёте. */
  count?: Maybe<Scalars['Int']>;
};

export type InvoiceCustomDzenPayReceiptValidationStats = {
  __typename?: 'InvoiceCustomDzenPayReceiptValidationStats';
  /** Количество проверок со статусом failed */
  failed?: Maybe<Scalars['Int']>;
  /** Количество чеков, требующих ручной проверки */
  needsReview?: Maybe<Scalars['Int']>;
  /** Количество отклоненных чеков */
  rejected?: Maybe<Scalars['Int']>;
  /** Количество успешно подтвержденных чеков */
  verified?: Maybe<Scalars['Int']>;
};

export type InvoiceCustomDzenPayTimingStats = {
  __typename?: 'InvoiceCustomDzenPayTimingStats';
  /** Статистика по времени завершения одного инвойса */
  invoiceCompletion?: Maybe<InvoiceCustomDzenPayDurationStats>;
  /** Статистика по времени загрузки чека */
  paymentReceiptUpload?: Maybe<InvoiceCustomDzenPayDurationStats>;
};

export type InvoiceCustomDzenPayDurationStats = {
  __typename?: 'InvoiceCustomDzenPayDurationStats';
  /** Среднее в минутах */
  averageMinutes?: Maybe<Scalars['Float']>;
  /** Количество */
  count?: Maybe<Scalars['Int']>;
  /** Среднее harmonika в минутах */
  harmonicAverageMinutes?: Maybe<Scalars['Float']>;
  /** Минимум в минутах */
  minMinutes?: Maybe<Scalars['Float']>;
};

export type InvoiceCustomerInfosPaginatedList = {
  __typename?: 'InvoiceCustomerInfosPaginatedList';
  nodes: Array<InvoiceCustomerInfo>;
  total: Scalars['Int'];
};

export type InvoiceCustomerInfo = {
  __typename?: 'InvoiceCustomerInfo';
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  fullNameRu?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
};

export type InvoiceLogsPaginatedList = {
  __typename?: 'InvoiceLogsPaginatedList';
  nodes: Array<InvoiceLog>;
  total: Scalars['Int'];
};

export type InvoiceLog = {
  __typename?: 'InvoiceLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  newAmount?: Maybe<Scalars['Int']>;
  nomenclature?: Maybe<Nomenclature>;
  object?: Maybe<ObjectOfServices>;
  oldAmount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

export type InvoicesSearchsFilter = {
  invoice: InvoiceFilter;
};

export type InvoiceFilter = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  invoiceType?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

export type InvoicesSearchsPaginatedList = {
  __typename?: 'InvoicesSearchsPaginatedList';
  nodes: Array<InvoiceSearch>;
  total: Scalars['Int'];
};

export type InvoiceSearch = {
  __typename?: 'InvoiceSearch';
  amount?: Maybe<Scalars['Float']>;
  clientName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currencyIso?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  ownerName?: Maybe<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export enum KaitaiAutoResubmitStateEnum {
  Disabled = 'disabled',
  Enabled = 'enabled'
}

export type QueueStatus = {
  __typename?: 'QueueStatus';
  currentMessageCount?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  time?: Maybe<Scalars['DateTime']>;
};

export type LimitsPlan = {
  __typename?: 'LimitsPlan';
  addExtraDays?: Maybe<Array<Scalars['String']>>;
  generatePlanDays?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
};

export type TypeOfLocality = {
  __typename?: 'TypeOfLocality';
  fullName?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

export type LogAgentEventsFilter = {
  logAgentEvent?: Maybe<LogAgentEventFilter>;
};

export type LogAgentEventFilter = {
  id?: Maybe<Scalars['Int']>;
};

export type LogAgentEventsPaginatedList = {
  __typename?: 'LogAgentEventsPaginatedList';
  nodes: Array<LogAgentEvent>;
  total: Scalars['Int'];
};

export type LogAgentEvent = {
  __typename?: 'LogAgentEvent';
  agent?: Maybe<Owner>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  serviceCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type LogsFilter = {
  log?: Maybe<LogFilter>;
};

export type LogFilter = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['Int']>;
};

export type LogsPaginatedList = {
  __typename?: 'LogsPaginatedList';
  nodes: Array<Log>;
  total: Scalars['Int'];
};

export type Log = {
  __typename?: 'Log';
  id?: Maybe<Scalars['Int']>;
  isJson?: Maybe<Scalars['Boolean']>;
  msg?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type LogsUserRequestsFilter = {
  logsUserRequest?: Maybe<LogsUserRequestFilter>;
};

export type LogsUserRequestFilter = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['Int']>;
};

export type LogsUserRequestsPaginatedList = {
  __typename?: 'LogsUserRequestsPaginatedList';
  nodes: Array<LogsUserRequest>;
  total: Scalars['Int'];
};

export type LogsUserRequest = {
  __typename?: 'LogsUserRequest';
  bodyParams?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  httpRequestMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  remoteIp?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userAgent?: Maybe<Scalars['String']>;
  userIp?: Maybe<Scalars['String']>;
};

export type LotteryTicket = {
  __typename?: 'LotteryTicket';
  isVacant?: Maybe<Scalars['Boolean']>;
  ticketId?: Maybe<Scalars['Int']>;
};

export type MasterAccountsClientsPaginatedList = {
  __typename?: 'MasterAccountsClientsPaginatedList';
  nodes: Array<Owner>;
  total: Scalars['Int'];
};

export type MediaObjectsFilter = {
  isAkebono?: Maybe<Scalars['Boolean']>;
  stockId?: Maybe<Scalars['Int']>;
  tripId?: Maybe<Scalars['Int']>;
  typeId?: Maybe<VehicleType>;
  vin?: Maybe<Scalars['String']>;
};

export enum VehicleType {
  Car = 'CAR',
  Moto = 'MOTO'
}

export type MediaStatistics = {
  __typename?: 'MediaStatistics';
  countObjectsWithMedia?: Maybe<Scalars['Int']>;
  countObjectsWoMedia?: Maybe<Scalars['Int']>;
  objects?: Maybe<Array<ObjectOfServices>>;
};

export type TripSchedule = {
  __typename?: 'TripSchedule';
  trips?: Maybe<Array<TripScheduleInfo>>;
  /** Самая последняя дата обновления среди рейсов и их планов погрузки */
  tripsUpdatedAt?: Maybe<Scalars['DateTime']>;
};

export type TripScheduleInfo = {
  __typename?: 'TripScheduleInfo';
  contractClosingDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  serialNum?: Maybe<Scalars['String']>;
  ship?: Maybe<VesselInfo>;
  status?: Maybe<TripStatusEnum>;
  wayPoints?: Maybe<Array<WayPoint>>;
};

export type VesselInfo = {
  __typename?: 'VesselInfo';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export enum TripStatusEnum {
  ComingSoon = 'comingSoon',
  DepartingSoon = 'departingSoon',
  OnWay = 'onWay',
  RecentlyEnded = 'recentlyEnded'
}

export type WayPoint = {
  __typename?: 'WayPoint';
  city?: Maybe<CityInfo>;
  date?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
};

export type CityInfo = {
  __typename?: 'CityInfo';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type NotificationLogsFilter = {
  notificationLog?: Maybe<NotificationLogFilter>;
};

export type NotificationLogFilter = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  entity?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  sendTo?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
};

export type NotificationLogsPaginatedList = {
  __typename?: 'NotificationLogsPaginatedList';
  nodes: Array<NotificationLog>;
  total: Scalars['Int'];
};

export type NotificationLog = {
  __typename?: 'NotificationLog';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<NotificationLogEntityEnum>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isSuccess?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['String']>;
  sendFrom?: Maybe<Scalars['String']>;
  sendTo?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum NotificationLogEntityEnum {
  Agents = 'AGENTS',
  Objects = 'OBJECTS',
  Tickets = 'TICKETS'
}

export type ObjectActivitysFilter = {
  objectActivity?: Maybe<ObjectActivityFilter>;
};

export type ObjectActivityFilter = {
  command?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  direction?: Maybe<ObjectActivityDirectionEnum>;
  objectGuid?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  objectVin?: Maybe<Scalars['String']>;
};

export enum ObjectActivityDirectionEnum {
  Incoming = 'incoming',
  Outgoing = 'outgoing'
}

export type ObjectActivitysSort = {
  objectActivity?: Maybe<ObjectActivitySort>;
};

export type ObjectActivitySort = {
  createdAt?: Maybe<SortOrderEnum>;
};

export type ObjectActivitysPaginatedList = {
  __typename?: 'ObjectActivitysPaginatedList';
  nodes: Array<ObjectActivity>;
  total: Scalars['Int'];
};

export type ObjectActivity = {
  __typename?: 'ObjectActivity';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSON']>;
  guid1c?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logKind?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['JSON']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  response?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceTable?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type OperationalObjectsFilter = {
  operationalObject?: Maybe<OperationalObjectFilter>;
};

export type OperationalObjectFilter = {
  broker?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isExtra?: Maybe<Scalars['Boolean']>;
  planDate?: Maybe<Scalars['String']>;
};

export type OperationalObjectsPaginatedList = {
  __typename?: 'OperationalObjectsPaginatedList';
  nodes: Array<SbktsObjectToPlan>;
  total: Scalars['Int'];
};

export type OwnersFilter = {
  owner?: Maybe<OwnerFilter>;
};

export type OwnerFilter = {
  hasYahooAccount?: Maybe<Scalars['Boolean']>;
};

export type OwnersPaginatedList = {
  __typename?: 'OwnersPaginatedList';
  nodes: Array<Owner>;
  total: Scalars['Int'];
};

export type P2pBuyRequest = {
  __typename?: 'P2pBuyRequest';
  amountCompleted?: Maybe<Scalars['Int']>;
  amountInDeals?: Maybe<Scalars['Int']>;
  amountTotal?: Maybe<Scalars['Int']>;
  /** Свободный остаток заявки */
  availableAmount?: Maybe<Scalars['Int']>;
  buyer?: Maybe<OwnerInfo>;
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerCode?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commissionPayer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Все сделки заявки, включая отменённые */
  deals?: Maybe<Array<P2pDeal>>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<P2pHistory>>;
  id?: Maybe<Scalars['Int']>;
  minDealAmount?: Maybe<Scalars['Int']>;
  paymentBankName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  /** Всегда buy_request — для единообразия с p2pMyRequests */
  type?: Maybe<Scalars['String']>;
};

export type P2pDeal = {
  __typename?: 'P2pDeal';
  amount?: Maybe<Scalars['Int']>;
  amountToCredit?: Maybe<Scalars['Int']>;
  buyer?: Maybe<OwnerInfo>;
  /** Только для сотрудников с доступом к p2pAdminDeal */
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerCode?: Maybe<Scalars['String']>;
  buyerCommissionAmount?: Maybe<Scalars['Int']>;
  buyRequestId?: Maybe<Scalars['Int']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  chatId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Int']>;
  commissionFixedAmount?: Maybe<Scalars['Int']>;
  commissionPayer?: Maybe<Scalars['String']>;
  commissionPercent?: Maybe<Scalars['Float']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<P2pHistory>>;
  id?: Maybe<Scalars['Int']>;
  /** Только для сотрудников с доступом к p2pAdminDeal */
  initiatorAgentId?: Maybe<Scalars['Int']>;
  /** Публичный код инициатора отклика */
  initiatorCode?: Maybe<Scalars['String']>;
  /** Кто создал отклик: buyer — к объявлению на продажу, seller — к заявке на покупку */
  initiatorRole?: Maybe<Scalars['String']>;
  myRole?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['Int']>;
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentBankName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  reviews?: Maybe<Array<P2pReview>>;
  seller?: Maybe<OwnerInfo>;
  /** Только для сотрудников с доступом к p2pAdminDeal */
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerCode?: Maybe<Scalars['String']>;
  sellerCommissionAmount?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pHistory = {
  __typename?: 'P2pHistory';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Scalars['String']>;
  eventLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
};

export type P2pReview = {
  __typename?: 'P2pReview';
  authorCode?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dealId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isMine?: Maybe<Scalars['Boolean']>;
  rating?: Maybe<Scalars['Int']>;
  targetCode?: Maybe<Scalars['String']>;
};

export type P2pAdminBuyRequestsFilter = {
  p2pAdminBuyRequest?: Maybe<P2pAdminBuyRequestFilter>;
};

export type P2pAdminBuyRequestFilter = {
  /** Покупатель */
  agentId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Scalars['String']>>;
};

export type P2pAdminBuyRequestsPaginatedList = {
  __typename?: 'P2pAdminBuyRequestsPaginatedList';
  nodes: Array<P2pBuyRequest>;
  total: Scalars['Int'];
};

export type P2pAdminDealsFilter = {
  p2pAdminDeal?: Maybe<P2pAdminDealFilter>;
};

export type P2pAdminDealFilter = {
  /** Контрагент — продавец или покупатель */
  agentId?: Maybe<Scalars['Int']>;
  /** Сумма сделки от, JPY */
  amountFrom?: Maybe<Scalars['Int']>;
  /** Сумма сделки до, JPY */
  amountTo?: Maybe<Scalars['Int']>;
  /** ID заявки на покупку: все сделки (отклики) этой заявки */
  buyRequestId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  /** ID объявления на продажу: все сделки (отклики) этого объявления */
  offerId?: Maybe<Scalars['Int']>;
  status?: Maybe<Array<Scalars['String']>>;
};

export type P2pAdminDealsPaginatedList = {
  __typename?: 'P2pAdminDealsPaginatedList';
  nodes: Array<P2pDeal>;
  total: Scalars['Int'];
};

export type P2pDealStatusCount = {
  __typename?: 'P2pDealStatusCount';
  count?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pOffer = {
  __typename?: 'P2pOffer';
  amountCancelled?: Maybe<Scalars['Int']>;
  amountCompleted?: Maybe<Scalars['Int']>;
  amountInDeals?: Maybe<Scalars['Int']>;
  amountTotal?: Maybe<Scalars['Int']>;
  /** Свободный остаток: всего − продано − отменено − в сделках */
  availableAmount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  commissionPayer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Все сделки предложения, включая отменённые */
  deals?: Maybe<Array<P2pDeal>>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  history?: Maybe<Array<P2pHistory>>;
  id?: Maybe<Scalars['Int']>;
  maxDealAmount?: Maybe<Scalars['Int']>;
  minDealAmount?: Maybe<Scalars['Int']>;
  paymentBankName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  seller?: Maybe<OwnerInfo>;
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerCode?: Maybe<Scalars['String']>;
  sourceAgreementGuid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** Всегда offer — для единообразия с p2pMyRequests */
  type?: Maybe<Scalars['String']>;
};

export type P2pAdminOffersFilter = {
  p2pAdminOffer?: Maybe<P2pAdminOfferFilter>;
};

export type P2pAdminOfferFilter = {
  /** Продавец */
  agentId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Scalars['String']>>;
};

export type P2pAdminOffersPaginatedList = {
  __typename?: 'P2pAdminOffersPaginatedList';
  nodes: Array<P2pOffer>;
  total: Scalars['Int'];
};

export type P2pOfferStatusCount = {
  __typename?: 'P2pOfferStatusCount';
  count?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminRequestsFilter = {
  p2pAdminRequest?: Maybe<P2pAdminRequestFilter>;
};

export type P2pAdminRequestFilter = {
  /** Контрагент — владелец объявления */
  agentId?: Maybe<Scalars['Int']>;
  /** Сумма объявления от, JPY */
  amountFrom?: Maybe<Scalars['Int']>;
  /** Сумма объявления до, JPY */
  amountTo?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Scalars['String']>>;
  /** offer — продажа, buy_request — покупка */
  type?: Maybe<Scalars['String']>;
};

export type P2pAdminRequestsPaginatedList = {
  __typename?: 'P2pAdminRequestsPaginatedList';
  nodes: Array<P2pAdminRequest>;
  total: Scalars['Int'];
};

export type P2pAdminRequest = {
  __typename?: 'P2pAdminRequest';
  amountCancelled?: Maybe<Scalars['Int']>;
  amountCompleted?: Maybe<Scalars['Int']>;
  amountInDeals?: Maybe<Scalars['Int']>;
  amountTotal?: Maybe<Scalars['Int']>;
  availableAmount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  commissionPayer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dealsCount?: Maybe<Scalars['Int']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** ID объявления: для сделок передавать как offerId или buyRequestId в p2pAdminDeals */
  id?: Maybe<Scalars['Int']>;
  ownerAgentId?: Maybe<Scalars['Int']>;
  ownerCode?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** offer — продажа, buy_request — покупка */
  type?: Maybe<Scalars['String']>;
  /** Продажа или Покупка */
  typeLabel?: Maybe<Scalars['String']>;
};

export type P2pBuyRequestPublic = {
  __typename?: 'P2pBuyRequestPublic';
  /** Занято незакрытыми сделками */
  amountInDeals?: Maybe<Scalars['Int']>;
  /** Вся сумма заявки */
  amountTotal?: Maybe<Scalars['Int']>;
  /** Свободный остаток желаемой суммы */
  availableAmount?: Maybe<Scalars['Int']>;
  buyerCode?: Maybe<Scalars['String']>;
  buyerRating?: Maybe<Scalars['Float']>;
  buyerReviewsCount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  commissionPayer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  /** Своя заявка — отклик на неё невозможен */
  isMine?: Maybe<Scalars['Boolean']>;
  /** Максимальная сумма одной продажи (глобальный лимит) */
  maxDealAmount?: Maybe<Scalars['Int']>;
  /** Минимальная сумма продажи */
  minDealAmount?: Maybe<Scalars['Int']>;
  paymentBankName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pPublicBuyRequestsPaginatedList = {
  __typename?: 'P2pPublicBuyRequestsPaginatedList';
  nodes: Array<P2pBuyRequestPublic>;
  total: Scalars['Int'];
};

export type P2pMyBuyRequestsPaginatedList = {
  __typename?: 'P2pMyBuyRequestsPaginatedList';
  nodes: Array<P2pBuyRequest>;
  total: Scalars['Int'];
};

export type P2pMyDealsPaginatedList = {
  __typename?: 'P2pMyDealsPaginatedList';
  nodes: Array<P2pDeal>;
  total: Scalars['Int'];
};

export type P2pMyOffersPaginatedList = {
  __typename?: 'P2pMyOffersPaginatedList';
  nodes: Array<P2pOffer>;
  total: Scalars['Int'];
};

export type P2pMyRequestsFilter = {
  p2pRequest?: Maybe<P2pRequestFilter>;
};

export type P2pRequestFilter = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Scalars['String']>>;
  /** offer — предложения на продажу, buy_request — заявки на покупку */
  type?: Maybe<Scalars['String']>;
};

export type P2pMyRequestsPaginatedList = {
  __typename?: 'P2pMyRequestsPaginatedList';
  nodes: Array<P2pMyRequest>;
  total: Scalars['Int'];
};

export type P2pMyRequest = {
  __typename?: 'P2pMyRequest';
  /** Отмененный остаток, всегда 0 для заявки на покупку */
  amountCancelled?: Maybe<Scalars['Int']>;
  amountCompleted?: Maybe<Scalars['Int']>;
  amountInDeals?: Maybe<Scalars['Int']>;
  amountTotal?: Maybe<Scalars['Int']>;
  /** Свободный остаток */
  availableAmount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  commissionPayer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Сделки по записи, включая отменённые; в чужой — только сделки пользователя */
  deals?: Maybe<Array<P2pDeal>>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  /** Своя запись; false — чужая, где пользователь участник сделки */
  isMine?: Maybe<Scalars['Boolean']>;
  /** Только для offer */
  maxDealAmount?: Maybe<Scalars['Int']>;
  /** Минимальная сумма одной сделки, есть у offer и buy_request */
  minDealAmount?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['Float']>;
  /** Только для offer */
  sourceAgreementGuid?: Maybe<Scalars['String']>;
  /** Наборы статусов offer и buy_request не совпадают */
  status?: Maybe<Scalars['String']>;
  /** offer — предложение на продажу, buy_request — заявка на покупку */
  type?: Maybe<Scalars['String']>;
};

export type P2pOfferPublic = {
  __typename?: 'P2pOfferPublic';
  /** Занято незакрытыми сделками */
  amountInDeals?: Maybe<Scalars['Int']>;
  /** Вся сумма предложения */
  amountTotal?: Maybe<Scalars['Int']>;
  /** Свободный остаток, доступный для покупки */
  availableAmount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  commissionPayer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  /** Своё предложение — отклик на него невозможен */
  isMine?: Maybe<Scalars['Boolean']>;
  /** Максимальная сумма покупки с учётом свободного остатка */
  maxDealAmount?: Maybe<Scalars['Int']>;
  minDealAmount?: Maybe<Scalars['Int']>;
  paymentBankName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentPhone?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  sellerCode?: Maybe<Scalars['String']>;
  sellerRating?: Maybe<Scalars['Float']>;
  sellerReviewsCount?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pPublicOffersPaginatedList = {
  __typename?: 'P2pPublicOffersPaginatedList';
  nodes: Array<P2pOfferPublic>;
  total: Scalars['Int'];
};

export type P2pPaymentDetail = {
  __typename?: 'P2pPaymentDetail';
  bankName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  method?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type P2pSettings = {
  __typename?: 'P2pSettings';
  /** Доступный аукционный аванс текущего пользователя, JPY */
  auctionBalance?: Maybe<Scalars['Int']>;
  /** Комиссия, если платит одна сторона, JPY */
  commissionFixedAmount?: Maybe<Scalars['Int']>;
  /** Комиссия с каждой стороны при оплате пополам, JPY */
  commissionFixedSplitAmount?: Maybe<Scalars['Int']>;
  /**
   * Всегда 0: комиссия только фиксированная
   * @deprecated Комиссия P2P без процента
   */
  commissionPercent?: Maybe<Scalars['Float']>;
  /** Максимальная сумма одной сделки, JPY */
  maxDealAmount?: Maybe<Scalars['Int']>;
  /** Минимальная сумма одной сделки, JPY */
  minDealAmount?: Maybe<Scalars['Int']>;
};

export type PalletsFilter = {
  pallet?: Maybe<PalletFilter>;
};

export type PalletFilter = {
  /** Пустой */
  empty?: Maybe<Scalars['Boolean']>;
  /** Готов к отгрузке */
  readyToTrip?: Maybe<Scalars['Boolean']>;
  /** Поставлен на рейс */
  toTrip?: Maybe<Scalars['Boolean']>;
};

export type PalletsPaginatedList = {
  __typename?: 'PalletsPaginatedList';
  nodes: Array<Pallet>;
  total: Scalars['Int'];
};

export type PartTemplate = {
  __typename?: 'PartTemplate';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentHistory = {
  __typename?: 'PaymentHistory';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<PaymentHistoryItem>>;
  sum?: Maybe<Scalars['String']>;
};

export type PaymentHistoryItem = {
  __typename?: 'PaymentHistoryItem';
  contractName?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  name?: Maybe<Scalars['String']>;
  object?: Maybe<ObjectOfServices>;
  sum?: Maybe<Scalars['String']>;
};

export type SbktsPlansPaginatedList = {
  __typename?: 'SbktsPlansPaginatedList';
  nodes: Array<SbktsPlan>;
  total: Scalars['Int'];
};

export type PortInfo = {
  __typename?: 'PortInfo';
  country?: Maybe<CountryInfo>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PortTypeInfo>;
};

export type CountryInfo = {
  __typename?: 'CountryInfo';
  engName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** Тип порта */
export type PortTypeInfo = {
  __typename?: 'PortTypeInfo';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameEng?: Maybe<Scalars['String']>;
};

export type PriceLevel = {
  __typename?: 'PriceLevel';
  /** Наценка в процентах */
  percent?: Maybe<Scalars['Float']>;
  /** Тип цены */
  priceLevel?: Maybe<PriceLevelEnum>;
};

export enum PriceLevelEnum {
  /** Отличная цена 0% - 5 % */
  Best = 'best',
  /** Скидочная цена < 0% */
  Discount = 'discount',
  /** Хорошая цена >5% - 10 % */
  Good = 'good',
  /** Высокая цена > 15% */
  High = 'high',
  /** Рыночная цена >10% - 15 % */
  Market = 'market'
}

export type QrPaymentAvailability = {
  __typename?: 'QrPaymentAvailability';
  allowed?: Maybe<Scalars['Boolean']>;
  blockType?: Maybe<QrPaymentBlockTypeGraphqlEnum>;
  payer?: Maybe<QrPaymentPayer>;
};

export enum QrPaymentBlockTypeGraphqlEnum {
  QrAlreadyExists = 'QR_ALREADY_EXISTS',
  RecipientRequired = 'RECIPIENT_REQUIRED'
}

export type QrPaymentPayer = {
  __typename?: 'QrPaymentPayer';
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
};

export type Reason = {
  __typename?: 'Reason';
  id?: Maybe<Scalars['Int']>;
  nameEn?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
};

export type ReportsFilter = {
  report?: Maybe<ReportFilter>;
};

export type ReportFilter = {
  /** Только неудалённые */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Отчёты Kaitai */
  isKaitai?: Maybe<Scalars['Boolean']>;
  /** Фильтр по статусам отчётов */
  statuses?: Maybe<Array<Maybe<ReportStatusEnum>>>;
  /** Перечень типов отчётов */
  typeIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** Статус отчёта */
export enum ReportStatusEnum {
  /** Отменён */
  Cancelled = 'cancelled',
  /** Формируется */
  Forming = 'forming',
  /** В процессе формирования */
  InProgress = 'in_progress',
  /** Готов */
  Ready = 'ready'
}

export type ReportsSort = {
  report?: Maybe<ReportSort>;
};

export type ReportSort = {
  completedAt?: Maybe<SortOrderEnum>;
  createdAt?: Maybe<SortOrderEnum>;
  startedAt?: Maybe<SortOrderEnum>;
};

export type ReportsPaginatedList = {
  __typename?: 'ReportsPaginatedList';
  nodes: Array<Report>;
  total: Scalars['Int'];
};

export type Report = {
  __typename?: 'Report';
  /** Дата завершения формирования отчёта */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Дата запроса отчёта */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Автор запроса отчёта */
  createdBy?: Maybe<User>;
  /** Сообщение об ошибке */
  errMsg?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** Файл для обработки */
  inputFile?: Maybe<S3File>;
  /** Генерация отчёта отменена */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Файл отчёта */
  outputFile?: Maybe<S3File>;
  /** Дата, на которую составлен отчёт */
  reportByDate?: Maybe<Scalars['String']>;
  /** Тип отчёта */
  reportType?: Maybe<TypeOfReport>;
  /** Дата начала формирования отчёта */
  startedAt?: Maybe<Scalars['DateTime']>;
};

export type TypeOfReport = {
  __typename?: 'TypeOfReport';
  filterTypes?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  isDateRequired?: Maybe<Scalars['Boolean']>;
  isFileRequired?: Maybe<Scalars['Boolean']>;
  isIdsRequired?: Maybe<Scalars['Boolean']>;
  nameEng?: Maybe<Scalars['String']>;
  nameRu?: Maybe<Scalars['String']>;
};

export type ReportTypeFilter = {
  /** Типы Kaitai */
  isKaitai?: Maybe<Scalars['Boolean']>;
};

export type SbktsStatistic = {
  __typename?: 'SbktsStatistic';
  brokers?: Maybe<Array<SbktsBrokerStatistic>>;
  objects?: Maybe<Array<SbktsObjectToPlan>>;
};

export type SbktsBrokerStatistic = {
  __typename?: 'SbktsBrokerStatistic';
  approved?: Maybe<Scalars['Int']>;
  broker?: Maybe<Broker>;
  created?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Int']>;
  elpts?: Maybe<Scalars['Int']>;
  expertise?: Maybe<Scalars['Int']>;
  hold?: Maybe<Scalars['Int']>;
  movedToAi?: Maybe<Scalars['Int']>;
  movedToTroyan?: Maybe<Scalars['Int']>;
  sbkts?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  unHold?: Maybe<Scalars['Int']>;
};

export type SbktsPlanStatistic = {
  __typename?: 'SbktsPlanStatistic';
  data?: Maybe<Array<SbktsPlanStatisticByDate>>;
  totalByBrokers?: Maybe<Array<SbktsBrokerStatistic>>;
};

export type SbktsPlanStatisticByDate = {
  __typename?: 'SbktsPlanStatisticByDate';
  brokers?: Maybe<Array<SbktsBrokerStatistic>>;
  date?: Maybe<Scalars['String']>;
  objects?: Maybe<Array<SbktsObjectToPlan>>;
  totalByOneDateWork?: Maybe<Scalars['Int']>;
};

export type SbktsRequestsFilter = {
  sbktsRequest?: Maybe<SbktsRequestFilter>;
};

export type SbktsRequestFilter = {
  assignedUsers?: Maybe<Array<Scalars['Int']>>;
  blankNumber?: Maybe<Scalars['String']>;
  broken?: Maybe<Scalars['Boolean']>;
  broker?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Boolean']>;
  consignment?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  hasHolds?: Maybe<Scalars['Boolean']>;
  isBeginWork?: Maybe<Scalars['Boolean']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isCompleteReleased?: Maybe<Scalars['Boolean']>;
  isFailExchange?: Maybe<Scalars['Boolean']>;
  isHasData?: Maybe<Scalars['Boolean']>;
  isHasElpts?: Maybe<Scalars['Boolean']>;
  isHold?: Maybe<Scalars['Boolean']>;
  isInBox?: Maybe<Scalars['Boolean']>;
  isMoto?: Maybe<Scalars['Boolean']>;
  isNotApproved?: Maybe<Scalars['Boolean']>;
  isNotApproveOver3Day?: Maybe<Scalars['Boolean']>;
  isNotApproveOverWeek?: Maybe<Scalars['Boolean']>;
  isNotHold?: Maybe<Scalars['Boolean']>;
  isOnWork?: Maybe<Scalars['Boolean']>;
  isPassedTests?: Maybe<Scalars['Boolean']>;
  isPriority?: Maybe<Scalars['Boolean']>;
  isThirdPartyObject?: Maybe<Scalars['Boolean']>;
  laboratory?: Maybe<Scalars['Int']>;
  maker?: Maybe<Scalars['Int']>;
  mark?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['Int']>;
  moreThirdDays?: Maybe<Scalars['Boolean']>;
  onTroyan?: Maybe<Scalars['Boolean']>;
  plan?: Maybe<Scalars['Int']>;
  requestNumber?: Maybe<Scalars['String']>;
  unfinished?: Maybe<Scalars['Boolean']>;
  unHold?: Maybe<Scalars['Boolean']>;
  vin?: Maybe<Scalars['String']>;
  withDeleted?: Maybe<Scalars['Boolean']>;
};

export type SbktsRequestsSort = {
  sbktsRequest?: Maybe<SbktsRequestSort>;
};

export type SbktsRequestSort = {
  active?: Maybe<Scalars['Boolean']>;
  approvedAt?: Maybe<SortOrderEnum>;
  completedAt?: Maybe<SortOrderEnum>;
  createdAt?: Maybe<SortOrderEnum>;
  passedTestsAt?: Maybe<SortOrderEnum>;
  requestNumber?: Maybe<SortOrderEnum>;
};

export type SbktsRequestsPaginatedList = {
  __typename?: 'SbktsRequestsPaginatedList';
  nodes: Array<SbktsRequest>;
  total: Scalars['Int'];
};

export type DisposalsPaginatedList = {
  __typename?: 'DisposalsPaginatedList';
  nodes: Array<ObjectOfServices>;
  total: Scalars['Int'];
};

export type ScrapTypeDescriptionsPaginatedList = {
  __typename?: 'ScrapTypeDescriptionsPaginatedList';
  nodes: Array<ScrapTypeDescription>;
  total: Scalars['Int'];
};

export type SeaCarriersPaginatedList = {
  __typename?: 'SeaCarriersPaginatedList';
  nodes: Array<SeaCarrier>;
  total: Scalars['Int'];
};

export type SearchObjectsPaginatedList = {
  __typename?: 'SearchObjectsPaginatedList';
  nodes: Array<SearchResult>;
  total: Scalars['Int'];
};

export type SearchResult = Invoice | InvoiceCustom | ObjectOfServices;

export type OwnerAgentsFilter = {
  senderAgentsSearch?: Maybe<SenderAgentsSearchFilter>;
};

export type SenderAgentsSearchFilter = {
  partName?: Maybe<Scalars['String']>;
};

export type OwnerAgentsPaginatedList = {
  __typename?: 'OwnerAgentsPaginatedList';
  nodes: Array<Owner>;
  total: Scalars['Int'];
};

export type SendersPaginatedList = {
  __typename?: 'SendersPaginatedList';
  nodes: Array<Sender>;
  total: Scalars['Int'];
};

export type ServiceRequestObjectsFilter = {
  objectServiceRequest?: Maybe<ObjectServiceRequestFilter>;
};

export type ObjectServiceRequestFilter = {
  /** Дата создания заявки от */
  dateFrom?: Maybe<Scalars['DateTime']>;
  /** Дата создания заявки до */
  dateTo?: Maybe<Scalars['DateTime']>;
  /** Поиск по кузову */
  searchByVin?: Maybe<Scalars['String']>;
  /** Статус заявки */
  status?: Maybe<ServiceRequestStatusEnum>;
  /** Тип услуги */
  typeId?: Maybe<Scalars['Int']>;
};

export type ServiceRequestObjectsSort = {
  objectOfService?: Maybe<ObjectOfServiceSort>;
};

export type ServiceRequestObjectsPaginatedList = {
  __typename?: 'ServiceRequestObjectsPaginatedList';
  nodes: Array<ObjectOfServices>;
  total: Scalars['Int'];
};

export type ServiceRequestsFilter = {
  serviceRequest?: Maybe<ServiceRequestFilter>;
};

export type ServiceRequestFilter = {
  /** Поиск по кузову */
  dateFrom?: Maybe<Scalars['DateTime']>;
  /** Поиск по кузову */
  dateTo?: Maybe<Scalars['DateTime']>;
  /** Запросы на досмотр на стокярде */
  isStock?: Maybe<Scalars['Boolean']>;
  /** Запросы на досмотр USS */
  isUSS?: Maybe<Scalars['Boolean']>;
  /** Поиск по кузову */
  searchByVin?: Maybe<Scalars['String']>;
  /** По статусу заявки */
  status?: Maybe<ServiceRequestStatusEnum>;
  /** Список типов инспекций по id */
  typesId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type ServiceRequestsSort = {
  serviceRequest?: Maybe<ServiceRequestSort>;
};

export type ServiceRequestSort = {
  createdAt?: Maybe<SortOrderEnum>;
  dueDate?: Maybe<SortOrderEnum>;
};

export type ServiceRequestsPaginatedList = {
  __typename?: 'ServiceRequestsPaginatedList';
  nodes: Array<ServiceRequest>;
  total: Scalars['Int'];
};

export type ServiceRequestCount = {
  __typename?: 'ServiceRequestCount';
  auctionInspectionCount?: Maybe<Scalars['Int']>;
  videoInspectionCount?: Maybe<Scalars['Int']>;
};

export enum StatisticTypeEnum {
  Auction = 'auction',
  Date = 'date',
  None = 'none'
}

export type CarInPlantStatistic = {
  __typename?: 'CarInPlantStatistic';
  /** Список аукционов за период */
  auctions?: Maybe<Array<Maybe<Auction>>>;
  /** Всего закупленно */
  buyCount: Scalars['Int'];
  /** Период начало */
  dateFrom: Scalars['String'];
  /** Период конец */
  dateTo: Scalars['String'];
  /** Список дней за период */
  purchaseDate?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Зарегистрированно на рейс */
  registeredTotal: Scalars['Int'];
  /** Зарегистрированно на рейс в % от buyCount */
  registeredTotalPercent: Scalars['Float'];
  /** Статистка за период */
  statistic?: Maybe<Array<Maybe<CarInPlantDayStatisticTotal>>>;
};

export type CarInPlantDayStatisticTotal = {
  __typename?: 'CarInPlantDayStatisticTotal';
  /** Всего зарегистрированно */
  count: Scalars['Int'];
  /** На какой день зарегистрированно в рейс. Значение null для не заригистрированно. */
  dayDiff?: Maybe<Scalars['Int']>;
  /** Всего зарегистрированно в % */
  percent: Scalars['Float'];
};

export enum TypeOfStatusEnum {
  Object = 'OBJECT',
  ObjectRecycle = 'OBJECT_RECYCLE',
  ObjectResale = 'OBJECT_RESALE',
  Troyan = 'TROYAN',
  YahooLot = 'YAHOO_LOT'
}

export type StockCountiesPaginatedList = {
  __typename?: 'StockCountiesPaginatedList';
  nodes: Array<Country>;
  total: Scalars['Int'];
};

export type StocksFilter = {
  countryStock?: Maybe<CountryStockFilter>;
};

export type CountryStockFilter = {
  active?: Maybe<Scalars['Boolean']>;
  countryId?: Maybe<Scalars['ID']>;
  inJapan?: Maybe<Scalars['Boolean']>;
};

export type StocksPaginatedList = {
  __typename?: 'StocksPaginatedList';
  nodes: Array<Stock>;
  total: Scalars['Int'];
};

export type SvhDeliveryAmbassadorsPaginatedList = {
  __typename?: 'SvhDeliveryAmbassadorsPaginatedList';
  nodes: Array<SvhDeliveryAmbassador>;
  total: Scalars['Int'];
};

export type SvhDeliveryAmbassador = {
  __typename?: 'SvhDeliveryAmbassador';
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  passportAddress?: Maybe<Scalars['String']>;
  passportIssued?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
};

export type SvhDeliveryRequestsFilter = {
  svhDeliveryRequest: SvhDeliveryRequestFilter;
};

export type SvhDeliveryRequestFilter = {
  carTypes?: Maybe<Array<Maybe<TransportationCarTypeEnum>>>;
  objectVin?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<Scalars['Int']>>>;
  requestTypes?: Maybe<Array<Maybe<TransportingRequestTypeEnum>>>;
  states?: Maybe<Array<Maybe<SvhDeliveryRequestStateEnum>>>;
};

/** Типы авто для транспортировки */
export enum TransportationCarTypeEnum {
  /** Bus */
  Bus = 'bus',
  /** Crossover */
  Crossover = 'crossover',
  /** Jeep */
  Jeep = 'jeep',
  /** Kei car */
  KeiCar = 'kei_car',
  /** Sedan */
  Sedan = 'sedan'
}

export enum TransportingRequestTypeEnum {
  Intercity = 'INTERCITY',
  SvhToClient = 'SVH_TO_CLIENT'
}

export enum SvhDeliveryRequestStateEnum {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Init = 'INIT',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Sent = 'SENT',
  Wait = 'WAIT'
}

export type SvhDeliveryRequestsSort = {
  svhDeliveryRequest: SvhDeliveryRequestSort;
};

export type SvhDeliveryRequestSort = {
  id?: Maybe<SortOrderEnum>;
};

export type SvhDeliveryRequestsPaginatedList = {
  __typename?: 'SvhDeliveryRequestsPaginatedList';
  nodes: Array<SvhDeliveryRequest>;
  total: Scalars['Int'];
};

export type SvhDeliveryRequest = {
  __typename?: 'SvhDeliveryRequest';
  /** Дата согласования заявки */
  acceptedAt?: Maybe<Scalars['DateTime']>;
  /** Представитель-водитель, на которого выдан акт приёма-передачи */
  ambassador?: Maybe<SvhDeliveryAmbassador>;
  /** Согласованная стоимость доставки */
  amount?: Maybe<Scalars['Int']>;
  /** Тип авто для перевозки */
  carType?: Maybe<TransportationCarTypeEnum>;
  /** Комментарий клиента к заявке */
  comment?: Maybe<Scalars['String']>;
  /** Комментарий логиста к заявке */
  commentLogist?: Maybe<Scalars['String']>;
  /** Дата завершения доставки */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Дата создания заявки */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Данные транспортировки */
  data?: Maybe<TransportationData>;
  /** Дата доставки */
  dateOutcome?: Maybe<Scalars['String']>;
  /** Дата отмены заявки */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** GUID заявки в 1C */
  guid1c?: Maybe<Scalars['String']>;
  /** ИД заявки */
  id?: Maybe<Scalars['Int']>;
  /** Объект услуг */
  object?: Maybe<ObjectOfServices>;
  /** Телефон клиента для связи */
  phone?: Maybe<Scalars['String']>;
  /** Дата выдачи пропуска */
  readyAt?: Maybe<Scalars['DateTime']>;
  /** Тип заявки (svh_to_client, intercity) */
  requestType?: Maybe<TransportingRequestTypeEnum>;
  /** Статус заявки */
  state?: Maybe<SvhDeliveryRequestStateEnum>;
  /** Дата последнего изменения заявки */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TicketDecisionsFilter = {
  ticketDecision?: Maybe<TicketDecisionFilter>;
};

export type TicketDecisionFilter = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  decisionStatuses?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAppeal?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isPayDirector?: Maybe<Scalars['Boolean']>;
  isPayout?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Scalars['Int']>;
  owners?: Maybe<Array<Scalars['Int']>>;
  payoutDateFrom?: Maybe<Scalars['String']>;
  payoutDateTo?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['Int']>;
  ticketNumber?: Maybe<Scalars['String']>;
  ticketStatuses?: Maybe<Array<Scalars['Int']>>;
  trips?: Maybe<Array<Scalars['Int']>>;
  vessels?: Maybe<Array<Scalars['Int']>>;
  vin?: Maybe<Scalars['String']>;
};

export type TicketDecisionsPaginatedList = {
  __typename?: 'TicketDecisionsPaginatedList';
  nodes: Array<TicketDecision>;
  total: Scalars['Int'];
};

export type TicketsFilter = {
  ticket?: Maybe<TicketFilter>;
};

export type TicketFilter = {
  activeForReport?: Maybe<Scalars['Boolean']>;
  byStatus?: Maybe<TicketClientStatusEnum>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  decisionCreate?: Maybe<Scalars['String']>;
  forReport?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isPayDirector?: Maybe<Scalars['Boolean']>;
  isPayout?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Scalars['Int']>;
  owners?: Maybe<Array<Scalars['Int']>>;
  payoutDateFrom?: Maybe<Scalars['String']>;
  payoutDateTo?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['Int']>;
  statuses?: Maybe<Array<Scalars['Int']>>;
  ticketNumber?: Maybe<Scalars['String']>;
  trips?: Maybe<Array<Scalars['Int']>>;
  types?: Maybe<Array<Scalars['Int']>>;
  vessels?: Maybe<Array<Scalars['Int']>>;
  vin?: Maybe<Scalars['String']>;
};

export enum TicketClientStatusEnum {
  Cancel = 'CANCEL',
  Done = 'DONE',
  New = 'NEW',
  Progress = 'PROGRESS',
  WaitPayout = 'WAIT_PAYOUT'
}

export type TicketsSort = {
  ticket?: Maybe<TicketSort>;
};

export type TicketSort = {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<SortOrderEnum>;
  id?: Maybe<SortOrderEnum>;
};

export type TicketsPaginatedList = {
  __typename?: 'TicketsPaginatedList';
  nodes: Array<Ticket>;
  total: Scalars['Int'];
};

export type TicketsReasonsPaginatedList = {
  __typename?: 'TicketsReasonsPaginatedList';
  nodes: Array<TicketReason>;
  total: Scalars['Int'];
};

export type TicketStatistic = {
  __typename?: 'TicketStatistic';
  closedByCloseRange?: Maybe<Scalars['Float']>;
  closedByCreatedRange?: Maybe<Scalars['Float']>;
  closedTotal?: Maybe<Scalars['Float']>;
  createdByRange?: Maybe<Scalars['Float']>;
  createdTotal?: Maybe<Scalars['Float']>;
  declinedByCreatedRange?: Maybe<Scalars['Float']>;
  declinedByDeclineRange?: Maybe<Scalars['Float']>;
  declineTotal?: Maybe<Scalars['Float']>;
  inProgressCreateByRange?: Maybe<Scalars['Float']>;
  inProgressTotal?: Maybe<Scalars['Float']>;
  waitApproveByCreateRange?: Maybe<Scalars['Float']>;
  waitApproveByDecisionRange?: Maybe<Scalars['Float']>;
  waitApproveTotal?: Maybe<Scalars['Float']>;
  waitDecisionByCreateRange?: Maybe<Scalars['Float']>;
  waitDecisionTotal?: Maybe<Scalars['Float']>;
  waitOrganizationApproveByApproveRange?: Maybe<Scalars['Float']>;
  waitOrganizationApproveByCreatedRange?: Maybe<Scalars['Float']>;
  waitOrganizationApproveTotal?: Maybe<Scalars['Float']>;
  waitPayoutByApproveRange?: Maybe<Scalars['Float']>;
  waitPayoutByCreatedRange?: Maybe<Scalars['Float']>;
  waitPayoutTotal?: Maybe<Scalars['Float']>;
};

export type TotalCustomsClearanceTime = {
  __typename?: 'TotalCustomsClearanceTime';
  bySenders?: Maybe<Array<CustomsClearanceTimeBySender>>;
  byTypes?: Maybe<Array<CustomsClearanceTimeByTypes>>;
};

export type CustomsClearanceTimeBySender = {
  __typename?: 'CustomsClearanceTimeBySender';
  byTypes?: Maybe<Array<CustomsClearanceTimeByTypes>>;
  senderName?: Maybe<Scalars['String']>;
};

export type CustomsClearanceTimeByTypes = {
  __typename?: 'CustomsClearanceTimeByTypes';
  totalByInvoicePaymentCount?: Maybe<Scalars['Int']>;
  totalByInvoicePaymentDay?: Maybe<Scalars['Int']>;
  totalDays?: Maybe<Scalars['Int']>;
  totalIndependentlyPaymentCount?: Maybe<Scalars['Int']>;
  totalIndependentlyPaymentDay?: Maybe<Scalars['Int']>;
  totalObjectsCount?: Maybe<Scalars['Int']>;
  totalPrimbrokerPaymentCount?: Maybe<Scalars['Int']>;
  totalPrimbrokerPaymentDay?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type TripsFilter = {
  trip?: Maybe<TripFilter>;
};

export type TripsSort = {
  trip?: Maybe<TripSort>;
};

export type TripsPaginatedList = {
  __typename?: 'TripsPaginatedList';
  nodes: Array<Trip>;
  total: Scalars['Int'];
};

export type TripsCalendar = {
  __typename?: 'TripsCalendar';
  events?: Maybe<Array<TripCalendarEvent>>;
  ships?: Maybe<Array<VesselInfoCalendar>>;
};

export type TripCalendarEvent = {
  __typename?: 'TripCalendarEvent';
  allDay?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  borderColor?: Maybe<Scalars['String']>;
  classNames?: Maybe<Scalars['String']>;
  colorWarning?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  iconWarning?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleWarning?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type VesselInfoCalendar = {
  __typename?: 'VesselInfoCalendar';
  backgroundColorEvent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type UndefinedPaymentsFilter = {
  undefinedPayment?: Maybe<UndefinedPaymentFilter>;
};

export type UndefinedPaymentFilter = {
  maxMays?: Maybe<Scalars['Int']>;
  minDays?: Maybe<Scalars['Int']>;
};

export type UndefinedPaymentsSort = {
  undefinedPayment?: Maybe<UndefinedPaymentSort>;
};

export type UndefinedPaymentSort = {
  amount?: Maybe<SortOrderEnum>;
  date?: Maybe<SortOrderEnum>;
  name?: Maybe<SortOrderEnum>;
};

export type UndefinedPaymentsPaginatedList = {
  __typename?: 'UndefinedPaymentsPaginatedList';
  nodes: Array<UndefinedPayment>;
  total: Scalars['Int'];
};

export type UndefinedPayment = {
  __typename?: 'UndefinedPayment';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['Int']>;
  payerName?: Maybe<Scalars['String']>;
  receiptDate?: Maybe<Scalars['DateTime']>;
};

export type ClientUnionLogsPaginatedList = {
  __typename?: 'ClientUnionLogsPaginatedList';
  nodes: Array<ClientUnionLog>;
  total: Scalars['Int'];
};

export type ClientUnionLog = {
  __typename?: 'ClientUnionLog';
  action?: Maybe<Scalars['String']>;
  connection?: Maybe<Scalars['String']>;
  /** Время создания события */
  createdAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор события */
  guid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobFail?: Maybe<ExchangeJobFail>;
  /** Сообщение */
  msg?: Maybe<Scalars['String']>;
  /** Параметры запроса */
  parameters?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  /** Время решения события */
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedMessage?: Maybe<Scalars['String']>;
  /** Сообщение */
  response?: Maybe<Scalars['String']>;
  /** Выборка из которой полученны данные */
  tableName?: Maybe<Scalars['String']>;
  transport?: Maybe<Scalars['String']>;
  /** Тип события */
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['String']>;
  /** Идентификатор VIN обьекта */
  vin?: Maybe<Scalars['String']>;
};

export type PermissionMenuItem = {
  __typename?: 'PermissionMenuItem';
  permission?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type UsersFilter = {
  user?: Maybe<UserFilter>;
};

export type UserFilter = {
  birthdaySoon?: Maybe<Scalars['Boolean']>;
  branchId?: Maybe<Scalars['Int']>;
  departmentId?: Maybe<Scalars['Int']>;
  documentsExpiringDays?: Maybe<Scalars['Int']>;
  employmentStatus?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isStaff?: Maybe<Scalars['Boolean']>;
  oldRoleId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  policyId?: Maybe<Scalars['Int']>;
  positionId?: Maybe<Scalars['Int']>;
  userTypeId?: Maybe<Scalars['Int']>;
};

export type UsersPaginatedList = {
  __typename?: 'UsersPaginatedList';
  nodes: Array<User>;
  total: Scalars['Int'];
};

export type WatchCommentTemplate = {
  __typename?: 'WatchCommentTemplate';
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type WheelsFilter = {
  wheel?: Maybe<WheelFilter>;
};

export type WheelFilter = {
  /** Купленны */
  asPurchased?: Maybe<Scalars['Boolean']>;
  /** Производитель диска */
  diskManufacturer?: Maybe<Scalars['String']>;
  /** Тип диска */
  diskType?: Maybe<Array<Maybe<DiskTypeEnum>>>;
  /** Производитель резины */
  tireManufacturer?: Maybe<Scalars['String']>;
  /** Высота резины максимум */
  tireProfileHeightMax?: Maybe<Scalars['Int']>;
  /** Высота резины минимум */
  tireProfileHeightMin?: Maybe<Scalars['Int']>;
  /** Ширина резины максимум */
  tireProfileWidthMax?: Maybe<Scalars['Int']>;
  /** Ширина резины минимум */
  tireProfileWidthMin?: Maybe<Scalars['Int']>;
  /** Радиус максимум */
  tireRadiusMax?: Maybe<Scalars['Int']>;
  /** Радиус минимум */
  tireRadiusMin?: Maybe<Scalars['Int']>;
  /** Тип резины */
  tireType?: Maybe<Array<Maybe<TireTypeEnum>>>;
  /** Процент износа резины максимум */
  tireWearMax?: Maybe<Scalars['Int']>;
  /** Процент износа резины минимум */
  tireWearMin?: Maybe<Scalars['Int']>;
  /** Без цены */
  withoutPrice?: Maybe<Scalars['Boolean']>;
};

export enum DiskTypeEnum {
  Aluminum = 'ALUMINUM',
  Iron = 'IRON'
}

export enum TireTypeEnum {
  Allseason = 'ALLSEASON',
  Dirt = 'DIRT',
  Spike = 'SPIKE',
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

export type WheelsPaginatedList = {
  __typename?: 'WheelsPaginatedList';
  nodes: Array<ObjectOfServices>;
  total: Scalars['Int'];
};

export type WheelAllsFilter = {
  wheel?: Maybe<WheelFilter>;
};

export type WheelAllsPaginatedList = {
  __typename?: 'WheelAllsPaginatedList';
  nodes: Array<ObjectOfServices>;
  total: Scalars['Int'];
};

export type WheelFilterValue = {
  __typename?: 'WheelFilterValue';
  /** Список производителей дисков */
  diskManufacturer?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Список типов дисков */
  diskType?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Список производителей резины */
  tireManufacturer?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Список размеров по высоте резины */
  tireProfileHeight?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Список размеров по ширине резины */
  tireProfileWidth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Список радиусов */
  tireRadius?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Список типов резины */
  tireType?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WheelStatistic = {
  __typename?: 'WheelStatistic';
  /** Колес купленно */
  wheelBuyCount?: Maybe<Scalars['Int']>;
  /** Колес упакованно на складе */
  wheelPackedCount?: Maybe<Scalars['Int']>;
  /** Колес на складе */
  wheelStockCount?: Maybe<Scalars['Int']>;
  /** Колес не упакованно на складе  */
  wheelUnpackedCount?: Maybe<Scalars['Int']>;
};

export type MediaObjectssFilter = {
  mediaObjects?: Maybe<MediaObjectsFilter>;
};

export type MediaObjectssSort = {
  mediaObjects?: Maybe<MediaObjectsSort>;
};

export type MediaObjectsSort = {
  id?: Maybe<SortOrderEnum>;
  isAkebono?: Maybe<SortOrderEnum>;
  mediaCount?: Maybe<SortOrderEnum>;
  sender?: Maybe<SortOrderEnum>;
  typeId?: Maybe<SortOrderEnum>;
  videoCount?: Maybe<SortOrderEnum>;
};

export type MediaObjectssPaginatedList = {
  __typename?: 'MediaObjectssPaginatedList';
  nodes: Array<ObjectOfServices>;
  total: Scalars['Int'];
};

export type YahooOwnersPaginatedList = {
  __typename?: 'YahooOwnersPaginatedList';
  nodes: Array<YahooOwner>;
  total: Scalars['Int'];
};

export type YahooOwner = {
  __typename?: 'YahooOwner';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isHasBlockedObjects?: Maybe<Scalars['Boolean']>;
  isHasOldDebts?: Maybe<Scalars['Boolean']>;
  isHasPenalty?: Maybe<Scalars['Boolean']>;
  isUnfairPartner?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Завершить согласование заявки на доставку с СВХ клиенту */
  acceptSvhDeliveryRequest?: Maybe<AcceptSvhDeliveryRequestOutput>;
  addComment?: Maybe<AddCommentOutput>;
  /** Добавить контейнер в план WorldWide */
  addContainerToPlan?: Maybe<AddContainerToPlanOutput>;
  addDisassemblyInfo?: Maybe<AddDisassemblyInfoOutput>;
  addExportCertificateToWorldwideObject?: Maybe<AddExportCertificateToWorldwideObjectOutput>;
  /** Добавить объект в план WorldWide */
  addExportObjectToPlan?: Maybe<AddExportObjectToPlanOutput>;
  addFilesToObject?: Maybe<AddFilesToObjectOutput>;
  addFirebaseToken?: Maybe<AddFirebaseTokenOutput>;
  addMessageToChat?: Maybe<AddMessageToChatOutput>;
  addObjectToPlan?: Maybe<AddObjectToPlanOutput>;
  addTagToChat?: Maybe<AddTagToChatOutput>;
  /** Зачет аванса на объект */
  akebonoObjectPayDebt?: Maybe<AkebonoObjectPayDebtOutput>;
  /** Разрешить смену грузополучателя */
  allowChangeRecipient?: Maybe<AllowChangeRecipientOutput>;
  allowVisiblePhoto?: Maybe<AllowVisiblePhotoOutput>;
  /** Добавить авто к выставлению на аукцион */
  auctionListingCreate?: Maybe<AuctionListingCreateOutput>;
  /** Отметить что авто не продано */
  auctionListingNotSold?: Maybe<AuctionListingNotSoldOutput>;
  /** Указать транспортную компанию для перевозки на аукцион */
  auctionListingSetTransport?: Maybe<AuctionListingSetTransportOutput>;
  /** Отметить что авто продано */
  auctionListingSold?: Maybe<AuctionListingSoldOutput>;
  /** Обновить данные по выставлению авто */
  auctionListingUpdateLot?: Maybe<AuctionListingUpdateLotOutput>;
  blockTheIssuance?: Maybe<BlockTheIssuanceOutput>;
  bookingRequest?: Maybe<BookingRequestOutput>;
  /** Купить лотерейный билет */
  buyLotteryTicket?: Maybe<BuyLotteryTicketOutput>;
  /** Отменить заявку на доставку (СВХ или в регион) */
  cancelSvhDeliveryRequest?: Maybe<CancelSvhDeliveryRequestOutput>;
  /** Создание|Изменений цен авто ЗУ|Другие страны */
  carClientParamsUpdate?: Maybe<CarClientParamsUpdateOutput>;
  /** Скрыты/Не скрыты фото */
  carMediaHiddenToggle?: Maybe<CarMediaHiddenToggleOutput>;
  changeAdditionalType?: Maybe<ChangeAdditionalTypeOutput>;
  changeDesiredTrip?: Maybe<ChangeDesiredTripOutput>;
  changeExportPrice?: Maybe<ChangeExportPriceOutput>;
  changeObjectBroker?: Maybe<ChangeObjectBrokerOutput>;
  changeObjectFormalOwner?: Maybe<ChangeObjectFormalOwnerOutput>;
  changeObjectFreightCountry?: Maybe<ChangeObjectFreightCountryOutput>;
  changeObjectOwner?: Maybe<ChangeObjectOwnerOutput>;
  changeObjectSender?: Maybe<ChangeObjectSenderOutput>;
  changeObjectType?: Maybe<ChangeObjectTypeOutput>;
  changeObjectVin?: Maybe<ChangeObjectVinOutput>;
  changeParentObject?: Maybe<ChangeParentObjectOutput>;
  changeSenderClient?: Maybe<ChangeSenderClientOutput>;
  /** Добавить группу пользователь в чат */
  chatAddGroupUsers?: Maybe<ChatAddGroupUsersOutput>;
  chatAddUser?: Maybe<ChatAddUserOutput>;
  chatArchiving?: Maybe<ChatArchivingOutput>;
  chatCreate?: Maybe<CreateChatOutput>;
  chatDeleteMessage?: Maybe<ChatDeleteMessageOutput>;
  chatRemoveUser?: Maybe<ChatRemoveUserOutput>;
  chatUnArchiving?: Maybe<ChatUnArchivingOutput>;
  checkDateOfManufacture?: Maybe<CheckDateOfManufactureOutput>;
  completeObject?: Maybe<CompleteObjectOutput>;
  /** Завершить заявку на транспортировку */
  completeTransportingRequest?: Maybe<CompleteTransportingRequestOutput>;
  /** Загрузить подтверждение букинга */
  containerConfirmBooked?: Maybe<ContainerConfirmBookedOutput>;
  containerCreate?: Maybe<ContainerCreateOutput>;
  containerDelete?: Maybe<ContainerDeleteOutput>;
  containerUpdate?: Maybe<ContainerUpdateOutput>;
  countryCreate?: Maybe<CountryCreateOutput>;
  createDeliveryRequest?: Maybe<CreateDeliveryRequestOutput>;
  createInvoiceJapanAuctionPurchase?: Maybe<CreateInvoiceJapanAuctionPurchaseOutput>;
  createObjectAct?: Maybe<CreateObjectActOutput>;
  /** Создать квитанцию об оплате */
  createReceiptOfPayment?: Maybe<CreateReceiptOfPaymentOutput>;
  createSbktsRequest?: Maybe<CreateSbktsRequestOutput>;
  /** Завершение работы над дилерским объектом */
  dealerObjectCompleted?: Maybe<DealerObjectCompletedOutput>;
  /** Создание дилерского объекта */
  dealerObjectCreate?: Maybe<DealerObjectCreateOutput>;
  /** Удаление дилерского объекта */
  dealerObjectDelete?: Maybe<DealerObjectDeleteOutput>;
  /** Изменение дилерского объекта */
  dealerObjectUpdate?: Maybe<DealerObjectUpdateOutput>;
  deleteObject?: Maybe<DeleteObjectOutput>;
  deleteUserNotifyMessage?: Maybe<DeleteUserNotifyMessageOutput>;
  deliveryToStock?: Maybe<DeliveryToStockOutput>;
  disallowVisiblePhoto?: Maybe<DisallowVisiblePhotoOutput>;
  /** Проверить статус оплаты услуги показа ставок */
  displayBidsCheck?: Maybe<DisplayBidsCheckOutput>;
  /** Задонатить на буханку */
  donateBuhanka?: Maybe<DonateBuhankaOutput>;
  /** Добавить менеджера агента */
  dzenPayAddManager?: Maybe<DzenPayAddManagerOutput>;
  /** Отмена инвойса платёжного агента клиентом */
  dzenPayCancelByClient?: Maybe<DzenPayCancelByClientOutput>;
  /** Получить статус заказа DzenPay из API */
  dzenPayGetOrderStatus?: Maybe<DzenPayGetOrderStatusOutput>;
  /** Создать чат с клиентом */
  dzenPayManagerCreateChat?: Maybe<DzenPayManagerCreateChatOutput>;
  /** Отметка менеджера по платежу. */
  dzenPayManagerOrderUpdate?: Maybe<DzenPayManagerOrderUpdateOutput>;
  /** Создать заказ платёжного агента для налички */
  dzenPayPartnerManualOrder?: Maybe<DzenPayPartnerManualOrderOutput>;
  /** Отметка платежу по заказу (отменить / завершить). Проставляется вручную. */
  dzenPayPartnerOrderUpdate?: Maybe<DzenPayPartnerOrderUpdateOutput>;
  /** Перезапросить документы для платежа */
  dzenPayRegenerateDocuments?: Maybe<DzenPayRegenerateDocumentsOutput>;
  /** Восстановление заявки платежного агента */
  dzenPayRestore?: Maybe<DzenPayRestoreOutput>;
  /** Перезапустить платеж с последнего шага */
  dzenPayRetryFlow?: Maybe<DzenPayRetryFlowOutput>;
  exchangeJobClose?: Maybe<ExchangeJobCloseOutput>;
  exchangeJobSend?: Maybe<ExchangeJobSendOutput>;
  /** Добавить объекты в экспортную декларацию */
  exportDeclarationAddObjects?: Maybe<ExportDeclarationAddObjectsOutput>;
  /** Создать экспортную декларацию */
  exportDeclarationCreate?: Maybe<ExportDeclarationCreateOutput>;
  /** Экспортная декларация оплачена */
  exportDeclarationPaid?: Maybe<ExportDeclarationPaidOutput>;
  /** Убрать объект из экспортной декларации */
  exportDeclarationRemoveObject?: Maybe<ExportDeclarationRemoveObjectOutput>;
  /** Изменить данные экспортной декларации */
  exportDeclarationUpdate?: Maybe<ExportDeclarationUpdateOutput>;
  exportToAuction?: Maybe<ExportToAuctionOutput>;
  fileDelete?: Maybe<FileDeleteOutput>;
  /** Добавить форвадера */
  forwarderCreate?: Maybe<ForwarderCreateOutput>;
  /** Удалить форвадера */
  forwarderDelete?: Maybe<ForwarderDeleteOutput>;
  /** Изменить форвадера */
  forwarderUpdate?: Maybe<ForwarderUpdateOutput>;
  /** Сгенерировать акт п-п на доставку с СВХ клиенту */
  getActSvhDeliveryRequest?: Maybe<GetActSvhDeliveryRequestOutput>;
  /** Сохранить итог проверки объекта ЗУ толщиномером */
  greenCornerInspectionSave?: Maybe<GreenCornerInspectionSaveOutput>;
  /** Изменить данные объекта ЗУ в каталоге */
  greenCornerManageObjectUpdate?: Maybe<GreenCornerManageObjectUpdateOutput>;
  /** Удалить из зеленого угла 2.0 */
  greenCornerRemove?: Maybe<GreenCornerRemoveOutput>;
  greenCornerSetSubscription?: Maybe<GreenCornerSetSubscriptionOutput>;
  /** Отменить запланированную публикацию ЗУ */
  greenCornerTgPostCancelSchedule?: Maybe<GreenCornerTgPostCancelScheduleOutput>;
  /** Создать публикацию ЗУ в Telegram */
  greenCornerTgPostCreate?: Maybe<GreenCornerTgPostCreateOutput>;
  /** Удалить публикацию ЗУ, из канала она тоже удаляется */
  greenCornerTgPostDelete?: Maybe<GreenCornerTgPostDeleteOutput>;
  /** Опубликовать сейчас или запланировать, повторный вызов обновляет пост в канале свежими данными */
  greenCornerTgPostPublish?: Maybe<GreenCornerTgPostPublishOutput>;
  /** Снять публикацию ЗУ с канала, сама публикация остаётся */
  greenCornerTgPostUnpublish?: Maybe<GreenCornerTgPostUnpublishOutput>;
  /** Изменить публикацию ЗУ, опубликованная сразу обновляется в канале */
  greenCornerTgPostUpdate?: Maybe<GreenCornerTgPostUpdateOutput>;
  /** Создать шаблон публикации ЗУ в Telegram */
  greenCornerTgTemplateCreate?: Maybe<GreenCornerTgTemplateCreateOutput>;
  /** Удалить шаблон публикации ЗУ в Telegram */
  greenCornerTgTemplateDelete?: Maybe<GreenCornerTgTemplateDeleteOutput>;
  /** Сделать шаблон публикации ЗУ шаблоном по умолчанию */
  greenCornerTgTemplateSetDefault?: Maybe<GreenCornerTgTemplateSetDefaultOutput>;
  /** Изменить шаблон публикации ЗУ в Telegram */
  greenCornerTgTemplateUpdate?: Maybe<GreenCornerTgTemplateUpdateOutput>;
  invoiceByObjectsGenerate?: Maybe<InvoiceByObjectsGenerateOutput>;
  /** Обновить кастомный инвойс платёжного агента */
  invoiceByObjectsUpdate?: Maybe<InvoiceByObjectsUpdateOutput>;
  /** Update payer data and regenerate document pack without changing financial values */
  invoiceCorrectionGenerate?: Maybe<InvoiceCorrectionGenerateOutput>;
  invoiceCustomGenerate?: Maybe<InvoiceCustomGenerateOutput>;
  /** Обновить кастомный инвойс */
  invoiceCustomUpdate?: Maybe<InvoiceCustomUpdateOutput>;
  /** Сформировать инвойс под реквизиты АКБ для платёжного агента */
  invoiceOwnRequisitesGenerate?: Maybe<InvoiceOwnRequisitesGenerateOutput>;
  /** Выдать объект клиенту */
  issueObject?: Maybe<IssueObjectOutput>;
  /** Включить/выключить автовыставление лотов */
  kaitaiAutoResubmitChangeState?: Maybe<KaitaiAutoResubmitChangeStateOutput>;
  /** Запустить/остановить очередь Kaitai емэйлов */
  kaitaiQueueStatusChange?: Maybe<KaitaiQueueStatusChangeOutput>;
  /** Добавить логирование события с мобильных приложений */
  logAppEvent?: Maybe<LogAppEventOutput>;
  magadanObjectCreate?: Maybe<MagadanObjectCreateOutput>;
  magadanObjectUpdate?: Maybe<MagadanObjectUpdateOutput>;
  makerCreate?: Maybe<MakerCreateOutput>;
  markCreate?: Maybe<MarkCreateOutput>;
  massiveObjectUploadFiles?: Maybe<MassiveObjectUploadFilesOutput>;
  moveMediaToObject?: Maybe<MoveMediaToObjectOutput>;
  objectAddPriorityPass?: Maybe<ObjectAddPriorityPassOutput>;
  /** Добавить объекту статус "Запрошен букинг" */
  objectAddStatusBookingRequest?: Maybe<ObjectAddStatusBookingRequestOutput>;
  /** Запрос на доставку с СВХ клиенту */
  objectAddSvhDeliveryRequest?: Maybe<ObjectAddSvhDeliveryRequestOutput>;
  /** Запрос на транспортировку */
  objectAddTransportingRequest?: Maybe<ObjectAddTransportingRequestOutput>;
  /** Перепродать объект */
  objectAutoResale?: Maybe<ObjectAutoResaleOutput>;
  /** Перенести на СВХ */
  objectBookParkingLot?: Maybe<ObjectBookParkingLotOutput>;
  objectChangeDestinationCountry?: Maybe<ObjectChangeDestinationCountryOutput>;
  /** Запрос смены владельца объекта */
  objectChangeOwner?: Maybe<ObjectChangeOwnerOutput>;
  objectChangeSawType?: Maybe<ObjectChangeSawTypeOutput>;
  objectCheckDebts?: Maybe<ObjectCheckDebtsOutput>;
  /** Удаление файла таможенных документов */
  objectDeleteCustomDocuments?: Maybe<ObjectDeleteCustomDocumentsOutput>;
  objectDeleteMedia?: Maybe<ObjectDeleteMediaOutput>;
  /** Оставить отзыв. */
  objectFeedbackCreate?: Maybe<ObjectFeedbackCreateOutput>;
  /** Редактировать объекта в зеленом углу */
  objectGreenCornerEdit?: Maybe<ObjectCatalogEditOutput>;
  /** @deprecated Создан новый модуль для рассылок ЗУ */
  objectGreenCornerTG?: Maybe<ObjectGreenCornerTgOutput>;
  objectHoldTo?: Maybe<ObjectHoldToOutput>;
  objectHoldToClose?: Maybe<ObjectHoldToCloseOutput>;
  objectOfServiceRemoveFromContainer?: Maybe<ObjectOfServiceRemoveFromContainerOutput>;
  objectRecipientPaymentEmail?: Maybe<ObjectRecipientPaymentEmailOutput>;
  /** Установить статус ресайкла */
  objectRecycleStatusSet?: Maybe<ObjectRecycelStatusSetOutput>;
  /** Снять авто с тарифа ЗУ, чтобы освободить его под отложенную доставку */
  objectRemoveIsGreenCorner?: Maybe<ObjectRemoveIsGreenCornerOutput>;
  objectRequestToParking?: Maybe<ObjectRequestToParkingOutput>;
  /** Запрос услуги Подготовка пакета документов для жителей не ДВФО */
  objectRequestToPreparationDocuments?: Maybe<ObjectRequestToPreparationDocumentsOutput>;
  /** Подтвердить сделку перепродажи */
  objectResaleApprove?: Maybe<ObjectResaleApproveOutput>;
  /** Создать сделку перепродажи */
  objectResaleClientCreate?: Maybe<ObjectResaleClientCreateOutput>;
  /** Изменить сделку перепродажи */
  objectResaleClientUpdate?: Maybe<ObjectResaleClientUpdateOutput>;
  /** Завершить сделку перепродажи */
  objectResaleComplete?: Maybe<ObjectResaleCompleteOutput>;
  /** Отменить сделку перепродажи */
  objectResaleDelete?: Maybe<ObjectResaleDeleteOutput>;
  /** Создать инвойс вручную, если не создался */
  objectResaleInvoiceCreate?: Maybe<ObjectResaleInvoiceCreateOutput>;
  /** Создать сделку перепродажи */
  objectResaleManagerCreate?: Maybe<ObjectResaleManagerCreateOutput>;
  /** Изменить сделку перепродажи */
  objectResaleManagerUpdate?: Maybe<ObjectResaleManagerUpdateOutput>;
  objectReset?: Maybe<ObjectResetOutput>;
  objectSendInvoiceEmail?: Maybe<ObjectSendInvoiceEmailOutput>;
  /** Указать номер букинга объекта */
  objectSetBookingNumber?: Maybe<ObjectSetBookingNumberOutput>;
  objectSetDateDismantleForCube?: Maybe<ObjectSetDateDismantleForCubeOutput>;
  objectSetDateRecyclingToCube?: Maybe<ObjectSetDateRecyclingToCubeOutput>;
  objectSetDateSoldRecyclingCube?: Maybe<ObjectSetDateSoldRecyclingCubeOutput>;
  objectSetGuidFrom1c?: Maybe<ObjectSetGuidFrom1cOutput>;
  objectSetIndependentFreightPayment?: Maybe<AkebonoObjectSetIndependentFreightPaymentOutput>;
  /** Автозачет делается на общих основаниях */
  objectSetIsGeneralBasisAdvance?: Maybe<ObjectSetIsGeneralBasisAdvanceOutput>;
  /** Привязать авто к тарифу ЗУ */
  objectSetIsGreenCorner?: Maybe<ObjectSetIsGreenCornerOutput>;
  /** Указать стоимость объекта утилизации */
  objectSetKaitaiPrice?: Maybe<ObjectSetKaitaiPriceOutput>;
  /** Указать клиента покупки (конечный клиент) */
  objectSetMasterAccountClient?: Maybe<ObjectSetMasterAccountClientOutput>;
  /** Указать дату продажи авто Дубаи, Монголия и т.д */
  objectSetSoldDate?: Maybe<ObjectSetSoldDateOutput>;
  /** Скрыть/отобразить объект */
  objectToggleHide?: Maybe<ObjectToggleHideOutput>;
  /** Удалить/восстановить объект */
  objectToggleRemove?: Maybe<ObjectToggleRemoveOutput>;
  /** Загрузка файлов для таможни */
  objectUploadCustomDocuments?: Maybe<ObjectUploadCustomDocumentsOutput>;
  objectUploadCustomPayment?: Maybe<ObjectUploadCustomPaymentOutput>;
  objectUploadFiles?: Maybe<ObjectUploadFilesOutput>;
  objectUploadFilesToPlan?: Maybe<ObjectUploadFilesToPlanOutput>;
  ownerSearchByParams?: Maybe<GetAgentsByParamsOutput>;
  /** Блокировка или разблокировка P2P-заявки на покупку сотрудником */
  p2pAdminBuyRequestBlock?: Maybe<P2pAdminBuyRequestBlockOutput>;
  /** Отмена P2P-заявки на покупку сотрудником */
  p2pAdminBuyRequestCancel?: Maybe<P2pAdminBuyRequestCancelOutput>;
  /** Блокировка или разблокировка P2P-сделки сотрудником на время разбирательства */
  p2pAdminDealBlock?: Maybe<P2pAdminDealBlockOutput>;
  /** Отмена P2P-сделки сотрудником в любом незавершённом статусе */
  p2pAdminDealCancel?: Maybe<P2pAdminDealCancelOutput>;
  /** Принудительное завершение P2P-сделки сотрудником: перевод покупателю и комиссия как при подтверждении продавцом */
  p2pAdminDealComplete?: Maybe<P2pAdminDealCompleteOutput>;
  /** Принудительная смена статуса P2P-сделки сотрудником без денежных операций */
  p2pAdminDealSetStatus?: Maybe<P2pAdminDealSetStatusOutput>;
  /** Одобрение P2P-предложения на модерации: публикация в общем списке */
  p2pAdminOfferApprove?: Maybe<P2pAdminOfferApproveOutput>;
  /** Блокировка или разблокировка P2P-предложения сотрудником */
  p2pAdminOfferBlock?: Maybe<P2pAdminOfferBlockOutput>;
  /** Снятие P2P-предложения сотрудником: свободный остаток возвращается продавцу */
  p2pAdminOfferCancel?: Maybe<P2pAdminOfferCancelOutput>;
  /** Отклонение P2P-предложения на модерации: отмена и возврат холда */
  p2pAdminOfferReject?: Maybe<P2pAdminOfferRejectOutput>;
  /** Отмена P2P-заявки на покупку её владельцем */
  p2pBuyRequestCancel?: Maybe<P2pBuyRequestCancelOutput>;
  /** Создание P2P-заявки на покупку валюты */
  p2pBuyRequestCreate?: Maybe<P2pBuyRequestCreateOutput>;
  /** Изменение суммы и курса своей P2P-заявки на покупку */
  p2pBuyRequestUpdate?: Maybe<P2pBuyRequestUpdateOutput>;
  /** Отмена P2P-сделки её участником, пока продавец не подтвердил оплату */
  p2pDealCancel?: Maybe<P2pDealCancelOutput>;
  /** Подтверждение продавцом получения оплаты по P2P-сделке */
  p2pDealConfirm?: Maybe<P2pDealConfirmOutput>;
  /** Код подтверждения оплаты на почту продавца */
  p2pDealConfirmOtpSend?: Maybe<P2pDealConfirmOtpSendOutput>;
  /** Создание P2P-сделки: продавец выбирает заявку покупателя */
  p2pDealCreateFromBuyRequest?: Maybe<P2pDealCreateFromBuyRequestOutput>;
  /** Создание P2P-сделки: покупатель выбирает предложение продавца */
  p2pDealCreateFromOffer?: Maybe<P2pDealCreateFromOfferOutput>;
  /** Покупатель заявляет об оплате P2P-сделки */
  p2pDealDeclarePayment?: Maybe<P2pDealDeclarePaymentOutput>;
  /** Отмена свободного остатка P2P-предложения продавцом */
  p2pOfferCancelRemainder?: Maybe<P2pOfferCancelRemainderOutput>;
  /** Создание P2P-предложения на продажу валюты */
  p2pOfferCreate?: Maybe<P2pOfferCreateOutput>;
  /** Пополнение суммы и изменение курса своего P2P-предложения */
  p2pOfferUpdate?: Maybe<P2pOfferUpdateOutput>;
  /** Сохранить реквизиты получения оплаты. Один набор на способ */
  p2pPaymentDetailSave?: Maybe<P2pPaymentDetailSaveOutput>;
  /** Отзыв участника P2P-сделки на контрагента */
  p2pReviewAdd?: Maybe<P2pReviewAddOutput>;
  /** Добавить в палет */
  palletAddWheel?: Maybe<PalletAddWheelOutput>;
  /** Создать палет */
  palletCreate?: Maybe<PalletCreateOutput>;
  /** Добавить колеса в план */
  palletToPlan?: Maybe<PalletToPlanOutput>;
  /** Переместить паллет в порт */
  palletToPort?: Maybe<PalletToPortOutput>;
  /** Аккредитовать партнера */
  partnerInfoAccredit?: Maybe<PartnerInfoAccreditOutput>;
  /** Редактировать информацию о партнере */
  partnerInfoUpdate?: Maybe<PartnerInfoUpdateOutput>;
  /** Админские настройки платёжного агента */
  paymentAgentAdminSettingsUpdate?: Maybe<PaymentAgentAdminSettingsUpdateOutput>;
  /** Создание платёжного агента (только superadmin) */
  paymentAgentCreate?: Maybe<PaymentAgentCreateOutput>;
  /** Отключение/включение платёжного агента */
  paymentAgentSetActive?: Maybe<PaymentAgentSetIsActiveOutput>;
  /** Настройки платёжного агента */
  paymentAgentSettingsUpdate?: Maybe<PaymentAgentSettingsUpdateOutput>;
  /** Обновление платёжного агента (реквизиты — только superadmin) */
  paymentAgentUpdate?: Maybe<PaymentAgentUpdateOutput>;
  /** Соглашение ПБ отправлено в офис */
  pbAgreementSended?: Maybe<PbAgreementSendedOutput>;
  pickupAppointment?: Maybe<PickupAppointmentOutput>;
  /** Запланировать на тип судна */
  planOnVesselType?: Maybe<PlanOnVesselTypeOutput>;
  portCreate?: Maybe<PortCreateOutput>;
  preSignedPostCreate?: Maybe<PreSignedPostCreateOutput>;
  putUpForSaleCreate?: Maybe<PutUpForSaleCreateOutput>;
  putUpForSaleSoldOut?: Maybe<PutUpForSaleSoldOutOutput>;
  putUpForSaleUpdate?: Maybe<PutUpForSaleUpdateOutput>;
  putUpForSaleWithdraw?: Maybe<PutUpForSaleWithdrawOutput>;
  reminderRemove?: Maybe<ReminderRemoveOutput>;
  removeFromStock?: Maybe<RemoveFromStockOutput>;
  /** Снять объект с плана */
  removeObjectFromPlan?: Maybe<RemoveObjectFromPlanOutput>;
  renewExportCertificate?: Maybe<RenewExportCertificateOutput>;
  replaceDouble?: Maybe<ReplaceDoubleOutput>;
  replaceToStock?: Maybe<ReplaceToStockOutput>;
  /** Создать запрос на операцию с отчётом */
  reportCreate?: Maybe<ReportCreateOutput>;
  /** Отменить запрос на операцию с отчётом */
  reportDelete?: Maybe<ReportDeleteOutput>;
  /** Осмотр с аукциона */
  requestPhotoFromAuction?: Maybe<RequestPhotoFromAuctionOutput>;
  /** Осмотр с аукциона (создание менеджером) */
  requestPhotoFromAuctionByAdmin?: Maybe<RequestPhotoFromAuctionByAdminOutput>;
  requestPrimbrokerInvoice?: Maybe<RequestPrimbrokerInvoiceOutput>;
  requestSbktsCreate?: Maybe<RequestSbktsCreateOutput>;
  requestSbktsFromExcelCreate?: Maybe<RequestSbktsFromExcelCreateOutput>;
  requestToIssue?: Maybe<RequestToIssueOutput>;
  requestUnHold?: Maybe<RequestUnHoldOutput>;
  restoreObject?: Maybe<RestoreObjectOutput>;
  /** Обновить сессию для кайтай аккаунта */
  scrapAccountSessionUpdate?: Maybe<ScrapAccountSessionUpdateOutput>;
  /** Добавить комментарий к объекту */
  scrapObjectCommentAdd?: Maybe<ScrapObjectCommentAddOutput>;
  /** Завести объект(запчасть) утилизации */
  scrapObjectCreate?: Maybe<ScrapObjectCreateOutput>;
  scrapObjectDeliverySet?: Maybe<ScrapObjectDeliverySetOutput>;
  /** Перевыставить объекты со скидкой */
  scrapObjectDiscountToYahoo?: Maybe<ScrapObjectsDiscountToYahooOutput>;
  /** Отменить лот в яху */
  scrapObjectLotCancel?: Maybe<ScrapObjectLotCancelOutput>;
  /** Расположение объекта на складе */
  scrapObjectPlaceSet?: Maybe<ScrapObjectPlaceSetOutput>;
  /** Отвязать запчасть и привязать к другому объекту */
  scrapObjectRebind?: Maybe<ScrapObjectRebindOutput>;
  /** Указать размер объекта */
  scrapObjectSizeSet?: Maybe<ScrapObjectSizeSetOutput>;
  /** Указать статус объекта */
  scrapObjectStatusSet?: Maybe<ScrapObjectStatusSetOutput>;
  /** Отправить объект в яху */
  scrapObjectToYahoo?: Maybe<ScrapObjectToYahooOutput>;
  /** Отвязать запчасть утилизации от головного */
  scrapObjectUnbind?: Maybe<ScrapObjectUnbindOutput>;
  /** Изменить объект(запчасть) утилизации */
  scrapObjectUpdate?: Maybe<ScrapObjectUpdateOutput>;
  /** Загрузить накладную отправки и списать объект */
  scrapObjectUploadShippingInvoice?: Maybe<ScrapObjectUploadShippingInvoiceOutput>;
  /** Списать объект */
  scrapObjectWriteOff?: Maybe<ScrapObjectWriteOffOutput>;
  scrapTypeCreate?: Maybe<ScrapTypeCreateOutput>;
  scrapTypeDescriptionCreate?: Maybe<ScrapTypeDescriptionCreateOutput>;
  scrapTypeDescriptionDelete?: Maybe<ScrapTypeDescriptionDeleteOutput>;
  scrapTypeDescriptionUpdate?: Maybe<ScrapTypeDescriptionUpdateOutput>;
  scrapTypeUpdate?: Maybe<ScrapTypeUpdateOutput>;
  scrapUtilized?: Maybe<ScrapUtilizedOutput>;
  /** Добавить морского доставщика */
  seaCarrierCreate?: Maybe<SeaCarrierCreateOutput>;
  /** Удалить морского доставщика */
  seaCarrierDelete?: Maybe<SeaCarrierDeleteOutput>;
  /** Изменгить морского доставщика */
  seaCarrierEdit?: Maybe<SeaCarrierEditOutput>;
  sendAllClientsNotification?: Maybe<SendAllClientsNotificationOutput>;
  sendDirectorFeedback?: Maybe<SendDirectorFeedbackOutput>;
  sendFeedback?: Maybe<SendFeedbackOutput>;
  sendNotificationEmail?: Maybe<SendNotificationEmailOutput>;
  sendPaymentInfo?: Maybe<SendPaymentInfoOutput>;
  sendRussianDeliveryRequest?: Maybe<SendRussianDeliveryRequestOutput>;
  /** Отменить заявку инспекции */
  serviceRequestCanceled?: Maybe<ServiceRequestCanceledOutput>;
  /** Завершить работу над заявками */
  serviceRequestCompleted?: Maybe<ServiceRequestCompletedOutput>;
  /** Создать запрос на доп услуги */
  serviceRequestCreate?: Maybe<ServiceRequestCreateOutput>;
  /** Создать параметр для доп услуги */
  serviceRequestTypeParamAdd?: Maybe<ServiceRequestTypeParamAddOutput>;
  setBoundary?: Maybe<SetBoundaryOutput>;
  /** Установить дату доставки с СВХ клиенту */
  setDateSvhDeliveryRequest?: Maybe<SetDateSvhDeliveryRequestOutput>;
  setIsGlonassNeed?: Maybe<SetIsGlonassNeedOutput>;
  sortObjectMedia?: Maybe<SortObjectMediaOutput>;
  storageCreate?: Maybe<StorageCreateOutput>;
  /** Редактирование параметров склада */
  storageEdit?: Maybe<StorageUpdateOutput>;
  storageSectorCreate?: Maybe<StorageSectorCreateOutput>;
  storageSectorEdit?: Maybe<StorageSectorEditOutput>;
  subscribeUserToTelegram?: Maybe<SubscribeUserToTelegramOutput>;
  svhDeliveryAmbassadorCreate?: Maybe<SvhDeliveryAmbassadorCreateOutput>;
  svhDeliveryAmbassadorUpdate?: Maybe<SvhDeliveryAmbassadorUpdateOutput>;
  syncObject?: Maybe<SyncObjectOutput>;
  /** Взять в работу заявку на доставку (СВХ или в регион) */
  takeSvhDeliveryRequest?: Maybe<TakeSvhDeliveryRequestOutput>;
  ticketAddReview?: Maybe<TicketAddReviewOutput>;
  /** Добавить пользователя */
  ticketAddUser?: Maybe<TicketAddUserOutput>;
  /** Изменить дополнительную отметку притензии */
  ticketChangeSubType?: Maybe<TicketChangeSubTypeOutput>;
  /** Изменить тип претензии */
  ticketChangeType?: Maybe<TicketChangeTypeOutput>;
  ticketCreate?: Maybe<TicketCreateOutput>;
  /** Принять решение */
  ticketDecision?: Maybe<TicketDecisionOutput>;
  /** Добавить решение */
  ticketDecisionAdd?: Maybe<TicketDecisionAddOutput>;
  /** Апеллировать решение */
  ticketDecisionAppeal?: Maybe<TicketDecisionAppealOutput>;
  /** Подтвердить тикет */
  ticketDecisionApprove?: Maybe<TicketDecisionApproveOutput>;
  /** Подтвердить решение для руководителя организации */
  ticketDecisionApproveOrganization?: Maybe<TicketDecisionApproveOrganizationOutput>;
  /** Отменить решение */
  ticketDecisionCancel?: Maybe<TicketDecisionCancelOutput>;
  /** Удалить решение претензии из любого состояния */
  ticketDecisionCancelOnlyAdmin?: Maybe<TicketDecisionCancelOnlyAdminOutput>;
  /** Выплатить по претензии */
  ticketDecisionPayout?: Maybe<TicketDecisionPayoutOutput>;
  /** Сбросить из ожидает оплаты */
  ticketDecisionResetPayout?: Maybe<TicketDecisionResetPayoutOutput>;
  /** Изменить сумму решения */
  ticketDecisionUpdate?: Maybe<TicketDecisionUpdateOutput>;
  /** Отклонить претензию */
  ticketDecline?: Maybe<TicketDeclineOutput>;
  /** Удалить пользователя из претензии */
  ticketRemoveUser?: Maybe<TicketRemoveUserOutput>;
  /** Восстановить претензию */
  ticketReset?: Maybe<TicketResetOutput>;
  /** Закрыть без уведомления */
  ticketSilentClose?: Maybe<TicketSilentCloseOutput>;
  /** Endpoint to create tickets for yahoo */
  ticketYahooCreate?: Maybe<TicketYahooCreateOutput>;
  toggleUserNotifyMessage?: Maybe<ToggleUserNotifyMessageOutput>;
  /** Перевод баланса между клиентами */
  transferBalanceBetweenClients?: Maybe<TransferBalanceBetweenClientsOutput>;
  /** Отправка кода подтверждения на почту отправителя перевода */
  transferBalanceOtpSend?: Maybe<TransferBalanceOtpSendOutput>;
  /** Создать рейс AIR */
  tripAirCreate?: Maybe<TripAirCreateOutput>;
  /** Редактировать рейс AIR */
  tripAirEdit?: Maybe<TripAirEditOutput>;
  /** Сменить порядок объектов на рейсе */
  tripChangeObjectsOrder?: Maybe<TripChangeObjectsOrderOutput>;
  tripClose?: Maybe<TripCloseOutput>;
  tripCreate?: Maybe<TripCreateOutput>;
  /** Удалить пустой рейс */
  tripDelete?: Maybe<TripDeleteOutput>;
  tripEdit?: Maybe<TripEditOutput>;
  /** Погрузить объекты на судно */
  tripLoading?: Maybe<TripLoadingOutput>;
  /** Вернуть объекты в порт погрузки */
  tripReturnToSourcePort?: Maybe<TripReturnToSourcePortOutput>;
  /** Рейс прибыл, выгрузка */
  tripToPort?: Maybe<TripToPortOutput>;
  typeOfExportEdit?: Maybe<TypeOfExportEditOutput>;
  unlockTheIssuance?: Maybe<UnlockTheIssuanceOutput>;
  unViewChat?: Maybe<UnViewChatOutput>;
  updateInvoiceAuctionPurchase?: Maybe<UpdateInvoiceAuctionPurchaseOutput>;
  uploadFiles?: Maybe<UploadFilesOutput>;
  userChangePassword?: Maybe<UserChangePasswordOutput>;
  userProfileUpdate?: Maybe<UserProfileUpdateOutput>;
  /** Создать судно */
  vesselCreate?: Maybe<VesselCreateOutput>;
  /** Редактировать судно */
  vesselUpdate?: Maybe<VesselUpdateOutput>;
  viewChat?: Maybe<ViewChatOutput>;
  watchCarUpdate?: Maybe<WatchCarUpdateOutput>;
  /** Купить колеса */
  wheelBuy?: Maybe<WheelBuyOutput>;
  /** Снять колёса с машины */
  wheelCreate?: Maybe<WheelCreateOutput>;
  /** Убрать колеса с пелеты */
  wheelRemoveFromPalle?: Maybe<WheelRemoveFromPalletOutput>;
  /** Собрано в палете */
  wheelSetIsLoaded?: Maybe<WheelSetIsLoadedOutput>;
  /** Установить цену колес */
  wheelSetPrice?: Maybe<WheelSetPriceOutput>;
};


export type MutationAcceptSvhDeliveryRequestArgs = {
  input?: Maybe<AcceptSvhDeliveryRequestInput>;
};


export type MutationAddCommentArgs = {
  input?: Maybe<AddCommentInput>;
};


export type MutationAddContainerToPlanArgs = {
  input?: Maybe<AddContainerToPlanInput>;
};


export type MutationAddDisassemblyInfoArgs = {
  input?: Maybe<AddDisassemblyInfoInput>;
};


export type MutationAddExportCertificateToWorldwideObjectArgs = {
  input?: Maybe<AddExportCertificateToWorldwideObjectInput>;
};


export type MutationAddExportObjectToPlanArgs = {
  input?: Maybe<AddExportObjectToPlanInput>;
};


export type MutationAddFilesToObjectArgs = {
  input?: Maybe<AddFilesToObjectInput>;
};


export type MutationAddFirebaseTokenArgs = {
  input?: Maybe<AddFirebaseTokenInput>;
};


export type MutationAddMessageToChatArgs = {
  input?: Maybe<AddMessageToChatInput>;
};


export type MutationAddObjectToPlanArgs = {
  input?: Maybe<AddObjectToPlanInput>;
};


export type MutationAddTagToChatArgs = {
  input?: Maybe<AddTagToChatInput>;
};


export type MutationAkebonoObjectPayDebtArgs = {
  input?: Maybe<AkebonoObjectPayDebtInput>;
};


export type MutationAllowChangeRecipientArgs = {
  input?: Maybe<AllowChangeRecipientInput>;
};


export type MutationAllowVisiblePhotoArgs = {
  input?: Maybe<AllowVisiblePhotoInput>;
};


export type MutationAuctionListingCreateArgs = {
  input?: Maybe<AuctionListingCreateInput>;
};


export type MutationAuctionListingNotSoldArgs = {
  input?: Maybe<AuctionListingNotSoldInput>;
};


export type MutationAuctionListingSetTransportArgs = {
  input?: Maybe<AuctionListingSetTransportInput>;
};


export type MutationAuctionListingSoldArgs = {
  input?: Maybe<AuctionListingSoldInput>;
};


export type MutationAuctionListingUpdateLotArgs = {
  input?: Maybe<AuctionListingUpdateLotInput>;
};


export type MutationBlockTheIssuanceArgs = {
  input?: Maybe<BlockTheIssuanceInput>;
};


export type MutationBookingRequestArgs = {
  input?: Maybe<BookingRequestInput>;
};


export type MutationBuyLotteryTicketArgs = {
  input?: Maybe<BuyLotteryTicketInput>;
};


export type MutationCancelSvhDeliveryRequestArgs = {
  input?: Maybe<CancelSvhDeliveryRequestInput>;
};


export type MutationCarClientParamsUpdateArgs = {
  input?: Maybe<CarClientParamsUpdateInput>;
};


export type MutationCarMediaHiddenToggleArgs = {
  input?: Maybe<CarMediaHiddenToggleInput>;
};


export type MutationChangeAdditionalTypeArgs = {
  input?: Maybe<ChangeAdditionalTypeInput>;
};


export type MutationChangeDesiredTripArgs = {
  input?: Maybe<ChangeDesiredTripInput>;
};


export type MutationChangeExportPriceArgs = {
  input?: Maybe<ChangeExportPriceInput>;
};


export type MutationChangeObjectBrokerArgs = {
  input?: Maybe<ChangeObjectBrokerInput>;
};


export type MutationChangeObjectFormalOwnerArgs = {
  input?: Maybe<ChangeObjectFormalOwnerInput>;
};


export type MutationChangeObjectFreightCountryArgs = {
  input?: Maybe<ChangeObjectFreightCountryInput>;
};


export type MutationChangeObjectOwnerArgs = {
  input?: Maybe<ChangeObjectOwnerInput>;
};


export type MutationChangeObjectSenderArgs = {
  input?: Maybe<ChangeObjectSenderInput>;
};


export type MutationChangeObjectTypeArgs = {
  input?: Maybe<ChangeObjectTypeInput>;
};


export type MutationChangeObjectVinArgs = {
  input?: Maybe<ChangeObjectVinInput>;
};


export type MutationChangeParentObjectArgs = {
  input?: Maybe<ChangeParentObjectInput>;
};


export type MutationChangeSenderClientArgs = {
  input?: Maybe<ChangeSenderClientInput>;
};


export type MutationChatAddGroupUsersArgs = {
  input?: Maybe<ChatAddGroupUsersInput>;
};


export type MutationChatAddUserArgs = {
  input?: Maybe<ChatAddUserInput>;
};


export type MutationChatArchivingArgs = {
  input?: Maybe<ChatArchivingInput>;
};


export type MutationChatCreateArgs = {
  input?: Maybe<CreateChatInput>;
};


export type MutationChatDeleteMessageArgs = {
  input?: Maybe<ChatDeleteMessageInput>;
};


export type MutationChatRemoveUserArgs = {
  input?: Maybe<ChatRemoveUserInput>;
};


export type MutationChatUnArchivingArgs = {
  input?: Maybe<ChatUnArchivingInput>;
};


export type MutationCheckDateOfManufactureArgs = {
  input?: Maybe<CheckDateOfManufactureInput>;
};


export type MutationCompleteObjectArgs = {
  input?: Maybe<CompleteObjectInput>;
};


export type MutationCompleteTransportingRequestArgs = {
  input?: Maybe<CompleteTransportingRequestInput>;
};


export type MutationContainerConfirmBookedArgs = {
  input?: Maybe<ContainerConfirmBookedInput>;
};


export type MutationContainerCreateArgs = {
  input?: Maybe<ContainerCreateInput>;
};


export type MutationContainerDeleteArgs = {
  input?: Maybe<ContainerDeleteInput>;
};


export type MutationContainerUpdateArgs = {
  input?: Maybe<ContainerUpdateInput>;
};


export type MutationCountryCreateArgs = {
  input?: Maybe<CountryCreateInput>;
};


export type MutationCreateDeliveryRequestArgs = {
  input?: Maybe<CreateDeliveryRequestInput>;
};


export type MutationCreateInvoiceJapanAuctionPurchaseArgs = {
  input?: Maybe<CreateInvoiceJapanAuctionPurchaseInput>;
};


export type MutationCreateObjectActArgs = {
  input?: Maybe<CreateObjectActInput>;
};


export type MutationCreateReceiptOfPaymentArgs = {
  input?: Maybe<CreateReceiptOfPaymentInput>;
};


export type MutationCreateSbktsRequestArgs = {
  input?: Maybe<CreateSbktsRequestInput>;
};


export type MutationDealerObjectCompletedArgs = {
  input?: Maybe<DealerObjectCompletedInput>;
};


export type MutationDealerObjectCreateArgs = {
  input?: Maybe<DealerObjectCreateInput>;
};


export type MutationDealerObjectDeleteArgs = {
  input?: Maybe<DealerObjectDeleteInput>;
};


export type MutationDealerObjectUpdateArgs = {
  input?: Maybe<DealerObjectUpdateInput>;
};


export type MutationDeleteObjectArgs = {
  input?: Maybe<DeleteObjectInput>;
};


export type MutationDeleteUserNotifyMessageArgs = {
  input?: Maybe<DeleteUserNotifyMessageInput>;
};


export type MutationDeliveryToStockArgs = {
  input?: Maybe<DeliveryToStockInput>;
};


export type MutationDisallowVisiblePhotoArgs = {
  input?: Maybe<DisallowVisiblePhotoInput>;
};


export type MutationDisplayBidsCheckArgs = {
  input?: Maybe<DisplayBidsCheckInput>;
};


export type MutationDonateBuhankaArgs = {
  input?: Maybe<DonateBuhankaInput>;
};


export type MutationDzenPayAddManagerArgs = {
  input?: Maybe<DzenPayAddManagerInput>;
};


export type MutationDzenPayCancelByClientArgs = {
  input?: Maybe<DzenPayCancelByClientInput>;
};


export type MutationDzenPayGetOrderStatusArgs = {
  input?: Maybe<DzenPayGetOrderStatusInput>;
};


export type MutationDzenPayManagerCreateChatArgs = {
  input?: Maybe<DzenPayManagerCreateChatInput>;
};


export type MutationDzenPayManagerOrderUpdateArgs = {
  input?: Maybe<DzenPayManagerOrderUpdateInput>;
};


export type MutationDzenPayPartnerManualOrderArgs = {
  input?: Maybe<DzenPayPartnerManualOrderInput>;
};


export type MutationDzenPayPartnerOrderUpdateArgs = {
  input?: Maybe<DzenPayPartnerOrderUpdateInput>;
};


export type MutationDzenPayRegenerateDocumentsArgs = {
  input?: Maybe<DzenPayRegenerateDocumentsInput>;
};


export type MutationDzenPayRestoreArgs = {
  input?: Maybe<DzenPayRestoreInput>;
};


export type MutationDzenPayRetryFlowArgs = {
  input?: Maybe<DzenPayRetryFlowInput>;
};


export type MutationExchangeJobCloseArgs = {
  input?: Maybe<ExchangeJobCloseInput>;
};


export type MutationExchangeJobSendArgs = {
  input?: Maybe<ExchangeJobSendInput>;
};


export type MutationExportDeclarationAddObjectsArgs = {
  input?: Maybe<ExportDeclarationAddObjectsInput>;
};


export type MutationExportDeclarationCreateArgs = {
  input?: Maybe<ExportDeclarationCreateInput>;
};


export type MutationExportDeclarationPaidArgs = {
  input?: Maybe<ExportDeclarationPaidInput>;
};


export type MutationExportDeclarationRemoveObjectArgs = {
  input?: Maybe<ExportDeclarationRemoveObjectInput>;
};


export type MutationExportDeclarationUpdateArgs = {
  input?: Maybe<ExportDeclarationUpdateInput>;
};


export type MutationExportToAuctionArgs = {
  input?: Maybe<ExportToAuctionInput>;
};


export type MutationFileDeleteArgs = {
  input?: Maybe<FileDeleteInput>;
};


export type MutationForwarderCreateArgs = {
  input?: Maybe<ForwarderCreateInput>;
};


export type MutationForwarderDeleteArgs = {
  input?: Maybe<ForwarderDeleteInput>;
};


export type MutationForwarderUpdateArgs = {
  input?: Maybe<ForwarderUpdateInput>;
};


export type MutationGetActSvhDeliveryRequestArgs = {
  input?: Maybe<GetActSvhDeliveryRequestInput>;
};


export type MutationGreenCornerInspectionSaveArgs = {
  input?: Maybe<GreenCornerInspectionSaveInput>;
};


export type MutationGreenCornerManageObjectUpdateArgs = {
  input?: Maybe<GreenCornerManageObjectUpdateInput>;
};


export type MutationGreenCornerRemoveArgs = {
  input?: Maybe<GreenCornerRemoveInput>;
};


export type MutationGreenCornerSetSubscriptionArgs = {
  input?: Maybe<GreenCornerSetSubscriptionInput>;
};


export type MutationGreenCornerTgPostCancelScheduleArgs = {
  input?: Maybe<GreenCornerTgPostCancelScheduleInput>;
};


export type MutationGreenCornerTgPostCreateArgs = {
  input?: Maybe<GreenCornerTgPostCreateInput>;
};


export type MutationGreenCornerTgPostDeleteArgs = {
  input?: Maybe<GreenCornerTgPostDeleteInput>;
};


export type MutationGreenCornerTgPostPublishArgs = {
  input?: Maybe<GreenCornerTgPostPublishInput>;
};


export type MutationGreenCornerTgPostUnpublishArgs = {
  input?: Maybe<GreenCornerTgPostUnpublishInput>;
};


export type MutationGreenCornerTgPostUpdateArgs = {
  input?: Maybe<GreenCornerTgPostUpdateInput>;
};


export type MutationGreenCornerTgTemplateCreateArgs = {
  input?: Maybe<GreenCornerTgTemplateCreateInput>;
};


export type MutationGreenCornerTgTemplateDeleteArgs = {
  input?: Maybe<GreenCornerTgTemplateDeleteInput>;
};


export type MutationGreenCornerTgTemplateSetDefaultArgs = {
  input?: Maybe<GreenCornerTgTemplateSetDefaultInput>;
};


export type MutationGreenCornerTgTemplateUpdateArgs = {
  input?: Maybe<GreenCornerTgTemplateUpdateInput>;
};


export type MutationInvoiceByObjectsGenerateArgs = {
  input?: Maybe<InvoiceByObjectsGenerateInput>;
};


export type MutationInvoiceByObjectsUpdateArgs = {
  input?: Maybe<InvoiceByObjectsUpdateInput>;
};


export type MutationInvoiceCorrectionGenerateArgs = {
  input?: Maybe<InvoiceCorrectionGenerateInput>;
};


export type MutationInvoiceCustomGenerateArgs = {
  input?: Maybe<InvoiceCustomGenerateInput>;
};


export type MutationInvoiceCustomUpdateArgs = {
  input?: Maybe<InvoiceCustomUpdateInput>;
};


export type MutationInvoiceOwnRequisitesGenerateArgs = {
  input?: Maybe<InvoiceOwnRequisitesGenerateInput>;
};


export type MutationIssueObjectArgs = {
  input?: Maybe<IssueObjectInput>;
};


export type MutationKaitaiAutoResubmitChangeStateArgs = {
  input?: Maybe<KaitaiAutoResubmitChangeStateInput>;
};


export type MutationKaitaiQueueStatusChangeArgs = {
  input?: Maybe<KaitaiQueueStatusChangeInput>;
};


export type MutationLogAppEventArgs = {
  input?: Maybe<LogAppEventInput>;
};


export type MutationMagadanObjectCreateArgs = {
  input?: Maybe<MagadanObjectCreateInput>;
};


export type MutationMagadanObjectUpdateArgs = {
  input?: Maybe<MagadanObjectUpdateInput>;
};


export type MutationMakerCreateArgs = {
  input?: Maybe<MakerCreateInput>;
};


export type MutationMarkCreateArgs = {
  input?: Maybe<MarkCreateInput>;
};


export type MutationMassiveObjectUploadFilesArgs = {
  input?: Maybe<MassiveObjectUploadFilesInput>;
};


export type MutationMoveMediaToObjectArgs = {
  input?: Maybe<MoveMediaToObjectInput>;
};


export type MutationObjectAddPriorityPassArgs = {
  input?: Maybe<ObjectAddPriorityPassInput>;
};


export type MutationObjectAddStatusBookingRequestArgs = {
  input?: Maybe<ObjectAddStatusBookingRequestInput>;
};


export type MutationObjectAddSvhDeliveryRequestArgs = {
  input?: Maybe<ObjectAddSvhDeliveryRequestInput>;
};


export type MutationObjectAddTransportingRequestArgs = {
  input?: Maybe<ObjectAddTransportingRequestInput>;
};


export type MutationObjectAutoResaleArgs = {
  input?: Maybe<ObjectAutoResaleInput>;
};


export type MutationObjectBookParkingLotArgs = {
  input?: Maybe<ObjectBookParkingLotInput>;
};


export type MutationObjectChangeDestinationCountryArgs = {
  input?: Maybe<ObjectChangeDestinationCountryInput>;
};


export type MutationObjectChangeOwnerArgs = {
  input?: Maybe<ObjectChangeOwnerInput>;
};


export type MutationObjectChangeSawTypeArgs = {
  input?: Maybe<ObjectChangeSawTypeInput>;
};


export type MutationObjectCheckDebtsArgs = {
  input?: Maybe<ObjectCheckDebtsInput>;
};


export type MutationObjectDeleteCustomDocumentsArgs = {
  input?: Maybe<ObjectDeleteCustomDocumentsInput>;
};


export type MutationObjectDeleteMediaArgs = {
  input?: Maybe<ObjectDeleteMediaInput>;
};


export type MutationObjectFeedbackCreateArgs = {
  input?: Maybe<ObjectFeedbackCreateInput>;
};


export type MutationObjectGreenCornerEditArgs = {
  input?: Maybe<ObjectCatalogEditInput>;
};


export type MutationObjectGreenCornerTgArgs = {
  input?: Maybe<ObjectGreenCornerTgInput>;
};


export type MutationObjectHoldToArgs = {
  input?: Maybe<ObjectHoldToInput>;
};


export type MutationObjectHoldToCloseArgs = {
  input?: Maybe<ObjectHoldToCloseInput>;
};


export type MutationObjectOfServiceRemoveFromContainerArgs = {
  input?: Maybe<ObjectOfServiceRemoveFromContainerInput>;
};


export type MutationObjectRecipientPaymentEmailArgs = {
  input?: Maybe<ObjectRecipientPaymentEmailInput>;
};


export type MutationObjectRecycleStatusSetArgs = {
  input?: Maybe<ObjectRecycelStatusSetInput>;
};


export type MutationObjectRemoveIsGreenCornerArgs = {
  input?: Maybe<ObjectRemoveIsGreenCornerInput>;
};


export type MutationObjectRequestToParkingArgs = {
  input?: Maybe<ObjectRequestToParkingInput>;
};


export type MutationObjectRequestToPreparationDocumentsArgs = {
  input?: Maybe<ObjectRequestToPreparationDocumentsInput>;
};


export type MutationObjectResaleApproveArgs = {
  input?: Maybe<ObjectResaleApproveInput>;
};


export type MutationObjectResaleClientCreateArgs = {
  input?: Maybe<ObjectResaleClientCreateInput>;
};


export type MutationObjectResaleClientUpdateArgs = {
  input?: Maybe<ObjectResaleClientUpdateInput>;
};


export type MutationObjectResaleCompleteArgs = {
  input?: Maybe<ObjectResaleCompleteInput>;
};


export type MutationObjectResaleDeleteArgs = {
  input?: Maybe<ObjectResaleDeleteInput>;
};


export type MutationObjectResaleInvoiceCreateArgs = {
  input?: Maybe<ObjectResaleInvoiceCreateInput>;
};


export type MutationObjectResaleManagerCreateArgs = {
  input?: Maybe<ObjectResaleManagerCreateInput>;
};


export type MutationObjectResaleManagerUpdateArgs = {
  input?: Maybe<ObjectResaleManagerUpdateInput>;
};


export type MutationObjectResetArgs = {
  input?: Maybe<ObjectResetInput>;
};


export type MutationObjectSendInvoiceEmailArgs = {
  input?: Maybe<ObjectSendInvoiceEmailInput>;
};


export type MutationObjectSetBookingNumberArgs = {
  input?: Maybe<ObjectSetBookingNumberInput>;
};


export type MutationObjectSetDateDismantleForCubeArgs = {
  input?: Maybe<ObjectSetDateDismantleForCubeInput>;
};


export type MutationObjectSetDateRecyclingToCubeArgs = {
  input?: Maybe<ObjectSetDateRecyclingToCubeInput>;
};


export type MutationObjectSetDateSoldRecyclingCubeArgs = {
  input?: Maybe<ObjectSetDateSoldRecyclingCubeInput>;
};


export type MutationObjectSetGuidFrom1cArgs = {
  input?: Maybe<ObjectSetGuidFrom1cInput>;
};


export type MutationObjectSetIndependentFreightPaymentArgs = {
  input?: Maybe<AkebonoObjectSetIndependentFreightPaymentInput>;
};


export type MutationObjectSetIsGeneralBasisAdvanceArgs = {
  input?: Maybe<ObjectSetIsGeneralBasisAdvanceInput>;
};


export type MutationObjectSetIsGreenCornerArgs = {
  input?: Maybe<ObjectSetIsGreenCornerInput>;
};


export type MutationObjectSetKaitaiPriceArgs = {
  input?: Maybe<ObjectSetKaitaiPriceInput>;
};


export type MutationObjectSetMasterAccountClientArgs = {
  input?: Maybe<ObjectSetMasterAccountClientInput>;
};


export type MutationObjectSetSoldDateArgs = {
  input?: Maybe<ObjectSetSoldDateInput>;
};


export type MutationObjectToggleHideArgs = {
  input?: Maybe<ObjectToggleHideInput>;
};


export type MutationObjectToggleRemoveArgs = {
  input?: Maybe<ObjectToggleRemoveInput>;
};


export type MutationObjectUploadCustomDocumentsArgs = {
  input?: Maybe<ObjectUploadCustomDocumentsInput>;
};


export type MutationObjectUploadCustomPaymentArgs = {
  input?: Maybe<ObjectUploadCustomPaymentInput>;
};


export type MutationObjectUploadFilesArgs = {
  input?: Maybe<ObjectUploadFilesInput>;
};


export type MutationObjectUploadFilesToPlanArgs = {
  input?: Maybe<ObjectUploadFilesToPlanInput>;
};


export type MutationOwnerSearchByParamsArgs = {
  input?: Maybe<GetAgentsByParamsInput>;
};


export type MutationP2pAdminBuyRequestBlockArgs = {
  input?: Maybe<P2pAdminBuyRequestBlockInput>;
};


export type MutationP2pAdminBuyRequestCancelArgs = {
  input?: Maybe<P2pAdminBuyRequestCancelInput>;
};


export type MutationP2pAdminDealBlockArgs = {
  input?: Maybe<P2pAdminDealBlockInput>;
};


export type MutationP2pAdminDealCancelArgs = {
  input?: Maybe<P2pAdminDealCancelInput>;
};


export type MutationP2pAdminDealCompleteArgs = {
  input?: Maybe<P2pAdminDealCompleteInput>;
};


export type MutationP2pAdminDealSetStatusArgs = {
  input?: Maybe<P2pAdminDealSetStatusInput>;
};


export type MutationP2pAdminOfferApproveArgs = {
  input?: Maybe<P2pAdminOfferApproveInput>;
};


export type MutationP2pAdminOfferBlockArgs = {
  input?: Maybe<P2pAdminOfferBlockInput>;
};


export type MutationP2pAdminOfferCancelArgs = {
  input?: Maybe<P2pAdminOfferCancelInput>;
};


export type MutationP2pAdminOfferRejectArgs = {
  input?: Maybe<P2pAdminOfferRejectInput>;
};


export type MutationP2pBuyRequestCancelArgs = {
  input?: Maybe<P2pBuyRequestCancelInput>;
};


export type MutationP2pBuyRequestCreateArgs = {
  input?: Maybe<P2pBuyRequestCreateInput>;
};


export type MutationP2pBuyRequestUpdateArgs = {
  input?: Maybe<P2pBuyRequestUpdateInput>;
};


export type MutationP2pDealCancelArgs = {
  input?: Maybe<P2pDealCancelInput>;
};


export type MutationP2pDealConfirmArgs = {
  input?: Maybe<P2pDealConfirmInput>;
};


export type MutationP2pDealConfirmOtpSendArgs = {
  input?: Maybe<P2pDealConfirmOtpSendInput>;
};


export type MutationP2pDealCreateFromBuyRequestArgs = {
  input?: Maybe<P2pDealCreateFromBuyRequestInput>;
};


export type MutationP2pDealCreateFromOfferArgs = {
  input?: Maybe<P2pDealCreateFromOfferInput>;
};


export type MutationP2pDealDeclarePaymentArgs = {
  input?: Maybe<P2pDealDeclarePaymentInput>;
};


export type MutationP2pOfferCancelRemainderArgs = {
  input?: Maybe<P2pOfferCancelRemainderInput>;
};


export type MutationP2pOfferCreateArgs = {
  input?: Maybe<P2pOfferCreateInput>;
};


export type MutationP2pOfferUpdateArgs = {
  input?: Maybe<P2pOfferUpdateInput>;
};


export type MutationP2pPaymentDetailSaveArgs = {
  input?: Maybe<P2pPaymentDetailSaveInput>;
};


export type MutationP2pReviewAddArgs = {
  input?: Maybe<P2pReviewAddInput>;
};


export type MutationPalletAddWheelArgs = {
  input?: Maybe<PalletAddWheelInput>;
};


export type MutationPalletCreateArgs = {
  input?: Maybe<PalletCreateInput>;
};


export type MutationPalletToPlanArgs = {
  input?: Maybe<PalletToPlanInput>;
};


export type MutationPalletToPortArgs = {
  input?: Maybe<PalletToPortInput>;
};


export type MutationPartnerInfoAccreditArgs = {
  input?: Maybe<PartnerInfoAccreditInput>;
};


export type MutationPartnerInfoUpdateArgs = {
  input?: Maybe<PartnerInfoUpdateInput>;
};


export type MutationPaymentAgentAdminSettingsUpdateArgs = {
  input?: Maybe<PaymentAgentAdminSettingsUpdateInput>;
};


export type MutationPaymentAgentCreateArgs = {
  input?: Maybe<PaymentAgentCreateInput>;
};


export type MutationPaymentAgentSetActiveArgs = {
  input?: Maybe<PaymentAgentSetIsActiveInput>;
};


export type MutationPaymentAgentSettingsUpdateArgs = {
  input?: Maybe<PaymentAgentSettingsUpdateInput>;
};


export type MutationPaymentAgentUpdateArgs = {
  input?: Maybe<PaymentAgentUpdateInput>;
};


export type MutationPbAgreementSendedArgs = {
  input?: Maybe<PbAgreementSendedInput>;
};


export type MutationPickupAppointmentArgs = {
  input?: Maybe<PickupAppointmentInput>;
};


export type MutationPlanOnVesselTypeArgs = {
  input?: Maybe<PlanOnVesselTypeInput>;
};


export type MutationPortCreateArgs = {
  input?: Maybe<PortCreateInput>;
};


export type MutationPreSignedPostCreateArgs = {
  input?: Maybe<PreSignedPostCreateInput>;
};


export type MutationPutUpForSaleCreateArgs = {
  input?: Maybe<PutUpForSaleCreateInput>;
};


export type MutationPutUpForSaleSoldOutArgs = {
  input?: Maybe<PutUpForSaleSoldOutInput>;
};


export type MutationPutUpForSaleUpdateArgs = {
  input?: Maybe<PutUpForSaleUpdateInput>;
};


export type MutationPutUpForSaleWithdrawArgs = {
  input?: Maybe<PutUpForSaleWithdrawInput>;
};


export type MutationReminderRemoveArgs = {
  input?: Maybe<ReminderRemoveInput>;
};


export type MutationRemoveFromStockArgs = {
  input?: Maybe<RemoveFromStockInput>;
};


export type MutationRemoveObjectFromPlanArgs = {
  input?: Maybe<RemoveObjectFromPlanInput>;
};


export type MutationRenewExportCertificateArgs = {
  input?: Maybe<RenewExportCertificateInput>;
};


export type MutationReplaceDoubleArgs = {
  input?: Maybe<ReplaceDoubleInput>;
};


export type MutationReplaceToStockArgs = {
  input?: Maybe<ReplaceToStockInput>;
};


export type MutationReportCreateArgs = {
  input?: Maybe<ReportCreateInput>;
};


export type MutationReportDeleteArgs = {
  input?: Maybe<ReportDeleteInput>;
};


export type MutationRequestPhotoFromAuctionArgs = {
  input?: Maybe<RequestPhotoFromAuctionInput>;
};


export type MutationRequestPhotoFromAuctionByAdminArgs = {
  input?: Maybe<RequestPhotoFromAuctionByAdminInput>;
};


export type MutationRequestPrimbrokerInvoiceArgs = {
  input?: Maybe<RequestPrimbrokerInvoiceInput>;
};


export type MutationRequestSbktsCreateArgs = {
  input?: Maybe<RequestSbktsCreateInput>;
};


export type MutationRequestSbktsFromExcelCreateArgs = {
  input?: Maybe<RequestSbktsFromExcelCreateInput>;
};


export type MutationRequestToIssueArgs = {
  input?: Maybe<RequestToIssueInput>;
};


export type MutationRequestUnHoldArgs = {
  input?: Maybe<RequestUnHoldInput>;
};


export type MutationRestoreObjectArgs = {
  input?: Maybe<RestoreObjectInput>;
};


export type MutationScrapAccountSessionUpdateArgs = {
  input?: Maybe<ScrapAccountSessionUpdateInput>;
};


export type MutationScrapObjectCommentAddArgs = {
  input?: Maybe<ScrapObjectCommentAddInput>;
};


export type MutationScrapObjectCreateArgs = {
  input?: Maybe<ScrapObjectCreateInput>;
};


export type MutationScrapObjectDeliverySetArgs = {
  input?: Maybe<ScrapObjectDeliverySetInput>;
};


export type MutationScrapObjectDiscountToYahooArgs = {
  input?: Maybe<ScrapObjectsDiscountToYahooInput>;
};


export type MutationScrapObjectLotCancelArgs = {
  input?: Maybe<ScrapObjectLotCancelInput>;
};


export type MutationScrapObjectPlaceSetArgs = {
  input?: Maybe<ScrapObjectPlaceSetInput>;
};


export type MutationScrapObjectRebindArgs = {
  input?: Maybe<ScrapObjectRebindInput>;
};


export type MutationScrapObjectSizeSetArgs = {
  input?: Maybe<ScrapObjectSizeSetInput>;
};


export type MutationScrapObjectStatusSetArgs = {
  input?: Maybe<ScrapObjectStatusSetInput>;
};


export type MutationScrapObjectToYahooArgs = {
  input?: Maybe<ScrapObjectToYahooInput>;
};


export type MutationScrapObjectUnbindArgs = {
  input?: Maybe<ScrapObjectUnbindInput>;
};


export type MutationScrapObjectUpdateArgs = {
  input?: Maybe<ScrapObjectUpdateInput>;
};


export type MutationScrapObjectUploadShippingInvoiceArgs = {
  input?: Maybe<ScrapObjectUploadShippingInvoiceInput>;
};


export type MutationScrapObjectWriteOffArgs = {
  input?: Maybe<ScrapObjectWriteOffInput>;
};


export type MutationScrapTypeCreateArgs = {
  input?: Maybe<ScrapTypeCreateInput>;
};


export type MutationScrapTypeDescriptionCreateArgs = {
  input?: Maybe<ScrapTypeDescriptionCreateInput>;
};


export type MutationScrapTypeDescriptionDeleteArgs = {
  input?: Maybe<ScrapTypeDescriptionDeleteInput>;
};


export type MutationScrapTypeDescriptionUpdateArgs = {
  input?: Maybe<ScrapTypeDescriptionUpdateInput>;
};


export type MutationScrapTypeUpdateArgs = {
  input?: Maybe<ScrapTypeUpdateInput>;
};


export type MutationScrapUtilizedArgs = {
  input?: Maybe<ScrapUtilizedInput>;
};


export type MutationSeaCarrierCreateArgs = {
  input?: Maybe<SeaCarrierCreateInput>;
};


export type MutationSeaCarrierDeleteArgs = {
  input?: Maybe<SeaCarrierDeleteInput>;
};


export type MutationSeaCarrierEditArgs = {
  input?: Maybe<SeaCarrierEditInput>;
};


export type MutationSendAllClientsNotificationArgs = {
  input?: Maybe<SendAllClientsNotificationInput>;
};


export type MutationSendDirectorFeedbackArgs = {
  input?: Maybe<SendDirectorFeedbackInput>;
};


export type MutationSendFeedbackArgs = {
  input?: Maybe<SendFeedbackInput>;
};


export type MutationSendNotificationEmailArgs = {
  input?: Maybe<SendNotificationEmailInput>;
};


export type MutationSendPaymentInfoArgs = {
  input?: Maybe<SendPaymentInfoInput>;
};


export type MutationSendRussianDeliveryRequestArgs = {
  input?: Maybe<SendRussianDeliveryRequestInput>;
};


export type MutationServiceRequestCanceledArgs = {
  input?: Maybe<ServiceRequestCanceledInput>;
};


export type MutationServiceRequestCompletedArgs = {
  input?: Maybe<ServiceRequestCompletedInput>;
};


export type MutationServiceRequestCreateArgs = {
  input?: Maybe<ServiceRequestCreateInput>;
};


export type MutationServiceRequestTypeParamAddArgs = {
  input?: Maybe<ServiceRequestTypeParamAddInput>;
};


export type MutationSetBoundaryArgs = {
  input?: Maybe<SetBoundaryInput>;
};


export type MutationSetDateSvhDeliveryRequestArgs = {
  input?: Maybe<SetDateSvhDeliveryRequestInput>;
};


export type MutationSetIsGlonassNeedArgs = {
  input?: Maybe<SetIsGlonassNeedInput>;
};


export type MutationSortObjectMediaArgs = {
  input?: Maybe<SortObjectMediaInput>;
};


export type MutationStorageCreateArgs = {
  input?: Maybe<StorageCreateInput>;
};


export type MutationStorageEditArgs = {
  input?: Maybe<StorageUpdateInput>;
};


export type MutationStorageSectorCreateArgs = {
  input?: Maybe<StorageSectorCreateInput>;
};


export type MutationStorageSectorEditArgs = {
  input?: Maybe<StorageSectorEditInput>;
};


export type MutationSubscribeUserToTelegramArgs = {
  input?: Maybe<SubscribeUserToTelegramInput>;
};


export type MutationSvhDeliveryAmbassadorCreateArgs = {
  input?: Maybe<SvhDeliveryAmbassadorCreateInput>;
};


export type MutationSvhDeliveryAmbassadorUpdateArgs = {
  input?: Maybe<SvhDeliveryAmbassadorUpdateInput>;
};


export type MutationSyncObjectArgs = {
  input?: Maybe<SyncObjectInput>;
};


export type MutationTakeSvhDeliveryRequestArgs = {
  input?: Maybe<TakeSvhDeliveryRequestInput>;
};


export type MutationTicketAddReviewArgs = {
  input?: Maybe<TicketAddReviewInput>;
};


export type MutationTicketAddUserArgs = {
  input?: Maybe<TicketAddUserInput>;
};


export type MutationTicketChangeSubTypeArgs = {
  input?: Maybe<TicketChangeSubTypeInput>;
};


export type MutationTicketChangeTypeArgs = {
  input?: Maybe<TicketChangeTypeInput>;
};


export type MutationTicketCreateArgs = {
  input?: Maybe<TicketCreateInput>;
};


export type MutationTicketDecisionArgs = {
  input?: Maybe<TicketDecisionInput>;
};


export type MutationTicketDecisionAddArgs = {
  input?: Maybe<TicketDecisionAddInput>;
};


export type MutationTicketDecisionAppealArgs = {
  input?: Maybe<TicketDecisionAppealInput>;
};


export type MutationTicketDecisionApproveArgs = {
  input?: Maybe<TicketDecisionApproveInput>;
};


export type MutationTicketDecisionApproveOrganizationArgs = {
  input?: Maybe<TicketDecisionApproveOrganizationInput>;
};


export type MutationTicketDecisionCancelArgs = {
  input?: Maybe<TicketDecisionCancelInput>;
};


export type MutationTicketDecisionCancelOnlyAdminArgs = {
  input?: Maybe<TicketDecisionCancelOnlyAdminInput>;
};


export type MutationTicketDecisionPayoutArgs = {
  input?: Maybe<TicketDecisionPayoutInput>;
};


export type MutationTicketDecisionResetPayoutArgs = {
  input?: Maybe<TicketDecisionResetPayoutInput>;
};


export type MutationTicketDecisionUpdateArgs = {
  input?: Maybe<TicketDecisionUpdateInput>;
};


export type MutationTicketDeclineArgs = {
  input?: Maybe<TicketDeclineInput>;
};


export type MutationTicketRemoveUserArgs = {
  input?: Maybe<TicketRemoveUserInput>;
};


export type MutationTicketResetArgs = {
  input?: Maybe<TicketResetInput>;
};


export type MutationTicketSilentCloseArgs = {
  input?: Maybe<TicketSilentCloseInput>;
};


export type MutationTicketYahooCreateArgs = {
  input?: Maybe<TicketYahooCreateInput>;
};


export type MutationToggleUserNotifyMessageArgs = {
  input?: Maybe<ToggleUserNotifyMessageInput>;
};


export type MutationTransferBalanceBetweenClientsArgs = {
  input?: Maybe<TransferBalanceBetweenClientsInput>;
};


export type MutationTransferBalanceOtpSendArgs = {
  input?: Maybe<TransferBalanceOtpSendInput>;
};


export type MutationTripAirCreateArgs = {
  input?: Maybe<TripAirCreateInput>;
};


export type MutationTripAirEditArgs = {
  input?: Maybe<TripAirEditInput>;
};


export type MutationTripChangeObjectsOrderArgs = {
  input?: Maybe<TripChangeObjectsOrderInput>;
};


export type MutationTripCloseArgs = {
  input?: Maybe<TripCloseInput>;
};


export type MutationTripCreateArgs = {
  input?: Maybe<TripCreateInput>;
};


export type MutationTripDeleteArgs = {
  input?: Maybe<TripDeleteInput>;
};


export type MutationTripEditArgs = {
  input?: Maybe<TripEditInput>;
};


export type MutationTripLoadingArgs = {
  input?: Maybe<TripLoadingInput>;
};


export type MutationTripReturnToSourcePortArgs = {
  input?: Maybe<TripReturnToSourcePortInput>;
};


export type MutationTripToPortArgs = {
  input?: Maybe<TripToPortInput>;
};


export type MutationTypeOfExportEditArgs = {
  input?: Maybe<TypeOfExportEditInput>;
};


export type MutationUnlockTheIssuanceArgs = {
  input?: Maybe<UnlockTheIssuanceInput>;
};


export type MutationUnViewChatArgs = {
  input?: Maybe<UnViewChatInput>;
};


export type MutationUpdateInvoiceAuctionPurchaseArgs = {
  input?: Maybe<UpdateInvoiceAuctionPurchaseInput>;
};


export type MutationUploadFilesArgs = {
  input?: Maybe<UploadFilesInput>;
};


export type MutationUserChangePasswordArgs = {
  input?: Maybe<UserChangePasswordInput>;
};


export type MutationUserProfileUpdateArgs = {
  input?: Maybe<UserProfileUpdateInput>;
};


export type MutationVesselCreateArgs = {
  input?: Maybe<VesselCreateInput>;
};


export type MutationVesselUpdateArgs = {
  input?: Maybe<VesselUpdateInput>;
};


export type MutationViewChatArgs = {
  input?: Maybe<ViewChatInput>;
};


export type MutationWatchCarUpdateArgs = {
  input?: Maybe<WatchCarUpdateInput>;
};


export type MutationWheelBuyArgs = {
  input?: Maybe<WheelBuyInput>;
};


export type MutationWheelCreateArgs = {
  input?: Maybe<WheelCreateInput>;
};


export type MutationWheelRemoveFromPalleArgs = {
  input?: Maybe<WheelRemoveFromPalletInput>;
};


export type MutationWheelSetIsLoadedArgs = {
  input?: Maybe<WheelSetIsLoadedInput>;
};


export type MutationWheelSetPriceArgs = {
  input?: Maybe<WheelSetPriceInput>;
};

export type AcceptSvhDeliveryRequestInput = {
  /** Согласованная стоимость доставки */
  amount: Scalars['Int'];
  /** Комментарий логиста к заявке */
  comment: Scalars['String'];
  id: Scalars['Int'];
};

export type AcceptSvhDeliveryRequestOutput = {
  __typename?: 'AcceptSvhDeliveryRequestOutput';
  error?: Maybe<MutationError>;
};

export type MutationError = {
  __typename?: 'MutationError';
  code?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  line?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type AddCommentInput = {
  comment: Scalars['String'];
  objectId: Scalars['Int'];
};

export type AddCommentOutput = {
  __typename?: 'AddCommentOutput';
  error?: Maybe<MutationError>;
};

export type AddContainerToPlanInput = {
  containerId: Scalars['Int'];
  planId: Scalars['Int'];
};

export type AddContainerToPlanOutput = {
  __typename?: 'AddContainerToPlanOutput';
  error?: Maybe<MutationError>;
};

export type AddDisassemblyInfoInput = {
  message: Scalars['String'];
  objectId: Scalars['Int'];
  type: DisassemblyInfoEnum;
};

export enum DisassemblyInfoEnum {
  Manual = 'manual',
  Notice = 'notice'
}

export type AddDisassemblyInfoOutput = {
  __typename?: 'AddDisassemblyInfoOutput';
  error?: Maybe<MutationError>;
};

export type AddExportCertificateToWorldwideObjectInput = {
  expirationDate: Scalars['String'];
  exportCertificateKeyS3File: Scalars['String'];
  number: Scalars['String'];
  objectId: Scalars['Int'];
};

export type AddExportCertificateToWorldwideObjectOutput = {
  __typename?: 'AddExportCertificateToWorldwideObjectOutput';
  error?: Maybe<MutationError>;
};

export type AddExportObjectToPlanInput = {
  chassisId: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  customId?: Maybe<Scalars['Int']>;
  engine?: Maybe<Scalars['String']>;
  engineTypeId?: Maybe<Scalars['Int']>;
  engineVolumeCm3?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  isAddDelivery?: Maybe<Scalars['Boolean']>;
  length?: Maybe<Scalars['Int']>;
  loadCapacity?: Maybe<Scalars['Int']>;
  makerId: Scalars['Int'];
  markId: Scalars['Int'];
  objectId: Scalars['Int'];
  ownerId: Scalars['Int'];
  payCountryId?: Maybe<Scalars['Int']>;
  planId: Scalars['Int'];
  price?: Maybe<Scalars['Int']>;
  priceCurrencyId?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  senderId: Scalars['Int'];
  typeId: Scalars['Int'];
  vin: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['String']>;
};

export type AddExportObjectToPlanOutput = {
  __typename?: 'AddExportObjectToPlanOutput';
  error?: Maybe<MutationError>;
};

export type AddFilesToObjectInput = {
  contentType: Scalars['String'];
  keyS3Files: Array<Scalars['String']>;
  objectId: Scalars['Int'];
  type: MediaTypeEnum;
};

export type AddFilesToObjectOutput = {
  __typename?: 'AddFilesToObjectOutput';
  error?: Maybe<MutationError>;
};

export type AddFirebaseTokenInput = {
  platform: Scalars['String'];
  source: AppSourceEnum;
  token: Scalars['String'];
};

export type AddFirebaseTokenOutput = {
  __typename?: 'AddFirebaseTokenOutput';
  error?: Maybe<MutationError>;
};

export type AddMessageToChatInput = {
  chatId: Scalars['Int'];
  filesKeys: Array<Maybe<Scalars['String']>>;
  isTask: Scalars['Boolean'];
  text: Scalars['String'];
};

export type AddMessageToChatOutput = {
  __typename?: 'AddMessageToChatOutput';
  error?: Maybe<MutationError>;
};

export type AddObjectToPlanInput = {
  contract: Scalars['Int'];
  isAddDelivery?: Maybe<Scalars['Boolean']>;
  objectId: Scalars['Int'];
  planId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type AddObjectToPlanOutput = {
  __typename?: 'AddObjectToPlanOutput';
  error?: Maybe<MutationError>;
};

export type AddTagToChatInput = {
  chatId: Scalars['Int'];
  tagId: Scalars['Int'];
};

export type AddTagToChatOutput = {
  __typename?: 'AddTagToChatOutput';
  error?: Maybe<MutationError>;
};

export type AkebonoObjectPayDebtInput = {
  agentId: Scalars['Int'];
  amount: Scalars['Int'];
  currentAdvance: Scalars['Int'];
  objectGuid?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type AkebonoObjectPayDebtOutput = {
  __typename?: 'AkebonoObjectPayDebtOutput';
  error?: Maybe<MutationError>;
};

export type AllowChangeRecipientInput = {
  objectId: Scalars['Int'];
  reason: Scalars['String'];
};

export type AllowChangeRecipientOutput = {
  __typename?: 'AllowChangeRecipientOutput';
  error?: Maybe<MutationError>;
};

export type AllowVisiblePhotoInput = {
  objectId: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
};

export type AllowVisiblePhotoOutput = {
  __typename?: 'AllowVisiblePhotoOutput';
  error?: Maybe<MutationError>;
};

export type AuctionListingCreateInput = {
  auctionId: Scalars['Int'];
  objectId: Scalars['Int'];
  startPrice: Scalars['Int'];
  wishPrice: Scalars['Int'];
};

export type AuctionListingCreateOutput = {
  __typename?: 'AuctionListingCreateOutput';
  error?: Maybe<MutationError>;
};

export type AuctionListingNotSoldInput = {
  notSoldPrice: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type AuctionListingNotSoldOutput = {
  __typename?: 'AuctionListingNotSoldOutput';
  error?: Maybe<MutationError>;
};

export type AuctionListingSetTransportInput = {
  objectId: Scalars['Int'];
  transportCompany: Scalars['String'];
};

export type AuctionListingSetTransportOutput = {
  __typename?: 'AuctionListingSetTransportOutput';
  error?: Maybe<MutationError>;
};

export type AuctionListingSoldInput = {
  objectId: Scalars['Int'];
  soldPrice: Scalars['Int'];
};

export type AuctionListingSoldOutput = {
  __typename?: 'AuctionListingSoldOutput';
  error?: Maybe<MutationError>;
};

export type AuctionListingUpdateLotInput = {
  auctionDate: Scalars['String'];
  auctionId: Scalars['Int'];
  kai?: Maybe<Scalars['String']>;
  numberLot?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  startPrice: Scalars['Int'];
  wishPrice: Scalars['Int'];
};

export type AuctionListingUpdateLotOutput = {
  __typename?: 'AuctionListingUpdateLotOutput';
  error?: Maybe<MutationError>;
};

export type BlockTheIssuanceInput = {
  comment: Scalars['String'];
  objectId: Scalars['Int'];
};

export type BlockTheIssuanceOutput = {
  __typename?: 'BlockTheIssuanceOutput';
  error?: Maybe<MutationError>;
};

export type BookingRequestInput = {
  isBoundary: Scalars['Boolean'];
  makerId?: Maybe<Scalars['Int']>;
  markId?: Maybe<Scalars['Int']>;
  mediaKeyS3ExportCertificate: Scalars['String'];
  mediaKeysS3Documents?: Maybe<Array<Maybe<Scalars['String']>>>;
  objectId?: Maybe<Scalars['Int']>;
  objectState: ObjectStateEnum;
  tripId?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['Int']>;
};

export type BookingRequestOutput = {
  __typename?: 'BookingRequestOutput';
  error?: Maybe<MutationError>;
};

export type BuyLotteryTicketInput = {
  ticketId: Scalars['Int'];
};

export type BuyLotteryTicketOutput = {
  __typename?: 'BuyLotteryTicketOutput';
  error?: Maybe<MutationError>;
};

export type CancelSvhDeliveryRequestInput = {
  id: Scalars['Int'];
};

export type CancelSvhDeliveryRequestOutput = {
  __typename?: 'CancelSvhDeliveryRequestOutput';
  error?: Maybe<MutationError>;
};

export type CarClientParamsUpdateInput = {
  currencyInDestination?: Maybe<Scalars['Int']>;
  currencyInJapanId?: Maybe<Scalars['Int']>;
  currencyOnDeliveryId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  priceInDestination?: Maybe<Scalars['Int']>;
  priceInJapan?: Maybe<Scalars['Int']>;
  priceOnDelivery?: Maybe<Scalars['Int']>;
};

export type CarClientParamsUpdateOutput = {
  __typename?: 'CarClientParamsUpdateOutput';
  error?: Maybe<MutationError>;
};

export type CarMediaHiddenToggleInput = {
  carMediaId: Scalars['Int'];
};

export type CarMediaHiddenToggleOutput = {
  __typename?: 'CarMediaHiddenToggleOutput';
  error?: Maybe<MutationError>;
};

export type ChangeAdditionalTypeInput = {
  additionalTypeId: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type ChangeAdditionalTypeOutput = {
  __typename?: 'ChangeAdditionalTypeOutput';
  error?: Maybe<MutationError>;
};

export type ChangeDesiredTripInput = {
  objectId: Scalars['Int'];
  tripId: Scalars['Int'];
};

export type ChangeDesiredTripOutput = {
  __typename?: 'ChangeDesiredTripOutput';
  error?: Maybe<MutationError>;
};

export type ChangeExportPriceInput = {
  currencyId: Scalars['Int'];
  exportPrice: Scalars['Float'];
  objectId: Scalars['Int'];
};

export type ChangeExportPriceOutput = {
  __typename?: 'ChangeExportPriceOutput';
  error?: Maybe<MutationError>;
};

export type ChangeObjectBrokerInput = {
  brokerAddress?: Maybe<Scalars['String']>;
  brokerContacts?: Maybe<Scalars['String']>;
  brokerId?: Maybe<Scalars['Int']>;
  brokerName?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
};

export type ChangeObjectBrokerOutput = {
  __typename?: 'ChangeObjectBrokerOutput';
  error?: Maybe<MutationError>;
};

export type ChangeObjectFormalOwnerInput = {
  formalOwnerId: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type ChangeObjectFormalOwnerOutput = {
  __typename?: 'ChangeObjectFormalOwnerOutput';
  error?: Maybe<MutationError>;
};

export type ChangeObjectFreightCountryInput = {
  countryId: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type ChangeObjectFreightCountryOutput = {
  __typename?: 'ChangeObjectFreightCountryOutput';
  error?: Maybe<MutationError>;
};

export type ChangeObjectOwnerInput = {
  objectId: Scalars['Int'];
  ownerId: Scalars['Int'];
};

export type ChangeObjectOwnerOutput = {
  __typename?: 'ChangeObjectOwnerOutput';
  error?: Maybe<MutationError>;
};

export type ChangeObjectSenderInput = {
  objectId: Scalars['Int'];
  senderId: Scalars['Int'];
};

export type ChangeObjectSenderOutput = {
  __typename?: 'ChangeObjectSenderOutput';
  error?: Maybe<MutationError>;
};

export type ChangeObjectTypeInput = {
  objectId: Scalars['Int'];
  objectTypeId: Scalars['Int'];
};

export type ChangeObjectTypeOutput = {
  __typename?: 'ChangeObjectTypeOutput';
  error?: Maybe<MutationError>;
};

export type ChangeObjectVinInput = {
  newVin: Scalars['String'];
  objectId: Scalars['Int'];
};

export type ChangeObjectVinOutput = {
  __typename?: 'ChangeObjectVinOutput';
  error?: Maybe<MutationError>;
};

export type ChangeParentObjectInput = {
  objectId: Scalars['Int'];
};

export type ChangeParentObjectOutput = {
  __typename?: 'ChangeParentObjectOutput';
  error?: Maybe<MutationError>;
};

export type ChangeSenderClientInput = {
  clientId: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type ChangeSenderClientOutput = {
  __typename?: 'ChangeSenderClientOutput';
  error?: Maybe<MutationError>;
};

export type ChatAddGroupUsersInput = {
  chatId: Scalars['Int'];
  groupId: Scalars['Int'];
};

export type ChatAddGroupUsersOutput = {
  __typename?: 'ChatAddGroupUsersOutput';
  error?: Maybe<MutationError>;
};

export type ChatAddUserInput = {
  chatId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ChatAddUserOutput = {
  __typename?: 'ChatAddUserOutput';
  error?: Maybe<MutationError>;
};

export type ChatArchivingInput = {
  chatId: Scalars['Int'];
};

export type ChatArchivingOutput = {
  __typename?: 'ChatArchivingOutput';
  error?: Maybe<MutationError>;
};

export type CreateChatInput = {
  isTask: Scalars['Boolean'];
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  objectId?: Maybe<Scalars['Int']>;
  subject: Scalars['String'];
  toGroupsIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  toUsersIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CreateChatOutput = {
  __typename?: 'CreateChatOutput';
  error?: Maybe<MutationError>;
};

export type ChatDeleteMessageInput = {
  messageId: Scalars['Int'];
};

export type ChatDeleteMessageOutput = {
  __typename?: 'ChatDeleteMessageOutput';
  error?: Maybe<MutationError>;
};

export type ChatRemoveUserInput = {
  id: Scalars['Int'];
};

export type ChatRemoveUserOutput = {
  __typename?: 'ChatRemoveUserOutput';
  error?: Maybe<MutationError>;
};

export type ChatUnArchivingInput = {
  chatId: Scalars['Int'];
};

export type ChatUnArchivingOutput = {
  __typename?: 'ChatUnArchivingOutput';
  error?: Maybe<MutationError>;
};

export type CheckDateOfManufactureInput = {
  objectId: Scalars['Int'];
};

export type CheckDateOfManufactureOutput = {
  __typename?: 'CheckDateOfManufactureOutput';
  error?: Maybe<MutationError>;
};

export type CompleteObjectInput = {
  objectId: Scalars['Int'];
};

export type CompleteObjectOutput = {
  __typename?: 'CompleteObjectOutput';
  error?: Maybe<MutationError>;
};

export type CompleteTransportingRequestInput = {
  id: Scalars['Int'];
};

export type CompleteTransportingRequestOutput = {
  __typename?: 'CompleteTransportingRequestOutput';
  error?: Maybe<MutationError>;
};

export type ContainerConfirmBookedInput = {
  containerId?: Maybe<Scalars['Int']>;
  keyS3File?: Maybe<Scalars['String']>;
};

export type ContainerConfirmBookedOutput = {
  __typename?: 'ContainerConfirmBookedOutput';
  error?: Maybe<MutationError>;
};

export type ContainerCreateInput = {
  arrivalDate?: Maybe<Scalars['String']>;
  carrierId?: Maybe<Scalars['Int']>;
  dateOfLoading?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['Int']>;
  insurancePolicy?: Maybe<Scalars['String']>;
  insurancePolicyKeyS3?: Maybe<Array<Scalars['String']>>;
  number: Scalars['String'];
  objects?: Maybe<Array<Scalars['Int']>>;
  /** Id сотрудников ваннинга, которые грузили объекты в контейнер */
  vanningUserIds?: Maybe<Array<Scalars['Int']>>;
};

export type ContainerCreateOutput = {
  __typename?: 'ContainerCreateOutput';
  error?: Maybe<MutationError>;
};

export type ContainerDeleteInput = {
  id: Scalars['Int'];
};

export type ContainerDeleteOutput = {
  __typename?: 'ContainerDeleteOutput';
  error?: Maybe<MutationError>;
};

export type ContainerUpdateInput = {
  arrivalDate?: Maybe<Scalars['String']>;
  carrierId?: Maybe<Scalars['Int']>;
  containerTypeId: Scalars['Int'];
  dateOfLoading?: Maybe<Scalars['DateTime']>;
  driverId?: Maybe<Scalars['Int']>;
  forwarderId?: Maybe<Scalars['Int']>;
  freightTypeId: Scalars['Int'];
  id: Scalars['Int'];
  insurancePolicy?: Maybe<Scalars['String']>;
  insurancePolicyKeyS3?: Maybe<Array<Scalars['String']>>;
  number?: Maybe<Scalars['String']>;
  seaCarrierId: Scalars['Int'];
  /** Id сотрудников ваннинга, которые грузили объекты в контейнер */
  vanningUserIds?: Maybe<Array<Scalars['Int']>>;
};

export type ContainerUpdateOutput = {
  __typename?: 'ContainerUpdateOutput';
  error?: Maybe<MutationError>;
};

export type CountryCreateInput = {
  alfa2: Scalars['String'];
  code: Scalars['String'];
  fullName: Scalars['String'];
  name: Scalars['String'];
  nameEng: Scalars['String'];
};

export type CountryCreateOutput = {
  __typename?: 'CountryCreateOutput';
  error?: Maybe<MutationError>;
};

export type CreateDeliveryRequestInput = {
  carrierId?: Maybe<Scalars['Int']>;
  clientPrice?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['Int']>;
  deliveryPrice?: Maybe<Scalars['Int']>;
  destinationId: Scalars['Int'];
  objectId: Scalars['Int'];
  sourceId: Scalars['Int'];
};

export type CreateDeliveryRequestOutput = {
  __typename?: 'CreateDeliveryRequestOutput';
  error?: Maybe<MutationError>;
};

export type CreateInvoiceJapanAuctionPurchaseInput = {
  objectId: Scalars['Int'];
};

export type CreateInvoiceJapanAuctionPurchaseOutput = {
  __typename?: 'CreateInvoiceJapanAuctionPurchaseOutput';
  error?: Maybe<MutationError>;
};

export type CreateObjectActInput = {
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  objectId: Scalars['Int'];
  subject: Scalars['String'];
};

export type CreateObjectActOutput = {
  __typename?: 'CreateObjectActOutput';
  error?: Maybe<MutationError>;
};

export type CreateReceiptOfPaymentInput = {
  amount: Scalars['Int'];
  currencyId: Scalars['Int'];
  dateOfPayment: Scalars['String'];
  invoiceListS3Files?: Maybe<Array<Scalars['String']>>;
  invoiceNumber: Scalars['String'];
  invoiceType: InvoiceCustomTypeEnum;
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  senderName: Scalars['String'];
};

export type CreateReceiptOfPaymentOutput = {
  __typename?: 'CreateReceiptOfPaymentOutput';
  error?: Maybe<MutationError>;
};

export type CreateSbktsRequestInput = {
  ambassador: Scalars['Int'];
  laboratory: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type CreateSbktsRequestOutput = {
  __typename?: 'CreateSbktsRequestOutput';
  error?: Maybe<MutationError>;
};

export type DealerObjectCompletedInput = {
  id: Scalars['Int'];
};

export type DealerObjectCompletedOutput = {
  __typename?: 'DealerObjectCompletedOutput';
  error?: Maybe<MutationError>;
};

export type DealerObjectCreateInput = {
  colorEn: Scalars['String'];
  dateOfManufacture?: Maybe<Scalars['String']>;
  dealerId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  engineVolumeNum: Scalars['Float'];
  equipmentEn: Scalars['String'];
  hasTelegram?: Maybe<Scalars['Boolean']>;
  hasWhatsapp?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  makerId: Scalars['Int'];
  markId: Scalars['Int'];
  mileageNum: Scalars['Int'];
  modelGradeEn: Scalars['String'];
  modelTypeEn: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  priceInDestination: Scalars['Float'];
  priceInDestinationCurrencyId: Scalars['Int'];
  transmissionEn: Scalars['String'];
  userDescription?: Maybe<Scalars['String']>;
  vin: Scalars['String'];
  year: Scalars['String'];
};

export type DealerObjectCreateOutput = {
  __typename?: 'DealerObjectCreateOutput';
  error?: Maybe<MutationError>;
};

export type DealerObjectDeleteInput = {
  id: Scalars['Int'];
};

export type DealerObjectDeleteOutput = {
  __typename?: 'DealerObjectDeleteOutput';
  error?: Maybe<MutationError>;
};

export type DealerObjectUpdateInput = {
  colorEn: Scalars['String'];
  dateOfManufacture?: Maybe<Scalars['String']>;
  dealerId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  engineVolumeNum: Scalars['Float'];
  equipmentEn: Scalars['String'];
  hasTelegram?: Maybe<Scalars['Boolean']>;
  hasWhatsapp?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isPublished: Scalars['Boolean'];
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  makerId: Scalars['Int'];
  markId: Scalars['Int'];
  mileageNum: Scalars['Int'];
  modelGradeEn: Scalars['String'];
  modelTypeEn: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  priceInDestination: Scalars['Float'];
  priceInDestinationCurrencyId: Scalars['Int'];
  transmissionEn: Scalars['String'];
  userDescription?: Maybe<Scalars['String']>;
  vin: Scalars['String'];
  year: Scalars['String'];
};

export type DealerObjectUpdateOutput = {
  __typename?: 'DealerObjectUpdateOutput';
  error?: Maybe<MutationError>;
};

export type DeleteObjectInput = {
  objectId: Scalars['Int'];
};

export type DeleteObjectOutput = {
  __typename?: 'DeleteObjectOutput';
  error?: Maybe<MutationError>;
};

export type DeleteUserNotifyMessageInput = {
  channelId: Scalars['Int'];
};

export type DeleteUserNotifyMessageOutput = {
  __typename?: 'DeleteUserNotifyMessageOutput';
  error?: Maybe<MutationError>;
};

export type DeliveryToStockInput = {
  objectId: Scalars['Int'];
  sectorId?: Maybe<Scalars['Int']>;
  stockId: Scalars['Int'];
};

export type DeliveryToStockOutput = {
  __typename?: 'DeliveryToStockOutput';
  error?: Maybe<MutationError>;
};

export type DisallowVisiblePhotoInput = {
  objectId: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
};

export type DisallowVisiblePhotoOutput = {
  __typename?: 'DisallowVisiblePhotoOutput';
  error?: Maybe<MutationError>;
};

export type DisplayBidsCheckInput = {
  agentId: Scalars['Int'];
};

export type DisplayBidsCheckOutput = {
  __typename?: 'DisplayBidsCheckOutput';
  error?: Maybe<MutationError>;
};

export type DonateBuhankaInput = {
  amount: Scalars['Int'];
};

export type DonateBuhankaOutput = {
  __typename?: 'DonateBuhankaOutput';
  error?: Maybe<MutationError>;
};

export type DzenPayAddManagerInput = {
  chatId: Scalars['Int'];
  dzenPayRecordId: Scalars['Int'];
};

export type DzenPayAddManagerOutput = {
  __typename?: 'DzenPayAddManagerOutput';
  chat?: Maybe<ChatForOthers>;
  error?: Maybe<MutationError>;
};

export type DzenPayCancelByClientInput = {
  comment?: Maybe<Scalars['String']>;
  invoiceId: Scalars['Int'];
};

export type DzenPayCancelByClientOutput = {
  __typename?: 'DzenPayCancelByClientOutput';
  error?: Maybe<MutationError>;
};

export type DzenPayGetOrderStatusInput = {
  dzenPayOrderId: Scalars['Int'];
};

export type DzenPayGetOrderStatusOutput = {
  __typename?: 'DzenPayGetOrderStatusOutput';
  error?: Maybe<MutationError>;
  orderStatus?: Maybe<DzenPayOrderStatusApi>;
};

export type DzenPayOrderStatusApi = {
  __typename?: 'DzenPayOrderStatusApi';
  documents?: Maybe<Scalars['JSON']>;
  invoice?: Maybe<Scalars['JSON']>;
  orderUid?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
};

export type DzenPayManagerCreateChatInput = {
  dzenPayOrderId: Scalars['Int'];
  message: Scalars['String'];
};

export type DzenPayManagerCreateChatOutput = {
  __typename?: 'DzenPayManagerCreateChatOutput';
  chat?: Maybe<ChatForOthers>;
  error?: Maybe<MutationError>;
};

export type DzenPayManagerOrderUpdateInput = {
  action: DzenPayManagerActionEnum;
  comment?: Maybe<Scalars['String']>;
  dzenPayOrderId: Scalars['Int'];
};

/** Действие менеджера по заказу DzenPay */
export enum DzenPayManagerActionEnum {
  /** Подтвердить отмену клиента */
  ClientCancellationConfirmed = 'client_cancellation_confirmed',
  /** Платёж принят */
  PaymentAccepted = 'payment_accepted',
  /** Платёж отклонён */
  PaymentRejected = 'payment_rejected'
}

export type DzenPayManagerOrderUpdateOutput = {
  __typename?: 'DzenPayManagerOrderUpdateOutput';
  error?: Maybe<MutationError>;
};

export type DzenPayPartnerManualOrderInput = {
  amountJpy: Scalars['Int'];
  clientCode: Scalars['String'];
  customRate: Scalars['Float'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceType: InvoiceCustomTypeEnum;
  paidAmountRub: Scalars['Int'];
  vin?: Maybe<Scalars['String']>;
};

export type DzenPayPartnerManualOrderOutput = {
  __typename?: 'DzenPayPartnerManualOrderOutput';
  error?: Maybe<MutationError>;
};

export type DzenPayPartnerOrderUpdateInput = {
  action: DzenPayPartnerActionEnum;
  comment?: Maybe<Scalars['String']>;
  dzenPayOrderId: Scalars['Int'];
};

/** Действие DzenPay по заказу */
export enum DzenPayPartnerActionEnum {
  /** Отменить */
  Cancelled = 'cancelled',
  /** Завершить */
  Completed = 'completed'
}

export type DzenPayPartnerOrderUpdateOutput = {
  __typename?: 'DzenPayPartnerOrderUpdateOutput';
  error?: Maybe<MutationError>;
};

export type DzenPayRegenerateDocumentsInput = {
  dzenPayOrderId: Scalars['Int'];
};

export type DzenPayRegenerateDocumentsOutput = {
  __typename?: 'DzenPayRegenerateDocumentsOutput';
  error?: Maybe<MutationError>;
};

export type DzenPayRestoreInput = {
  comment?: Maybe<Scalars['String']>;
  dzenPayOrderId: Scalars['Int'];
};

export type DzenPayRestoreOutput = {
  __typename?: 'DzenPayRestoreOutput';
  error?: Maybe<MutationError>;
};

export type DzenPayRetryFlowInput = {
  dzenPayOrderId: Scalars['Int'];
};

export type DzenPayRetryFlowOutput = {
  __typename?: 'DzenPayRetryFlowOutput';
  error?: Maybe<MutationError>;
};

export type ExchangeJobCloseInput = {
  id: Scalars['Int'];
};

export type ExchangeJobCloseOutput = {
  __typename?: 'ExchangeJobCloseOutput';
  error?: Maybe<MutationError>;
};

export type ExchangeJobSendInput = {
  id: Scalars['Int'];
};

export type ExchangeJobSendOutput = {
  __typename?: 'ExchangeJobSendOutput';
  error?: Maybe<MutationError>;
};

export type ExportDeclarationAddObjectsInput = {
  id: Scalars['Int'];
  objectIds: Array<Scalars['Int']>;
};

export type ExportDeclarationAddObjectsOutput = {
  __typename?: 'ExportDeclarationAddObjectsOutput';
  error?: Maybe<MutationError>;
};

export type ExportDeclarationCreateInput = {
  bookingNo: Scalars['String'];
  objectIds?: Maybe<Array<Scalars['Int']>>;
  registrationDate: Scalars['DateTime'];
  tripId: Scalars['Int'];
};

export type ExportDeclarationCreateOutput = {
  __typename?: 'ExportDeclarationCreateOutput';
  error?: Maybe<MutationError>;
};

export type ExportDeclarationPaidInput = {
  id: Scalars['Int'];
  keyS3File: Scalars['String'];
  paidAt: Scalars['DateTime'];
};

export type ExportDeclarationPaidOutput = {
  __typename?: 'ExportDeclarationPaidOutput';
  error?: Maybe<MutationError>;
};

export type ExportDeclarationRemoveObjectInput = {
  id: Scalars['Int'];
  objectIds: Scalars['Int'];
};

export type ExportDeclarationRemoveObjectOutput = {
  __typename?: 'ExportDeclarationRemoveObjectOutput';
  error?: Maybe<MutationError>;
};

export type ExportDeclarationUpdateInput = {
  bookingNo: Scalars['String'];
  id: Scalars['Int'];
  registrationDate: Scalars['DateTime'];
  tripId: Scalars['Int'];
};

export type ExportDeclarationUpdateOutput = {
  __typename?: 'ExportDeclarationUpdateOutput';
  error?: Maybe<MutationError>;
};

export type ExportToAuctionInput = {
  auctionId: Scalars['Int'];
  driverId?: Maybe<Scalars['Int']>;
  objectId: Scalars['Int'];
};

export type ExportToAuctionOutput = {
  __typename?: 'ExportToAuctionOutput';
  error?: Maybe<MutationError>;
};

export type FileDeleteInput = {
  fileId: Scalars['Int'];
};

export type FileDeleteOutput = {
  __typename?: 'FileDeleteOutput';
  error?: Maybe<MutationError>;
};

export type ForwarderCreateInput = {
  name: Scalars['String'];
};

export type ForwarderCreateOutput = {
  __typename?: 'ForwarderCreateOutput';
  error?: Maybe<MutationError>;
};

export type ForwarderDeleteInput = {
  id: Scalars['Int'];
};

export type ForwarderDeleteOutput = {
  __typename?: 'ForwarderDeleteOutput';
  error?: Maybe<MutationError>;
};

export type ForwarderUpdateInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ForwarderUpdateOutput = {
  __typename?: 'ForwarderUpdateOutput';
  error?: Maybe<MutationError>;
};

export type GetActSvhDeliveryRequestInput = {
  /** ID представителя-водителя ДТ */
  ambassador_id: Scalars['Int'];
  /** Юр. адрес перевозчика */
  carrierAddress: Scalars['String'];
  /** Основание представителя перевозчика */
  carrierBasis?: Maybe<Scalars['String']>;
  /** ФИО представителя перевозчика */
  carrierFio?: Maybe<Scalars['String']>;
  /** Наименование перевозчика */
  carrierName: Scalars['String'];
  /** Доверенность представителя ДТ */
  clientPoa?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type GetActSvhDeliveryRequestOutput = {
  __typename?: 'GetActSvhDeliveryRequestOutput';
  document?: Maybe<Scalars['String']>;
  error?: Maybe<MutationError>;
};

export type GreenCornerInspectionSaveInput = {
  /** Проблемные части кузова */
  bodyParts?: Maybe<Array<GreenCornerBodyPart>>;
  objectId: Scalars['Int'];
  /** Проверено Акебоно / Под восстановление, без значения — обычный объект */
  status?: Maybe<GreenCornerInspectionStatus>;
};

export type GreenCornerInspectionSaveOutput = {
  __typename?: 'GreenCornerInspectionSaveOutput';
  error?: Maybe<MutationError>;
  inspection?: Maybe<GreenCornerInspection>;
};

export type GreenCornerManageObjectUpdateInput = {
  /** Цвет */
  color?: Maybe<Scalars['String']>;
  /** Дата производства */
  dateOfManufacture?: Maybe<Scalars['String']>;
  /** Привод */
  driveType?: Maybe<Scalars['String']>;
  /** Объём двигателя */
  engineVolume?: Maybe<Scalars['String']>;
  /** Комплектация */
  grade?: Maybe<Scalars['String']>;
  /** Пробег */
  mileage?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  /** Трансмиссия */
  transmission?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type GreenCornerManageObjectUpdateOutput = {
  __typename?: 'GreenCornerManageObjectUpdateOutput';
  error?: Maybe<MutationError>;
  lot?: Maybe<Lot>;
};

export type GreenCornerRemoveInput = {
  /** Id объекта */
  objectId: Scalars['Int'];
};

export type GreenCornerRemoveOutput = {
  __typename?: 'GreenCornerRemoveOutput';
  error?: Maybe<MutationError>;
};

export type GreenCornerSetSubscriptionInput = {
  active: Scalars['Boolean'];
};

export type GreenCornerSetSubscriptionOutput = {
  __typename?: 'GreenCornerSetSubscriptionOutput';
  error?: Maybe<MutationError>;
};

export type GreenCornerTgPostCancelScheduleInput = {
  postId: Scalars['Int'];
};

export type GreenCornerTgPostCancelScheduleOutput = {
  __typename?: 'GreenCornerTgPostCancelScheduleOutput';
  error?: Maybe<MutationError>;
  post?: Maybe<GreenCornerTgPost>;
};

export type GreenCornerTgPostCreateInput = {
  /** Собственный текст публикации вместо текста шаблона */
  body?: Maybe<Scalars['String']>;
  carId: Scalars['Int'];
  /** Фото в порядке публикации, по умолчанию — первые по сортировке */
  mediaIds?: Maybe<Array<Scalars['Int']>>;
  /** Шаблон, по умолчанию — шаблон по умолчанию */
  templateId?: Maybe<Scalars['Int']>;
};

export type GreenCornerTgPostCreateOutput = {
  __typename?: 'GreenCornerTgPostCreateOutput';
  error?: Maybe<MutationError>;
  post?: Maybe<GreenCornerTgPost>;
};

export type GreenCornerTgPostDeleteInput = {
  postId: Scalars['Int'];
};

export type GreenCornerTgPostDeleteOutput = {
  __typename?: 'GreenCornerTgPostDeleteOutput';
  error?: Maybe<MutationError>;
};

export type GreenCornerTgPostPublishInput = {
  postId: Scalars['Int'];
  /** Дата и время публикации в ISO 8601, без него — публикуем сразу */
  scheduledAt?: Maybe<Scalars['String']>;
};

export type GreenCornerTgPostPublishOutput = {
  __typename?: 'GreenCornerTgPostPublishOutput';
  error?: Maybe<MutationError>;
  post?: Maybe<GreenCornerTgPost>;
};

export type GreenCornerTgPostUnpublishInput = {
  postId: Scalars['Int'];
};

export type GreenCornerTgPostUnpublishOutput = {
  __typename?: 'GreenCornerTgPostUnpublishOutput';
  error?: Maybe<MutationError>;
  post?: Maybe<GreenCornerTgPost>;
};

export type GreenCornerTgPostUpdateInput = {
  /** Собственный текст публикации, null — текст шаблона */
  body?: Maybe<Scalars['String']>;
  /** Фото в порядке публикации, пустой список — без фото */
  mediaIds?: Maybe<Array<Scalars['Int']>>;
  postId: Scalars['Int'];
  /** Шаблон, null — шаблон по умолчанию */
  templateId?: Maybe<Scalars['Int']>;
};

export type GreenCornerTgPostUpdateOutput = {
  __typename?: 'GreenCornerTgPostUpdateOutput';
  error?: Maybe<MutationError>;
  post?: Maybe<GreenCornerTgPost>;
};

export type GreenCornerTgTemplateCreateInput = {
  body: Scalars['String'];
  /** Сделать шаблоном по умолчанию, первый шаблон становится им автоматически */
  isDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type GreenCornerTgTemplateCreateOutput = {
  __typename?: 'GreenCornerTgTemplateCreateOutput';
  error?: Maybe<MutationError>;
  template?: Maybe<GreenCornerTgTemplate>;
};

export type GreenCornerTgTemplateDeleteInput = {
  id: Scalars['Int'];
};

export type GreenCornerTgTemplateDeleteOutput = {
  __typename?: 'GreenCornerTgTemplateDeleteOutput';
  error?: Maybe<MutationError>;
};

export type GreenCornerTgTemplateSetDefaultInput = {
  id: Scalars['Int'];
};

export type GreenCornerTgTemplateSetDefaultOutput = {
  __typename?: 'GreenCornerTgTemplateSetDefaultOutput';
  error?: Maybe<MutationError>;
  template?: Maybe<GreenCornerTgTemplate>;
};

export type GreenCornerTgTemplateUpdateInput = {
  body?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type GreenCornerTgTemplateUpdateOutput = {
  __typename?: 'GreenCornerTgTemplateUpdateOutput';
  error?: Maybe<MutationError>;
  template?: Maybe<GreenCornerTgTemplate>;
};

export type InvoiceByObjectsGenerateInput = {
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  advance?: Maybe<Scalars['Float']>;
  bankId?: Maybe<Scalars['Int']>;
  currencyId: Scalars['Int'];
  deposit?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  exchangeRateCustomer?: Maybe<Scalars['Float']>;
  fullName: Scalars['String'];
  fullNameRus?: Maybe<Scalars['String']>;
  hideStamp?: Maybe<Scalars['Boolean']>;
  inn?: Maybe<Scalars['String']>;
  logoKeyS3?: Maybe<Scalars['String']>;
  logoState: LogoStateEnum;
  objects: Array<Maybe<ObjectInvoiceItemInput>>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  portName?: Maybe<Scalars['String']>;
  useAdvance?: Maybe<Scalars['Boolean']>;
  useDeposit?: Maybe<Scalars['Boolean']>;
};

export enum LogoStateEnum {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
  Without = 'WITHOUT'
}

export type ObjectInvoiceItemInput = {
  amount: Scalars['Float'];
  complexAmount: Scalars['Float'];
  freight: Scalars['Float'];
  id: Scalars['Int'];
};

export type InvoiceByObjectsGenerateOutput = {
  __typename?: 'InvoiceByObjectsGenerateOutput';
  error?: Maybe<MutationError>;
  invoice?: Maybe<Scalars['String']>;
};

export type InvoiceByObjectsUpdateInput = {
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  exchangeRateCustomer?: Maybe<Scalars['Float']>;
  fullName?: Maybe<Scalars['String']>;
  fullNameRus?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  invoiceId: Scalars['Int'];
  logoKeyS3?: Maybe<Scalars['String']>;
  logoState?: Maybe<LogoStateEnum>;
  objects: Array<Maybe<ObjectInvoiceItemInput>>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type InvoiceByObjectsUpdateOutput = {
  __typename?: 'InvoiceByObjectsUpdateOutput';
  error?: Maybe<MutationError>;
};

export type InvoiceCorrectionGenerateInput = {
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  fullNameRus?: Maybe<Scalars['String']>;
  invoiceId: Scalars['Int'];
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
};

export type InvoiceCorrectionGenerateOutput = {
  __typename?: 'InvoiceCorrectionGenerateOutput';
  error?: Maybe<MutationError>;
  invoice?: Maybe<Scalars['String']>;
};

export type InvoiceCustomGenerateInput = {
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  bankId?: Maybe<Scalars['Int']>;
  currencyId: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  exchangeRateCustomer?: Maybe<Scalars['Float']>;
  fullName: Scalars['String'];
  fullNameRus?: Maybe<Scalars['String']>;
  hideStamp?: Maybe<Scalars['Boolean']>;
  inn?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  purposeMessage?: Maybe<Scalars['String']>;
  type: InvoiceCustomTypeEnum;
};

export type InvoiceCustomGenerateOutput = {
  __typename?: 'InvoiceCustomGenerateOutput';
  error?: Maybe<MutationError>;
  invoice?: Maybe<Scalars['String']>;
};

export type InvoiceCustomUpdateInput = {
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  currencyId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  exchangeRateCustomer?: Maybe<Scalars['Float']>;
  fullName?: Maybe<Scalars['String']>;
  fullNameRus?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  invoiceId: Scalars['Int'];
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type InvoiceCustomUpdateOutput = {
  __typename?: 'InvoiceCustomUpdateOutput';
  error?: Maybe<MutationError>;
};

export type InvoiceOwnRequisitesGenerateInput = {
  address?: Maybe<Scalars['String']>;
  addressRu?: Maybe<Scalars['String']>;
  currencyId: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  fullNameRus?: Maybe<Scalars['String']>;
  hideItemizedPrices?: Maybe<Scalars['Boolean']>;
  inn?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  items: Array<Maybe<OwnRequisitesInvoiceItemInput>>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type OwnRequisitesInvoiceItemInput = {
  amount: Scalars['Float'];
  purpose: Scalars['String'];
};

export type InvoiceOwnRequisitesGenerateOutput = {
  __typename?: 'InvoiceOwnRequisitesGenerateOutput';
  error?: Maybe<MutationError>;
  invoice?: Maybe<Scalars['String']>;
};

export type IssueObjectInput = {
  objectId: Scalars['Int'];
};

export type IssueObjectOutput = {
  __typename?: 'IssueObjectOutput';
  error?: Maybe<MutationError>;
};

export type KaitaiAutoResubmitChangeStateInput = {
  state: KaitaiAutoResubmitStateEnum;
};

export type KaitaiAutoResubmitChangeStateOutput = {
  __typename?: 'KaitaiAutoResubmitChangeStateOutput';
  error?: Maybe<MutationError>;
  state: KaitaiAutoResubmitStateEnum;
};

export type KaitaiQueueStatusChangeInput = {
  state: Scalars['Boolean'];
};

export type KaitaiQueueStatusChangeOutput = {
  __typename?: 'KaitaiQueueStatusChangeOutput';
  error?: Maybe<MutationError>;
  queueStatus?: Maybe<QueueStatus>;
};

export type LogAppEventInput = {
  appEvent: AppEventInput;
  eventName: Scalars['String'];
  parameters?: Maybe<Scalars['JSON']>;
  phone?: Maybe<PhoneInput>;
};

export type AppEventInput = {
  /** Приложение-источник */
  name: AppSourceEnum;
  /** Текущая версия приложения пользователя */
  version?: Maybe<Scalars['String']>;
};

export type PhoneInput = {
  /** Модель устройства */
  model?: Maybe<Scalars['String']>;
  /** Версия ОС */
  os?: Maybe<Scalars['String']>;
};

export type LogAppEventOutput = {
  __typename?: 'LogAppEventOutput';
  error?: Maybe<MutationError>;
};

export type MagadanObjectCreateInput = {
  attachments: Scalars['String'];
  carrierId?: Maybe<Scalars['Int']>;
  chassisTypeId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  countKeys: Scalars['Int'];
  hasSdCard?: Maybe<Scalars['Boolean']>;
  isArrived?: Maybe<Scalars['Boolean']>;
  isBroken?: Maybe<Scalars['Boolean']>;
  isNoneKeys?: Maybe<Scalars['Boolean']>;
  isNotDrivable?: Maybe<Scalars['Boolean']>;
  isRadCheck?: Maybe<Scalars['Boolean']>;
  makerId: Scalars['Int'];
  markId: Scalars['Int'];
  mediaKeysS3?: Maybe<Array<Maybe<Scalars['String']>>>;
  radiation: Scalars['String'];
  sawId?: Maybe<Scalars['Int']>;
  sectorId?: Maybe<Scalars['Int']>;
  senderId: Scalars['Int'];
  vin: Scalars['String'];
};

export type MagadanObjectCreateOutput = {
  __typename?: 'MagadanObjectCreateOutput';
  error?: Maybe<MutationError>;
};

export type MagadanObjectUpdateInput = {
  attachments: Scalars['String'];
  carrierId?: Maybe<Scalars['Int']>;
  chassisTypeId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  countKeys: Scalars['Int'];
  hasSdCard?: Maybe<Scalars['Boolean']>;
  isArrived?: Maybe<Scalars['Boolean']>;
  isBroken?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isNoneKeys?: Maybe<Scalars['Boolean']>;
  isNotDrivable?: Maybe<Scalars['Boolean']>;
  isRadCheck?: Maybe<Scalars['Boolean']>;
  makerId: Scalars['Int'];
  markId: Scalars['Int'];
  mediaKeysS3?: Maybe<Array<Maybe<Scalars['String']>>>;
  objectId: Scalars['Int'];
  radiation: Scalars['String'];
  sawId?: Maybe<Scalars['Int']>;
  sectorId?: Maybe<Scalars['Int']>;
  senderId: Scalars['Int'];
  vin: Scalars['String'];
};

export type MagadanObjectUpdateOutput = {
  __typename?: 'MagadanObjectUpdateOutput';
  error?: Maybe<MutationError>;
};

export type MakerCreateInput = {
  name: Scalars['String'];
};

export type MakerCreateOutput = {
  __typename?: 'MakerCreateOutput';
  error?: Maybe<MutationError>;
};

export type MarkCreateInput = {
  maker: Scalars['Int'];
  name: Scalars['String'];
};

export type MarkCreateOutput = {
  __typename?: 'MarkCreateOutput';
  error?: Maybe<MutationError>;
};

export type MassiveObjectUploadFilesInput = {
  files: Array<MassiveUploadFileItem>;
  mediaType?: Maybe<MediaTypeEnum>;
  nameFilesType?: Maybe<NameFilesTypeEnum>;
  planId?: Maybe<Scalars['Int']>;
  sendNotification?: Maybe<Scalars['Boolean']>;
};

export type MassiveUploadFileItem = {
  keyS3: Scalars['String'];
  originalName: Scalars['String'];
};

export enum NameFilesTypeEnum {
  Contract = 'CONTRACT',
  Vin = 'VIN'
}

export type MassiveObjectUploadFilesOutput = {
  __typename?: 'MassiveObjectUploadFilesOutput';
  error?: Maybe<MutationError>;
  skipped: Array<Scalars['String']>;
};

export type MoveMediaToObjectInput = {
  sourceId: Scalars['Int'];
  targetId: Scalars['Int'];
};

export type MoveMediaToObjectOutput = {
  __typename?: 'MoveMediaToObjectOutput';
  error?: Maybe<MutationError>;
};

export type ObjectAddPriorityPassInput = {
  objectId: Scalars['Int'];
};

export type ObjectAddPriorityPassOutput = {
  __typename?: 'ObjectAddPriorityPassOutput';
  error?: Maybe<MutationError>;
};

export type ObjectAddStatusBookingRequestInput = {
  bookingNumber: Scalars['String'];
  objectId: Scalars['Int'];
};

export type ObjectAddStatusBookingRequestOutput = {
  __typename?: 'ObjectAddStatusBookingRequestOutput';
  error?: Maybe<MutationError>;
};

export type ObjectAddSvhDeliveryRequestInput = {
  /** Пожелания клиента к заказу */
  comment?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  /** Телефон клиента для связи */
  phone?: Maybe<Scalars['String']>;
};

export type ObjectAddSvhDeliveryRequestOutput = {
  __typename?: 'ObjectAddSvhDeliveryRequestOutput';
  error?: Maybe<MutationError>;
};

export type ObjectAddTransportingRequestInput = {
  amount: Scalars['Int'];
  carType: TransportationCarTypeEnum;
  comment?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  transportationDataId: Scalars['Int'];
};

export type ObjectAddTransportingRequestOutput = {
  __typename?: 'ObjectAddTransportingRequestOutput';
  error?: Maybe<MutationError>;
};

export type ObjectAutoResaleInput = {
  amount: Scalars['Int'];
  buyerId: Scalars['Int'];
  comissionAmount: Scalars['Int'];
  freightAmount: Scalars['Int'];
  isSilent: Scalars['Boolean'];
  noChecks?: Maybe<Scalars['Boolean']>;
  objectId: Scalars['Int'];
  sellerFreightAmount?: Maybe<Scalars['Int']>;
};

export type ObjectAutoResaleOutput = {
  __typename?: 'ObjectAutoResaleOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectBookParkingLotInput = {
  id: Scalars['Int'];
};

export type ObjectBookParkingLotOutput = {
  __typename?: 'ObjectBookParkingLotOutput';
  error?: Maybe<MutationError>;
  object?: Maybe<ObjectOfServices>;
};

export type ObjectChangeDestinationCountryInput = {
  countryId: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type ObjectChangeDestinationCountryOutput = {
  __typename?: 'ObjectChangeDestinationCountryOutput';
  error?: Maybe<MutationError>;
};

export type ObjectChangeOwnerInput = {
  newOwnerId: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type ObjectChangeOwnerOutput = {
  __typename?: 'ObjectChangeOwnerOutput';
  error?: Maybe<MutationError>;
};

export type ObjectChangeSawTypeInput = {
  objectId: Scalars['Int'];
  sawTypeId: Scalars['Int'];
};

export type ObjectChangeSawTypeOutput = {
  __typename?: 'ObjectChangeSawTypeOutput';
  error?: Maybe<MutationError>;
};

export type ObjectCheckDebtsInput = {
  objectId: Scalars['Int'];
  organizationGuids?: Maybe<Array<OrganizationGuidEnum>>;
};

export enum OrganizationGuidEnum {
  AkebonoLtdGuid = 'AKEBONO_LTD_GUID',
  AkebonoLtdRGuid = 'AKEBONO_LTD_R_GUID',
  NavisShippingGuid = 'NAVIS_SHIPPING_GUID',
  NavisShippingJscGuid = 'NAVIS_SHIPPING_JSC_GUID',
  PrimbrokerGuid = 'PRIMBROKER_GUID'
}

export type ObjectCheckDebtsOutput = {
  __typename?: 'ObjectCheckDebtsOutput';
  error?: Maybe<MutationError>;
  isFinanceClear?: Maybe<Scalars['Boolean']>;
};

export type ObjectDeleteCustomDocumentsInput = {
  fileId?: Maybe<Scalars['Int']>;
  objectId: Scalars['Int'];
};

export type ObjectDeleteCustomDocumentsOutput = {
  __typename?: 'ObjectDeleteCustomDocumentsOutput';
  error?: Maybe<MutationError>;
};

export type ObjectDeleteMediaInput = {
  imagesList: Array<Scalars['Int']>;
  objectId: Scalars['Int'];
};

export type ObjectDeleteMediaOutput = {
  __typename?: 'ObjectDeleteMediaOutput';
  error?: Maybe<MutationError>;
};

export type ObjectFeedbackCreateInput = {
  evaluation: Scalars['Int'];
  feedback?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
};

export type ObjectFeedbackCreateOutput = {
  __typename?: 'ObjectFeedbackCreateOutput';
  error?: Maybe<MutationError>;
};

export type ObjectCatalogEditInput = {
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Скидка (процент или сумма в йенах) */
  discount?: Maybe<Scalars['Float']>;
  /** Дата окончания скидки (timestamp) */
  discountExpiresAt?: Maybe<Scalars['Int']>;
  /** Тип скидки: percent или amount */
  discountType?: Maybe<DiscountTypeEnum>;
  /** Мощность в лошадиных силах */
  horsepower: Scalars['Int'];
  /** Порядок фотографий */
  mediaOrder?: Maybe<Array<Scalars['String']>>;
  /** Id объекта */
  objectId: Scalars['Int'];
  /** Цена */
  price: Scalars['Int'];
  /** Год для расчёт таможенных платежей */
  yearForCustom: Scalars['Int'];
};

export type ObjectCatalogEditOutput = {
  __typename?: 'ObjectCatalogEditOutput';
  error?: Maybe<MutationError>;
};

export type ObjectGreenCornerTgInput = {
  fewImages?: Maybe<Scalars['Boolean']>;
  objectId: Scalars['Int'];
};

export type ObjectGreenCornerTgOutput = {
  __typename?: 'ObjectGreenCornerTGOutput';
  error?: Maybe<MutationError>;
};

export type ObjectHoldToInput = {
  holdTo: Scalars['String'];
  objectId: Scalars['Int'];
};

export type ObjectHoldToOutput = {
  __typename?: 'ObjectHoldToOutput';
  error?: Maybe<MutationError>;
};

export type ObjectHoldToCloseInput = {
  objectId: Scalars['Int'];
};

export type ObjectHoldToCloseOutput = {
  __typename?: 'ObjectHoldToCloseOutput';
  error?: Maybe<MutationError>;
};

export type ObjectOfServiceRemoveFromContainerInput = {
  containerId: Scalars['Int'];
  objectId: Scalars['Int'];
};

export type ObjectOfServiceRemoveFromContainerOutput = {
  __typename?: 'ObjectOfServiceRemoveFromContainerOutput';
  error?: Maybe<MutationError>;
};

export type ObjectRecipientPaymentEmailInput = {
  objectId: Scalars['Int'];
};

export type ObjectRecipientPaymentEmailOutput = {
  __typename?: 'ObjectRecipientPaymentEmailOutput';
  error?: Maybe<MutationError>;
};

export type ObjectRecycelStatusSetInput = {
  objectId: Scalars['Int'];
  statusId: Scalars['Int'];
};

export type ObjectRecycelStatusSetOutput = {
  __typename?: 'ObjectRecycelStatusSetOutput';
  error?: Maybe<MutationError>;
  object?: Maybe<ObjectOfServices>;
};

export type ObjectRemoveIsGreenCornerInput = {
  objectId: Scalars['Int'];
};

export type ObjectRemoveIsGreenCornerOutput = {
  __typename?: 'ObjectRemoveIsGreenCornerOutput';
  error?: Maybe<MutationError>;
};

export type ObjectRequestToParkingInput = {
  comment?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
};

export type ObjectRequestToParkingOutput = {
  __typename?: 'ObjectRequestToParkingOutput';
  error?: Maybe<MutationError>;
};

export type ObjectRequestToPreparationDocumentsInput = {
  objectId: Scalars['Int'];
};

export type ObjectRequestToPreparationDocumentsOutput = {
  __typename?: 'ObjectRequestToPreparationDocumentsOutput';
  error?: Maybe<MutationError>;
};

export type ObjectResaleApproveInput = {
  resaleId: Scalars['Int'];
};

export type ObjectResaleApproveOutput = {
  __typename?: 'ObjectResaleApproveOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectResaleClientCreateInput = {
  amount: Scalars['Int'];
  buyerEmail: Scalars['String'];
  buyerFullName: Scalars['String'];
  buyerPhone: Scalars['String'];
  currencyId?: Maybe<Scalars['Int']>;
  objectId: Scalars['Int'];
};

export type ObjectResaleClientCreateOutput = {
  __typename?: 'ObjectResaleClientCreateOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectResaleClientUpdateInput = {
  amount: Scalars['Int'];
  currencyId?: Maybe<Scalars['Int']>;
  resaleId: Scalars['Int'];
};

export type ObjectResaleClientUpdateOutput = {
  __typename?: 'ObjectResaleClientUpdateOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectResaleCompleteInput = {
  /** Сумма комиссии за услугу перепродажи */
  comissionAmount: Scalars['Int'];
  /** Сумма фрахта для покупателя */
  freightAmount: Scalars['Int'];
  /** Игнорировать проверки */
  noChecks?: Maybe<Scalars['Boolean']>;
  resaleId: Scalars['Int'];
  /** Сумма фрахта для продавца */
  sellerFreightAmount?: Maybe<Scalars['Int']>;
};

export type ObjectResaleCompleteOutput = {
  __typename?: 'ObjectResaleCompleteOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectResaleDeleteInput = {
  cancelReason?: Maybe<Scalars['String']>;
  resaleId: Scalars['Int'];
};

export type ObjectResaleDeleteOutput = {
  __typename?: 'ObjectResaleDeleteOutput';
  error?: Maybe<MutationError>;
};

export type ObjectResaleInvoiceCreateInput = {
  resaleId: Scalars['Int'];
};

export type ObjectResaleInvoiceCreateOutput = {
  __typename?: 'ObjectResaleInvoiceCreateOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectResaleManagerCreateInput = {
  amount: Scalars['Int'];
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerFullName?: Maybe<Scalars['String']>;
  buyerPhone?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['Int']>;
  /** Игнорировать проверки */
  noChecks?: Maybe<Scalars['Boolean']>;
  objectId: Scalars['Int'];
};

export type ObjectResaleManagerCreateOutput = {
  __typename?: 'ObjectResaleManagerCreateOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectResaleManagerUpdateInput = {
  amount: Scalars['Int'];
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerFullName?: Maybe<Scalars['String']>;
  buyerPhone?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['Int']>;
  resaleId: Scalars['Int'];
};

export type ObjectResaleManagerUpdateOutput = {
  __typename?: 'ObjectResaleManagerUpdateOutput';
  error?: Maybe<MutationError>;
  resale?: Maybe<ObjectResale>;
};

export type ObjectResetInput = {
  objectId: Scalars['Int'];
  reason: Scalars['String'];
};

export type ObjectResetOutput = {
  __typename?: 'ObjectResetOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSendInvoiceEmailInput = {
  guid: Scalars['String'];
  types: Array<Maybe<InvoiceEmailTypeEnum>>;
};

export enum InvoiceEmailTypeEnum {
  Accountant = 'ACCOUNTANT',
  Client = 'CLIENT'
}

export type ObjectSendInvoiceEmailOutput = {
  __typename?: 'ObjectSendInvoiceEmailOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetBookingNumberInput = {
  bookingNumber: Scalars['String'];
  objectId: Scalars['Int'];
};

export type ObjectSetBookingNumberOutput = {
  __typename?: 'ObjectSetBookingNumberOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetDateDismantleForCubeInput = {
  date: Scalars['String'];
  objectId: Scalars['Int'];
};

export type ObjectSetDateDismantleForCubeOutput = {
  __typename?: 'ObjectSetDateDismantleForCubeOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetDateRecyclingToCubeInput = {
  date: Scalars['String'];
  objectId: Scalars['Int'];
};

export type ObjectSetDateRecyclingToCubeOutput = {
  __typename?: 'ObjectSetDateRecyclingToCubeOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetDateSoldRecyclingCubeInput = {
  date: Scalars['String'];
  objectId: Scalars['Int'];
};

export type ObjectSetDateSoldRecyclingCubeOutput = {
  __typename?: 'ObjectSetDateSoldRecyclingCubeOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetGuidFrom1cInput = {
  objectId: Scalars['Int'];
};

export type ObjectSetGuidFrom1cOutput = {
  __typename?: 'ObjectSetGuidFrom1cOutput';
  error?: Maybe<MutationError>;
};

export type AkebonoObjectSetIndependentFreightPaymentInput = {
  isIndependentFreightPayment: Scalars['Boolean'];
  objectId: Scalars['Int'];
};

export type AkebonoObjectSetIndependentFreightPaymentOutput = {
  __typename?: 'AkebonoObjectSetIndependentFreightPaymentOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetIsGeneralBasisAdvanceInput = {
  objectId: Scalars['Int'];
};

export type ObjectSetIsGeneralBasisAdvanceOutput = {
  __typename?: 'ObjectSetIsGeneralBasisAdvanceOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetIsGreenCornerInput = {
  objectId: Scalars['Int'];
};

export type ObjectSetIsGreenCornerOutput = {
  __typename?: 'ObjectSetIsGreenCornerOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetKaitaiPriceInput = {
  objectId: Scalars['Int'];
  price: Scalars['Int'];
};

export type ObjectSetKaitaiPriceOutput = {
  __typename?: 'ObjectSetKaitaiPriceOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetMasterAccountClientInput = {
  clientId: Scalars['DateTime'];
  objectId: Scalars['Int'];
};

export type ObjectSetMasterAccountClientOutput = {
  __typename?: 'ObjectSetMasterAccountClientOutput';
  error?: Maybe<MutationError>;
};

export type ObjectSetSoldDateInput = {
  objectId: Scalars['Int'];
  soldDate: Scalars['DateTime'];
};

export type ObjectSetSoldDateOutput = {
  __typename?: 'ObjectSetSoldDateOutput';
  error?: Maybe<MutationError>;
};

export type ObjectToggleHideInput = {
  id: Scalars['Int'];
};

export type ObjectToggleHideOutput = {
  __typename?: 'ObjectToggleHideOutput';
  error?: Maybe<MutationError>;
};

export type ObjectToggleRemoveInput = {
  id: Scalars['Int'];
};

export type ObjectToggleRemoveOutput = {
  __typename?: 'ObjectToggleRemoveOutput';
  error?: Maybe<MutationError>;
};

export type ObjectUploadCustomDocumentsInput = {
  /** Файл подписанный договор ПБ клиентом */
  agreementKeyS3File?: Maybe<Array<Scalars['String']>>;
  boardingPassesKeyS3Files?: Maybe<Array<Scalars['String']>>;
  /** Файл справка из гостиницы с чеком об оплате */
  certificateFromHotelKeyS3Files?: Maybe<Array<Scalars['String']>>;
  /** Флаг требуется явка в таможню */
  comeToCustoms?: Maybe<Scalars['Boolean']>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']>;
  /** Файл объяснительной */
  explanatoryKeyS3File?: Maybe<Array<Scalars['String']>>;
  /** Файл объяснительная (не ДВФО) */
  explanatoryNoDVFOKeyS3File?: Maybe<Array<Scalars['String']>>;
  /** Файл Скриншот профиля в Госуслугах */
  gosuslugiProfileScreenS3File?: Maybe<Scalars['String']>;
  /** Файл ИНН pdf */
  innKeyS3File?: Maybe<Scalars['String']>;
  /** Дата создания инвойса */
  invoiceCreateDate?: Maybe<Scalars['String']>;
  /** Дата оплаты инвойса */
  invoiceDate?: Maybe<Scalars['String']>;
  /** Файл инвойс оплаты */
  invoiceKeyS3Files?: Maybe<Array<Scalars['String']>>;
  /** Номер инвойса */
  invoiceNumber?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  /** Файл паспорт PDF */
  passportKeyS3Files?: Maybe<Array<Scalars['String']>>;
  /** Файл квитанция об оплате покупки */
  receiptKeyS3File?: Maybe<Array<Scalars['String']>>;
  /** Файл подтверждение поступления денежных средств на счет ФТС */
  receiptOfMoneyToFtsS3File?: Maybe<Scalars['String']>;
  /** Файл временной регистрации */
  tempRegistrationKeyS3File?: Maybe<Scalars['String']>;
  /** Файл проверки свидетельства о регистрации на действительность */
  validationTempRegistrationS3File?: Maybe<Scalars['String']>;
};

export type ObjectUploadCustomDocumentsOutput = {
  __typename?: 'ObjectUploadCustomDocumentsOutput';
  error?: Maybe<MutationError>;
};

export type ObjectUploadCustomPaymentInput = {
  keyS3Files: Array<Maybe<Scalars['String']>>;
  objectId: Scalars['Int'];
};

export type ObjectUploadCustomPaymentOutput = {
  __typename?: 'ObjectUploadCustomPaymentOutput';
  error?: Maybe<MutationError>;
};

export type ObjectUploadFilesInput = {
  isFile: Scalars['Boolean'];
  keyS3Files: Array<Scalars['String']>;
  mediaType: MediaTypeEnum;
  objectId: Scalars['Int'];
};

export type ObjectUploadFilesOutput = {
  __typename?: 'ObjectUploadFilesOutput';
  error?: Maybe<MutationError>;
};

export type ObjectUploadFilesToPlanInput = {
  keyS3Files: Array<Scalars['String']>;
  mediaType: MediaTypeEnum;
  planId: Scalars['Int'];
};

export type ObjectUploadFilesToPlanOutput = {
  __typename?: 'ObjectUploadFilesToPlanOutput';
  error?: Maybe<MutationError>;
  processed: Scalars['Int'];
  skipped: Array<Scalars['Int']>;
};

export type GetAgentsByParamsInput = {
  email?: Maybe<Scalars['String']>;
  fio: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type GetAgentsByParamsOutput = {
  __typename?: 'GetAgentsByParamsOutput';
  agents?: Maybe<Array<OwnerWithAgreements>>;
  error?: Maybe<MutationError>;
};

export type OwnerWithAgreements = {
  __typename?: 'OwnerWithAgreements';
  agent?: Maybe<Owner>;
  agreementsList?: Maybe<Array<OwnerAgreement>>;
  guidClient?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OwnerAgreement = {
  __typename?: 'OwnerAgreement';
  nameAgreement?: Maybe<Scalars['String']>;
  nameCurrency?: Maybe<Scalars['String']>;
  nameOrganization?: Maybe<Scalars['String']>;
  sumActive?: Maybe<Scalars['Float']>;
  sumBalance?: Maybe<Scalars['Float']>;
  sumPassive?: Maybe<Scalars['Float']>;
};

export type P2pAdminBuyRequestBlockInput = {
  /** true — заблокировать, false — разблокировать */
  blocked: Scalars['Boolean'];
  /** ID заявки на покупку */
  buyRequestId: Scalars['Int'];
  /** Причина блокировки или комментарий к разблокировке, уходит покупателю */
  reason: Scalars['String'];
};

export type P2pAdminBuyRequestBlockOutput = {
  __typename?: 'P2pAdminBuyRequestBlockOutput';
  buyRequestId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminBuyRequestCancelInput = {
  /** ID заявки на покупку */
  buyRequestId: Scalars['Int'];
  /** Причина отмены, уходит покупателю */
  reason: Scalars['String'];
};

export type P2pAdminBuyRequestCancelOutput = {
  __typename?: 'P2pAdminBuyRequestCancelOutput';
  buyRequestId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminDealBlockInput = {
  /** true — заблокировать, false — разблокировать */
  blocked: Scalars['Boolean'];
  /** ID сделки */
  dealId: Scalars['Int'];
  /** Причина блокировки или комментарий к разблокировке, уходит обоим участникам */
  reason: Scalars['String'];
};

export type P2pAdminDealBlockOutput = {
  __typename?: 'P2pAdminDealBlockOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminDealCancelInput = {
  /** ID сделки */
  dealId: Scalars['Int'];
  /** Причина отмены, уходит обоим участникам */
  reason: Scalars['String'];
};

export type P2pAdminDealCancelOutput = {
  __typename?: 'P2pAdminDealCancelOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pAdminDealCompleteInput = {
  /** ID сделки */
  dealId: Scalars['Int'];
  /** Основание завершения, уходит обоим участникам */
  reason: Scalars['String'];
};

export type P2pAdminDealCompleteOutput = {
  __typename?: 'P2pAdminDealCompleteOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminDealSetStatusInput = {
  /** ID сделки */
  dealId: Scalars['Int'];
  /** Причина смены статуса, пишется в историю */
  reason: Scalars['String'];
  /** Новый статус из P2pDealStatusEnum */
  status: Scalars['String'];
};

export type P2pAdminDealSetStatusOutput = {
  __typename?: 'P2pAdminDealSetStatusOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminOfferApproveInput = {
  /** Необязательный комментарий продавцу */
  comment?: Maybe<Scalars['String']>;
  /** ID предложения на модерации */
  offerId: Scalars['Int'];
};

export type P2pAdminOfferApproveOutput = {
  __typename?: 'P2pAdminOfferApproveOutput';
  error?: Maybe<MutationError>;
  offerId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminOfferBlockInput = {
  /** true — заблокировать, false — разблокировать */
  blocked: Scalars['Boolean'];
  /** ID предложения */
  offerId: Scalars['Int'];
  /** Причина блокировки или комментарий к разблокировке, уходит продавцу */
  reason: Scalars['String'];
};

export type P2pAdminOfferBlockOutput = {
  __typename?: 'P2pAdminOfferBlockOutput';
  error?: Maybe<MutationError>;
  offerId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminOfferCancelInput = {
  /** ID предложения */
  offerId: Scalars['Int'];
  /** Причина снятия, уходит продавцу */
  reason: Scalars['String'];
};

export type P2pAdminOfferCancelOutput = {
  __typename?: 'P2pAdminOfferCancelOutput';
  error?: Maybe<MutationError>;
  offerId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pAdminOfferRejectInput = {
  /** ID предложения на модерации */
  offerId: Scalars['Int'];
  /** Причина отклонения, уходит продавцу */
  reason: Scalars['String'];
};

export type P2pAdminOfferRejectOutput = {
  __typename?: 'P2pAdminOfferRejectOutput';
  error?: Maybe<MutationError>;
  offerId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type P2pBuyRequestCancelInput = {
  /** ID заявки на покупку */
  buyRequestId: Scalars['Int'];
};

export type P2pBuyRequestCancelOutput = {
  __typename?: 'P2pBuyRequestCancelOutput';
  buyRequestId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pBuyRequestCreateInput = {
  /** Желаемая сумма покупки, JPY */
  amount: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  /** Кто платит комиссию: seller, buyer или split. По умолчанию seller */
  commissionPayer?: Maybe<Scalars['String']>;
  /** Срок действия заявки, дата строкой: 2026-08-01 */
  expiresAt?: Maybe<Scalars['String']>;
  /** Минимальная сумма одной продажи по заявке, JPY. По умолчанию — общий минимум */
  minDealAmount?: Maybe<Scalars['Int']>;
  /** ID сохранённых реквизитов */
  paymentDetailId?: Maybe<Scalars['Int']>;
  /** Желаемый курс (за 1 JPY) */
  rate: Scalars['Float'];
};

export type P2pBuyRequestCreateOutput = {
  __typename?: 'P2pBuyRequestCreateOutput';
  buyRequestId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pBuyRequestUpdateInput = {
  /** Новая сумма заявки, JPY */
  amount?: Maybe<Scalars['Int']>;
  /** ID заявки на покупку */
  buyRequestId: Scalars['Int'];
  /** Новый курс */
  rate?: Maybe<Scalars['Float']>;
};

export type P2pBuyRequestUpdateOutput = {
  __typename?: 'P2pBuyRequestUpdateOutput';
  buyRequestId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pDealCancelInput = {
  /** ID сделки */
  dealId: Scalars['Int'];
  /** Причина отмены */
  reason?: Maybe<Scalars['String']>;
};

export type P2pDealCancelOutput = {
  __typename?: 'P2pDealCancelOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pDealConfirmInput = {
  /** ID сделки */
  dealId: Scalars['Int'];
  /** Код подтверждения из письма продавца */
  otp: Scalars['String'];
};

export type P2pDealConfirmOutput = {
  __typename?: 'P2pDealConfirmOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pDealConfirmOtpSendInput = {
  /** ID сделки */
  dealId: Scalars['Int'];
};

export type P2pDealConfirmOtpSendOutput = {
  __typename?: 'P2pDealConfirmOtpSendOutput';
  error?: Maybe<MutationError>;
  expiresAt?: Maybe<Scalars['DateTime']>;
};

export type P2pDealCreateFromBuyRequestInput = {
  /** Сумма продажи, JPY */
  amount: Scalars['Int'];
  /** ID заявки на покупку */
  buyRequestId: Scalars['Int'];
  /** Комментарий к сделке */
  comment?: Maybe<Scalars['String']>;
  /** GUID договора-источника в 1С */
  sourceAgreementGuid?: Maybe<Scalars['String']>;
};

export type P2pDealCreateFromBuyRequestOutput = {
  __typename?: 'P2pDealCreateFromBuyRequestOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pDealCreateFromOfferInput = {
  /** Сумма покупки, JPY */
  amount: Scalars['Int'];
  /** Комментарий к сделке */
  comment?: Maybe<Scalars['String']>;
  /** ID предложения на продажу */
  offerId: Scalars['Int'];
};

export type P2pDealCreateFromOfferOutput = {
  __typename?: 'P2pDealCreateFromOfferOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pDealDeclarePaymentInput = {
  /** ID сделки */
  dealId: Scalars['Int'];
};

export type P2pDealDeclarePaymentOutput = {
  __typename?: 'P2pDealDeclarePaymentOutput';
  dealId?: Maybe<Scalars['Int']>;
  error?: Maybe<MutationError>;
};

export type P2pOfferCancelRemainderInput = {
  /** ID предложения */
  offerId: Scalars['Int'];
};

export type P2pOfferCancelRemainderOutput = {
  __typename?: 'P2pOfferCancelRemainderOutput';
  error?: Maybe<MutationError>;
  offerId?: Maybe<Scalars['Int']>;
};

export type P2pOfferCreateInput = {
  /** Сумма продажи, JPY */
  amount: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  /** Кто платит комиссию: seller, buyer или split. По умолчанию seller */
  commissionPayer?: Maybe<Scalars['String']>;
  /** Срок действия предложения, дата строкой: 2026-08-01 */
  expiresAt?: Maybe<Scalars['String']>;
  /** Максимальная сумма одной сделки, JPY. По умолчанию — вся сумма предложения */
  maxDealAmount?: Maybe<Scalars['Int']>;
  /** Минимальная сумма одной сделки, JPY */
  minDealAmount: Scalars['Int'];
  /** ID сохранённых реквизитов продавца */
  paymentDetailId?: Maybe<Scalars['Int']>;
  /** Курс продажи (за 1 JPY) */
  rate: Scalars['Float'];
  /** GUID договора-источника в 1С */
  sourceAgreementGuid?: Maybe<Scalars['String']>;
};

export type P2pOfferCreateOutput = {
  __typename?: 'P2pOfferCreateOutput';
  error?: Maybe<MutationError>;
  offerId?: Maybe<Scalars['Int']>;
};

export type P2pOfferUpdateInput = {
  /** Сумма пополнения (прибавляется к текущей), JPY */
  amount?: Maybe<Scalars['Int']>;
  /** ID предложения на продажу */
  offerId: Scalars['Int'];
  /** Новый курс (за 1 JPY) */
  rate?: Maybe<Scalars['Float']>;
};

export type P2pOfferUpdateOutput = {
  __typename?: 'P2pOfferUpdateOutput';
  error?: Maybe<MutationError>;
  offerId?: Maybe<Scalars['Int']>;
};

export type P2pPaymentDetailSaveInput = {
  bankName?: Maybe<Scalars['String']>;
  /** sbp, tinkoff или bank */
  method: Scalars['String'];
  phone: Scalars['String'];
};

export type P2pPaymentDetailSaveOutput = {
  __typename?: 'P2pPaymentDetailSaveOutput';
  error?: Maybe<MutationError>;
  id?: Maybe<Scalars['Int']>;
};

export type P2pReviewAddInput = {
  comment?: Maybe<Scalars['String']>;
  /** ID завершённой сделки */
  dealId: Scalars['Int'];
  /** Оценка контрагента от 1 до 5 */
  rating: Scalars['Int'];
};

export type P2pReviewAddOutput = {
  __typename?: 'P2pReviewAddOutput';
  error?: Maybe<MutationError>;
  reviewId?: Maybe<Scalars['Int']>;
};

export type PalletAddWheelInput = {
  objectsId: Array<Maybe<Scalars['Int']>>;
  palletNumber: Scalars['String'];
};

export type PalletAddWheelOutput = {
  __typename?: 'PalletAddWheelOutput';
  error?: Maybe<MutationError>;
};

export type PalletCreateInput = {
  name?: Maybe<Scalars['String']>;
};

export type PalletCreateOutput = {
  __typename?: 'PalletCreateOutput';
  error?: Maybe<MutationError>;
};

export type PalletToPlanInput = {
  palletNumber: Scalars['String'];
  tripId: Scalars['Int'];
};

export type PalletToPlanOutput = {
  __typename?: 'PalletToPlanOutput';
  error?: Maybe<MutationError>;
};

export type PalletToPortInput = {
  palletNumber: Scalars['String'];
};

export type PalletToPortOutput = {
  __typename?: 'PalletToPortOutput';
  error?: Maybe<MutationError>;
  failedObjects?: Maybe<Array<ObjectOfServices>>;
};

export type PartnerInfoAccreditInput = {
  /** id партнера */
  agentId: Scalars['Int'];
  /** Position for ordering */
  position?: Maybe<Scalars['Int']>;
  /** Show on homepage flag */
  showOnHomepage?: Maybe<Scalars['Boolean']>;
  /** Partner status */
  status?: Maybe<PartnerStatusEnum>;
  /** Вип статус */
  vip?: Maybe<Scalars['Boolean']>;
};

export type PartnerInfoAccreditOutput = {
  __typename?: 'PartnerInfoAccreditOutput';
  error?: Maybe<MutationError>;
};

export type PartnerInfoUpdateInput = {
  /** Адрес офиса */
  address?: Maybe<Scalars['String']>;
  /** Контактные данные */
  contacts?: Maybe<Array<ContactInput>>;
  /** Год основания самого дилера */
  dateFoundationPartner?: Maybe<Scalars['String']>;
  /** Типы доставок */
  deliveryTypes?: Maybe<Array<DeliveryTypeEnum>>;
  /** Описание кратко, для карточки */
  description?: Maybe<Scalars['String']>;
  /** Скрытие контактов дилера в трекинге */
  hideContacts?: Maybe<Scalars['Boolean']>;
  /** Геопозиция широта */
  latitude?: Maybe<Scalars['Float']>;
  /** Логотип в S3 */
  logoS3?: Maybe<Scalars['String']>;
  /** Геопозиция долгота */
  longitude?: Maybe<Scalars['Float']>;
  /** Фото офиса в S3 */
  officeImage?: Maybe<Array<Scalars['String']>>;
  /** Способы оплат */
  paymentTypes?: Maybe<Array<PaymentTypeEnum>>;
  /** Название для отображения */
  title?: Maybe<Scalars['String']>;
  /** Ссылки на подробную информацию */
  urlsDetailedData?: Maybe<Array<Scalars['String']>>;
  /** Часы работы */
  workTime?: Maybe<Array<WorkTimeInput>>;
};

export type ContactInput = {
  /** Тип контакта */
  type?: Maybe<ContactTypeEnum>;
  /** Значение контакта */
  value?: Maybe<Scalars['String']>;
};

export type WorkTimeInput = {
  /** Конец рабочего дня */
  end?: Maybe<Scalars['DateTime']>;
  /** Начало рабочего дня */
  start?: Maybe<Scalars['DateTime']>;
};

export type PartnerInfoUpdateOutput = {
  __typename?: 'PartnerInfoUpdateOutput';
  error?: Maybe<MutationError>;
};

export type PaymentAgentAdminSettingsUpdateInput = {
  accessAuto: Scalars['Boolean'];
  accessP2p: Scalars['Boolean'];
  accessShop: Scalars['Boolean'];
  adminDisabled: Scalars['Boolean'];
  canConfigureExchangeRate: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  disabledForClients: Scalars['Boolean'];
  exchangeRate?: Maybe<Scalars['Float']>;
  generateOwnRequisitesInvoice: Scalars['Boolean'];
  hideAdditionalRates: Scalars['Boolean'];
  hideChats?: Maybe<Scalars['Boolean']>;
  paymentAgentId: Scalars['Int'];
};

export type PaymentAgentAdminSettingsUpdateOutput = {
  __typename?: 'PaymentAgentAdminSettingsUpdateOutput';
  error?: Maybe<MutationError>;
};

export type PaymentAgentCreateInput = {
  accessAuto?: Maybe<Scalars['Boolean']>;
  accessP2p?: Maybe<Scalars['Boolean']>;
  accessShop?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  adminDisabled?: Maybe<Scalars['Boolean']>;
  agreementDate?: Maybe<Scalars['String']>;
  agreementNumber?: Maybe<Scalars['String']>;
  alertLimit?: Maybe<Scalars['Int']>;
  allocationReportTemplateKeyS3?: Maybe<Scalars['String']>;
  allowedInvoiceTypes?: Maybe<Array<Maybe<InvoiceCustomTypeEnum>>>;
  balanceLimit?: Maybe<Scalars['Int']>;
  bankName?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  canConfigureExchangeRate?: Maybe<Scalars['Boolean']>;
  clientInvoiceRouting?: Maybe<Array<Maybe<ClientInvoiceRoutingInput>>>;
  color?: Maybe<Scalars['String']>;
  correspAcc?: Maybe<Scalars['String']>;
  depositLimit?: Maybe<Scalars['Int']>;
  disabledForClients?: Maybe<Scalars['Boolean']>;
  documentTemplateKeyS3?: Maybe<Scalars['String']>;
  exchangeRateFormulaConfig?: Maybe<Scalars['JSON']>;
  fileExpireTtl?: Maybe<Scalars['Int']>;
  generateOwnRequisitesInvoice?: Maybe<Scalars['Boolean']>;
  globalInvoiceRouting?: Maybe<Array<Maybe<InvoiceRoutingInput>>>;
  hideAdditionalRates?: Maybe<Scalars['Boolean']>;
  hideChats?: Maybe<Scalars['Boolean']>;
  iban?: Maybe<Scalars['String']>;
  ibanUsd?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  innerExchangeRateCashDiff?: Maybe<Scalars['Float']>;
  innerExchangeRateDiff?: Maybe<Scalars['Float']>;
  innerName?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  kpp?: Maybe<Scalars['String']>;
  linkedBalanceAgentId?: Maybe<Scalars['Int']>;
  linkedBalanceWeeklyLimit?: Maybe<Scalars['Int']>;
  maxExchangeRatePercentUp?: Maybe<Scalars['Int']>;
  minAmountToCreateOrder?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  paymentAgentId: Scalars['Int'];
  personalAcc?: Maybe<Scalars['String']>;
  personalBank?: Maybe<Scalars['String']>;
  personalName?: Maybe<Scalars['String']>;
  personalNameEng?: Maybe<Scalars['String']>;
  purposeTemplate?: Maybe<Scalars['JSON']>;
  schedule?: Maybe<Scalars['JSON']>;
  swift?: Maybe<Scalars['String']>;
  visibleUserIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type ClientInvoiceRoutingInput = {
  invoiceType: InvoiceCustomTypeEnum;
  /** BrAgent Id */
  ownerId: Scalars['Int'];
  /** BrInvoiceBank Id */
  targetBankId?: Maybe<Scalars['Int']>;
};

export type InvoiceRoutingInput = {
  invoiceType: InvoiceCustomTypeEnum;
  /** BrInvoiceBank Id */
  targetBankId?: Maybe<Scalars['Int']>;
};

export type PaymentAgentCreateOutput = {
  __typename?: 'PaymentAgentCreateOutput';
  error?: Maybe<MutationError>;
  id?: Maybe<Scalars['Int']>;
};

export type PaymentAgentSetIsActiveInput = {
  isActive: Scalars['Boolean'];
  paymentAgentId: Scalars['Int'];
};

export type PaymentAgentSetIsActiveOutput = {
  __typename?: 'PaymentAgentSetIsActiveOutput';
  error?: Maybe<MutationError>;
};

export type PaymentAgentSettingsUpdateInput = {
  disabled: Scalars['Boolean'];
  exchangeRate?: Maybe<Scalars['Float']>;
};

export type PaymentAgentSettingsUpdateOutput = {
  __typename?: 'PaymentAgentSettingsUpdateOutput';
  error?: Maybe<MutationError>;
};

export type PaymentAgentUpdateInput = {
  accessAuto?: Maybe<Scalars['Boolean']>;
  accessP2p?: Maybe<Scalars['Boolean']>;
  accessShop?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  adminDisabled?: Maybe<Scalars['Boolean']>;
  agreementDate?: Maybe<Scalars['String']>;
  agreementNumber?: Maybe<Scalars['String']>;
  alertLimit?: Maybe<Scalars['Int']>;
  allocationReportTemplateKeyS3?: Maybe<Scalars['String']>;
  allowedInvoiceTypes?: Maybe<Array<Maybe<InvoiceCustomTypeEnum>>>;
  balanceLimit?: Maybe<Scalars['Int']>;
  bankName?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  canConfigureExchangeRate?: Maybe<Scalars['Boolean']>;
  clientInvoiceRouting?: Maybe<Array<Maybe<ClientInvoiceRoutingInput>>>;
  color?: Maybe<Scalars['String']>;
  correspAcc?: Maybe<Scalars['String']>;
  depositLimit?: Maybe<Scalars['Int']>;
  disabledForClients?: Maybe<Scalars['Boolean']>;
  documentTemplateKeyS3?: Maybe<Scalars['String']>;
  exchangeRateFormulaConfig?: Maybe<Scalars['JSON']>;
  fileExpireTtl?: Maybe<Scalars['Int']>;
  generateOwnRequisitesInvoice?: Maybe<Scalars['Boolean']>;
  globalInvoiceRouting?: Maybe<Array<Maybe<InvoiceRoutingInput>>>;
  hideAdditionalRates?: Maybe<Scalars['Boolean']>;
  hideChats?: Maybe<Scalars['Boolean']>;
  iban?: Maybe<Scalars['String']>;
  ibanUsd?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  innerExchangeRateCashDiff?: Maybe<Scalars['Float']>;
  innerExchangeRateDiff?: Maybe<Scalars['Float']>;
  innerName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  kpp?: Maybe<Scalars['String']>;
  linkedBalanceAgentId?: Maybe<Scalars['Int']>;
  linkedBalanceWeeklyLimit?: Maybe<Scalars['Int']>;
  maxExchangeRatePercentUp?: Maybe<Scalars['Int']>;
  minAmountToCreateOrder?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notificationEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  notifyDailyPassengerDeclaration?: Maybe<Scalars['Boolean']>;
  notifyDailyPayments?: Maybe<Scalars['Boolean']>;
  notifyDocumentPack?: Maybe<Scalars['Boolean']>;
  notifyPaymentAccepted?: Maybe<Scalars['Boolean']>;
  paymentAgentId: Scalars['Int'];
  personalAcc?: Maybe<Scalars['String']>;
  personalBank?: Maybe<Scalars['String']>;
  personalName?: Maybe<Scalars['String']>;
  personalNameEng?: Maybe<Scalars['String']>;
  purposeTemplate?: Maybe<Scalars['JSON']>;
  schedule?: Maybe<Scalars['JSON']>;
  swift?: Maybe<Scalars['String']>;
  visibleUserIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PaymentAgentUpdateOutput = {
  __typename?: 'PaymentAgentUpdateOutput';
  error?: Maybe<MutationError>;
};

export type PbAgreementSendedInput = {
  objectId: Scalars['String'];
};

export type PbAgreementSendedOutput = {
  __typename?: 'PbAgreementSendedOutput';
  error?: Maybe<MutationError>;
};

export type PickupAppointmentInput = {
  comment?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  plannedAt: Scalars['String'];
};

export type PickupAppointmentOutput = {
  __typename?: 'PickupAppointmentOutput';
  error?: Maybe<MutationError>;
};

export type PlanOnVesselTypeInput = {
  objectId: Scalars['Int'];
  vesselTypeId: Scalars['Int'];
};

export type PlanOnVesselTypeOutput = {
  __typename?: 'PlanOnVesselTypeOutput';
  error?: Maybe<MutationError>;
};

export type PortCreateInput = {
  countryId: Scalars['Int'];
  name: Scalars['String'];
};

export type PortCreateOutput = {
  __typename?: 'PortCreateOutput';
  error?: Maybe<MutationError>;
};

export type PreSignedPostCreateInput = {
  bucketType?: Maybe<BucketTypeEnum>;
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  increaseUploadSize?: Maybe<Scalars['Boolean']>;
  logicFileType?: Maybe<LogicFileTypeEnum>;
};

export enum BucketTypeEnum {
  File = 'FILE',
  Image = 'IMAGE',
  Junk = 'JUNK',
  Video = 'VIDEO'
}

export enum LogicFileTypeEnum {
  FeedbackAttachment = 'FEEDBACK_ATTACHMENT'
}

export type PreSignedPostCreateOutput = {
  __typename?: 'PreSignedPostCreateOutput';
  error?: Maybe<MutationError>;
  fields?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PutUpForSaleCreateInput = {
  objectId: Scalars['Int'];
  price: Scalars['Int'];
};

export type PutUpForSaleCreateOutput = {
  __typename?: 'PutUpForSaleCreateOutput';
  error?: Maybe<MutationError>;
};

export type PutUpForSaleSoldOutInput = {
  objectId: Scalars['Int'];
};

export type PutUpForSaleSoldOutOutput = {
  __typename?: 'PutUpForSaleSoldOutOutput';
  error?: Maybe<MutationError>;
};

export type PutUpForSaleUpdateInput = {
  objectId: Scalars['Int'];
  price: Scalars['Int'];
};

export type PutUpForSaleUpdateOutput = {
  __typename?: 'PutUpForSaleUpdateOutput';
  error?: Maybe<MutationError>;
};

export type PutUpForSaleWithdrawInput = {
  objectId: Scalars['Int'];
};

export type PutUpForSaleWithdrawOutput = {
  __typename?: 'PutUpForSaleWithdrawOutput';
  error?: Maybe<MutationError>;
};

export type ReminderRemoveInput = {
  id: Scalars['Int'];
};

export type ReminderRemoveOutput = {
  __typename?: 'ReminderRemoveOutput';
  error?: Maybe<MutationError>;
};

export type RemoveFromStockInput = {
  objectId: Scalars['Int'];
  reason: Scalars['String'];
};

export type RemoveFromStockOutput = {
  __typename?: 'RemoveFromStockOutput';
  error?: Maybe<MutationError>;
};

export type RemoveObjectFromPlanInput = {
  objectId: Scalars['Int'];
  reasonId: Scalars['Int'];
};

export type RemoveObjectFromPlanOutput = {
  __typename?: 'RemoveObjectFromPlanOutput';
  error?: Maybe<MutationError>;
};

export type RenewExportCertificateInput = {
  exportCertificateId: Scalars['Int'];
  scheduledDate: Scalars['String'];
};

export type RenewExportCertificateOutput = {
  __typename?: 'RenewExportCertificateOutput';
  error?: Maybe<MutationError>;
};

export type ReplaceDoubleInput = {
  doubleId: Scalars['Int'];
  originalId: Scalars['Int'];
};

export type ReplaceDoubleOutput = {
  __typename?: 'ReplaceDoubleOutput';
  error?: Maybe<MutationError>;
};

export type ReplaceToStockInput = {
  objectId: Scalars['Int'];
  sectorId?: Maybe<Scalars['Int']>;
  stockId: Scalars['Int'];
};

export type ReplaceToStockOutput = {
  __typename?: 'ReplaceToStockOutput';
  error?: Maybe<MutationError>;
};

export type ReportCreateInput = {
  /** Отчёт по логам на указанную дату (Y-m-d) */
  byDate?: Maybe<Scalars['String']>;
  /** Список ID */
  ids?: Maybe<Array<Scalars['Int']>>;
  /** Файл для обработки */
  keyS3File?: Maybe<Scalars['String']>;
  /** Тип отчёта */
  typeId: Scalars['Int'];
};

export type ReportCreateOutput = {
  __typename?: 'ReportCreateOutput';
  error?: Maybe<MutationError>;
  report?: Maybe<Report>;
};

export type ReportDeleteInput = {
  /** ID отчёта */
  reportId: Scalars['Int'];
};

export type ReportDeleteOutput = {
  __typename?: 'ReportDeleteOutput';
  error?: Maybe<MutationError>;
};

export type RequestPhotoFromAuctionInput = {
  comment?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  lotData: Scalars['String'];
  /** Id originalId */
  lotId: Scalars['String'];
  lotLink: Scalars['String'];
  /** Провайдер данных */
  lotSource: Scalars['String'];
  /** Группа  */
  lotSubgroup: Scalars['String'];
  type: Scalars['Int'];
};

export type RequestPhotoFromAuctionOutput = {
  __typename?: 'RequestPhotoFromAuctionOutput';
  error?: Maybe<MutationError>;
};

export type RequestPhotoFromAuctionByAdminInput = {
  agentId: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  lotData: Scalars['String'];
  /** Id originalId */
  lotId: Scalars['String'];
  lotLink: Scalars['String'];
  /** Провайдер данных */
  lotSource: Scalars['String'];
  /** Группа  */
  lotSubgroup: Scalars['String'];
  type: Scalars['Int'];
};

export type RequestPhotoFromAuctionByAdminOutput = {
  __typename?: 'RequestPhotoFromAuctionByAdminOutput';
  error?: Maybe<MutationError>;
};

export type RequestPrimbrokerInvoiceInput = {
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  objectId?: Maybe<Scalars['Int']>;
};

export type RequestPrimbrokerInvoiceOutput = {
  __typename?: 'RequestPrimbrokerInvoiceOutput';
  error?: Maybe<MutationError>;
};

export type RequestSbktsCreateInput = {
  agent?: Maybe<RequestSbktsAgentInput>;
  agentLegal?: Maybe<RequestSbktsAgentLegalInput>;
  ambassador: Scalars['Int'];
  customer: Scalars['Int'];
  laboratory: Scalars['Int'];
  object: RequestSbktsObjectInput;
  objectId: Scalars['Int'];
};

export type RequestSbktsAgentInput = {
  fullAddress?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  issuedAtPassport: Scalars['String'];
  issuedUnit: Scalars['String'];
  issuedUnitName: Scalars['String'];
  name: Scalars['String'];
  passportDocuments?: Maybe<Array<Scalars['String']>>;
  passportNumber: Scalars['String'];
  passportSeries: Scalars['String'];
  snils?: Maybe<Scalars['String']>;
};

export type RequestSbktsAgentLegalInput = {
  bank: Scalars['String'];
  bik: Scalars['String'];
  kpp: Scalars['String'];
  ks: Scalars['String'];
  name: Scalars['String'];
  ogrn: Scalars['String'];
  rs: Scalars['String'];
};

export type RequestSbktsObjectInput = {
  color: Scalars['Int'];
  consignment?: Maybe<Array<Scalars['String']>>;
  dateOfManufacture: Scalars['String'];
  driveType?: Maybe<Scalars['String']>;
  engineModel?: Maybe<Scalars['String']>;
  engineNumber: Scalars['String'];
  enginePower: Scalars['Float'];
  engineVolume?: Maybe<Scalars['Float']>;
  glonassDocument?: Maybe<Array<Scalars['String']>>;
  glonassICCID?: Maybe<Scalars['String']>;
  glonassModel?: Maybe<Scalars['String']>;
  markName: Scalars['String'];
  maxWeight: Scalars['Int'];
  modelName: Scalars['String'];
  needEngineWatch?: Maybe<Scalars['Boolean']>;
  ownWeight: Scalars['Int'];
  seats?: Maybe<Scalars['Int']>;
  /** Документы таможенный платежный ордер(ТПО) */
  tpo?: Maybe<Array<Scalars['String']>>;
};

export type RequestSbktsCreateOutput = {
  __typename?: 'RequestSbktsCreateOutput';
  error?: Maybe<MutationError>;
};

export type RequestSbktsFromExcelCreateInput = {
  agent?: Maybe<RequestSbktsExcelAgentInput>;
  agentLegal?: Maybe<RequestSbktsExcelAgentLegalInput>;
  ambassador: Scalars['Int'];
  customer: Scalars['Int'];
  laboratory: Scalars['Int'];
  object?: Maybe<RequestSbktsExcelInput>;
  objectId?: Maybe<Scalars['Int']>;
};

export type RequestSbktsExcelAgentInput = {
  fullAddress?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  innDocuments?: Maybe<Array<Scalars['String']>>;
  issuedAtPassport?: Maybe<Scalars['String']>;
  issuedUnit?: Maybe<Scalars['String']>;
  issuedUnitName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ogrnDocuments?: Maybe<Array<Scalars['String']>>;
  passportDocuments?: Maybe<Array<Scalars['String']>>;
  passportNumber?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  residentFEFD?: Maybe<Scalars['Boolean']>;
  snils?: Maybe<Scalars['String']>;
};

export type RequestSbktsExcelAgentLegalInput = {
  bank?: Maybe<Scalars['String']>;
  bik?: Maybe<Scalars['String']>;
  kpp?: Maybe<Scalars['String']>;
  ks?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ogrn?: Maybe<Scalars['String']>;
  rs?: Maybe<Scalars['String']>;
};

export type RequestSbktsExcelInput = {
  color?: Maybe<Scalars['Int']>;
  consignment?: Maybe<Array<Scalars['String']>>;
  dateOfManufacture?: Maybe<Scalars['String']>;
  driveType?: Maybe<Scalars['String']>;
  enableGlonass?: Maybe<Scalars['Boolean']>;
  engineModel?: Maybe<Scalars['String']>;
  engineNumber?: Maybe<Scalars['String']>;
  enginePower?: Maybe<Scalars['Float']>;
  engineType?: Maybe<Scalars['Int']>;
  engineVolume?: Maybe<Scalars['Float']>;
  glonassDocument?: Maybe<Array<Scalars['String']>>;
  glonassICCID?: Maybe<Scalars['String']>;
  glonassModel?: Maybe<Scalars['String']>;
  markName: Scalars['String'];
  maxWeight?: Maybe<Scalars['Int']>;
  modelName: Scalars['String'];
  needEngineWatch?: Maybe<Scalars['Boolean']>;
  ownWeight?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  tpo?: Maybe<Array<Scalars['String']>>;
};

export type RequestSbktsFromExcelCreateOutput = {
  __typename?: 'RequestSbktsFromExcelCreateOutput';
  agentUpdateError?: Maybe<Scalars['String']>;
  error?: Maybe<MutationError>;
  fields?: Maybe<Array<RequestSbktsExcelFixField>>;
  objectUpdateError?: Maybe<Scalars['String']>;
  sbktsError?: Maybe<Scalars['String']>;
};

export type RequestSbktsExcelFixField = {
  __typename?: 'RequestSbktsExcelFixField';
  errorMessage?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
};

export type RequestToIssueInput = {
  comment?: Maybe<Scalars['String']>;
  dateIssue: Scalars['String'];
  objectId: Scalars['Int'];
};

export type RequestToIssueOutput = {
  __typename?: 'RequestToIssueOutput';
  error?: Maybe<MutationError>;
};

export type RequestUnHoldInput = {
  requestId: Scalars['Int'];
};

export type RequestUnHoldOutput = {
  __typename?: 'RequestUnHoldOutput';
  error?: Maybe<MutationError>;
};

export type RestoreObjectInput = {
  objectId: Scalars['Int'];
};

export type RestoreObjectOutput = {
  __typename?: 'RestoreObjectOutput';
  error?: Maybe<MutationError>;
};

export type ScrapAccountSessionUpdateInput = {
  session: Scalars['String'];
  yahooAccount: YahooAccountEnum;
};

export enum YahooAccountEnum {
  Akebono429 = 'akebono429',
  Eoosh66991 = 'eoosh66991',
  Ikyib99865 = 'ikyib99865',
  Magadanshop = 'magadanshop'
}

export type ScrapAccountSessionUpdateOutput = {
  __typename?: 'ScrapAccountSessionUpdateOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectCommentAddInput = {
  comment: Scalars['String'];
  id: Scalars['Int'];
};

export type ScrapObjectCommentAddOutput = {
  __typename?: 'ScrapObjectCommentAddOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectCreateInput = {
  /** Номер */
  aggregateNumber?: Maybe<Scalars['String']>;
  basket?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  lotSize: Scalars['String'];
  /** Количество занимаемых ячеек */
  lotSizeMultiplier?: Maybe<Scalars['Int']>;
  objectId: Scalars['Int'];
  place?: Maybe<Scalars['String']>;
  /** Список отметок */
  remarkIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Тип запчасти */
  scrapTypeId: Scalars['Int'];
  /** Список сторон */
  sideIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Состояние запчасти */
  status: YahooStateLotEnum;
};

export type ScrapObjectCreateOutput = {
  __typename?: 'ScrapObjectCreateOutput';
  error?: Maybe<MutationError>;
  scrapObject?: Maybe<ObjectOfServices>;
};

export type ScrapObjectDeliverySetInput = {
  address: Scalars['String'];
  carrier: Scalars['String'];
  id: Scalars['Int'];
  trackNumber?: Maybe<Scalars['String']>;
};

export type ScrapObjectDeliverySetOutput = {
  __typename?: 'ScrapObjectDeliverySetOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectsDiscountToYahooInput = {
  objectsIds: Array<Maybe<Scalars['Int']>>;
};

export type ScrapObjectsDiscountToYahooOutput = {
  __typename?: 'ScrapObjectsDiscountToYahooOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectLotCancelInput = {
  id: Scalars['Int'];
};

export type ScrapObjectLotCancelOutput = {
  __typename?: 'ScrapObjectLotCancelOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectPlaceSetInput = {
  basket?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  place: Scalars['String'];
};

export type ScrapObjectPlaceSetOutput = {
  __typename?: 'ScrapObjectPlaceSetOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectRebindInput = {
  parentObjectId: Scalars['Int'];
  scrapObjectId: Scalars['Int'];
};

export type ScrapObjectRebindOutput = {
  __typename?: 'ScrapObjectRebindOutput';
  error?: Maybe<MutationError>;
  scrapObject?: Maybe<ObjectOfServices>;
};

export type ScrapObjectSizeSetInput = {
  id: Scalars['Int'];
  lotSize: Scalars['String'];
  lotSizeMultiplier?: Maybe<Scalars['Int']>;
};

export type ScrapObjectSizeSetOutput = {
  __typename?: 'ScrapObjectSizeSetOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectStatusSetInput = {
  objectId: Scalars['Int'];
  statusId: Scalars['Int'];
};

export type ScrapObjectStatusSetOutput = {
  __typename?: 'ScrapObjectStatusSetOutput';
  error?: Maybe<MutationError>;
  scrapObject?: Maybe<ObjectOfServices>;
};

export type ScrapObjectToYahooInput = {
  amount: Scalars['Int'];
  autoExtension: Scalars['Boolean'];
  buyoutPrice?: Maybe<Scalars['Int']>;
  categoryCode: Scalars['String'];
  categoryId: Scalars['String'];
  description: Scalars['String'];
  endDate: Scalars['String'];
  endTime: Scalars['Int'];
  id: Scalars['Int'];
  imageIds: Array<Scalars['Int']>;
  markdownRatio?: Maybe<YahooLotResubmitRatioEnum>;
  numResubmit?: Maybe<Scalars['Int']>;
  shipnames: Array<YahooLotDeliveryServiceEnum>;
  shipping: YahooLotShippingEnum;
  shippinginput: YahooLotShippingInputEnum;
  shipschedule: YahooLotShipScheduleEnum;
  startPrice: Scalars['Int'];
  status: YahooStateLotEnum;
  title: Scalars['String'];
  yahooAccount: YahooAccountEnum;
};

export enum YahooLotDeliveryServiceEnum {
  Other = 'other',
  Sagawa = 'sagawa',
  Seino = 'seino',
  Yamato = 'yamato',
  YuMail = 'yu_mail',
  YuPack = 'yu_pack'
}

export enum YahooLotShippingEnum {
  Buyer = 'buyer',
  Seller = 'seller'
}

export enum YahooLotShipScheduleEnum {
  OneTwo = 'one_two',
  ThreeSeven = 'three_seven',
  TwoThree = 'two_three'
}

export type ScrapObjectToYahooOutput = {
  __typename?: 'ScrapObjectToYahooOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectUnbindInput = {
  objectId: Scalars['Int'];
};

export type ScrapObjectUnbindOutput = {
  __typename?: 'ScrapObjectUnbindOutput';
  error?: Maybe<MutationError>;
  scrapObject?: Maybe<ObjectOfServices>;
};

export type ScrapObjectUpdateInput = {
  aggregateNumber?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  /** Список отметок */
  remarkIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  scrapTypeId: Scalars['Int'];
  /** Список сторон */
  sideIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type ScrapObjectUpdateOutput = {
  __typename?: 'ScrapObjectUpdateOutput';
  error?: Maybe<MutationError>;
  scrapObject?: Maybe<ObjectOfServices>;
};

export type ScrapObjectUploadShippingInvoiceInput = {
  id: Scalars['Int'];
  keyS3Files: Array<Maybe<Scalars['String']>>;
};

export type ScrapObjectUploadShippingInvoiceOutput = {
  __typename?: 'ScrapObjectUploadShippingInvoiceOutput';
  error?: Maybe<MutationError>;
};

export type ScrapObjectWriteOffInput = {
  objectId: Scalars['Int'];
};

export type ScrapObjectWriteOffOutput = {
  __typename?: 'ScrapObjectWriteOffOutput';
  error?: Maybe<MutationError>;
  scrapObject?: Maybe<ObjectOfServices>;
};

export type ScrapTypeCreateInput = {
  aggregateTypeId?: Maybe<Scalars['Int']>;
  carTypeId: Scalars['Int'];
  costInPercent?: Maybe<Scalars['Int']>;
  countObjects?: Maybe<Scalars['Int']>;
  descriptionId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nameEn: Scalars['String'];
  nameJp: Scalars['String'];
};

export type ScrapTypeCreateOutput = {
  __typename?: 'ScrapTypeCreateOutput';
  error?: Maybe<MutationError>;
};

export type ScrapTypeDescriptionCreateInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ScrapTypeDescriptionCreateOutput = {
  __typename?: 'ScrapTypeDescriptionCreateOutput';
  description?: Maybe<ScrapTypeDescription>;
  error?: Maybe<MutationError>;
};

export type ScrapTypeDescriptionDeleteInput = {
  id: Scalars['Int'];
};

export type ScrapTypeDescriptionDeleteOutput = {
  __typename?: 'ScrapTypeDescriptionDeleteOutput';
  error?: Maybe<MutationError>;
};

export type ScrapTypeDescriptionUpdateInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ScrapTypeDescriptionUpdateOutput = {
  __typename?: 'ScrapTypeDescriptionUpdateOutput';
  description?: Maybe<ScrapTypeDescription>;
  error?: Maybe<MutationError>;
};

export type ScrapTypeUpdateInput = {
  aggregateTypeId?: Maybe<Scalars['Int']>;
  carTypeId: Scalars['Int'];
  costInPercent?: Maybe<Scalars['Int']>;
  countObjects?: Maybe<Scalars['Int']>;
  descriptionId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  nameEn: Scalars['String'];
  nameJp: Scalars['String'];
};

export type ScrapTypeUpdateOutput = {
  __typename?: 'ScrapTypeUpdateOutput';
  error?: Maybe<MutationError>;
};

export type ScrapUtilizedInput = {
  id: Scalars['Int'];
};

export type ScrapUtilizedOutput = {
  __typename?: 'ScrapUtilizedOutput';
  error?: Maybe<MutationError>;
};

export type SeaCarrierCreateInput = {
  name: Scalars['String'];
};

export type SeaCarrierCreateOutput = {
  __typename?: 'SeaCarrierCreateOutput';
  error?: Maybe<MutationError>;
};

export type SeaCarrierDeleteInput = {
  id: Scalars['Int'];
};

export type SeaCarrierDeleteOutput = {
  __typename?: 'SeaCarrierDeleteOutput';
  error?: Maybe<MutationError>;
};

export type SeaCarrierEditInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SeaCarrierEditOutput = {
  __typename?: 'SeaCarrierEditOutput';
  error?: Maybe<MutationError>;
};

export type SendAllClientsNotificationInput = {
  message: Scalars['String'];
};

export type SendAllClientsNotificationOutput = {
  __typename?: 'SendAllClientsNotificationOutput';
  error?: Maybe<MutationError>;
};

export type SendDirectorFeedbackInput = {
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  text: Scalars['String'];
};

export type SendDirectorFeedbackOutput = {
  __typename?: 'SendDirectorFeedbackOutput';
  error?: Maybe<MutationError>;
};

export type SendFeedbackInput = {
  email?: Maybe<Scalars['String']>;
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  name: Scalars['String'];
};

export type SendFeedbackOutput = {
  __typename?: 'SendFeedbackOutput';
  error?: Maybe<MutationError>;
};

export type SendNotificationEmailInput = {
  notificationKey: EmailObjectNotificationEnum;
  objectId: Scalars['Int'];
};

export enum EmailObjectNotificationEnum {
  /** Предоставьте паспорт с пропиской */
  GetPassportWithRegistration = 'GET_PASSPORT_WITH_REGISTRATION',
  /** Неверная регистрация физлица в СЭП */
  WrongEpsRegistration = 'WRONG_EPS_REGISTRATION'
}

export type SendNotificationEmailOutput = {
  __typename?: 'SendNotificationEmailOutput';
  error?: Maybe<MutationError>;
};

export type SendPaymentInfoInput = {
  keyS3Files: Array<Scalars['String']>;
  paymentId: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};

export type SendPaymentInfoOutput = {
  __typename?: 'SendPaymentInfoOutput';
  error?: Maybe<MutationError>;
};

export type SendRussianDeliveryRequestInput = {
  address: Scalars['String'];
  contact: Scalars['String'];
  fileBase64?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  text: Scalars['String'];
};

export type SendRussianDeliveryRequestOutput = {
  __typename?: 'SendRussianDeliveryRequestOutput';
  error?: Maybe<MutationError>;
};

export type ServiceRequestCanceledInput = {
  appSource?: Maybe<AppSourceEnum>;
  id: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
};

export type ServiceRequestCanceledOutput = {
  __typename?: 'ServiceRequestCanceledOutput';
  error?: Maybe<MutationError>;
};

export type ServiceRequestCompletedInput = {
  additionalServices?: Maybe<Array<AdditionalServiceInput>>;
  appSource?: Maybe<AppSourceEnum>;
  comment?: Maybe<Scalars['String']>;
  isFree?: Maybe<Scalars['Boolean']>;
  services: Array<CompletedServiceRequestInput>;
};

export type AdditionalServiceInput = {
  cost: Scalars['Int'];
  typeId: Scalars['Int'];
};

export type CompletedServiceRequestInput = {
  cost: Scalars['Int'];
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  param?: Maybe<CompletedServiceRequestParamInput>;
  requestId: Scalars['Int'];
};

export type CompletedServiceRequestParamInput = {
  cost: Scalars['Int'];
  paramId: Scalars['Int'];
};

export type ServiceRequestCompletedOutput = {
  __typename?: 'ServiceRequestCompletedOutput';
  error?: Maybe<MutationError>;
};

export type ServiceRequestCreateInput = {
  objectId: Scalars['Int'];
  serviceRequests: Array<ServiceRequestInput>;
};

export type ServiceRequestInput = {
  comment?: Maybe<Scalars['String']>;
  typeId: Scalars['Int'];
  typeParamId?: Maybe<Scalars['Int']>;
};

export type ServiceRequestCreateOutput = {
  __typename?: 'ServiceRequestCreateOutput';
  error?: Maybe<MutationError>;
  serviceRequests?: Maybe<Array<ServiceRequest>>;
};

export type ServiceRequestTypeParamAddInput = {
  cost: Scalars['Int'];
  description: Scalars['String'];
  descriptionEng: Scalars['String'];
  isHidden?: Maybe<Scalars['Boolean']>;
  makerId?: Maybe<Scalars['Int']>;
  markId?: Maybe<Scalars['Int']>;
  requestTypeId: Scalars['Int'];
};

export type ServiceRequestTypeParamAddOutput = {
  __typename?: 'ServiceRequestTypeParamAddOutput';
  error?: Maybe<MutationError>;
  requestTypeParam?: Maybe<ServiceRequestTypeParam>;
};

export type SetBoundaryInput = {
  boundaryDate: Scalars['String'];
  objectId: Scalars['Int'];
};

export type SetBoundaryOutput = {
  __typename?: 'SetBoundaryOutput';
  error?: Maybe<MutationError>;
};

export type SetDateSvhDeliveryRequestInput = {
  /** Согласованная дата доставки */
  dateOutcome: Scalars['String'];
  id: Scalars['Int'];
};

export type SetDateSvhDeliveryRequestOutput = {
  __typename?: 'SetDateSvhDeliveryRequestOutput';
  error?: Maybe<MutationError>;
};

export type SetIsGlonassNeedInput = {
  objectId: Scalars['Int'];
};

export type SetIsGlonassNeedOutput = {
  __typename?: 'SetIsGlonassNeedOutput';
  error?: Maybe<MutationError>;
};

export type SortObjectMediaInput = {
  imageIdsArray: Array<Maybe<Scalars['Int']>>;
};

export type SortObjectMediaOutput = {
  __typename?: 'SortObjectMediaOutput';
  error?: Maybe<MutationError>;
};

export type StorageCreateInput = {
  countryId: Scalars['Int'];
  name: Scalars['String'];
};

export type StorageCreateOutput = {
  __typename?: 'StorageCreateOutput';
  error?: Maybe<MutationError>;
};

export type StorageUpdateInput = {
  /** Id склада */
  id: Scalars['Int'];
  /** Уведомлять клиента о прибытии объекта */
  notificationClient: Scalars['Boolean'];
  /** Уведомлять менеджера о прибытии объекта */
  notificationManager: Scalars['Boolean'];
  /** Стоимость одного дня хранения (Иен) */
  storageCost?: Maybe<Scalars['Int']>;
  /** Количество дней бесплатного хранения */
  storageFreeDays?: Maybe<Scalars['Int']>;
};

export type StorageUpdateOutput = {
  __typename?: 'StorageUpdateOutput';
  error?: Maybe<MutationError>;
};

export type StorageSectorCreateInput = {
  capacity: Scalars['Int'];
  name: Scalars['String'];
  nameEng: Scalars['String'];
  order: Scalars['Int'];
  stockId: Scalars['Int'];
};

export type StorageSectorCreateOutput = {
  __typename?: 'StorageSectorCreateOutput';
  error?: Maybe<MutationError>;
};

export type StorageSectorEditInput = {
  capacity: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  nameEng: Scalars['String'];
  order: Scalars['Int'];
  sectorId: Scalars['Int'];
  stockId: Scalars['Int'];
};

export type StorageSectorEditOutput = {
  __typename?: 'StorageSectorEditOutput';
  error?: Maybe<MutationError>;
};

export type SubscribeUserToTelegramInput = {
  botId: Scalars['Int'];
};

export type SubscribeUserToTelegramOutput = {
  __typename?: 'SubscribeUserToTelegramOutput';
  error?: Maybe<MutationError>;
  uuid: Scalars['String'];
};

export type SvhDeliveryAmbassadorCreateInput = {
  name: Scalars['String'];
  passportAddress: Scalars['String'];
  passportIssued: Scalars['String'];
  passportNumber: Scalars['String'];
};

export type SvhDeliveryAmbassadorCreateOutput = {
  __typename?: 'SvhDeliveryAmbassadorCreateOutput';
  error?: Maybe<MutationError>;
};

export type SvhDeliveryAmbassadorUpdateInput = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  passportAddress: Scalars['String'];
  passportIssued: Scalars['String'];
  passportNumber: Scalars['String'];
};

export type SvhDeliveryAmbassadorUpdateOutput = {
  __typename?: 'SvhDeliveryAmbassadorUpdateOutput';
  error?: Maybe<MutationError>;
};

export type SyncObjectInput = {
  objectId: Scalars['Int'];
};

export type SyncObjectOutput = {
  __typename?: 'SyncObjectOutput';
  error?: Maybe<MutationError>;
};

export type TakeSvhDeliveryRequestInput = {
  id: Scalars['Int'];
};

export type TakeSvhDeliveryRequestOutput = {
  __typename?: 'TakeSvhDeliveryRequestOutput';
  error?: Maybe<MutationError>;
};

export type TicketAddReviewInput = {
  message: Scalars['String'];
  rating?: Maybe<Scalars['Float']>;
  ticketId: Scalars['Int'];
};

export type TicketAddReviewOutput = {
  __typename?: 'TicketAddReviewOutput';
  error?: Maybe<MutationError>;
};

export type TicketAddUserInput = {
  ticketId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type TicketAddUserOutput = {
  __typename?: 'TicketAddUserOutput';
  error?: Maybe<MutationError>;
};

export type TicketChangeSubTypeInput = {
  ticketId: Scalars['Int'];
  typeId?: Maybe<Scalars['Int']>;
};

export type TicketChangeSubTypeOutput = {
  __typename?: 'TicketChangeSubTypeOutput';
  error?: Maybe<MutationError>;
};

export type TicketChangeTypeInput = {
  ticketId: Scalars['Int'];
  typeId: Scalars['Int'];
};

export type TicketChangeTypeOutput = {
  __typename?: 'TicketChangeTypeOutput';
  error?: Maybe<MutationError>;
};

export type TicketCreateInput = {
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  objectId: Scalars['Int'];
  requestAmount?: Maybe<Scalars['Int']>;
  ticketTypeId: Scalars['Int'];
};

export type TicketCreateOutput = {
  __typename?: 'TicketCreateOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionInput = {
  decisions: Array<TicketDecisionItemInput>;
  innerReason?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  ticketId: Scalars['Int'];
};

export type TicketDecisionItemInput = {
  amount?: Maybe<Scalars['Int']>;
  currencyId?: Maybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
};

export type TicketDecisionOutput = {
  __typename?: 'TicketDecisionOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionAddInput = {
  decisions: Array<TicketDecisionItemInput>;
  ticketId: Scalars['Int'];
};

export type TicketDecisionAddOutput = {
  __typename?: 'TicketDecisionAddOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionAppealInput = {
  decisionId: Scalars['Int'];
  keyS3Files?: Maybe<Array<Maybe<Scalars['String']>>>;
  message: Scalars['String'];
};

export type TicketDecisionAppealOutput = {
  __typename?: 'TicketDecisionAppealOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionApproveInput = {
  ticketId: Scalars['Int'];
};

export type TicketDecisionApproveOutput = {
  __typename?: 'TicketDecisionApproveOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionApproveOrganizationInput = {
  decisions: Array<Maybe<TicketApproveItemInput>>;
  ticketId: Scalars['Int'];
};

export type TicketApproveItemInput = {
  comment?: Maybe<Scalars['String']>;
  compensationAmount?: Maybe<Scalars['Float']>;
  currencyId?: Maybe<Scalars['Int']>;
  decisionId: Scalars['Int'];
  guiltyMessage: Scalars['String'];
  isCompensatedByThirdParty?: Maybe<Scalars['Boolean']>;
  isPayOrganization?: Maybe<Scalars['Boolean']>;
};

export type TicketDecisionApproveOrganizationOutput = {
  __typename?: 'TicketDecisionApproveOrganizationOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionCancelInput = {
  decisionId: Scalars['Int'];
  message: Scalars['String'];
};

export type TicketDecisionCancelOutput = {
  __typename?: 'TicketDecisionCancelOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionCancelOnlyAdminInput = {
  decisionId: Scalars['Int'];
};

export type TicketDecisionCancelOnlyAdminOutput = {
  __typename?: 'TicketDecisionCancelOnlyAdminOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionPayoutInput = {
  message: Scalars['String'];
  ticketId: Scalars['Int'];
};

export type TicketDecisionPayoutOutput = {
  __typename?: 'TicketDecisionPayoutOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionResetPayoutInput = {
  decisionId: Scalars['Int'];
};

export type TicketDecisionResetPayoutOutput = {
  __typename?: 'TicketDecisionResetPayoutOutput';
  error?: Maybe<MutationError>;
};

export type TicketDecisionUpdateInput = {
  amount: Scalars['String'];
  currencyId?: Maybe<Scalars['Int']>;
  decisionId: Scalars['Int'];
};

export type TicketDecisionUpdateOutput = {
  __typename?: 'TicketDecisionUpdateOutput';
  error?: Maybe<MutationError>;
};

export type TicketDeclineInput = {
  innerReason: Scalars['String'];
  reason: Scalars['String'];
  ticketId: Scalars['Int'];
};

export type TicketDeclineOutput = {
  __typename?: 'TicketDeclineOutput';
  error?: Maybe<MutationError>;
};

export type TicketRemoveUserInput = {
  ticketId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type TicketRemoveUserOutput = {
  __typename?: 'TicketRemoveUserOutput';
  error?: Maybe<MutationError>;
};

export type TicketResetInput = {
  ticketId: Scalars['Int'];
};

export type TicketResetOutput = {
  __typename?: 'TicketResetOutput';
  error?: Maybe<MutationError>;
};

export type TicketSilentCloseInput = {
  ticketId: Scalars['Int'];
};

export type TicketSilentCloseOutput = {
  __typename?: 'TicketSilentCloseOutput';
  error?: Maybe<MutationError>;
};

export type TicketYahooCreateInput = {
  keyS3Files?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  requestAmount?: Maybe<Scalars['Int']>;
  yahooId: Scalars['Int'];
};

export type TicketYahooCreateOutput = {
  __typename?: 'TicketYahooCreateOutput';
  error?: Maybe<MutationError>;
};

export type ToggleUserNotifyMessageInput = {
  channelId: Scalars['Int'];
  messageTypeId: Scalars['Int'];
};

export type ToggleUserNotifyMessageOutput = {
  __typename?: 'ToggleUserNotifyMessageOutput';
  error?: Maybe<MutationError>;
};

export type TransferBalanceBetweenClientsInput = {
  /** Сумма перевода */
  amount: Scalars['Int'];
  /** Код клиента-получателя в base32 */
  destinationAgentCode: Scalars['String'];
  /** Вид баланса получателя */
  destinationBalanceType: ClientBalanceTypeEnum;
  /** Услуга за счёт получателя */
  isRecipientExpense: Scalars['Boolean'];
  /** Код подтверждения из письма, нужен только для перевода другому клиенту */
  otp?: Maybe<Scalars['String']>;
  /** Если не указан, то от вызвавшего юзера */
  sourceAgentId?: Maybe<Scalars['Int']>;
  /** Вид баланса отправителя */
  sourceBalanceType: ClientBalanceTypeEnum;
};

export type TransferBalanceBetweenClientsOutput = {
  __typename?: 'TransferBalanceBetweenClientsOutput';
  error?: Maybe<MutationError>;
};

export type TransferBalanceOtpSendInput = {
  /** Сумма перевода */
  amount: Scalars['Int'];
  /** Код клиента-получателя в base32 */
  destinationAgentCode: Scalars['String'];
  /** Вид баланса получателя */
  destinationBalanceType: ClientBalanceTypeEnum;
  /** Услуга за счёт получателя */
  isRecipientExpense: Scalars['Boolean'];
  /** Если не указан, то от вызвавшего юзера */
  sourceAgentId?: Maybe<Scalars['Int']>;
  /** Вид баланса отправителя */
  sourceBalanceType: ClientBalanceTypeEnum;
};

export type TransferBalanceOtpSendOutput = {
  __typename?: 'TransferBalanceOtpSendOutput';
  error?: Maybe<MutationError>;
  expiresAt?: Maybe<Scalars['DateTime']>;
};

export type TripAirCreateInput = {
  aircraftId: Scalars['Int'];
  airlineId: Scalars['Int'];
  airportFromId: Scalars['Int'];
  airportToId: Scalars['Int'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  dateVl?: Maybe<Scalars['DateTime']>;
  flightNumber: Scalars['String'];
  stockFromId?: Maybe<Scalars['Int']>;
  stockToId: Scalars['Int'];
};

export type TripAirCreateOutput = {
  __typename?: 'TripAirCreateOutput';
  error?: Maybe<MutationError>;
};

export type TripAirEditInput = {
  aircraftId: Scalars['Int'];
  airlineId: Scalars['Int'];
  airportFromId: Scalars['Int'];
  airportToId: Scalars['Int'];
  contractClosingDate?: Maybe<Scalars['DateTime']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  dateVl?: Maybe<Scalars['DateTime']>;
  flightNumber: Scalars['String'];
  id: Scalars['Int'];
  stockFromId?: Maybe<Scalars['Int']>;
  stockToId: Scalars['Int'];
};

export type TripAirEditOutput = {
  __typename?: 'TripAirEditOutput';
  error?: Maybe<MutationError>;
};

export type TripChangeObjectsOrderInput = {
  objectOrderList: Array<TripObjectOrderInput>;
  planId: Scalars['Int'];
};

export type TripObjectOrderInput = {
  objectId: Scalars['Int'];
  /** Позиция в списке */
  position: Scalars['Int'];
};

export type TripChangeObjectsOrderOutput = {
  __typename?: 'TripChangeObjectsOrderOutput';
  error?: Maybe<MutationError>;
};

export type TripCloseInput = {
  id: Scalars['Int'];
};

export type TripCloseOutput = {
  __typename?: 'TripCloseOutput';
  error?: Maybe<MutationError>;
};

export type TripCreateInput = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  dateVl: Scalars['DateTime'];
  number: Scalars['String'];
  portFrom: Scalars['Int'];
  portTo: Scalars['Int'];
  seaCarrierId: Scalars['Int'];
  ship: Scalars['Int'];
  stockTo: Scalars['Int'];
};

export type TripCreateOutput = {
  __typename?: 'TripCreateOutput';
  error?: Maybe<MutationError>;
};

export type TripDeleteInput = {
  id: Scalars['Int'];
};

export type TripDeleteOutput = {
  __typename?: 'TripDeleteOutput';
  error?: Maybe<MutationError>;
};

export type TripEditInput = {
  contractClosingDate?: Maybe<Scalars['DateTime']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  dateVl: Scalars['DateTime'];
  id: Scalars['Int'];
  number: Scalars['String'];
  portFrom: Scalars['Int'];
  portTo: Scalars['Int'];
  seaCarrierId: Scalars['Int'];
  ship: Scalars['Int'];
  stockTo: Scalars['Int'];
};

export type TripEditOutput = {
  __typename?: 'TripEditOutput';
  error?: Maybe<MutationError>;
};

export type TripLoadingInput = {
  planId: Scalars['Int'];
};

export type TripLoadingOutput = {
  __typename?: 'TripLoadingOutput';
  error?: Maybe<MutationError>;
};

export type TripReturnToSourcePortInput = {
  planId: Scalars['Int'];
};

export type TripReturnToSourcePortOutput = {
  __typename?: 'TripReturnToSourcePortOutput';
  error?: Maybe<MutationError>;
};

export type TripToPortInput = {
  containerId?: Maybe<Scalars['Int']>;
  planId: Scalars['Int'];
};

export type TripToPortOutput = {
  __typename?: 'TripToPortOutput';
  error?: Maybe<MutationError>;
};

export type TypeOfExportEditInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
  nameEng: Scalars['String'];
};

export type TypeOfExportEditOutput = {
  __typename?: 'TypeOfExportEditOutput';
  error?: Maybe<MutationError>;
};

export type UnlockTheIssuanceInput = {
  comment: Scalars['String'];
  objectId: Scalars['Int'];
};

export type UnlockTheIssuanceOutput = {
  __typename?: 'UnlockTheIssuanceOutput';
  error?: Maybe<MutationError>;
};

export type UnViewChatInput = {
  chatId: Scalars['Int'];
};

export type UnViewChatOutput = {
  __typename?: 'UnViewChatOutput';
  error?: Maybe<MutationError>;
};

export type UpdateInvoiceAuctionPurchaseInput = {
  invoiceKeysS3?: Maybe<Array<Scalars['String']>>;
  nomenclaturesList: Array<Maybe<InvoiceServiceInput>>;
  objectId: Scalars['Int'];
};

export type InvoiceServiceInput = {
  amount: Scalars['Int'];
  nomenclature: Scalars['Int'];
};

export type UpdateInvoiceAuctionPurchaseOutput = {
  __typename?: 'UpdateInvoiceAuctionPurchaseOutput';
  error?: Maybe<MutationError>;
};

export type UploadFilesInput = {
  entity: MediaEntityEnum;
  entityId: Scalars['Int'];
  keyS3Files: Array<Scalars['String']>;
  mediaType: MediaTypeEnum;
  onlyOneFile?: Maybe<Scalars['Boolean']>;
};

export enum MediaEntityEnum {
  BrAgents = 'br_agents',
  BrAgentsFormal = 'br_agents_formal',
  RegCars = 'reg_cars',
  RegContainers = 'reg_containers',
  RegEmployeeDocuments = 'reg_employee_documents',
  RegExportDeclarations = 'reg_export_declarations',
  RegSbktsDocs = 'reg_sbkts_docs',
  RegTicket = 'reg_ticket',
  RegUsersProfiles = 'reg_users_profiles',
  RegVehicles = 'reg_vehicles'
}

export type UploadFilesOutput = {
  __typename?: 'UploadFilesOutput';
  error?: Maybe<MutationError>;
};

export type UserChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type UserChangePasswordOutput = {
  __typename?: 'UserChangePasswordOutput';
  error?: Maybe<MutationError>;
};

export type UserProfileUpdateInput = {
  emails?: Maybe<Array<UserEmailInput>>;
  language: LanguageEnum;
  timezone: Scalars['String'];
};

export type UserEmailInput = {
  email: Scalars['String'];
  useForNotification?: Maybe<Scalars['Boolean']>;
};

export type UserProfileUpdateOutput = {
  __typename?: 'UserProfileUpdateOutput';
  error?: Maybe<MutationError>;
};

export type VesselCreateInput = {
  name: Scalars['String'];
};

export type VesselCreateOutput = {
  __typename?: 'VesselCreateOutput';
  error?: Maybe<MutationError>;
};

export type VesselUpdateInput = {
  id: Scalars['Int'];
  type: Scalars['Int'];
};

export type VesselUpdateOutput = {
  __typename?: 'VesselUpdateOutput';
  error?: Maybe<MutationError>;
};

export type ViewChatInput = {
  chatId: Scalars['Int'];
};

export type ViewChatOutput = {
  __typename?: 'ViewChatOutput';
  error?: Maybe<MutationError>;
};

export type WatchCarUpdateInput = {
  attachments?: Maybe<Scalars['String']>;
  carTypeId: Scalars['Int'];
  chassisTypeId: Scalars['Int'];
  colorId: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  complete: Scalars['Boolean'];
  engineModel?: Maybe<Scalars['String']>;
  engineNumber?: Maybe<Scalars['String']>;
  engineTypeId: Scalars['Int'];
  height: Scalars['Int'];
  isBroken?: Maybe<Scalars['Boolean']>;
  length: Scalars['Int'];
  loadCapacity: Scalars['Float'];
  makerId: Scalars['Int'];
  markId: Scalars['Int'];
  mediaKeysS3?: Maybe<Array<Maybe<Scalars['String']>>>;
  objectId: Scalars['Int'];
  sawId?: Maybe<Scalars['String']>;
  seats?: Maybe<Scalars['Int']>;
  templateId?: Maybe<Scalars['Int']>;
  vin: Scalars['String'];
  weight: Scalars['Int'];
  width: Scalars['Int'];
};

export type WatchCarUpdateOutput = {
  __typename?: 'WatchCarUpdateOutput';
  error?: Maybe<MutationError>;
};

export type WheelBuyInput = {
  objectId: Scalars['Int'];
};

export type WheelBuyOutput = {
  __typename?: 'WheelBuyOutput';
  error?: Maybe<MutationError>;
};

export type WheelCreateInput = {
  count: Scalars['Int'];
  diskManufacturer: Scalars['String'];
  diskType: DiskTypeEnum;
  fotos?: Maybe<Array<Maybe<Scalars['String']>>>;
  objectId: Scalars['Int'];
  tireManufacturer: Scalars['String'];
  tireProfileHeight: Scalars['Int'];
  tireProfileWidth: Scalars['Int'];
  tireRadius: Scalars['Int'];
  tireType: TireTypeEnum;
  tireWear: Scalars['Int'];
};

export type WheelCreateOutput = {
  __typename?: 'WheelCreateOutput';
  error?: Maybe<MutationError>;
};

export type WheelRemoveFromPalletInput = {
  objectId: Scalars['Int'];
};

export type WheelRemoveFromPalletOutput = {
  __typename?: 'WheelRemoveFromPalletOutput';
  error?: Maybe<MutationError>;
};

export type WheelSetIsLoadedInput = {
  objectId: Scalars['Int'];
};

export type WheelSetIsLoadedOutput = {
  __typename?: 'WheelSetIsLoadedOutput';
  error?: Maybe<MutationError>;
};

export type WheelSetPriceInput = {
  objectId: Scalars['Int'];
  price: Scalars['Int'];
};

export type WheelSetPriceOutput = {
  __typename?: 'WheelSetPriceOutput';
  error?: Maybe<MutationError>;
};

export type DeleteUserNotifyMessageMutationVariables = Exact<{
  input?: Maybe<DeleteUserNotifyMessageInput>;
}>;


export type DeleteUserNotifyMessageMutation = { __typename?: 'Mutation', deleteUserNotifyMessage?: Maybe<{ __typename?: 'DeleteUserNotifyMessageOutput', error?: Maybe<{ __typename?: 'MutationError', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type RequestPhotoFromAuctionByAdminMutationVariables = Exact<{
  input: RequestPhotoFromAuctionByAdminInput;
}>;


export type RequestPhotoFromAuctionByAdminMutation = { __typename?: 'Mutation', requestPhotoFromAuctionByAdmin?: Maybe<{ __typename?: 'RequestPhotoFromAuctionByAdminOutput', error?: Maybe<{ __typename?: 'MutationError', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type RequestPhotoFromAuctionMutationVariables = Exact<{
  input: RequestPhotoFromAuctionInput;
}>;


export type RequestPhotoFromAuctionMutation = { __typename?: 'Mutation', requestPhotoFromAuction?: Maybe<{ __typename?: 'RequestPhotoFromAuctionOutput', error?: Maybe<{ __typename?: 'MutationError', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type SubscribeUserToTelegramMutationVariables = Exact<{
  input?: Maybe<SubscribeUserToTelegramInput>;
}>;


export type SubscribeUserToTelegramMutation = { __typename?: 'Mutation', subscribeUserToTelegram?: Maybe<{ __typename?: 'SubscribeUserToTelegramOutput', uuid: string, error?: Maybe<{ __typename?: 'MutationError', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type ToggleUserNotifyMessageMutationVariables = Exact<{
  input?: Maybe<ToggleUserNotifyMessageInput>;
}>;


export type ToggleUserNotifyMessageMutation = { __typename?: 'Mutation', toggleUserNotifyMessage?: Maybe<{ __typename?: 'ToggleUserNotifyMessageOutput', error?: Maybe<{ __typename?: 'MutationError', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type AddGreenCornerPriceQueryVariables = Exact<{ [key: string]: never; }>;


export type AddGreenCornerPriceQuery = { __typename?: 'Query', addGreenCornerPrice?: Maybe<{ __typename?: 'AddGreenCornerPrice', motoBidLimit?: Maybe<number>, price?: Maybe<number> }> };

export type AuctionFeedbacksQueryVariables = Exact<{
  auctionId: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type AuctionFeedbacksQuery = { __typename?: 'Query', auctionFeedbacks?: Maybe<{ __typename?: 'AuctionFeedbacksPaginatedList', total: number, nodes: Array<{ __typename?: 'CarFeedback', id?: Maybe<number>, createdAt?: Maybe<any>, evaluation?: Maybe<number>, feedback?: Maybe<string>, owner?: Maybe<{ __typename?: 'OwnerFeedback', id?: Maybe<number>, link?: Maybe<string>, purchase?: Maybe<number>, rating?: Maybe<UserRatingEnum> }>, carInfo?: Maybe<{ __typename?: 'CarInfo', maker?: Maybe<string>, mark?: Maybe<string>, year?: Maybe<string> }> }> }> };

export type CheckAgentDebtsQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckAgentDebtsQuery = { __typename?: 'Query', checkAgentDebts?: Maybe<boolean> };

export type CurrentUserIsEcarjpBotConnectedQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIsEcarjpBotConnectedQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'User', id?: Maybe<number>, isBotEcarJpAuc?: Maybe<boolean> }> };

export type CurrentUserNotifyMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserNotifyMessagesQuery = { __typename?: 'Query', currentUserNotifyMessages?: Maybe<Array<{ __typename?: 'CurrentUserNotifyMessage', bot?: Maybe<{ __typename?: 'NotifyBotInfo', id?: Maybe<number>, name?: Maybe<string>, clientName?: Maybe<string> }>, channels?: Maybe<Array<{ __typename?: 'UserChannel', enabled?: Maybe<boolean>, id?: Maybe<number>, username?: Maybe<string> }>>, messageTypes?: Maybe<Array<{ __typename?: 'NotifyMessage', description?: Maybe<string>, id?: Maybe<number>, isDisabled?: Maybe<boolean>, name?: Maybe<string>, nameEng?: Maybe<string>, channels?: Maybe<Array<{ __typename?: 'UserChannel', enabledMessage?: Maybe<boolean>, id?: Maybe<number>, username?: Maybe<string> }>> }>> }>> };

export type EcarJpBotSubscribeUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type EcarJpBotSubscribeUrlQuery = { __typename?: 'Query', ecarJpBotSubscribeUrl: string };

export type MakersQueryVariables = Exact<{ [key: string]: never; }>;


export type MakersQuery = { __typename?: 'Query', makers?: Maybe<Array<{ __typename?: 'Maker', id?: Maybe<number>, name?: Maybe<string> }>> };

export type MarksQueryVariables = Exact<{
  makerId: Scalars['Int'];
}>;


export type MarksQuery = { __typename?: 'Query', marks?: Maybe<Array<{ __typename?: 'Mark', id?: Maybe<number>, name?: Maybe<string> }>> };

export type OwnerSearchQueryVariables = Exact<{
  ownerId: Scalars['Int'];
}>;


export type OwnerSearchQuery = { __typename?: 'Query', owner?: Maybe<{ __typename?: 'Owner', id?: Maybe<number>, name?: Maybe<string>, phones?: Maybe<Array<string>>, email?: Maybe<string> }> };

export type OwnersSearchFullQueryVariables = Exact<{
  filter?: Maybe<OwnersFilter>;
  search: Scalars['String'];
}>;


export type OwnersSearchFullQuery = { __typename?: 'Query', owners?: Maybe<{ __typename?: 'OwnersPaginatedList', nodes: Array<{ __typename?: 'Owner', id?: Maybe<number>, name?: Maybe<string>, uuid?: Maybe<string> }> }> };

export type ServiceRequestAuctionLotByUserQueryVariables = Exact<{
  lotSource: Scalars['String'];
  lotId: Scalars['String'];
  lotSubgroup: Scalars['String'];
}>;


export type ServiceRequestAuctionLotByUserQuery = { __typename?: 'Query', serviceRequestAuctionLotByUser?: Maybe<{ __typename?: 'ServiceRequest', id?: Maybe<number>, isForCurrentUser?: Maybe<boolean>, files?: Maybe<Array<Maybe<{ __typename?: 'S3File', id?: Maybe<number>, fullPathForFile?: Maybe<string> }>>> }> };

export type ServiceRequestAuctionLotPriceQueryVariables = Exact<{
  type: Scalars['Int'];
  lotSource: Scalars['String'];
  lotId: Scalars['String'];
  lotSubgroup: Scalars['String'];
}>;


export type ServiceRequestAuctionLotPriceQuery = { __typename?: 'Query', serviceRequestAuctionLotPrice?: Maybe<number> };

export const DeleteUserNotifyMessageDocument = gql`
    mutation deleteUserNotifyMessage($input: DeleteUserNotifyMessageInput) {
  deleteUserNotifyMessage(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserNotifyMessageGQL extends Apollo.Mutation<DeleteUserNotifyMessageMutation, DeleteUserNotifyMessageMutationVariables> {
    document = DeleteUserNotifyMessageDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPhotoFromAuctionByAdminDocument = gql`
    mutation requestPhotoFromAuctionByAdmin($input: RequestPhotoFromAuctionByAdminInput!) {
  requestPhotoFromAuctionByAdmin(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPhotoFromAuctionByAdminGQL extends Apollo.Mutation<RequestPhotoFromAuctionByAdminMutation, RequestPhotoFromAuctionByAdminMutationVariables> {
    document = RequestPhotoFromAuctionByAdminDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPhotoFromAuctionDocument = gql`
    mutation requestPhotoFromAuction($input: RequestPhotoFromAuctionInput!) {
  requestPhotoFromAuction(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPhotoFromAuctionGQL extends Apollo.Mutation<RequestPhotoFromAuctionMutation, RequestPhotoFromAuctionMutationVariables> {
    document = RequestPhotoFromAuctionDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubscribeUserToTelegramDocument = gql`
    mutation subscribeUserToTelegram($input: SubscribeUserToTelegramInput) {
  subscribeUserToTelegram(input: $input) {
    error {
      code
      message
    }
    uuid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubscribeUserToTelegramGQL extends Apollo.Mutation<SubscribeUserToTelegramMutation, SubscribeUserToTelegramMutationVariables> {
    document = SubscribeUserToTelegramDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleUserNotifyMessageDocument = gql`
    mutation toggleUserNotifyMessage($input: ToggleUserNotifyMessageInput) {
  toggleUserNotifyMessage(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleUserNotifyMessageGQL extends Apollo.Mutation<ToggleUserNotifyMessageMutation, ToggleUserNotifyMessageMutationVariables> {
    document = ToggleUserNotifyMessageDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddGreenCornerPriceDocument = gql`
    query addGreenCornerPrice {
  addGreenCornerPrice {
    motoBidLimit
    price
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddGreenCornerPriceGQL extends Apollo.Query<AddGreenCornerPriceQuery, AddGreenCornerPriceQueryVariables> {
    document = AddGreenCornerPriceDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuctionFeedbacksDocument = gql`
    query auctionFeedbacks($auctionId: Int!, $first: Int, $offset: Int) {
  auctionFeedbacks(auctionId: $auctionId, first: $first, offset: $offset) {
    nodes {
      id
      createdAt
      evaluation
      feedback
      owner {
        id
        link
        purchase
        rating
      }
      carInfo {
        maker
        mark
        year
      }
    }
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuctionFeedbacksGQL extends Apollo.Query<AuctionFeedbacksQuery, AuctionFeedbacksQueryVariables> {
    document = AuctionFeedbacksDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckAgentDebtsDocument = gql`
    query checkAgentDebts {
  checkAgentDebts
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckAgentDebtsGQL extends Apollo.Query<CheckAgentDebtsQuery, CheckAgentDebtsQueryVariables> {
    document = CheckAgentDebtsDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserIsEcarjpBotConnectedDocument = gql`
    query currentUserIsEcarjpBotConnected {
  currentUser {
    id
    isBotEcarJpAuc
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserIsEcarjpBotConnectedGQL extends Apollo.Query<CurrentUserIsEcarjpBotConnectedQuery, CurrentUserIsEcarjpBotConnectedQueryVariables> {
    document = CurrentUserIsEcarjpBotConnectedDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserNotifyMessagesDocument = gql`
    query currentUserNotifyMessages {
  currentUserNotifyMessages(onlyEcarjpBot: true) {
    bot {
      id
      name
      clientName
    }
    channels {
      enabled
      id
      username
    }
    messageTypes {
      channels {
        enabledMessage
        id
        username
      }
      description
      id
      isDisabled
      name
      nameEng
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserNotifyMessagesGQL extends Apollo.Query<CurrentUserNotifyMessagesQuery, CurrentUserNotifyMessagesQueryVariables> {
    document = CurrentUserNotifyMessagesDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EcarJpBotSubscribeUrlDocument = gql`
    query ecarJpBotSubscribeUrl {
  ecarJpBotSubscribeUrl
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EcarJpBotSubscribeUrlGQL extends Apollo.Query<EcarJpBotSubscribeUrlQuery, EcarJpBotSubscribeUrlQueryVariables> {
    document = EcarJpBotSubscribeUrlDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MakersDocument = gql`
    query makers {
  makers {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MakersGQL extends Apollo.Query<MakersQuery, MakersQueryVariables> {
    document = MakersDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarksDocument = gql`
    query marks($makerId: Int!) {
  marks(makerId: $makerId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarksGQL extends Apollo.Query<MarksQuery, MarksQueryVariables> {
    document = MarksDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OwnerSearchDocument = gql`
    query ownerSearch($ownerId: Int!) {
  owner(id: $ownerId) {
    id
    name
    phones
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OwnerSearchGQL extends Apollo.Query<OwnerSearchQuery, OwnerSearchQueryVariables> {
    document = OwnerSearchDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OwnersSearchFullDocument = gql`
    query ownersSearchFull($filter: OwnersFilter, $search: String!) {
  owners(filter: $filter, partName: $search) {
    nodes {
      id
      name
      uuid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OwnersSearchFullGQL extends Apollo.Query<OwnersSearchFullQuery, OwnersSearchFullQueryVariables> {
    document = OwnersSearchFullDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceRequestAuctionLotByUserDocument = gql`
    query serviceRequestAuctionLotByUser($lotSource: String!, $lotId: String!, $lotSubgroup: String!) {
  serviceRequestAuctionLotByUser(lotSource: $lotSource, lotId: $lotId, lotSubgroup: $lotSubgroup) {
    id
    files {
      id
      fullPathForFile
    }
    isForCurrentUser
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceRequestAuctionLotByUserGQL extends Apollo.Query<ServiceRequestAuctionLotByUserQuery, ServiceRequestAuctionLotByUserQueryVariables> {
    document = ServiceRequestAuctionLotByUserDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceRequestAuctionLotPriceDocument = gql`
    query serviceRequestAuctionLotPrice($type: Int!, $lotSource: String!, $lotId: String!, $lotSubgroup: String!) {
  serviceRequestAuctionLotPrice(type: $type, lotSource: $lotSource, lotId: $lotId, lotSubgroup: $lotSubgroup)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceRequestAuctionLotPriceGQL extends Apollo.Query<ServiceRequestAuctionLotPriceQuery, ServiceRequestAuctionLotPriceQueryVariables> {
    document = ServiceRequestAuctionLotPriceDocument;
    client = 'shared-familiar';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "DeliveryUnion": [
      "DeliveryRequest",
      "ObjectDelivered"
    ],
    "MediaUnion": [
      "ObjectMediaItem",
      "S3File"
    ],
    "SearchResult": [
      "Invoice",
      "InvoiceCustom",
      "ObjectOfServices"
    ]
  }
};
      export default result;
    